window.stratego = window.stratego or {}

# To get `AUTH_TOKEN`, open a Rails console and run:
# AdminUser.find_by(email: 'stratego-2020-api@steveandkate.com').auth_token
stratego.SECRETS =
  production:
    AUTH_TOKEN: "kvxYfCx7WhgmAr3DasuzG"
  staging:
    # AUTH_TOKEN: "J3qwGktDz9iqBVKHoygTQ"
    AUTH_TOKEN: "fiv-vLUoZUUxNz4sLnzs"
  review:
    AUTH_TOKEN: 'stratego-user-token'
  development:
    #AUTH_TOKEN: 'stratego-user-token'
    #AUTH_TOKEN: "fiv-vLUoZUUxNz4sLnzs"
    AUTH_TOKEN: "monopoly-user-token"

window.ActivityIndicator =
  show: (text) ->
    if SpinnerPlugin?
      SpinnerPlugin.activityStart(text)
    else
      console.info("ActivityIndicator.show(#{text})")
  hide: () ->
    if SpinnerPlugin?
      SpinnerPlugin.activityStop()
    else
      console.info("ActivityIndicator.hide()")

###
phaser.coffee

Phaser improvements
###


# 'client' coordinates = browser, where origin is top-left corner of browser window
# 'view' coordiantes = the rectangle the camera is looking at in the game world. 
#       E.g. if we are scrolled to the right, 0,0 in the view might equal (100, 0) in the game world
# 'world' coordinates = the game level where origin is top-left of the level, but the level scrolls left-right.


Phaser.Game::clientToView = (client_pos) ->
    bounds = @scale.bounds
    x: (client_pos.x - bounds.x)/bounds.width
    y: (client_pos.y - bounds.y)/bounds.height

Phaser.Game::viewToWorld = (view_pos) ->
  view = @camera.view
  x: (view_pos.x*view.width) + view.x
  y: (view_pos.y*view.height) + view.y

Phaser.Game::clientToWorld = (client_pos) ->
  @viewToWorld( @clientToView( client_pos ) )

###
constants.coffee
###
window.stratego = window.stratego or {}

stratego.VERSION = 'v3.2.11'

# stratego.ENVIRONMENT = 'development'
stratego.ENVIRONMENT = 'production' # development, staging, review, or production

stratego.IS_PRODUCTION = (stratego.ENVIRONMENT == 'production')
stratego.DEBUG = false # enable verbose logging, allow CamperApps to run on desktop

# To get `AUTH_TOKEN`, open a Rails console and run:
# AdminUser.find_by(email: 'stratego-api@steveandkate.com').auth_token
# ENVIRONMENTS =

#   production:
#     MANCALA_URL: 'https://join.steveandkatescamp.com'
#     UNO_API_URL: 'https://api.steveandkatescamp.com'
#     STAFF_CAMPER_ID: 50701
#   staging:
#     MANCALA_URL: 'https://mancala-staging.herokuapp.com'
#     UNO_API_URL: 'https://sk-uno-api-staging.herokuapp.com'
#     STAFF_CAMPER_ID: 50701
#   review:
#     MANCALA_URL: 'https://mancala-staging.herokuapp.com'
#     UNO_API_URL: 'http://sk-uno-api-staging-pr-137.herokuapp.com'
#     STAFF_CAMPER_ID: 1
#   development:
#     # MANCALA_URL: 'http://10.0.1.9:3000'
#     # UNO_API_URL: 'http://10.0.1.9:3001/api'
#     # MANCALA_URL: 'https://mancala-staging.herokuapp.com'
#     MANCALA_URL: 'https://mancala-bug-fix-cors-fo-wcn31e.herokuapp.com'
#     UNO_API_URL: 'https://sk-uno-api-staging.herokuapp.com'
#     STAFF_CAMPER_ID: 1

# env = ENVIRONMENTS[stratego.ENVIRONMENT]
# stratego.MANCALA_URL = env.MANCALA_URL
# stratego.UNO_API_URL = env.UNO_API_URL
# stratego.STAFF_CAMPER_ID = env.STAFF_CAMPER_ID

# secrets = stratego.SECRETS or {}
# envSecrets = secrets[stratego.ENVIRONMENT] or {}
# stratego.AUTH_TOKEN = envSecrets.AUTH_TOKEN

# stratego.GO_SHARE_URL = stratego.MANCALA_URL + '/go/share_app?app_url='

# Indices for TileSet tiles.
stratego.TILESET = {
  START: 2
  END: 3
  CHECKPOINT: 5
  FIRE: 8   # hurts player, NPCs, and devices
  POISON: 9
  SOLID: 10
  KEY: 11
  LOCKED_KEY: 12

  ROUND_KEY: 16
  HOURGLASS_KEY: 17
  SQUARE_KEY: 18
  PIE_KEY: 19
  ICE: 20 # slippery
  FIRST_GID: 1  # offset from tile ID seen in Tiled to Tile.index

  GRID_HEIGHT: 23

  TILE_SIZE: 64
}

stratego.PROJECTILES = {
  SNOWBALL: 0
  EGGBALL: 1
  FIREBALL: 2
  ROBOPOLLI: 3
  ROCKBALL: 4
}

stratego.BREAKABLES = {
  ICE: 0
  STEEL: 1
  ROCK: 2
  GOLD: 3
  SNOW: 4
}

# Keys matching their respective projectiles
stratego.KEYS = {
  ROUND: 1
  HOURGLASS: 2
  SQUARE: 3
  PIE: 4
}

TILES_WITH_COLLISION_BODIES = [
  stratego.TILESET.FIRST_GID + stratego.TILESET.FIRE,
  stratego.TILESET.FIRST_GID + stratego.TILESET.ICE,
  stratego.TILESET.FIRST_GID + stratego.TILESET.SOLID,
  stratego.TILESET.FIRST_GID + stratego.TILESET.END,
  stratego.TILESET.FIRST_GID + stratego.TILESET.POISON,
]

MAIN_MENU_STATE_KEY = 'mainMenu'

###
What height should the editor be?
  iPad "logical pixel" resolution = 1024 x 768
  editor_height = 1024 - button_bar_height - game_height_in_portrait
    = 1024 - 58 - (ipad_width / game_aspect_ratio)
    = 1024 - 58 - (768 / (4 / 3))
    = 410
###
IPAD_SHORT = 768
IPAD_LONG = 1024
EDITOR_HEIGHT_PX = 372

MACHINES_TO_EXECUTE_PER_UPDATE = 5 # Maximum of machines to execute every update cycle
MACHINE_LEISURE_FRAMES = 5 # Number of waiting frames for each individual machine to wait between updates

# Location of first block in default programs.
START_BLOCK_X = 150
START_BLOCK_Y = 25

DEFAULT_TEMPO = 60
MAX_TEMPO = 500
DEFAULT_CRAB_ASKING_WAIT = 50 # 5 seconds

HIDDEN_MESSAGE_NAME ="hiddenMessage"
CORRECT_ANSWER_NAME = "clue"
INCORRECT_ANSWER_NAME = "decoy"
ANSWER_NAME = "answer"
CORRECT_MESSAGE = "correctMessage"
INCORRECT_MESSAGE = "incorrectMessage"

FUNCTION_HELP_DEFAULT_TEXT = "Definition blocks wrap a reusable group of blocks.
The block with the same name will run the group of code blocks.
Add inputs, which are like location variables, by using the “settings” icon in the top left corner of the definition block.
Then name and drag inputs into the inputs block.
Tap the “settings” icon to close."

WEAK_FORCE = '600'
MEDIUM_FORCE = '700'
HARD_FORCE = '1000'

FUNCTION = 'function';

class stratego.StrategoException
  constructor: (@message) ->

  toString: ->
    @message

#Gravity value
GRAVITY = 9.8 #Currently simulating Earth's gravity

# Block colors -- We patched Blockly.makeColour() to allow hex values.
HUE_EVENT = '#f79f31' # orange
HUE_FLOW     = '#aa4c9a' # plum
HUE_APPEARANCE  = '#5f318f' # purple
HUE_MOVEMENT = '#1eafec' # light blue
HUE_MATH    = '#e9178c' # magenta
HUE_LOGIC  = '#b3d043' # green
HUE_ADVANCED = '#1baaac' # aqua

stratego.MESSAGE_OPTIONS = [
  ['wink', 'wink'],
  ['wave', 'wave'],
  ['fist-bump', 'fist-bump'],
  ['high-five', 'high-five'],
  ['smile', 'smile'],
  ['peace', 'peace'],
  ['thumbs-up', 'thumbs-up'],
  ['shrug', 'shrug']
]

stratego.SOUND_OPTIONS = [
  ['boing', 'boing'],
  ['slide', 'slide'],
  ['crash', 'crash'],
  ['pop', 'pop'],
  ['tada', 'tada'],
  ['alarm', 'alarm'],
  ['chicken', 'chicken'],
  ['drop', 'drop'],
  ['slap', 'slap'],
  ['tape', 'tape']
]

stratego.DRUM_SOUND_OPTIONS = [
    ['drum-bass', 'drum-bass'],
    ['drum-bongo', 'drum-bongo'],
    ['drum-claves', 'drum-claves'],
    ['drum-cymbal', 'drum-cymbal']
]

stratego.CAMPER_APP_BACKGROUNDS = [
  'bg-spooky',
  'bg-space',
  'bg-castle',
  'bg-map2',
  'bg-map1',
  'bg-levelsnow',
  'bg-carnival',
  'bg-storefront',
  'bg-house',
  'bg-map',
  'bg-clouds'
  'bg-levelsand',
  'bg-levelforest',
  'bg-levelboat',
  'bg-honeycomb',
  'bg-tiled',
  'bg-lab',
  'bg-labyrinth',
  'bg-pool',
  'bg-field',
  'bg-water',
  'bg-forest',
  'bg-starburst',
  'bg-jungle',
  'bg-grass',
  'bg-wood',
  'bg-workshop',
  'bg-grid_white',
  'bg-grid_black',
  'bg-blank'
]

stratego.CAMPER_APP_SPRITES = [
  'animals_01_monster',
  'animals_02_shark',
  'animals_03_fish',
  'animals_04_sheep',
  'animals_05_moose',
  'animals_06_mouse',
  'animals_07_bee',
  'animals_08_panda',
  'animals_09_dragon',
  'animals_10_camel',
  'animals_11_chicken',
  'animals_12_grin',
  'animals_13_yuck',
  'animals_14_smirk',
  'animals_15_smile',
  'animals_16_frown',
  'animals_17_big-mouth',
  'animals_20_giraffe',
  'animals_21_toucan',
  'animals_22_monkey',
  'animals_23_owl',
  'animals_24_croc',
  'bread',
  'brush',
  'button',
  'chicken',
  'cone',
  'food_01_tomato',
  'food_02_greens',
  'food_03_candy',
  'food_04_chips',
  'food_05_fries',
  'food_06_donut',
  'food_07_soda',
  'food_08_carrot',
  'food_09_cheese',
  'food_10_grapes',
  'food_11_banana',
  'food_12_plate',
  'food_13_pumpkin',
  'headphones',
  'hockey',
  'kate',
  'keyboard',
  'markers',
  'mic',
  'moose',
  'needle',
  'pants',
  'pawn',
  'people_01_science-man',
  'people_02_science-woman',
  'people_03_gent',
  'people_04_gal',
  'people_05_andy',
  'people_06_anne',
  'people_07_ghost',
  'people_08_guitar',
  'people_09_keyboard',
  'people_09_mic',
  'people_10_hat',
  'people_11_ducky',
  'people_12_crown',
  'people_13_cap',
  'people_14_shades',
  'people_15_stache',
  'people_16_unicorn',
  'people_17_harriet',
  'people_18_garth',
  'people_19_evan',
  'people_20_frank',
  'people_21_callie',
  'people_22_dahlia',
  'people_23_eva',
  'people_24_dax',
  'people_24_wand',
  'people_25_flo',
  'people_25_glasses',
  'people_26_harlow',
  'people_27_knight',
  'people_28_femknight',
  'people_29_climbknight',
  'people_30_supermask',
  'people_31_supercape',
  'people_32_supercrest',
  'people_33_wizardhat',
  'pie',
  'scissors',
  'shapes_01_rectangle',
  'shapes_02_square',
  'shapes_03_circle',
  'shapes_04_hexagon',
  'shapes_05_right-arrow',
  'shapes_06_x',
  'shapes_07_o',
  'shapes_08_mirror',
  'shapes_09_balloon',
  'shapes_10_needle',
  'shapes_11_cash',
  'shapes_12_coin',
  'shapes_13_treasure',
  'shapes_14_flower',
  'shapes_15_mushroom',
  'shapes_16_island',
  'shapes_17_cactus',
  'shapes_18_raft',
  'shapes_19_key',
  'shapes_20_elevator',
  'shapes_21_door',
  'shapes_22_ladder',
  'shapes_23_bag',
  'shapes_24_button',
  'shapes_25_dial',
  'shapes_26_speech',
  'shapes_27_zzz',
  'shapes_28_feet',
  'shapes_29_paws',
  'shapes_30_block',
  'shapes_31_100',
  'shapes_32_90',
  'shapes_33_80',
  'shapes_34_70',
  'shapes_35_60',
  'shapes_36_50',
  'shapes_37_40',
  'shapes_38_30',
  'shapes_39_20',
  'shapes_40_10',
  'shapes_41_0',
  'shirt',
  'soccer',
  'space_01_star',
  'space_02_mars',
  'space_03_jupiter',
  'space_04_saturn',
  'space_05_blam',
  'space_06_lightning',
  'space_07_fire',
  'space_08_dark-cloud',
  'space_09_confetti',
  'space_10_lab-flask',
  'space_11_beaker',
  'space_12_cylinder',
  'space_13_fire-extingisher',
  'sports_01_bat',
  'sports_02_football',
  'sports_03_basketball',
  'sports_04_baseball',
  'sports_05_tennis-ball',
  'sports_06_skateboard',
  'sports_07_ramp',
  'sports_08_pitch',
  'sports_09_ramp-left',
  'sports_10_rail',
  'steve',
  'string',
  'trans_01_ship',
  'trans_02_truck',
  'trans_03_car',
  'trans_04_rocket',
  'trans_05_backhoe',
  'trans_06_house',
  'trans_07_skyscraper',
  'trans_08_metal',
  'trans_09_screwdriver',
  'trans_10_hammer',
  'trans_11_screw',
  'trans_12_paintbrush',
  'trans_13_table',
  'trans_14_chair',
  'trans_15_sofa',
  'trans_16_bed',
  'utensils',
  'waterbottle',
  'watermelon',
  'wristband'
]

###
util.coffee

Utlity functions
###
window.stratego = window.stratego or {}

util = window.stratego.util =

  isPrimitive: (arg) ->
    type = typeof arg
    arg == null || (type != "object" && type != "function")

  str_hash: (s) ->
    hash = 0
    if s.length == 0
      return hash
    for i in [0 .. s.length]
      chr   = s.charCodeAt(i)
      hash  = ((hash << 5) - hash) + chr
      hash |= 0  # Convert to 32bit integer

    return hash

  sign: (n) ->
    if n then (if n < 0 then -1 else 1 ) else 0

  stringStartsWith: (baseString, lookingFor) ->
    baseString.slice(0, lookingFor.length) == lookingFor

  orientation: (width, height) ->
    if width >= height then 'landscape' else 'portrait'

  map_to_player_coordinates: (x, y, deviceHeight) ->
    newX = x * stratego.TILESET.TILE_SIZE # x and y coordinates are mapped to a 32 x 24 grid
    newY = y * stratego.TILESET.TILE_SIZE
    newY = (deviceHeight - newY) # The original coordinates have the origin at the top left corner, change the origin to the bottom left size
    console.log(newX, newY)
    [newX, newY]

  player_to_map_coordinates: (x, y, device) ->
    newX = x / stratego.TILESET.TILE_SIZE # x and y coordinates are mapped to a 32 x 24 grid
    newY = y / stratego.TILESET.TILE_SIZE
    newY = (Math.round(device.game.height/stratego.TILESET.TILE_SIZE) - newY) # The original coordinates have the origin at the top left corner, change the origin to the bottom left size
    [newX, newY]

    # To convert from radians to degrees
  radiansToDegrees: (radians) ->
    degrees = radians * 180 / Math.PI
    degrees

  # To convert from degrees to radians
  degreesToRadians: (degrees) ->
    radians = degrees * Math.PI / 180
    radians

  distance: (pointA, pointB) ->
    dx = pointA.x - pointB.x
    dy = pointA.y - pointB.y
    Math.sqrt(dx*dx + dy*dy)

  magnitude: (vector) ->
    dx = vector.x
    dy = vector.y
    Math.sqrt(dx*dx + dy*dy)

  clamp: (value, min, max) ->
    Math.min(Math.max(value, min), max)

  # Returns a random number between `low` and `high`
  randrange: (low, high) ->
    delta = high - low
    result = low + Math.random() * delta
    result

  # returns an array of frame names for phaser animation
  anim: (name, start, end) ->
    #(x for x in [start..end])
    (name + x for x in [start..end])

  # Returns an array for blockly FieldDropdown configuration
  generateFields: (low, high) ->
    result = (["#{num}","#{num}"] for num in [low..high])

  # Returns a random item from an array
  randomOf: (arr) ->
    arr[Math.floor(Math.random() * arr.length)]

  # Searches array `arr` calling `filterFunc` for each element until filterFunc
  # returns true, then returns the element
  first: (arr, filterFunc) ->
    for a in arr
      return a if filterFunc(a)

  #returns the subset of an array whose elements are type and not exceptType
  filterByType: (arr, type, exceptType) ->
    elms = (e for e in arr when (e instanceof type))
    if exceptType?
      elms = (e for e in elms when (e not instanceof exceptType))
    elms

  locationSearch: ->
    window.location.search

  getLocationQueryValue: (key) ->
    return if !util.locationSearch()
    query = util.locationSearch().substring(1).split('&')
    terms = (pair.split('=') for pair in query)
    pairs = {}
    pairs[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]) for pair in terms
    pairs[key]

  spriteWorldTransform: (sprite) ->
    matrix = new PIXI.Matrix()
    matrix.a = sprite.worldTransform.a
    matrix.b = sprite.worldTransform.b
    matrix.c = sprite.worldTransform.c
    matrix.d = sprite.worldTransform.d
    matrix.tx = sprite.x
    matrix.ty = sprite.y
    matrix

  # returns array of all 'sprites' that contain (worldX, worldY)
  spritesAt: (sprites, worldX, worldY) ->
    _.filter sprites, (sprite) ->
      matrix = util.spriteWorldTransform(sprite) # When things are first created, sprite.worldTransform is incomplete
      sprite.getBounds(matrix).contains(worldX, worldY)

  # Given an native object from browser code, returns a JS-Intepreter opaque
  # object that can be passed around and back out to a native function.
  createInterpreterBlob: (interpreter, nativeData) ->
    subBlob = interpreter.createObject(interpreter.OBJECT)
    subBlob.data = nativeData
    subBlob

  vecLengthOrNum: (numberOrVector) ->
    if numberOrVector instanceof Vec2
      numberOrVector.length()
    else
      numberOrVector


  #
  # Runtime assertions -- check our assumptions in non-test code
  #

  assertInObject: (key, obj, msg=null) ->
    if key is undefined or obj is undefined or key not of obj
      allowed = if _.isObject(obj) then Object.keys(obj) else '<not an object>'
      msg = util._assertMsg('assertInObject',
        "Expected '#{key}' to be one of: #{allowed}", msg)
      throw new stratego.StrategoException(msg)

  assertContains: (arrayOrObject, value, msg=null) ->
    return if _.contains(arrayOrObject, value)
    msg = util._assertMsg('assertContains',
      "Expected '#{arrayOrObject}' to contain: #{value}", msg)
    throw new stratego.StrategoException(msg)

  assertTypeOf: (obj, expectedType, msg=null) ->
    if typeof obj != expectedType
      msg = util._assertMsg('assertTypeOf',
        "Should be type '#{expectedType.name}' but is #{typeof obj}", msg)
      throw new stratego.StrategoException(msg)

  assertInstanceOf: (obj, expectedType, msg=null) ->
    if obj not instanceof expectedType
      msg = util._assertMsg('assertInstanceOf',
        "Should be instance of '#{expectedType.name}' but is #{typeof obj}", msg)
      throw new stratego.StrategoException(msg)

  assertExists: (obj, msg=null) ->
    if not obj?
      msg = util._assertMsg('assertExists',
        "Should be non-null but is #{obj}", msg)
      throw new stratego.StrategoException(msg)

  _assertMsg: (funcName, assertMsg, userMsg) ->
      extraMsg = if userMsg then " #{userMsg} --" else ''
      "#{funcName}:#{extraMsg} #{assertMsg}"


  sleepPromise: (time) ->
    deferred = Q.defer()
    setTimeout( deferred.resolve, time )
    deferred.promise

  randomId: ->
   (Math.random()*0xffffffff|0).toString(36) +
   (Math.random()*0xffffffff|0).toString(36) +
   (Math.random()*0xffffffff|0).toString(36) +
   (Math.random()*0xffffffff|0).toString(36)

  checkGyroscope: ->
    deferred = Q.defer()
    if not window.DeviceOrientationEvent?
      deferred.resolve(false) # no gyro
    else
      timeoutHandle = null

      # see if device fires events
      checkEventIsValid = (event) ->
        window.removeEventListener('deviceorientation', checkEventIsValid)
        clearTimeout(timeoutHandle)
        hasGyro = typeof event.alpha is 'number' and
                  typeof event.beta  is 'number' and
                  typeof event.gamma is 'number'
        deferred.resolve(hasGyro)
      window.addEventListener('deviceorientation', checkEventIsValid)

      # if no event comes, assume there's no gyroscope
      timeoutHandle = setTimeout( ->
        window.removeEventListener('deviceorientation', checkEventIsValid)
        deferred.resolve(false) # no gyroscope
      , 1000)


    deferred.promise

  checkTouch: ->
    Navigator.maxTouchPoints > 0 || /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

  # Returns bounding box of the gameScreenContainer. Values are in: rect.top, left, bottom, right
  gameBoundingRect: (game) ->
    game.parent.getBoundingClientRect()

  # convert '#33ff33' to 0x33ff33
  colorHexToInt32: (hexString) ->
    Phaser.Color.hexToRGB(hexString) & 0xffffff

  #
  # Marks - Track objects created are also destroyed
  #
  _marks: {
    Highlighter: -1 # We expect one instance where logMarks() is called
    BlocklyEditor: -1
    Bulletins: -1
    EventManager: -1
    MainMenu: -1
  }
  mark: (name) ->
    if name not of util._marks
      util._marks[name] = 0
    util._marks[name] += 1

  unmark: (name) ->
    util._marks[name] -= 1

  logMarks: ->
    for name, value of util._marks
      if value != 0
        console.info('util.mark: instances of', name, '=', value)

  # Pixie seems to have bugs cleaning up textures.
  cleanUpImageCache: (game, cacheKey) ->
    game.cache.removeImage(cacheKey)

###
vec2.coffee
###

RAD_TO_DEG = 57.2957795131  # 360 / (PI * 2)
DEG_TO_RAD = 0.01745329252

# a 2d vector
class stratego.Vec2

  constructor: (@_direction=0, @_length=1) ->

  x: ->
    Math.cos(@_direction * DEG_TO_RAD) * @_length

  y: ->
    Math.sin(@_direction * DEG_TO_RAD) * @_length

  # return angle of vector 0..360
  direction: ->
    @_direction

  length: ->
    @_length

  @newPolar: (direction, length) ->
    new stratego.Vec2(direction, length)

  @newXY: (x, y) ->
    direction = Math.atan2(y, x) * RAD_TO_DEG
    if direction < 0
      direction += 360
    length = Math.sqrt(x * x + y * y)
    new stratego.Vec2(direction, length)

  toString: ->
    "new_vector(#{@_direction}, #{@_length})"

###
cross_origin.coffee
###


# turn on crossOrigin only for urls that really are because Cordova's local web server
# rejects requests when crossOrigin is on.
class stratego.CrossOriginAdjuster

  constructor: (@game) ->
    util.mark('CrossOriginAdjuster')

  destroy: ->
    @disable()
    @game = null
    util.unmark('CrossOriginAdjuster')

  enable: ->
    @game.load.onFileStart.add(@_setCrossOriginDependingOnUrl, this)
    @game.load.onLoadComplete.addOnce(@disable, this)
    this

  disable: ->
    @game.load.crossOrigin = false
    @game.load.onFileStart.remove(@_setCrossOriginDependingOnUrl, this)
    @game.load.onLoadComplete.remove(@disable, this)

  _setCrossOriginDependingOnUrl: (progress, key, url) =>
    isOtherHost = util.stringStartsWith(url, 'http') and not ( \
          util.stringStartsWith(url, 'http://localhost') \
          or util.stringStartsWith(url, 'https://localhost'))
    @game.load.crossOrigin = if isOtherHost then 'anonymous' else false

###
thing.coffee

Thing - objects you can interact with in the game.
###

# imports
phaser = Phaser

DEVICES_FOR_TILESET = null

nextThingId = 100  # for debugging, differentiate different objects
class stratego.Thing extends phaser.Sprite
  constructor: (game, x, y, key, frame, group) ->
    super(game, x, y, key, frame)
    if group? then group.add(this) else @game.add.existing(this)
    @name = null
    @tileId = -1
    @_thingId = nextThingId
    nextThingId += 1
    @cancelLock()
    util.mark('Thing')
    @_eventManager = @level().eventManager
    @_eventManager.addEventHandler('toggleCamera', @toggleCamera, this) # Add event to toggle when entering or leaving camera view
    @currentlyInCameraView = @inCameraView()
    @executeOutOfCameraView = false # Devices aren't allowed to execute out of camera view by default

  destroy: (args...) ->
    super(args...)
    util.unmark('Thing')

  @createFromTiledObjectJson: (game, objJson) ->
    newThing = new this(game, objJson.x, objJson.y)
    newThing.width = objJson.width
    newThing.height = objJson.height
    newThing

  update: ->
    super()
    # Fire event when the thing either starts or stops being seen by the camera
    if @currentlyInCameraView != @inCameraView()
      @_eventManager.dispatchEvent('toggleCamera', {source: this, inCamera: @inCameraView()})
      @currentlyInCameraView = @inCameraView()

    # Stop body if outside of camera view
    if @body != null
      if @currentVelocity != @body.velocity
        if util.magnitude(@body.velocity) > 0 and not @inCameraView()
          @body.velocity.x = 0
          @body.velocity.y = 0

  setTileId: (id) ->
    @tileId = id

  level: ->
    @game.state.getCurrentState()

  _enablePhysics: ->
    @game.physics.enable(this)
    @body.collideWorldBounds = true
    @currentVelocity = @body.velocity

  toString: ->
    name = if @name then " #{@name}" else ''
    "<#{@constructor.name}_#{@_thingId}#{name} xy=#{@x.toFixed(1)} #{@y.toFixed(1)}>"

  # mocha tests use this in console.log
  toJSON: ->
    @toString()

  canPickupKey: ->
    'pickupKey' of this

  checkThingOverlaps: ->
    @level()._proximityChecker.findOverlap(this, @level().things)

  inCameraView: ->
    # Get camera view when in a level, in camper app always set to true
    if stratego.Level != undefined and @level() instanceof stratego.Level
      return @level().inCameraView(this)
    return true
    
  toggleCamera: (params) -> # ToggleCamera general implementation, specific cases like robodillo override the event method
    return if params.source != this

  onTopOf: (bottom) ->
    @body.touching.down and bottom.body.touching.up

  sideBySide: (neighbor) ->
    a = @body.touching
    n = neighbor.body.touching
    a.left and n.right or a.right and n.left

  rightOf: (neighbor) ->
    a = @body.touching
    n = neighbor.body.touching
    a.left and n.right

  ride: (ridden) ->
    @body.x += ridden.body.deltaX()
    @body.velocity.y = 0

  #
  # locking to other Things
  #

  isLocked: ->
    @lockedTo != null

  lockTo: (thing) ->
    @body.velocity.y = 0
    @lockedTo = thing

  cancelLock: ->
    @lockedTo = null

  updateLock: ->
    return if not @lockedTo
    @body.velocity.y = 0

    # If the player has walked off either side of the platform then they're no longer locked to it
    if @body.right < @lockedTo.body.x || @body.x > @lockedTo.body.right
      @cancelLock()
      return

  # Call me in preRender()
  followLock: ->
    if @isLocked()
      @x += @lockedTo.deltaX
      @y = @lockedTo.y - @height + @pivot.y

###
machine.coffee

The virtual machine that Player's scripts run in.
###
MACHINE_STEP_RATE_MS = 100

class stratego.Machine
  @num_running_machines: 0

  # _initNativeFunctions = one function which is called on initialization and
  #   allows installation of native functions, i.e. function that run in the
  #   browser.
  # _subinterpreterFunctions = a dictionary of functions to be installed and
  #   will be run in the sub-interpreter
  # See tests for examples
  constructor: (@device, @eventManager, @_initNativeFunctions, @_subinterpreterFunctions) ->
    @_running_machine = false
    @_waitingHandler = null
    @_hasCompletedBlock = false
    @interpreter = null
    # 'charon' is a dictionary of values that can be easily access from browser and sub-intrepreter
    @charon = {}
    util.mark('Machine')
    @intervals = []

    @machineManager = stratego.MachineManager.getInstance()


  destroy: ->
    @clearIntervals()
    @stop()
    @machineManager.removeMachine(this) # Remove machine from Machine Manager when destroyed
    @device = null
    @eventManager = null
    @interpreter = null
    @charon = null
    @_initNativeFunctions = null
    @_subinterpreterFunctions = null
    util.unmark('Machine')

  toString: ->
    "<Machine for #{@device}>"

  isAlive: ->
    @isRunning() or @isWaiting()

  isRunning: ->
    @_running_machine

  isWaiting: ->
    @_waitingHandler != null

  #
  # Running the sub-interpreter
  #

  start: (code) ->
    @_initInterpreter(code)
    @_startMachine()
    stratego.Machine.num_running_machines += 1

  stop: ->
    if @isAlive()
      @_stopMachine()
      @_stopWaiting()
      stratego.Machine.num_running_machines -= 1
      if stratego.Machine.num_running_machines < 0 then throw new Error("num_running_machines should be >= 0 but is #{stratego.Machine.num_running_machines}")
      @eventManager.dispatchEvent('machine_stopped', {device: @device})

  # Instead of running a timer, add machine to Machine Manager and set the running flag to true 
  _startMachine: ->
    @machineManager.addMachine(this) # Add machine to Machine Manager
    @_running_machine = true

  _stopMachine: ->
    if @isRunning()
      @machineManager.removeMachine(this) # Remove machine when stopping it to avoid updating
      @_running_machine = false
      @_hasCompletedBlock = true

  addInterval: (interval) ->
    @intervals.push interval
    
  clearIntervals: ->
    clearInterval(interval) for interval in @intervals # Stop all of the intervals set, to avoid having threads running after stopping blockly
    @intervals.length = 0;

  _initInterpreter: (code) ->
    bootCode = @_subinterpreterFunctionsAsString() + code
    initNativeFn = _.partial(@_initNativeFunctions, this)
    try
      @interpreter = new Interpreter(bootCode, initNativeFn)
    catch exc
      console.error("Problem starting Machine with following code: #{exc}\n>>>\n#{code}\n<<<")

  _subinterpreterFunctionsAsString: ->
    ("var #{name} = #{func.toString()}\n" for name, func of @_subinterpreterFunctions).join('\n')

  # Run machine code block from the Machine Manager
  updateMachine: ->
    if @_running_machine
      @_runOneBlock()

  _runOneBlock: ->
    @_hasCompletedBlock = false
    step_limit = 10000
    try
      until @_hasCompletedBlock
        has_more_code = @interpreter.step()
        if not has_more_code
          @stop()
          break
        step_limit--
        if step_limit <= 0
          console.error("Interpreter has been running too long for one block.")
          @stop()
          break
    catch e
      console.info("Machine: error in user program.\n---\nException:", @_exceptionMessage(e))
      @stop()

  _exceptionMessage: (exception) ->
    if _.isObject(exception) and 'stack' of exception
      "#{exception.toString()}\n---\nStack:\n#{exception.stack}"
    else
      exception.toString()

  #
  # Pausing interpreter waiting for events
  #

  wait_for: (eventName, predicate) ->
    @_stopMachine()

    wrappedHandler = (params) ->
      if !predicate? or predicate(eventName, params)
        # condition has been fulfilled
        @_onEvent(eventName, params)
        @_stopWaiting()

    @_waitingHandler = @eventManager.addEventHandler(eventName, wrappedHandler, this)

  _stopWaiting: ->
    if @_waitingHandler?
      @_waitingHandler.detach()
      @_waitingHandler = null

  _onEvent: (eventNameStr, params) ->
      @charon['event.name'] = eventNameStr
      for key, val of params
        @charon["event.#{key}"] = val
      @_startMachine()

###
machineManager.coffee
###

# Data Structure class to manage each Machine individually inside the machineManager machines array
class MachineStruct

  constructor: (machine, totalWaitingFrames) ->
    @machine = machine
    @totalWaitingFrames = MACHINE_LEISURE_FRAMES # Use MACHINE_LEISURE_FRAMES constant to define the amount of frames to be waited between updates, 
                                     # could be changed if a specific device machine needs to be updated more/less frequently than the usual
    @currentFrame = 0
    @waiting = false

  isWaiting: ->
    return @waiting


  # Update Machine if finished waiting
  updateMachine: ->
    return false if @waiting
    @machine.updateMachine()
    @currentFrame = 0
    @waiting = true
    return true

  machineInCameraView: ->
    return @machine.device.inCameraView()

  # Verify if the machine's device allows for out of camera execution
  executeOutOfCameraView: ->
    return @machine.device.executeOutOfCameraView

  # Update cycle to determine if the Machine inside each MachineStruct is ready to be updated again
  update: ->
    if @waiting
      @currentFrame++
      if @currentFrame >= @totalWaitingFrames
        @currentFrame = 0
        @waiting = false


# Singleton class to manage all the machines running in the level or camper app
class stratego.MachineManager

  instance = null

  # Only public method to access the Singleton instance
  @getInstance: ->
    instance ?= new PrivateClass() # Create instance only when it hasn't been defined yet

  # Internal class with all the implementations
  class PrivateClass
    constructor: ->
      @machines = []

    createMachine: (device, code) ->
      machine = new stratego.Machine(device, device.eventManager, device.initNativeFunctions, device.subinterpreterFunctions())
      machine.start(code)
      machine

    addMachine: (machine) ->
      if machine.device != undefined 
        m = new MachineStruct(machine)
        @machines.push(m)
      
    removeMachine: (machine) -> 
      i = 0
      while (i < @machines.length)
        if @machines[i].machine == machine
          @removeMachineByIndex(i)
        i++

    emptyMachines: ->
      @machines = []

    removeMachineByIndex: (index) ->
      removed = @machines.splice(index, 1)

    # Update every machine in the array to refresh their individual waiting times
    updateAll: ->
      i = 0
      while (i < @machines.length)
        if @machines[i] == undefined or @machines[i].machine.device == undefined
          @removeMachineByIndex(i)
        else
          @machines[i].update()
        i++

    updateMachines: ->
      # Update all machines
      @updateAll() 

      # Execute the minimum number of machines each cycle
      i = 0
      min = Math.min(@machines.length, MACHINES_TO_EXECUTE_PER_UPDATE) # Update only min machines per update cycle
      while (i < min)
        if i >= @machines.length
          break
        
        if @machines[0].machine.device == null
          @removeMachineByIndex(0)
          continue

        # Update machine if it is in camera view or if it's device is able to execute out of camera view
        if @machines[0].machineInCameraView() or @machines[0].executeOutOfCameraView()
          updated = @machines[0].updateMachine() # Update first machine on the list if possible
        @machines.push(@machines.shift()) #  Remove first machine and append it to the end of the list to update later
        
        i += 1
class stratego.EventManager
  constructor: ->
    @_signals = {}
    util.mark('EventManager')

  destroy: ->
    for key, sig of @_signals
      sig.dispose()
    @_signals = null
    util.unmark('EventManager')

  addEventHandler: (eventName, handler, that) ->
    @_guaranteeSignal(eventName)
    @_signals[eventName].add( handler, that )

  addEventHandlerOnce: (eventName, handler, that) ->
    @_guaranteeSignal(eventName)
    @_signals[eventName].addOnce( handler, that )

  dispatchEvent: (eventName, params...) ->
    signal = @_signals[eventName]
    signal.dispatch(params...) if signal?

  removeAllEventHandlers: (that) ->
    signal.removeAll(that) for name, signal of @_signals

  removeEventHandler: (eventName, that) ->
    return if not @_signals[eventName]
    @_signals[eventName].removeAll(that)

  _guaranteeSignal: (eventName) ->
    @_signals[eventName] = @_signals[eventName] || new phaser.Signal()

###
device.coffee

In-game object that is programmable by user
###

class stratego.Device extends stratego.Thing

  @TOOLBOX: DEFAULT: ''

  constructor: (game, x, y, args...) ->
    super(game, x, y, args...)
    @firstLoc = {x: @x, y: @y}
    @_codeXml = null
    @_codeJs = [] # array of strings, each containing a javascript program
    @toolboxXml = @constructor.TOOLBOX.DEFAULT
    @_machines = []
    @_playerNearby = false
    @eventManager = @level().eventManager

    @machineManager = stratego.MachineManager.getInstance()
    
    @setDefaultProgram()
    util.mark('Device')

  destroy: (args...) ->
    @stopCode()
    @firstLoc = null
    @_codeXml = null
    @_codeJs.length = 0
    @toolboxXml = null
    @_machines.length = 0
    @eventManager = null
    super(args...)
    util.unmark('Device')

  setDefaultProgram: ->
    @setCode("<xml></xml>")

  codeXml: -> @_codeXml

  clearCode: ->
    @setCode('<xml></xml>')

  # This method uses BlocklyEditor so it's only usable when editing, i.e. not when stand-alone
  setCode: (codeXml, codeJs=null) ->
    if codeJs == null
      [@_codeJs, @_codeXml] = stratego.BlocklyEditor.compileXml(codeXml)
    else
      # If caller passes both XML and JS, we assume the XML has been recompiled to have sequential IDs.
      @_codeXml = codeXml
      @_codeJs = codeJs.slice()

  runCode: ->
    @stopCode()
    functionsStr = ''
    funcRegex = /function [^\n]+\(/
    for code in @_codeJs
      if funcRegex.test(code) # if the JS code block starts with "function", it is a new blockly function
        comment = code.substring(code.indexOf('//'), code.indexOf('function')) # Extract comment, currently unused, might be useful in the future
        name = code.substring(code.indexOf('function'), code.indexOf('(')).split(' ')[1] # Extract name of function
        func = code.substring(code.indexOf('function')) # Remove potential variables from beginning of text
        func = func.replace(/function.*\(/, 'function (') # Remove function name, ex: function test () -> function ()
        functionsStr += "var #{name} = #{func}\n" # Concatenate every function into new variables
    
    for code in @_codeJs
      continue if funcRegex.test(code)
      m = @machineManager.createMachine(this, functionsStr + code) # Create a new machine and add it to MachineManager to update when needed
      @_machines.push(m)

  stopCode: ->
    for m in @_machines
      m.destroy()
    @_machines.length = 0

  runningMachinesCount: ->
    count = 0
    if @_machines?
      for m in @_machines
        if m.isAlive()
          count += 1
    count

  isEditable: -> true

  #
  #  Commands i.e. implementation of coding blocks
  #
  move: (amount) ->
    @body.velocity.x = amount

  _resetPosition: ->
    @reset(@firstLoc.x, @firstLoc.y)

  showCaption: (msg, anchorPointX = 0.5, anchorPointY = 0) ->
    if msg?
      if not @_caption?
        style =
          fill: '#ffffff'
          backgroundColor: 'rgba(103, 135, 152, 0.59)'
          font: 'normal 35px sans-serif'
          wordWrap: true
          wordWrapWidth: 650
        @_caption = new Phaser.Text(@game, 0, 0, '', style)
        @_caption.anchor = new Phaser.Point(anchorPointX, anchorPointY)
        @addChild(@_caption)

      @_caption.text = " #{msg} "
      @_caption.visible = true
    else
      @_caption?.visible = false

  hideCaption: ->
    @_caption?.visible = false

  initNativeFunctions: (machine, interpreter, scope) =>
    device = this  # available to functions below
    nativeFunctions = {

    #--- editor integration

      highlightBlock: (idStr) ->
        id = idStr.data
        machine._hasCompletedBlock = true
        device.eventManager.dispatchEvent('device_highlight_block', {device: device, id: id})
        return

    #--- control flow

      wait: -> # Pause the interpretor for one tick
        machine._hasCompletedBlock = true
        return

      charon_get: (key) ->
        key = if key then key.toString() else ''
        nativeVal = machine.charon[key]
        unless util.isPrimitive(nativeVal)
          throw new stratego.StrategoException("charon[#{key}] is not a primitive: #{nativeVal}")
        interpreter.createPrimitive(nativeVal)

    #--- movement

      reset_position: ->
        device._resetPosition()
        return

      move_to: (x,y) ->
        device.x = x.toNumber()
        device.y = y.toNumber()
        return

      get_x: ->
        x = device.x
        interpreter.createPrimitive(x)

      get_y: ->
        y = device.y
        interpreter.createPrimitive(y)

    }
    for name, func of nativeFunctions
      interpreter.setProperty(scope, name, interpreter.createNativeFunction(func))

  # Returns dictionary of functions to be installed into sub-interpreter's
  # global scope. These functions are executed in the sub-interpreter. So no
  # input or output adjustments need to be made. No `this` will be defined.
  subinterpreterFunctions: ->
    {
      glide_to: (x, y) ->
        SPEED_FACTOR = 12
        startX = get_x()
        startY = get_y()
        deltaX = x - startX
        deltaY = y - startY
        steps = Math.sqrt(deltaX*deltaX + deltaY*deltaY) / SPEED_FACTOR
        for i in [1..steps] by 1
          nextX = startX + (i * deltaX/steps)
          nextY = startY + (i * deltaY/steps)
          move_to(nextX, nextY)
          wait()
        move_to(x, y)
        return

      glide_by: (deltaX, deltaY) ->
        glide_to(get_x() + deltaX, get_y() + deltaY)
        return

      glide_up: (deltaY) ->
        glide_by(0, -deltaY * 64)
        return

      glide_down: (deltaY) ->
        glide_by(0, deltaY * 64)
        return

      glide_right: (deltaX) ->
        glide_by(deltaX * 64, 0)
        return

      glide_left: (deltaX) ->
        glide_by(-deltaX * 64, 0)
        return
    }


  #
  # Class Methods
  #

  # Compares two code stacks and returns true if they contain the same programs.
  @_codeStacksEqual: (codeJs1, codeJs2) ->
    return false if codeJs1.length != codeJs2.length

    HIGHLIGHT_RE = /highlightBlock\([^)]*\)/g
    s1 = (p.replace(HIGHLIGHT_RE, '') for p in codeJs1)
    s2 = (p.replace(HIGHLIGHT_RE, '') for p in codeJs2)
    s1.sort()
    s2.sort()
    for i in [0..s1.length]
      return false if s1[i] != s2[i]

    return true # they are equal

###
depth_groups.coffee
###

class stratego.DepthGroups

  # listOfGroupNames = e.g. ['background', 'foreground']
  constructor: (game, listOfGroupNames) ->
    @_groups = {}
    for groupName, i in listOfGroupNames
      group = game.add.group()
      group.z = i
      if @hasOwnProperty(groupName) then throw new Error("DepthGroups already has a property '#{groupName}'")
      @_groups[groupName] = group
      @[groupName] = group  # allow easy access
    util.mark('DepthGroups')

  destroy: ->
    for name, group of @_groups
      group.destroy()
      @[name] = null

    @_groups.length = 0
    util.unmark('DepthGroups')
  

###
camper_device.coffee
###

Vec2 = stratego.Vec2

class stratego.CamperDevice extends stratego.Device
    #<i class='fa fa-wordpress"></i>
  @TOOLBOX: DEFAULT: """
    <category name="Events">
      <!-- events -->
      <block type="stratego_when_started"></block>
      <block type="stratego_when_pressed"></block>
      <block type="stratego_when_overlap"></block>
    </category>

    <category name="Flow">
      <!-- flow control -->
      <block type="stratego_repeat_forever"></block>
      <block type="controls_repeat_ext">
        <value name="TIMES">
          <block type="stratego_number">
            <field name="NUM">3</field>
          </block>
        </value>
      </block>
      <block type="stratego_wait">
        <value name="TIMES">
          <block type="stratego_number">
            <field name="NUM">10</field>
          </block>
        </value>
      </block>
    </category>

    <category name="Appearance">
      <!-- appearance -->
      <block type="stratego_set_color_2">
        <value name="COLOR">
          <block type="colour_picker"></block>
        </value>
      </block>
      <block type="stratego_resize">
        <value name="SIZE">
          <block type="stratego_number">
            <field name="NUM">10</field>
          </block>
        </value>
      </block>
      <block type="stratego_show"></block>
      <block type="stratego_hide"></block>
      <block type="stratego_say">
        <value name="MSG">
          <block type="text">
            <field name="TEXT">hello</field>
          </block>
        </value>
      </block>
      <block type="stratego_play_sound"></block>
      <block type="text">
        <field name="TEXT">hello</field>
      </block>
      <block type="stratego_play_drum_sound_for_beats">
        <value name="BEATS">
          <block type="stratego_number">
            <field name="NUM">0.5</field>
          </block>
        </value>
      </block>
      <block type="stratego_set_tempo">
        <value name="TEMPO">
          <block type="stratego_number">
            <field name="NUM">60</field>
          </block>
        </value>
      </block>
    </category>

    <category name="Move">
      <!-- movement -->
      <block type="stratego_move_by"></block>
      <block type="stratego_teleport_to_coordinates">
        <value name="X">
          <block type="stratego_number">
            <field name="NUM">16</field>
          </block>
        </value>
        <value name="Y">
          <block type="stratego_number">
            <field name="NUM">12</field>
          </block>
        </value>
      </block>
      <block type="stratego_artificial_jump">
        <value name="FORCE">
          <block type="stratego_number">
            <field name="NUM">50</field>
          </block>
        </value>
      </block>
      <block type="stratego_new_vector">
        <value name="DIRECTION">
          <block type="stratego_number">
            <field name="NUM">90</field>
          </block>
        </value>
        <value name="LENGTH">
          <block type="stratego_number">
            <field name="NUM">10</field>
          </block>
        </value>
      </block>
      <block type="stratego_reset_position"></block>
      <block type="stratego_rotate">
        <value name="ANGLE">
          <block type="stratego_number">
            <field name="NUM">90</field>
          </block>
        </value>
      </block>

      <!-- sensors -->
      <block type="stratego_tilt"></block>
      <block type="stratego_sprite_is"></block>
    </category>

    <category name="MATH">
      <!-- math -->
      <block type="stratego_number"></block>
      <block type="stratego_arithmetic"></block>
      <block type="math_random_int">
        <value name="FROM">
          <block type="stratego_number">
            <field name="NUM">0</field>
          </block>
        </value>
        <value name="TO">
          <block type="stratego_number">
            <field name="NUM">10</field>
          </block>
        </value>
      </block>
    </category>

    <category name="Logic">
      <!-- logic -->
      <block type="stratego_if"></block>
      <block type="stratego_if_else"></block>
      <block type="logic_compare"></block>
      <block type="logic_negate"></block>
      <block type="logic_operation"></block>
    </category>

    <category name="ADV">
      <!-- variables -->
      <block type="stratego_set"></block>
      <block type="stratego_get"></block>
      <block type="stratego_wait_for_answer">
        <value name="ANSWER">
          <block type="text">
            <field name="TEXT">What's your favorite color?</field>
          </block>
        </value>
      </block>
      <block type="stratego_get_answer"></block>

      <!-- Custom events -->
      <block type="stratego_send_message"></block>
      <block type="stratego_send_message_with_data"></block>
      <block type="stratego_when_message"></block>
      <block type="stratego_message_data"></block>
    </category>

    <category name="Functions" custom="PROCEDURE"></category>
    <category name="Variables" custom="VARIABLE"></category>
    
    """

  setDefaultProgram: ->
    @setCode("""
      <xml>
        <block type="stratego_when_started" id="1" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}"/>
      </xml>
    """, []) # empty codeJs [] avoids compilation of XML which won't work standalone

  @SERIALIZABLE_FIELDS: [
    '_codeXml',
    '_codeJs',
    'key',
    'firstLoc',
  ]

  constructor: (args...) ->
    super(args...)
    @_pressingPointers = []
    @inputEnabled = true
    @events.onInputDown.add(@_onInputDown, this)
    @events.onInputUp.add(@_onInputUp, this)
    @variables = {}
    @answer = ""
    @isJumping = false;
    @anchor = new Phaser.Point(0.5, 0.5) # do before enabling physics
    @game.physics.enable(this)
    @body.collideWorldBounds = true
    @body.allowGravity = false
    @resize()

  isEditable: -> not @camperApp().isRunning()

  runCode: ->
    @firstLoc = {x: @x, y: @y}
    super()

  reset: ->
    super(@firstLoc.x, @firstLoc.y)
    @resize()
    @tint = 0xFFFFFF
    @showCaption(null)
    @angle = 0

  _resetPosition: ->
    @x = @firstLoc.x
    @y = @firstLoc.y

  #
  # Serialization into JSON
  #

  serialize: ->
    deviceDesc = {}
    for key in stratego.CamperDevice.SERIALIZABLE_FIELDS
      deviceDesc[key] = this[key]
    deviceDesc

  @deserialize: (game, deviceDesc, group) ->
    x = deviceDesc.firstLoc?.x || 100
    y = deviceDesc.firstLoc?.y || 100
    device = new stratego.CamperDevice(game, x, y, deviceDesc.key, null, group)
    for key in stratego.CamperDevice.SERIALIZABLE_FIELDS
      if key of deviceDesc
        device[key] = deviceDesc[key]
    device

  #
  # Other
  #

  # return current instance of CamperApp
  camperApp: ->
    # todo: This assumption about other objects is fragile. Can we improve this?
    @game.state.getCurrentState().camperApp

  resize: (factor=5) ->
    @height = @width = factor * 256 / 5

  showCaption: (msg) ->
    if msg?
      if not @_caption?
        style =
          stroke: '#000'
          backgroundColor: '#fff'
          font: 'normal 80px Arial'
        @_caption = new Phaser.Text(@game, 0, @height / 2, '', style)
        @_caption.anchor = new Phaser.Point(0.5, 0)
        @addChild(@_caption)

      @_caption.text = " #{msg} "
      @_caption.visible = true
    else
      @_caption?.visible = false

  _onInputDown: (sprite, pointer) ->
    @eventManager.dispatchEvent('camper_device_pressed', device: this)
    @_pressingPointers[pointer.id] = true

  _onInputUp: (sprite, pointer) ->
    @_pressingPointers[pointer.id] = false

  # True if any touches are on this sprite
  isPressed: ->
    _.any(@_pressingPointers)


  #
  # Sub-interpreter setup
  #

  initNativeFunctions: (machine, interpreter, scope) =>
    super(machine, interpreter, scope)

    device = this  # available to functions below

    # These functions are accessible from sub-interpreter but executed in browser
    # Inputs are sub-interpreter wrapper objects. Return values should also be
    # sub-interpeter wrappers, or `undefined`.
    nativeFunctions = {
      tilt: (axes) ->
        axes = axes.toString().toLowerCase()
        throw "bad axes value: #{axes}" if axes not in ['xy', 'yz', 'xz']
        t = device.camperApp().tiltReading()
        result = Vec2.newXY( t[axes[0]], t[axes[1]] )
        util.createInterpreterBlob(interpreter, result)

      move_by: (block) ->
        if block.data instanceof Vec2
          vec = block.data
          device.x += vec.x()
          device.y -= vec.y()
        else
          device.x += block
        return

      artificial_jump: (block) -> 
        if block.data instanceof Vec2 # If the block data is a vec2, use x = direction and y = length
          vec = block.data
        else if typeof block.data is 'number' # If the block data is a number, default to jump upwards
          vec = new stratego.Vec2(90, block) 
        else
          return

        # Store initial values 
        initialYPosition = device.y 
        initialXPosition = device.x

        currGravity = 0 # Initial gravity
        device.isJumping = true # Know while the object is jumping

        # Set a jumping interval to simulate a jump with gravity to any direction
        interval = setInterval ->

          #Calculate jump direction based on angle
          device.x += if Math.abs(vec.x()) > 0.001 then vec.x() else 0
          device.y -= if Math.abs(vec.y()) > 0.001 then vec.y() else 0

          #Gravity simulation towards inverse direction from original force
          device.x -= if Math.abs(vec.x()) > 0.001 then (Math.cos(vec._direction * DEG_TO_RAD) * currGravity) else 0 
          device.y += if Math.abs(vec.y()) > 0.001 then (Math.sin(vec._direction * DEG_TO_RAD) * currGravity) else 0
          
          currGravity += GRAVITY # Increase gravity each time

          # Get current distance between initial position and current position
          currentDistance = util.distance(
            {
              x: device.x, 
              y: device.y
            }, 
            {
              x: initialXPosition, 
              y: initialYPosition
            }
          )
          
          # When reaching the starting position stop moving
          if currentDistance < vec.length()
            clearInterval(interval) # Stop interval thread

            # Align device when finishing the jump
            device.x = initialXPosition 
            device.y = initialYPosition 

            device.isJumping = false; # Finish jumping
            
        , 50 # Miliseconds per execution, 50ms is a good number for it to look smooth

        machine.addInterval(interval) # Add interval to machine list to be able to stop them when stopping execution

      is_jumping: ->
        interpreter.createPrimitive(device.isJumping)

      teleport_to_coordinates: (x, y) ->
        mappedCoordinates = util.map_to_player_coordinates(x, y, device.game.height)
        device.x = mappedCoordinates[0]
        device.y = mappedCoordinates[1]
        return

      wait_for_overlap: ->
        machine.wait_for( 'device_overlap', (eventName, params) ->
          params.left == device || params.right == device
        )
        return

      wait_for_sprite_press: ->
        machine.wait_for( 'camper_device_pressed', (eventName, params) -> params.device == device )
        return

      wait_for_answer: (input) ->
        message = input.toString()
        if input?
          input = input.data
          device.answer = prompt(input.toString())          
        else
          device.answer = prompt("")
        if not isNaN(device.answer)
          device.answer = parseInt(device.answer, 10)
        return

      get_answer: ->
        if device.answer?
          return interpreter.createPrimitive(device.answer)
        else # If the prompt is closed, return empty text
          return interpreter.createPrimitive("")

      # !!! No longer in toolbox, but keep for summer 2015 in case a camper has it in their app
      # Tint the sprite with a hue, saturation, or brightness. 'value' should be
      # a Number 0..10, or a Vec2 with the direction be used.
      set_color: (axis, value) ->
        axis = axis.data
        value = value.data
        if value instanceof Vec2
          value = value.direction() / 36  # 0..360 -> 0..10
        tintHsv = Phaser.Color.unpackPixel(device.tint, null, false, true)
        switch axis
          when 'HUE'
            tintHsv.h = util.clamp(value / 10, 0, 1)  # hue should be 0..10
            if not device?._hasSetColor # set saturation so we can see the color
              device._hasSetColor = true
              tintHsv.s = 1
          when 'SATURATION'
            tintHsv.s = util.clamp(value / 10, 0, 1)
          when 'BRIGHTNESS'
            tintHsv.v = util.clamp(value / 10, 0, 1)
          else
            throw "unknown axis: '#{axis}'"

        tintObj = Phaser.Color.HSVtoRGB(tintHsv.h, tintHsv.s, tintHsv.v)
        tintInt32 = Phaser.Color.packPixel(tintObj.r, tintObj.g, tintObj.b)
        device.tint = tintInt32
        return

      set_color_2: (color) ->
        color = color.data
        if _.isString(color) # e.g. '#aabbcc'
          tint32 = util.colorHexToInt32(color)

        else # number 0..10 or vector
          hue = util.vecLengthOrNum(color)
          hue = (hue % 10) / 10
          tintObj = Phaser.Color.HSVtoRGB(hue, 1, 1)
          tint32 = Phaser.Color.packPixel(tintObj.r, tintObj.g, tintObj.b)

        device.tint = tint32
        return

      resize: (amount) ->
        amount = amount.data
        factor = util.vecLengthOrNum(amount)
        device.resize(factor)
        return

      send_message: (messageName) ->
        messageNameStr = messageName.data
        device.eventManager.dispatchEvent(messageNameStr)
        return

      send_message_with_data: (messageName, messageParam) ->
        messageNameStr = messageName.data
        messageData = messageParam.data
        if messageData? and typeof messageData == 'object'
          messageData = messageData.toString()
        messageDataObj = {'messageData': messageData}
        device.eventManager.dispatchEvent(messageNameStr, messageDataObj)
        return

      wait_for_message: (messageName) ->
        messageNameStr = messageName
        machine.wait_for(messageNameStr)
        return

      get_variable: (varName) ->
        if varName not of device.variables
          device.variables[varName] = 0
        return interpreter.createPrimitive(device.variables[varName])


      # Directly using get_charon on the block definition
      # didn't let strings to be passed through messages
      get_event_message_data: ->
        nativeVal = machine.charon['event.messageData']
        unless util.isPrimitive(nativeVal)
          throw new stratego.StrategoException("charon[event.messageData] is not a primitive: #{nativeVal}")
        return interpreter.createPrimitive(nativeVal)

      set_variable: (varName, varVal) ->
        device.variables[varName.data] = varVal.data
        return

      stamp: ->
        device.camperApp().stamp(device)
        return

      clear: ->
        device.camperApp().clear()
        return

      new_vector: (direction, length) ->
        dir = direction.data
        len = length.data
        v = stratego.Vec2.newPolar(dir, len)
        util.createInterpreterBlob(interpreter, v)

      new_random_number: (min, max) ->
        min = min.data
        max = max.data + 1 # Add 1 to have min <= n <= max
        n = Math.floor(Math.random() * max) + min
        return interpreter.createPrimitive(n)

      show: ->
        device.visible = true
        return

      hide: ->
        device.visible = false
        return

      #!!! Deprecated. Remove after summer 2015
      scale: (a, b) ->
        a = a.data
        b = b.data

        bMagnitude = util.vecLengthOrNum(b)

        if a instanceof Vec2 # return a vector
          newMagnitude = a.length() * bMagnitude
          return util.createInterpreterBlob(interpreter, Vec2.newPolar(a.direction(), newMagnitude))

        else # return number
          return interpreter.createPrimitive(a * bMagnitude)

      play_sound: (name) ->
        device.camperApp().playSound(name)

      play_drum_sound_for_beats: (name, beats) ->
        device.camperApp().playDrumSoundForBeats(name, beats)

      set_tempo: (tempo) ->
        if (tempo < 0) 
          device.camperApp().tempo = 0 #Tempo can't be negative
        else if (tempo > MAX_TEMPO) #Limit tempo to a maximum defined value
          device.camperApp().tempo = MAX_TEMPO
        else 
          device.camperApp().tempo = tempo

      arithmetic: (operation, a, b) ->
        operation = operation.data
        a = a.data
        b = b.data
        util.assertContains(['ADD', 'MINUS', 'MULTIPLY', 'DIVIDE', 'POWER'], operation)

        # Calculate using just magnitudes of a, b
        _scalarMath = (operation, a, b) ->
          aMagnitude = util.vecLengthOrNum(a)
          bMagnitude = util.vecLengthOrNum(b)

          result = switch operation
            when 'ADD'          then aMagnitude + bMagnitude
            when 'MINUS'        then aMagnitude - bMagnitude
            when 'MULTIPLY'     then aMagnitude * bMagnitude
            when 'DIVIDE'       then aMagnitude / bMagnitude
            when 'POWER'        then Math.pow(aMagnitude, bMagnitude)
          result

        _vectorMath = (operation, a, b) ->
          result = switch operation
            when 'ADD'          then Vec2.newXY(a.x() + b.x(), a.y() + b.y())
            when 'MINUS'        then Vec2.newXY(a.x() - b.x(), a.y() - b.y())
            when 'MULTIPLY'     then Vec2.newXY(a.x() * b.x(), a.y() * b.y()) # This is NOT dot product. We're making things up.
            when 'DIVIDE'       then Vec2.newXY(a.x() / b.x(), a.y() / b.y())
            when 'POWER'        then Vec2.newXY(Math.pow(a.x(), b.x()), Math.pow(a.y(), b.y()))
          result

        if a instanceof Vec2 # return a vector
          if b instanceof Vec2
            # Vec2 & Vec2
            resultVector = _vectorMath(operation, a, b)
          else
            # Vec2 & number
            resultVector = Vec2.newPolar(a.direction(), _scalarMath(operation, a, b))

          return util.createInterpreterBlob(interpreter, resultVector)

        else
          # number & (number or vector)
          return interpreter.createPrimitive(_scalarMath(operation, a, b))

      # Show some text on the screen. pass `null` to clear.
      say: (msg) ->
        if msg?
          msg = msg.data
          device.showCaption(msg.toString())
        else
          device.showCaption(null)
        return

      isHidden: ->
        return interpreter.createPrimitive(not device.visible)

      isPressed: ->
        return interpreter.createPrimitive(device.isPressed())

      rotate_to: (angle) ->
        angle = angle.data
        device.angle = angle
        return

      rotate_by: (angle) ->
        angle = angle.data
        device.angle += angle
        return
    }

    for name, func of nativeFunctions
      nativeWrappedFunc = interpreter.createNativeFunction(func)
      interpreter.setProperty(scope, name, nativeWrappedFunc)

#  subinterpreterFunctions: ->
#    super().concat(
#    )

###
camper_app.coffee
###

stratego.AssetType =
  IMAGE: 'IMAGE'

class stratego.CamperApp

  constructor: (appJson, @eventManager, @camperManager, @codingStudioHost="") ->
    @_isRunning = false
    @_tiltWatcher = null
    @_background = null
    @_assets = []
    @devices = []
    @_depthGroup = null
    @tempo = DEFAULT_TEMPO
    @showGrid = false

    @_appDesc = @_deserialize(appJson)
    @_assets = @_appDesc.assets.slice()
    # @eventManager.addEventHandler('machine_stopped', @_onMachineStopped, this)
    util.mark('CamperApp')

  preload: (@game, options) ->
    @game.stage.backgroundColor = '#333333'
    @_deserializeAssets(@_appDesc)
    @_preloadSprites(options)
    @_preloadBackgrounds(options)

  _preloadSprites: (options) ->
    camperSprites = if options.editor then stratego.CAMPER_APP_SPRITES else @getDeviceKeys()
    spritesPath = "#{@codingStudioHost}slug/sprites"
    for s in camperSprites
      @game.load.image(s, "#{spritesPath}/#{s}.png")

  _preloadBackgrounds: (options) ->
    backgrounds = if options.editor then stratego.CAMPER_APP_BACKGROUNDS else [@getBackgroundKey()]
    backgroundsPath = "#{@codingStudioHost}slug/backgrounds"

    for b in backgrounds
      @game.load.image(b, "#{backgroundsPath}/#{b}.png") if b?
    @game.load.image("grid", "#{backgroundsPath}/bg-grid_white.png")

  _soundAssets: () ->
    "tada": "#{@codingStudioHost}audio/tada.mp3"
    "slide": "#{@codingStudioHost}audio/door-open.mp3"
    "pop": "#{@codingStudioHost}audio/pop.mp3"
    "crash": "#{@codingStudioHost}audio/boom.mp3"
    "boing": "#{@codingStudioHost}audio/boing.mp3"
    "alarm": "#{@codingStudioHost}audio/alarm-clock.mp3"
    "chicken": "#{@codingStudioHost}audio/chicken.mp3"
    "drop": "#{@codingStudioHost}audio/drop.mp3"
    "slap": "#{@codingStudioHost}audio/slap.mp3"
    "tape": "#{@codingStudioHost}audio/tape.mp3"
  
  #Define drum sounds apart from all the other sounds
  _drumSoundAssets: () ->
    "drum-bass": "#{@codingStudioHost}audio/drum-bass.mp3"
    "drum-bongo": "#{@codingStudioHost}audio/drum-bongo.mp3"
    "drum-claves": "#{@codingStudioHost}audio/drum-claves.mp3"
    "drum-cymbal": "#{@codingStudioHost}audio/drum-cymbal.mp3"

  create: ->
    @game.physics.startSystem(phaser.Physics.ARCADE)
    
    @game.time.desiredFps = 60

    @stampTexture = @game.add.renderTexture(2048, 1536)
    @stampSprite = @game.add.sprite(0, 0, @stampTexture)

    @_createSounds()
    @_setMachineManager()
    @setBackground(@_appDesc.backgroundKey)
    # @setBackgroundGrid()
    @_deserializeDevices(@_appDesc); @_appDesc = null  # everything in _appDesc is reconstituted now

    # ensure 4 pointers for multitouch
    morePointers = 4 - @game.input.pointers.length
    if morePointers > 0
      for [0...morePointers]
        @game.input.addPointer()

  destroy: ->
    @_tiltWatcher?.destroy(); @_tiltWatcher = null
    @_assets = null
    @_destroySounds()
    @stampTexture.destroy(); @stampTexture = null
    @stampSprite.destroy(); @stampSprite = null
    @_background?.destroy(); @_background = null
    @_depthGroup?.destroy(); @_depthGroup = null
    @_crossOriginAdjuster?.destroy(); @_crossOriginAdjuster = null
    util.unmark('CamperApp')

  _createSounds: ->
    @_sounds = {}
    for name, path of @_soundAssets()
      @_sounds[name] = new Howl({
        src: [path]
      }) 
    
    @_drumSounds = {}
    for name, path of @_drumSoundAssets()
      @_drumSounds[name] = new Howl({
        src: [path]
      }) 

  _destroySounds: ->
    if @_sounds
      sound.unload() for sound in @_sounds # Howler uses unload() instead of destroy()
    @_sounds = null

    if @_drumSounds
      sound.unload() for sound in @_drumSounds # Howler uses unload() instead of destroy()
    @_drumSounds = null

  #
  # Serialization
  #

  serialize: ->
    @cleanUnusedAssets()
    appDesc = {
      devices: @devices.map (d) -> d.serialize()
      assets: @_assets.slice()
      backgroundKey: @_backgroundKey
      showGrid: @showGrid
    }
    JSON.stringify(appDesc, null, 2)

  # Return list of keys for Sprites, i.e. assets that are not photos
  getDeviceKeys: ->
    allDeviceKeys = []
    if @_appDesc?
      allDeviceKeys = (@_appDesc.devices || []).map (d) -> d.key
    else
      allDeviceKeys = @devices.map (d) -> d.key

    isNotPhoto = (key, assets) ->
      result = !_.some(assets, (asset) -> asset.key == key)
      result

    theAssets = @_assets
    spriteKeys = _.filter(allDeviceKeys, (key) -> isNotPhoto(key, theAssets))

    _.uniq(spriteKeys)

  _getRawBackgroundKey: ->
    if @_appDesc?
      @_appDesc.backgroundKey
    else
      @_backgroundKey

  getBackgroundKey: ->
    key = @_getRawBackgroundKey()
    return key unless _.some(@_assets, (asset) -> asset.key == key)

  getPhotoBackgroundUrl: ->
    key = @_getRawBackgroundKey()
    asset = _.find(@_assets, (asset) -> asset.key == key)
    return asset.url if asset

  _deserialize: (appJson) ->
    try
      appDesc = JSON.parse(appJson)
    catch e
      throw new stratego.StrategoException('Could not deserialize JSON. Exception: ' + e)

    # Fill in any missing parts
    appDesc.devices = appDesc.devices || []
    appDesc.assets = appDesc.assets || []

    appDesc

  _deserializeAssets: (appDesc) ->
    @_crossOriginAdjuster = new stratego.CrossOriginAdjuster(@game).enable()
    for asset in appDesc.assets
      switch asset.type
        when stratego.AssetType.IMAGE
          @game.load.image(asset.key, asset.url)
        else
          console.warn('CamperApp.preload() Skipping asset because type is unknown:', asset)

  _deserializeDevices: (appDesc) ->
    for deviceDesc in appDesc.devices
      device = stratego.CamperDevice.deserialize(@game, deviceDesc, @depthGroup()['devices'])
      @devices.push(device)

      @_shrinkBoundingBox(device)

      @eventManager.dispatchEvent('deviceAdded', device: device)

  #
  # related to Construction / Creation
  #

  depthGroup: ->
    util.assertExists(@game, 'CamperApp.depthGroup')
    if not @_depthGroup?
      @_depthGroup = new stratego.DepthGroups(@game, [
        'background',
        'grid',
        'graphics', # spotlight
        'devices',
        ])
    @_depthGroup

  addDevice: (name, browserX, browserY) ->
    pos = @game.clientToWorld( x: browserX, y: browserY)
    device = new stratego.CamperDevice(@game, pos.x, pos.y, name, null, @depthGroup()['devices'])
    @devices.push(device)

    @_shrinkBoundingBox(device)

    @eventManager.dispatchEvent('deviceAdded', device: device)
    device

  setBackground: (cacheKey) ->
    if @_background?
      @_background.destroy(); @_background = null
      @_backgroundKey = null
    if cacheKey? # null == leave no background
      @_backgroundKey = cacheKey
      @_background = @game.add.image(0, 0, cacheKey, null, @depthGroup()['background'])

      if @_background.height > @_background.width
        @_rotateAndScaleBackground()
      else
        @_scaleBackground()

  setBackgroundGrid: ->
    @_backgroundGrid = @game.add.image(0, 0, 'grid', null, @depthGroup()['grid'])
    @_scaleGridBackground()

  _scaleGridBackground: ->
    if @_backgroundGrid.height > @_backgroundGrid.width
      @_backgroundGrid.height = @game.width
      @_backgroundGrid.width = @game.height
      @_backgroundGrid.angle = 90
      @_backgroundGrid.x = @game.width
    else
      @_backgroundGrid.width = @game.width
      @_backgroundGrid.height = @game.height

  toggleGrid: ->
    if not @_backgroundGrid?
      @setBackgroundGrid()
    @showGrid = !@showGrid
    @_backgroundGrid.visible = @showGrid

  _rotateAndScaleBackground: ->
    @_background.height = @game.width
    @_background.width = @game.height
    @_background.angle = 90
    @_background.x = @game.width

  _scaleBackground: ->
    @_background.width = @game.width
    @_background.height = @game.height

  _shrinkBoundingBox: (device) ->
    scale = 0.6
    device.body.width = scale * device.width
    device.body.height = scale * device.height

    leftOffset = 0.5 * (device.width - scale*device.width)
    topOffset = 0.5 * (device.height - scale*device.height)
    device.body.offset = new Phaser.Point( leftOffset, topOffset)

  _removeDevice: (device) ->
    index = @devices.indexOf(device)
    throw new Error('Stratego CamperApp Unfound Device') if index == -1
    @devices.splice(index, 1)
    @eventManager.dispatchEvent('deviceRemoved', device: device)
    device.destroy()

  addAsset: (cacheKey, assetType, url) ->
    util.assertInObject(assetType, stratego.AssetType)
    @_assets.push
      key: cacheKey
      type: assetType
      url: url

  cleanUnusedAssets: ->
    keysInUse = @devices.map (device) -> device.key
    keysInUse.push(@_backgroundKey) if @_backgroundKey?
    @_assets = @_assets.filter (asset) -> asset.key in keysInUse

  update: ->
    @game.physics.arcade.overlap(@devices, @devices, @_onCollisionDevices, ((a, b) -> !_.isEqual(a, b)), this)
    if @machineManager != undefined
      @machineManager.updateMachines() # Update all registered machines through the MachineManager

  _onCollisionDevices: (a, b) ->
    @eventManager.dispatchEvent('device_overlap', left: a, right: b )


  #
  # Running and Stopping
  #

  run: ->
    for camperDevice in @devices
      camperDevice.runCode()
    @_isRunning = true
    @eventManager.dispatchEvent('camper_app_started')

  stop: ->
    for camperDevice in @devices
      camperDevice.stopCode()
      camperDevice.reset()
    @_isRunning = false
    @eventManager.dispatchEvent('camper_app_stopped')

  isRunning: ->
    @_isRunning

  _onMachineStopped: (params) ->
    if @runningMachinesCount() <= 0
      @_isRunning = false
      @eventManager.dispatchEvent('camper_app_stopped')

  runningMachinesCount: ->
    count = 0
    if @devices?
      for d in @devices
        count += d.runningMachinesCount()
    count

  # Get Machine Manager instance when starting a new camper app
  _setMachineManager: ->
    @machineManager = stratego.MachineManager.getInstance()
    @machineManager.emptyMachines() # Empty previous machine list to make sure there are no old machines left
  #
  # Other
  #

  # Return the current reading of TiltWatcher, e.g. {x: 0.0, y:10.0, z:-10.0}
  tiltReading: ->
    if not @_tiltWatcher?
      @_tiltWatcher = new stratego.TiltWatcher(@camperManager?.devicePermissions?.tiltPermissionAsked)
      @camperManager?.devicePermissions?.tiltPermissionAsked = true
    @_tiltWatcher.currentReading

  playSound: (name) ->
    if @_sounds[name]?
      @_sounds[name].play()
    else
      console.error("playSound #{name}: Can't find a sound with that name")
  
  
  stopSound: (name) ->
    if @_sounds[name]?
      @_sounds[name].stop()
    else if @_drumSounds[name]?
      @_drumSounds[name].stop()

  playDrumSoundForBeats: (name, beats) ->
    if @_drumSounds[name]?
      beatLength = (60 / @tempo) #Duration of a single beat
      beatLength *= beats        #Play for the duration of 'beats' beats
      @_drumSounds[name].play()
      time = new Date             #beatLength is in seconds, convert it to miliseconds
      maxTime = time.getTime() + (beatLength * 1000) 
      while time.getTime() < maxTime #maxTime allowed in a beat
        time = new Date  #refresh current time
      
      if @_drumSounds[name].duration > beatLength #In the case the sound is still going, stop it as the beat finished
        @_drumSounds[name].stop() #when the time is exceeded, stop sound and continue
    else
      console.error("playDrumSoundForBeats #{name}: Can't find a sound with that name")

  stamp: (device) ->
    @stampTexture.render(device, device.position, false)

  clear: ->
    @stampTexture.clear()

###
camper_app_player.coffee
###
class stratego.CamperAppPlayer extends phaser.State

  constructor: (@appJson, @codingStudioHost) ->
    super()
    @eventManager = new stratego.EventManager()
    @camperApp = new stratego.CamperApp(@appJson, @eventManager, null, @codingStudioHost)
    util.mark('CamperAppPlayer')

  shutdown: ->
    @eventManager.destroy(); @eventManager = null
    util.unmark('CamperAppPlayer')
    super()

  preload: (game) ->
    @camperApp.preload?(game, published: true, editor: false)

  create: ->
    @_createInit()
    @camperApp.create?()
    @camperApp.run()

  update: ->
    @camperApp.update?()

  _createInit: ->
    @game.scale.scaleMode = phaser.ScaleManager.SHOW_ALL

###
camper_app_main.coffee
###

#
# Starting point for user-generated apps.
#
class stratego.CamperAppMain

  constructor: (@$gameScreenContainer, @codingStudioHost) ->
    stratego.util.assertInstanceOf(@$gameScreenContainer, jQuery)

    @runGame()
    # Are we on a mobile device?
    # if stratego.util.checkTouch() || stratego.DEBUG
    #   @runGame()
    # else
    #   stratego.util.checkGyroscope()
    #     .then (hasGyro) =>
    #       if hasGyro
    #         @runGame()
    #       else
    #         @offerToSendSms()

  runGame: ->
    $.ajax
      url: 'app.json'
      dataType: 'text'
      success: (data, textStatus, jqXHR) =>
        htmlElement = @$gameScreenContainer[0]
        @game = new phaser.Game(2048, 1536, phaser.AUTO, htmlElement)
        @game.app = this
        @appPlayer = new stratego.CamperAppPlayer(data, @codingStudioHost)

        @game.state.add('appPlayer', @appPlayer) # install main menu
        @game.state.start('appPlayer')

class stratego.TiltWatcher

  constructor: (@tiltPermissionAsked) ->
    if ( typeof( DeviceMotionEvent ) == "undefined" or typeof( DeviceMotionEvent.requestPermission ) != "function" ) 
      window.alert("This game uses tilt-sensing and will work best on a mobile device");
    else
      if !@tiltPermissionAsked
        stratego.renderModal("Permission is needed to access tilt-sensing on this device", @_clickHandler)
      else
        @_clickHandler()

    @currentReading =
      x: 0.0
      y: 0.0
      z: 0.0
    util.mark('TiltWatcher')

  _clickHandler: =>
    DeviceMotionEvent.requestPermission().then (response) => 
      if ( response == "granted" ) 
        window.addEventListener("devicemotion", @_onDeviceMotion, true)
        # console.log("Added eventListener for devicemotion")

  destroy: ->
    #window.ondevicemotion = null
    window.removeEventListener("devicemotion", @_onDeviceMotion, true)
    # console.log("Removed eventListener for devicemotion")
    util.unmark('TiltWatcher')

  _onDeviceMotion: (event) =>
    # console.log("deviceMotion event is", event)
    # event has these props:
    #   event.acceleration, with x, y, z attributes
    #   event.accelerationIncludingGravity, with x, y, z attributes
    #   event.rotationRate, with alpha, beta, gamma attributes

    # first, be sure there are actually values in the event
    if event.accelerationIncludingGravity.x != null
      switch window.orientation
        when 0
          @currentReading.x = event.accelerationIncludingGravity.x
          @currentReading.y = event.accelerationIncludingGravity.y
        when 90
          @currentReading.x = -event.accelerationIncludingGravity.y
          @currentReading.y = event.accelerationIncludingGravity.x
        when -90
          @currentReading.x = event.accelerationIncludingGravity.y
          @currentReading.y = -event.accelerationIncludingGravity.x
        when 180
          @currentReading.x = -event.accelerationIncludingGravity.x
          @currentReading.y = -event.accelerationIncludingGravity.y
      @currentReading.z = event.accelerationIncludingGravity.z

window.stratego = window.stratego or {}

# https://gist.github.com/xdissent/d20bbdd57ca16b3d86b5
class stratego.StrategoError
  constructor: (message) ->
    @name = @constructor.name
    @message = message
    # @stack = (new Error).stack

  # new Error
  # @::constructor = @

# NETWORK

class stratego.ApiResponseError extends stratego.StrategoError
  constructor: (message="The server returned an error.") ->
    super(message)

class stratego.WifiError extends stratego.StrategoError
  constructor: (message="Please check your wifi.") ->
    super(message)

class stratego.CancelledPhotoError extends stratego.StrategoError
  constructor: (message="The photo was cancelled.") ->
    super(message)

# SCANNING

class stratego.CancelledScanError extends stratego.StrategoError
  constructor: (message="The scan was cancelled.") ->
    super(message)

class stratego.UnrecognizedBarcodeTypeError extends stratego.StrategoError
  constructor: (message="That's not a QR code!") ->
    super(message)

class stratego.CameraPermissionError extends stratego.StrategoError
  constructor: (message="Please check camera permissions in settings.") ->
    super(message)

class stratego.Mancala


  # @getS3PostPolicy: (serverConfig) ->
  #   url = upload_policy_url(serverConfig.mancalaUrl)
  #   console.log("policy url is", url)
  #   @_postMancala(url)

  # upload_policy_url = (root_url) ->
  #   "#{root_url}/api/stratego_apps"

  # # Return a promise for JSON response from `url`
  # @_postMancala: (url) ->
  #   deferred = Q.defer()
  #   xhr = new XMLHttpRequest()
  #   xhr.open("POST", url, true)
  #   xhr.onreadystatechange = () ->
  #     if(xhr.readyState == 4)
  #       if(xhr.status == 200)
  #         deferred.resolve( JSON.parse( xhr.responseText ) )
  #       else
  #         deferred.reject( new Error(xhr.statusText) )
  #   xhr.send()
  #   deferred.promise

  @getCamper: (camper_id, serverConfig, store) ->
    deferred = Q.defer()
    query = """
      query {
        currentCamper {
          id
          firstName
          lastName
          largePhotoUrl
          strategoProgresses {
            id
            level
          }
          strategoApps {
            icon
            shared
            id
            slot
            source
            state
            title
            parent {
              id
            }
          }
        }
      }
    """
    variables = {}

    stratego.Mancala.executeGraphqlQuery(query, variables, serverConfig)
      .then ( response ) =>
        camper = stratego.Mancala.transform_graphql_camper(response)
        deferred.resolve( store.sync(camper) )
      .catch (e) =>
        console.log("Caught this error: ", e)
        deferred.reject(e)

    deferred.promise

  # Return a promise for JSON response from `url`
  # @_postMancala: (url) ->
  #   deferred = Q.defer()
  #   xhr = new XMLHttpRequest()
  #   xhr.open("POST", url, true)
  #   xhr.onreadystatechange = () ->
  #     if(xhr.readyState == 4)
  #       if(xhr.status == 200)
  #         deferred.resolve( JSON.parse( xhr.responseText ) )
  #       else
  #         deferred.reject( new Error(xhr.statusText) )
  #   xhr.send()
  #   deferred.promise

  @getS3PostPolicy: (camperId, uploadType, serverConfig, contentType="image/jpeg") ->
    query = """
      query uploadPolicy($camperId: ID, $uploadType: String, $contentType: String)
      {
        uploadPolicy(camperId: $camperId,
                     uploadType: $uploadType,
                     contentType: $contentType) {
          fields
          postUrl
        }
      }
    """
    variables =
      camperId: camperId
      uploadType: uploadType
      contentType: contentType

    console.log("gettingS3PostPolicy with this query and variables", query, variables)
    result = await stratego.Mancala.executeGraphqlQuery(query, variables, serverConfig)
    console.log("s3PostPolicy is", result.data.uploadPolicy)
    console.log("s3PostPolicy policy is", result.data.uploadPolicy.fields.policy)
    result.data.uploadPolicy

  @uploadSprite: (imageData, photoType, camperId, serverConfig) ->
    stratego.Mancala.getS3PostPolicy(camperId, "StrategoSprite", serverConfig)
    .then (policy) ->
      s3RelativePath = "#{photoType}.jpg"
      stratego.S3Manager.uploadBase64File(imageData, s3RelativePath, policy)

  @registerAsset: (camperId, assetUrl, serverConfig) ->
    query = """
      mutation ( $camperId: ID!, $input: CreateStrategoSpriteInput!)
      {
        createStrategoSprite(
          camperId: $camperId,
          input: $input
        ) {
          errors {
            path
            message
          }
        }
      }
    """
    variables =
      camperId: camperId
      input:
        sprite: assetUrl

    stratego.Mancala.executeGraphqlQuery(query, variables, serverConfig)
      .then (response) =>
        console.log("Got this response", response)


  # @registerAsset: (camperId, assetUrl, serverConfig) ->
  #   console.log("In old mancala.registerAsset with assetUrl:", assetUrl)
  #   promise = Q(
  #     $.ajax
  #       method: 'POST'
  #       url: register_asset_url(camperId, serverConfig)
  #       data:
  #         sprite: assetUrl
  #   )
  #   promise

  @sendGameProgress: (camperId, levelName, serverConfig) ->
    query = """
      mutation ( $camperId: ID!, $input: CreateStrategoProgressInput!)
      {
        createStrategoProgress (
          camperId: $camperId,
          input: $input
        ) {
          errors {
            path
            message
          }
          camper {
            id
            strategoProgresses {
              id
              level
            }
          }
        }
      }
    """

    variables =
      camperId: camperId
      input:
        level: levelName

    stratego.Mancala.executeGraphqlQuery(query, variables, serverConfig)
      .then (response) =>
        response.data.createStrategoProgress.camper
      .catch (e) =>
        console.log("Caught this error: ", e)
        deferred.reject(e)

  @saveApp: (app, serverConfig, store) ->
    query = """
      mutation ( $id: ID!, $input: UpdateStrategoAppInput!)
      {
        updateStrategoApp (
          id: $id,
          input: $input
        ) {
          errors {
            path
            message
          }
          app {
            id
            source
            state
            slot
            icon
            title
          }
        }
      }
    """
    variables =
      id: app.id
      input:
        slot: app.slot
        title: app.title
        icon: app.icon
        source: app.source


    deferred = Q.defer()
    stratego.Mancala.executeGraphqlQuery(query, variables, serverConfig)
      .then (response) =>
        updatedApp = stratego.Mancala.transform_graphql_app(response.data.updateStrategoApp.app)
        deferred.resolve( store.sync(updatedApp))
      .catch (e) =>
        console.log("Caught this error: ", e)
        deferred.reject(e)
    deferred.promise

  @shareApp: (appId, friendId, serverConfig, store) ->
    query = """
      mutation ( $id: ID!, $input: ShareStrategoAppInput!)
      {
        shareStrategoApp (
          id: $id,
          input: $input
        ) {
          errors {
            path
            message
          }
          sharedApp {
            id
            state
          }
        }
      }
    """

    variables =
      id: appId
      input:
        recipientId: friendId

    deferred = Q.defer()
    stratego.Mancala.executeGraphqlQuery(query, variables, serverConfig)
      .then (response) =>
        app = stratego.Mancala.transform_graphql_app(response.data.shareStrategoApp.sharedApp)
        deferred.resolve( store.sync(app) )
      .catch (e) =>
        console.log("Caught this error: ", e)
        deferred.reject(e)
    deferred.promise

  @copyApp: (appId, serverConfig, store) ->
    query = """
      mutation ( $id: ID!)
      {
        duplicateStrategoApp (
          id: $id,
        ) {
          errors {
            path
            message
          }
          duplicatedApp {
            id
            state
            icon
            source
            title
          }
        }
      }
    """

    variables =
      id: appId

    deferred = Q.defer()
    stratego.Mancala.executeGraphqlQuery(query, variables, serverConfig)
      .then (response) =>
        app = stratego.Mancala.transform_graphql_app(response.data.duplicateStrategoApp.duplicatedApp)
        deferred.resolve( store.sync(app) )
      .catch (e) =>
        console.log("Caught this error: ", e)
        deferred.reject(e)
    deferred.promise

  @deleteApp: (appId, serverConfig, store) ->
    query = """
      mutation ( $id: ID!)
      {
        deleteStrategoApp (
          id: $id,
        ) {
          errors {
            path
            message
          }
          app {
            id
            source
            state
          }
        }
      }
    """

    variables =
      id: appId

    deferred = Q.defer()
    stratego.Mancala.executeGraphqlQuery(query, variables, serverConfig)
      .then (response) =>
        app = stratego.Mancala.transform_graphql_app(response.data.deleteStrategoApp.app)
        deferred.resolve( store.sync(app) )
      .catch (e) =>
        console.log("Caught this error: ", e)
        deferred.reject(e)
    deferred.promise

  @createApp: (camperId, app, serverConfig, store) ->
    query = """
      mutation ( $camperId: ID!, $input: CreateStrategoAppInput!)
      {
        createStrategoApp (
          camperId: $camperId,
          input: $input
        ) {
          errors {
            path
            message
          }
          app {
            id
            source
            state
          }
        }
      }
    """
    variables =
      camperId: camperId
      input:
        source: app.data.attributes.source

    deferred = Q.defer()
    stratego.Mancala.executeGraphqlQuery(query, variables, serverConfig)
      .then (response) =>
        app = stratego.Mancala.transform_graphql_app(response.data.createStrategoApp.app)
        deferred.resolve( store.sync(app) )
      .catch (e) =>
        console.log("Caught this error: ", e)
        deferred.reject(e)

    deferred.promise


  # @sendGameProgress: (camperId, levelName, serverConfig) ->
  #   deferred = Q.defer()
  #   xhr = new XMLHttpRequest()
  #   xhr.open("POST", progress_url(serverConfig.mancalaUrl, camperId), true)
  #   xhr.onreadystatechange = ->
  #     if(xhr.readyState == 4)
  #       if(200 <= xhr.status < 300)
  #         deferred.resolve( JSON.parse(xhr.responseText) )
  #       else
  #         deferred.reject( new Error(xhr.statusText) )
  #   fd = new FormData()
  #   fd.append('level', levelName)
  #   xhr.send(fd)
  #   deferred.promise

  @transform_graphql_camper = (response) ->
    data = response.data.currentCamper
    apps = data.strategoApps.map (app) -> {id: app.id, type: "camper_apps"}
    apps_with_attributes = data.strategoApps.map (app) -> {id: app.id, type: "camper_apps", attributes: app}
    progresses = data.strategoProgresses.map (progress) -> {id: progress.id, type: "stratego_progresses"}
    progresses_with_attributes = data.strategoProgresses.map (progress) -> {id: progress.id, type: "stratego_progresses", attributes: progress}

    formatted_camper =
      included: apps_with_attributes.concat(progresses_with_attributes)
      data:
        id: data.id
        type: "campers"
        attributes:
          first_name: data.firstName
          last_name: data.lastName
          photo_url_large: data.largePhotoUrl
        relationships:
          apps:
            data: apps
          stratego_progresses:
            data: progresses

    formatted_camper

  @transform_graphql_app = (data) ->
    app =
      data:
        id: data.id
        type: "camper_apps"
        attributes:
          slot: data.slot
          state: data.state
          source: data.source
          title: data.title
          icon: data.icon
        relationships:
          camper: {}
          parent: {}

    app

  @executeGraphqlQuery: (query, variables, serverConfig) ->
    body =
      query: query
      variables: variables

    deferred = Q.defer()
    xhr = new XMLHttpRequest()
    url = serverConfig.mancalaUrl + '/graphql'
    xhr.open("POST", url, true)
    xhr.setRequestHeader('Authorization', "Bearer #{serverConfig.mancalaToken}")
    xhr.setRequestHeader('Content-Type', 'application/json')
    xhr.onreadystatechange = ->
      if(xhr.readyState == 4)
        if(200 <= xhr.status < 300)
          json = JSON.parse(xhr.responseText)
          if json.errors && json.errors.length > 0
            messages = (error.message for error in json.errors)
            deferred.reject( new Error(messages.join("\r\n")))
          else
            deferred.resolve(JSON.parse(xhr.responseText))
        else if xhr.status == 0
          deferred.reject( new Error(xhr.statusText) )
        else
          deferred.reject( new Error(xhr.statusText) )

    xhr.send(JSON.stringify(body))
    deferred.promise


class stratego.UnoApi
  @createFile: (camper, camperAppUrl, metadata, serverConfig) ->
    console.info('UnoApi.createFile', camper.id, camperAppUrl) if stratego.DEBUG
    query = """
      mutation (
        $mancalaCamperId: ID,
        $input: CreateFileInput!
      ) {
        createFile (
          mancalaCamperId: $mancalaCamperId,
          input: $input
        ) {
          id
        }
      }
    """

    camperId = camper.id
    locationId = camper.checked_in_attendance?.location_id
    title = metadata.appTitle
    url = camperAppUrl.replace(".s3-accelerate.amazonaws.com", ".s3.amazonaws.com")

    body =
      query: query
      variables:
        mancalaCamperId: camperId
        input:
          title: title
          studio: 'coding'
          activity: 'coding'
          app_name: 'Stratego'
          content_type: 'text/html'
          location: locationId
          url: url
          metadata: metadata

    deferred = Q.defer()
    xhr = new XMLHttpRequest()
    url = serverConfig.unoUrl + '/graphql'
    xhr.open("POST", url, true)
    xhr.setRequestHeader('Authorization', "Bearer #{serverConfig.unoToken}")
    xhr.setRequestHeader('Content-Type', 'application/json')
    xhr.onreadystatechange = ->
      if(xhr.readyState == 4)
        if(200 <= xhr.status < 300)
          deferred.resolve(JSON.parse(xhr.responseText))
        else if xhr.status == 0
          deferred.reject( new Error(xhr.statusText) )
        else
          console.error("XHR POST to #{url} failed with status \"#{xhr.statusText}\"", xhr)
          deferred.reject( new stratego.ApiResponseError("There was a problem! (#{xhr.statusText})") )

    xhr.send(JSON.stringify(body))
    deferred.promise

###
file_manager.coffee
###


class stratego.FileManager
  # See here for some info on this File api:
  #   http://www.html5rocks.com/en/tutorials/file/dndfiles/

  @mimeType: (file_name) ->
    ext = file_name.substr( file_name.lastIndexOf('.')+ 1 ).toLowerCase()
    {
      html: 'text/html'
      # json: 'text/json'
      json: 'application/json'
      png: 'image/png'
      jpg: 'image/jpeg'
      jpeg: 'image/jpeg'
      mp3: 'audio/mp3'
      js: 'application/javascript'
      map: 'text/plain'
      coffee: 'application/coffeescript'
    }[ext] || 'text/plain'

  @requestFileSystem: (type) ->
    type = type || window.TEMPORARY
    deferred = Q.defer()
    requestFileSystem  = window.requestFileSystem || window.webkitRequestFileSystem
    requestFileSystem(type, 1024*1024, deferred.resolve, deferred.reject )
    deferred.promise

  @getFileEntry: (fs, filename, opts) ->
    deferred = Q.defer()
    fs.root.getFile(filename, opts || {}, deferred.resolve, deferred.reject)
    deferred.promise

  # Returns promise for a File, i.e. it's name, size, mimetype
  @getFile: (fileEntry) ->
    util.assertInstanceOf(fileEntry, FileEntry)
    deferred = Q.defer()
    fileEntry.file( deferred.resolve, deferred.reject )
    deferred.promise

  # Returns promise for the contents of 'file'.
  # https://github.com/apache/cordova-plugin-file
  @readFile: (file) ->
    console.info('FileManager.readFile', file.localURL) if stratego.DEBUG
    util.assertInstanceOf(file, File, 'FileManager.readFile')
    deferred = Q.defer()
    reader = new FileReader()

    # debug only
    reader.onloadstart = (event) ->
      console.info('FileManager.readFile onloadstart', event) if stratego.DEBUG

    # FIXME: Attempting to handle failed upload issue, where `onloadend` callback
    # does not fire. Not sure if this handler is redundant vs `onloadend` called
    # with an `event.target.error`.
    reader.onerror = (event) ->
      console.error('FileManager.readFile onerror', event, file)
      deferred.reject(event.target.error)

    # FIXME: Also attempting to handle failed upload issue. We don't call this,
    # but maybe something else does?
    reader.onabort = (event) ->
      console.error('FileManager.readFile onabort', event)
      deferred.reject(event)

    # FIXME: sometimes this event never fires, leaving the promise unresolved/unrejected
    reader.onloadend = (event) ->
      error = event.target.error
      if error
        console.error('FileManager.readFile() onloadend ERROR', file.localURL, 'error=', error)
        deferred.reject(error)
      else
        console.info('FileManager.readFile onloadend', file.localURL) if stratego.DEBUG
        fileContents = event.target.result
        deferred.resolve(fileContents)

    reader.readAsArrayBuffer(file)
    deferred.promise

  # Returns promise for contents of 'file'. Result will be a data url.
  @readFileAsDataURL: (file) ->
    util.assertInstanceOf(file, File, 'FileManager.readFileAsDataURL')
    deferred = Q.defer()
    reader = new FileReader()
    reader.onloadend = (event) ->
      error = event.target.error
      if error
        console.error('S3Manager.readFileAsDataURL() Problem reading file', file.localURL, 'error=', error)
        deferred.reject(error)
      else
        dataUrl = event.target.result
        deferred.resolve(dataUrl)
    # Note: to get this working, I needed to add in NSData+Base64.h/m from
    #       http://projectswithlove.com/projects/NSData_Base64.zip
    # and fix it for Automatic Reference Counting by removing the [autorelease]
    reader.readAsDataURL(file)
    deferred.promise

  @createReader: (fileEntry) ->
    Q.fcall( fileEntry.createReader() )

  @createWriter: (fileEntry) ->
    deferred = Q.defer()
    fileEntry.createWriter( deferred.resolve, deferred.reject )
    deferred.promise

  @getEntryTraverser: (visitor) ->
    (entry) ->
      visitor(entry)
      .then( ->
        if(entry.isDirectory)
          reader = entry.createReader()
          stratego.FileManager.childEntries(reader)
          .then( (entries) ->
            traverse = stratego.FileManager.getEntryTraverser(visitor)
            traverse(entry) for entry in entries
          )
        else
          Q(undefined)
      )
      .done()

  # Recursively search `fileEntry` and resolve to array FileEntry for every file.
  @childEntriesDeep: (fileEntry) ->

    _processOneEntry = (entry) ->
      if entry.isFile
        return Q([entry])

      else # is directory
        reader = entry.createReader()
        stratego.FileManager.childEntries(reader)
          .then (listOfEntries) ->
            Q.all(_processOneEntry(e) for e in listOfEntries)
          .then (listOfPromises) ->
            promise.valueOf() for promise in _.flatten(listOfPromises)

    return _processOneEntry(fileEntry)


  # Resolves to array of FileEntries, one for each file contained within directory
  # that 'reader' was created from. This is not recursive.
  @childEntries: (reader) ->
    deferred = Q.defer()

    entries = []
    readOneChunk = ->
      reader.readEntries( (results) ->
        if results.length
          entries = entries.concat(results)
          readOneChunk() # any more results?
        else
          deferred.resolve(entries.sort())
      , deferred.reject )

    readOneChunk()

    deferred.promise

  # returns fileEntry
  @resolveLocalFileSystemURL: (path) ->
    deferred = Q.defer()
    window.resolveLocalFileSystemURL( path, deferred.resolve, deferred.reject )
    deferred.promise

  @writeFile: (filename, content, type) ->
    stratego.FilemManager.requestFileSystem(window.TEMPORARY)
    .then( (fs) =>
      stratego.FilemManager.getFileEntry(fs, filename, {create: true}) )
    .then( stratego.FilemManager.createWriter )
    .then( stratego.FilemManager.write(content, type) )

  @write: (content, type) ->
    (fileWriter) ->
      deferred = Q.defer()
      fileWriter.onwriteend = deferred.resolve
      fileWriter.onerror = deferred.reject
      blob = new Blob([content], {type: type})
      fileWriter.write(blob)
      deferred.promise

###
s3_manager.coffee
###

class stratego.S3Manager

  @replaceFilename: (key, s3_relative_path) ->
    throw "replaceFilename() should have '${filename}' in '#{key}'" if key.indexOf('${filename}') < 0
    key.replace('${filename}', s3_relative_path)

  # Posts file to S3. Returns promise resolving to URL of that file
  @postBlob: (blob, post_policy, s3_relative_path) ->
      console.log("in postBlob, s3_relative_path is", s3_relative_path)
      deferred = Q.defer()

      url = post_policy.postUrl
      #url = post_policy.post_url
      console.log("In postblob, url is", url)
      console.log("Blob is ", blob)
#      url = 'http'+post_policy.post_url.slice(5) # use http for debugging
      s3Key = stratego.S3Manager.replaceFilename(post_policy.fields.key, s3_relative_path)
      console.log("in postBlob, s3Key is", s3Key)
      console.log("in postBlob, mimeType is is", stratego.FileManager.mimeType(s3Key))

      uploadedUrl = "#{url}#{s3Key}"
      data = await blob.arrayBuffer()

      fd = new FormData()
      fd.append('key', s3Key )
      fd.append(key, post_policy.fields[key]) for key in ['AWSAccessKeyId', 'acl', 'policy', 'signature']
      fd.append('Content-Type', stratego.FileManager.mimeType(s3Key))
      fd.append('file', blob, s3Key) # 'file' must be last
      entries = fd.entries()

      xhr = new XMLHttpRequest()
      xhr.open("POST", url, true)
      xhr.onreadystatechange = ->
        console.log("In onreadystatechange")
        if(xhr.readyState == XMLHttpRequest.DONE)
          if(200 <= xhr.status < 300)
            console.log("In onreadystatechange, gonna resolve")
            deferred.resolve(uploadedUrl)
          else
            deferred.reject( new Error(xhr.statusText) )
      xhr.send(fd)
      deferred.promise

  @uploadFile: (fileContents, s3_relative_path, policy) ->
    mimeType = stratego.FileManager.mimeType(s3_relative_path)
    blob = new Blob([fileContents], {type: mimeType})
    promise = stratego.S3Manager.postBlob(blob, policy, s3_relative_path)
    promise

  @uploadBase64File: (fileContents, s3_relative_path, policy) ->
    mimeType = stratego.FileManager.mimeType(s3_relative_path)
    blob = @base64toBlob(fileContents, mimeType, 512)
    promise = stratego.S3Manager.postBlob(blob, policy, s3_relative_path)
    promise

  # http://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
  @base64toBlob: (base64data, contentType, sliceSize) ->
    contentType = contentType or ''
    sliceSize = sliceSize or 512
    byteCharacters = atob(base64data)
    byteArrays = []
    offset = 0
    while offset < byteCharacters.length
      slice = byteCharacters.slice(offset, offset + sliceSize)
      byteNumbers = new Array(slice.length)
      i = 0
      while i < slice.length
        byteNumbers[i] = slice.charCodeAt(i)
        i++
      byteArray = new Uint8Array(byteNumbers)
      byteArrays.push byteArray
      offset += sliceSize
    blob = new Blob(byteArrays, type: contentType)
    blob

window.stratego = window.stratego or {}

# imports
phaser = Phaser
util = stratego.util

class stratego.InputNintendoJumpSwipe
  SWIPE_MIN = 5
  SWIPE_MAX_INITIAL = 60
  SWIPE_MAX = 120
  SWIPE_TIME = 200 #milliseconds

  constructor: (@game, @eventManager) ->
    @init()
    util.mark('InputNintendoJumpSwipe')

  init: ->
    @pointer = null
    @pressed = false
    @active = true

    @game.input.onDown.add( @_onDown, this )
    @_moveCallback = @game.input.addMoveCallback(@_onMove, this)
    @game.input.onUp.add( @_onUp, this )

  shutdown: ->
    @pointer = null
    @game.input.onDown.removeAll( this )
    @game.input.deleteMoveCallback( @_onMove )
    @game.input.onUp.removeAll( this )
    util.unmark('InputNintendoJumpSwipe')

  activate: ->
    @active = true

  deactivate: ->
    @active = false

  _onDown: (pointer, evt) ->
    if @_inRegion(pointer)
      @pointer = pointer
      @pressed = true
      @_setPosition(pointer)
      @_start =
        x: pointer.worldX
        y: pointer.worldY
        time: @game.time.now

  _onMove: (pointer, x, y, down_state) ->
    if @pointer == pointer
      @_setPosition(pointer)
      @_considerJumping(pointer)

  _onUp: (pointer, evt) ->
    if @pointer == pointer
      @_considerJumping(pointer)
      @pressed = false
      @pointer = null

  _considerJumping: (pointer) ->
    atLeastEnoughY = @_start.y - pointer.worldY > SWIPE_MAX_INITIAL
    notTooMuchX = Math.abs( @_start.x - pointer.worldX < SWIPE_MAX_INITIAL)
    fastEnough = @game.time.now - @_start.time < SWIPE_TIME
    if atLeastEnoughY and notTooMuchX and fastEnough
      @_jump(pointer) if @active

  _boost: (length) ->
    length > 0.5 * @maxLength

  _jump: (pointer) ->
    length = Math.min(SWIPE_MAX, Math.abs( pointer.worldY - @_start.y ) )
    @maxLength = Math.max( @maxLength || SWIPE_MAX_INITIAL, length )
    @eventManager.dispatchEvent('jump', pointer.timeDown, boost: @_boost(length) )

  _setPosition: (pointer) ->
    @position =
      x: pointer.clientX
      y: pointer.clientY

  _inRegion: (pointer) ->
    pointer.x > @game.camera.width/2 and pointer.positionDown.x > @game.camera.width/2

window.stratego = window.stratego or {}

# imports
phaser = Phaser
util = stratego.util

class stratego.InputNintendoJumpTouch
  JUMP_BOOST_DELAY = 350 # milliseconds

  constructor: (@game, @eventManager) ->
    @init()
    util.mark('InputNintendoJumpTouch')

  init: ->
    @pressed = false
    @active = true

    @game.input.onDown.add( @_onDown, this )
    @game.input.onTap.add( @_onTap, this )
    @game.input.onUp.add( @_onUp, this )

  shutdown: ->
    @game.input.onDown.removeAll( this )
    @game.input.onTap.removeAll( this )
    @game.input.onUp.removeAll( this )
    util.unmark('InputNintendoJumpTouch')

  activate: ->
    @active = true

  deactivate: ->
    @active = false

  _onDown: (pointer, evt) ->
    @pressed = true if @active and @_inRegion(pointer)

  _onTap: (pointer, evt) ->
    console.log('tap', pointer, evt )

  _onUp: (pointer, evt) ->
    @pressed = false if @active and @_inRegion(pointer)

  _jump: (pointer) ->
    console.log('jump', pointer )

    wantJumpBoost = false

    jumpTimeDown = pointer.timeDown
    if not pointer.justPressed(JUMP_BOOST_DELAY)
      wantJumpBoost = true

    @eventManager.dispatchEvent('jump', jumpTimeDown, boost: wantJumpBoost )

  _inRegion: (pointer) ->
    pointer.x > @game.camera.width/2 and pointer.positionDown.x > @game.camera.width/2

window.stratego = window.stratego or {}

# imports
phaser = Phaser
util = stratego.util

class stratego.InputNintendoKeyboard
  JUMP_BOOST_DELAY = 350 # milliseconds

  constructor: (@game, @eventManager) ->
    @init()
    @touch = false
    util.mark('InputNintendoKeyboard')

  init: ->
    @moveDown = false
    @jumpDown = false
    @moveActive = true
    @jumpActive = true

    @cursors = @game.input.keyboard.createCursorKeys()

    @cursors.left.onHoldCallback = @_move
    @cursors.left.onHoldContext = this
    @cursors.left.onUp.add( @_move, this )

    @cursors.right.onHoldCallback = @_move
    @cursors.right.onHoldContext = this
    @cursors.right.onUp.add( @_move, this )

    @cursors.up.onDown.add( @_jump, this )
    @cursors.down.onDown.add( @_boost, this )

  shutdown: ->
    @cursors.left.onHoldCallback = null
    @cursors.left.onHoldContext = null
    @cursors.left.onUp.removeAll( this )

    @cursors.right.onHoldCallback = null
    @cursors.right.onHoldContext = null
    @cursors.right.onUp.removeAll( this )

    @cursors.up.onDown.removeAll( this )
    @cursors.down.onDown.removeAll( this )

    @eventManager = null
    util.unmark('InputNintendoKeyboard')

  _move: ->
    return unless @moveActive
    velocity = 0
    if @cursors.left.isDown
      velocity = -@cursors.left.duration
    else if @cursors.right.isDown
      velocity = @cursors.right.duration

    if @velocity is 0
      @eventManager.dispatchEvent('stop')
    else
      @eventManager.dispatchEvent('move', velocity)

  _jump: (e, timedown, boost) ->
    return unless @jumpActive
    timedown = timedown || @cursors.up.timeDown

    @eventManager.dispatchEvent('jump', timedown, boost: 'true' )

  _boost: (e) ->
    @_jump(e, @cursors.down.timeDown, true)

  active: (input) ->
    if input == 'move' then else
    @_sub(input).active

  deactivate: (input) ->
    active = if input == 'move' then @moveActive else @jumpActive
    active = false

  activate: (input) ->
    active = if input == 'move' then @moveActive else @jumpActive
    active = true

  pressed: (input) ->
    if input == 'move'
      return @cursors.left.isDown or @cursors.right.isDown
    else
      return @cursors.up.isDown

  position: (input) ->

window.stratego = window.stratego or {}

# imports
phaser = Phaser
util = stratego.util

class stratego.InputNintendoMoveBend
  TOUCH_SENSITIVITY = 3

  constructor: (@game, @eventManager) ->
    @init()
    util.mark('InputNintendoMoveBend')

  init: ->
    @pointer = null
    @pressed = false
    @active = true

    @game.input.onDown.add( @_onDown, this )
    @_moveCallback = @game.input.addMoveCallback(@_onMove, this)
    @game.input.onUp.add( @_onUp, this )

  shutdown: ->
    @pointer = null
    @game.input.onDown.removeAll( this )
    @game.input.deleteMoveCallback( @_onMove )
    @game.input.onUp.removeAll( this )
    util.unmark('InputNintendoMoveBend')

  activate: ->
    @active = true

  deactivate: ->
    @active = false

  _onDown: (pointer, evt) ->
    if @_inRegion(pointer)
      @pointer = pointer
      @pressed = true
      @_setPosition(pointer)

  _onMove: (pointer, x, y, down_state) ->
    if @pointer == pointer
      if @_inRegion(pointer)
        @_setPosition(pointer)
        if @active
          velocity = (pointer.x - pointer.positionDown.x) * TOUCH_SENSITIVITY
          @eventManager.dispatchEvent('move', velocity)
      else
        @_onUp(pointer)

  _onUp: (pointer, evt) ->
    if @pointer == pointer
      @eventManager.dispatchEvent('stop') if @active
      @pressed = false
      @pointer = null

  _setPosition: (pointer) ->
    @position =
      x: pointer.clientX
      y: pointer.clientY

  _inRegion: (pointer) ->
    pointer.positionDown.x < @game.camera.width/2

window.stratego = window.stratego or {}

# imports
phaser = Phaser
util = stratego.util

stratego.InputNintendoSubd = (JumpController, MoveController) ->
  class
    constructor: (@game, @eventManager) ->
      @init()
      @touch = true
      @touchFeedback = true
      util.mark('InputNintendoSubd')

    init: ->
      @jump = new JumpController(@game, @eventManager)
      @move = new MoveController(@game, @eventManager)

    shutdown: ->
      @jump.shutdown() if @jump
      @jump = null

      @move.shutdown() if @move
      @move = null
      util.unmark('InputNintendoSubd')

    active: (input) ->
      @_sub(input).active

    deactivate: (input) ->
      @_sub(input).deactivate()

    activate: (input) ->
      @_sub(input).activate()

    pressed: (input) ->
      @_sub(input).pressed

    position: (input) ->
      @_sub(input).position

    _sub: (input) ->
      if input == 'jump' then @jump else @move

window.stratego = window.stratego or {}

# imports
phaser = Phaser
util = stratego.util

stratego.InputNintendoSwipe =
  stratego.InputNintendoSubd(
    stratego.InputNintendoJumpSwipe,
    stratego.InputNintendoMoveBend
  )

window.stratego = window.stratego or {}

# imports

stratego.InputNintendoTouch =
  stratego.InputNintendoSubd(
    stratego.InputNintendoJumpTouch,
    stratego.InputNintendoMoveBend
  )

window.stratego = window.stratego or {}

stratego.drawSpotlight = (gfx, focusObj) ->
  [spotlightX, spotlightY] = stratego.spotlightCenter(focusObj)
  diameter = stratego.spotlightDiameter(focusObj)
  gfx.beginFill(0xffffff, 0.5)
  gfx.drawCircle(spotlightX, spotlightY, diameter)
  gfx.endFill()

stratego.spotlightCenter = (focusObj) ->
  spotlightX = (focusObj.left + focusObj.right) / 2
  spotlightY = (focusObj.top + focusObj.bottom) / 2
  [spotlightX, spotlightY]

stratego.spotlightDiameter = (focusObj) ->
  diameter = Math.max(focusObj.width, focusObj.height)
  diameter += Math.max(diameter*0.2, 128)
  diameter
  

###
bulletins.coffee
###

# Show errors on screen to help diagnosing problems.
class stratego.Bulletins

  @_defaultInstance: null

  @destroy: ->
    stratego.Bulletins._defaultInstance?.destroy()
    stratego.Bulletins._defaultInstance = null

  @error: (args...) ->
    stratego.Bulletins._defaultInstance.error(args...)


  # Create an instance that knows about our game, so we can call it elsewhere
  constructor: (@_game) ->
    stratego.Bulletins._defaultInstance = this
    @_textArea = null
    @_fadeOutTween = null
    util.mark('Bulletins')

  destroy: ->
    @_textArea.destroy() ; @_textArea = null
    util.unmark('Bulletins')

  textArea: ->
    if not @_textArea?
      style =
        fill: '#f00'
        font: 'normal 40px Arial'
        wordWrap: true
        wordWrapWidth: @_game.width * 0.8
        align: 'right'
      @_textArea = new Phaser.Text(@_game,
        @_game.width * 0.87, @_game.height * 0.005, '', style)
      @_textArea.anchor = new Phaser.Point(1.0, 0.0)
      @_game.stage.addChild(@_textArea)
    @_textArea

  error: (args...) ->
    msg = args.join(' ')
    console.error("Bulletin: #{msg}")
    @textArea().text += '\n' + msg
    @_visibleForAWhile()
  
  _visibleForAWhile: ->
    @textArea().alpha = 1.0

    if @_fadeOutTween?
      @_fadeOutTween.stop()
    DURATION = 20000
    DELAY = 10000 # wait before fading
    @_fadeOutTween = @_game.add.tween(@textArea())
    @_fadeOutTween.to( { alpha: 0 }, DURATION, "Linear", true, DELAY)
    @_fadeOutTween.onComplete.add(@clear, this)

  clear: ->
    @textArea().text = ''
    @_fadeOutTween = null
    
    


###
camera.coffee
###

class stratego.Camera

  @takePhoto: (previewRect, photoType) ->
    if photoType == 'sprite'
      isFacingUser = true
    else
      isFacingUser = false

    promise = stratego.renderCamera(previewRect.width, previewRect.height, isFacingUser)
    return promise

  # @_buildCameraOptions: (cam, previewRect, photoType) ->
  #   direction = allowEdit = null

  #   if photoType == 'sprite'
  #     direction = cam.Direction.FRONT
  #     allowEdit = true
  #   else
  #     direction = cam.Direction.BACK
  #     allowEdit = false

  #   destinationType: cam.DestinationType.DATA_URL
  #   cameraDirection: direction
  #   correctOrientation: true
  #   targetWidth: previewRect.width
  #   targetHeight: previewRect.height
  #   allowEdit: allowEdit

  @takePhotoAndUpload: (previewRect, camperId, phaserCache, photoType, serverConfig) ->
    cacheKey = "PHOTO-#{photoType}-#{util.randomId()}"

    @takePhoto(previewRect, photoType)
      .then (imageData) ->
        ActivityIndicator?.show('saving photo...')

        # Strip meta data from camera image data
        imageData = imageData.substring(imageData.indexOf(',') + 1)

        # Upload to S3
        stratego.Mancala.uploadSprite(imageData, photoType, camperId, serverConfig).then (imageUrlAtS3) ->
          # Tell mancala about asset
          stratego.Mancala.registerAsset(camperId, imageUrlAtS3, serverConfig)
            .then ->
              # Shove image into phaser's cache
              dataUrl = "data:image/jpeg;base64,#{imageData}"
              imageElement = new Image()
              imageElement.src = dataUrl
              util.sleepPromise(100).then -> # without this delay, sprites are black

                # Add to phaser cache
                phaserCache.addImage(cacheKey, 'unused', imageElement)

          .then -> Q([imageUrlAtS3, cacheKey])
      .finally -> ActivityIndicator?.hide()

###
blockly.coffee

Blockly improvements
###

if Blockly?

  Blockly.Msg.MATH_RANDOM_INT_TITLE = 'random %1 to %2'

  Blockly.FieldTextInput.prototype.showEditor_ = (opt_quietInput) ->
    quietInput = opt_quietInput || false

    Blockly.WidgetDiv.show(this, @sourceBlock_.RTL, @widgetDispose_())
    div = Blockly.WidgetDiv.DIV
    # Create the input.
    htmlInput = goog.dom.createDom('input', 'blocklyHtmlInput')
    htmlInput.setAttribute('spellcheck', this.spellcheck_)
    if @name == 'NUM'
      htmlInput.setAttribute('type', 'number')  # better keyboard for numbers on iOS
      htmlInput.setAttribute('pattern', '\\d*')

    Blockly.FieldTextInput.htmlInput_ = htmlInput
    div.appendChild(htmlInput)

    htmlInput.value = htmlInput.defaultValue = @text_
    htmlInput.oldValue_ = null
    @validate_()
    @resizeEditor_()
    if (!quietInput)
      htmlInput.focus()
      if (goog.userAgent.IPAD || goog.userAgent.IPHONE)
        # input.select() does't work on mobile safari
        htmlInput.setSelectionRange(0, 9999)
      else
        htmlInput.select()

    # Bind to keydown -- trap Enter without IME and Esc to hide.
    htmlInput.onKeyDownWrapper_ =
        Blockly.bindEvent_(htmlInput, 'keydown', this, @onHtmlInputKeyDown_)
    # Bind to keyup -- trap Enter; resize after every keystroke.
    htmlInput.onKeyUpWrapper_ =
        Blockly.bindEvent_(htmlInput, 'keyup', this, @onHtmlInputChange_)
    # Bind to keyPress -- repeatedly resize when holding down a key.
    htmlInput.onKeyPressWrapper_ =
        Blockly.bindEvent_(htmlInput, 'keypress', this, @onHtmlInputChange_)
    workspaceSvg = @sourceBlock_.workspace.getCanvas()
    htmlInput.onWorkspaceChangeWrapper_ =
        Blockly.bindEvent_(workspaceSvg, 'blocklyWorkspaceChange', this, @resizeEditor_)

  # allow setting exact colors with '#ffeecc'
  _oldMakeColour = Blockly.makeColour
  Blockly.makeColour = (hueOrColor) ->
    if _.isString(hueOrColor)
      return goog.color.normalizeHex(hueOrColor)
    else
      return _oldMakeColour(hueOrColor)

  # fix: Pinch gesture causes error:
  #     Invalid value for <rect> attribute y="NaN"
  _oldBlocklyOnMouseMove_ = Blockly.onMouseMove_
  Blockly.onMouseMove_ = (event) ->
    return if event.touches?.length >= 2
    _oldBlocklyOnMouseMove_.call(this, event)


###
highlighter.coffee
###
window.stratego = window.stratego or {}

# imports
util = stratego.util


class stratego.Highlighter
  constructor: (@blocklyEditor) ->
    util.mark('Highlighter')

  open: (@device) ->
    @blocklyEditor._eventManager.addEventHandler('device_highlight_block', @_onHighlightBlock, this)
    @blocklyEditor._eventManager.addEventHandler('device_highlight_clear', @clear, this)
    @blocklyEditor._eventManager.addEventHandler('machine_stopped', @clear, this)
    @_workspace()?.traceOn(true)

  destroy: ->
    @device = null
    @blocklyEditor = null
    util.unmark('Highlighter')

  _workspace: ->
    @blocklyEditor.mainWorkspace

  close: ->
    @blocklyEditor._eventManager?.removeAllEventHandlers(this)

  _onHighlightBlock: (params) ->
    return unless @_workspace()?

    device = params.device
    blockName = params.id
    if @device == device
      block = @_namedBlock(blockName)
      @highlight(block) if block

  _namedBlock: (blockName) ->
    for b in @_workspace().getAllBlocks()
      if b.data == blockName
        return b
    return null

  highlight: (block) ->
    @_workspace().traceOn(true)
    @_workspace().highlightBlock(block.id)

  clear: (block) ->
    @_workspace()?.highlightBlock(0)

  @ensureUniqueNames: (workspace) ->
    names = {}
    for b in workspace.getAllBlocks()
      if (not b.data?) or (b.data of names) # no name or duplicate name?
        b.data = util.randomId()
      names[b.data] = b

  @blockName: (block) ->
    block.data

  @replaceIdsWithNames: (code, workspace) ->
    result = code.replace /highlightBlock\('(\d*)'\)/g, (match, p1, offset, string) ->
      "highlightBlock('#{workspace.getBlockById(p1).data}')"
    result



    


###
blockly_editor.coffee
###
window.stratego = window.stratego or {}

# imports
util = stratego.util

class stratego.BlocklyEditor

  # editorElement = the <div> that should be shown and hidden when the editor is opened
  # blocklyContainer = the <div> where Blockly's canvas will be inserted
  constructor: (@editorElement, @blocklyContainer, blockDescriptions, @shouldDelayEditorUpdate) ->
    @_injected = false
    @_onChangeBlocklyHandle = null
    @_lastResetEditabilityState = {device:null, isEditable: null}
    @_lastOrientation = util.orientation(window.innerWidth, window.innerHeight)

    @_configureBlocks(blockDescriptions)
    window.addEventListener("resize", @_onResize, false)
    @_highlight = new stratego.Highlighter(this)
    util.mark('BlocklyEditor')

  _configureBlocks: (blockDescriptions) ->
    Blockly.JavaScript.STATEMENT_PREFIX = "highlightBlock(%1);\n"
    Blockly.JavaScript.addReservedWords("highlightBlock")

    # override blockly colors
    Blockly.Blocks.variables.HUE = HUE_ADVANCED
    Blockly.Blocks.loops.HUE = HUE_FLOW
    Blockly.Blocks.math.HUE = HUE_MATH
    Blockly.Blocks.logic.HUE = HUE_LOGIC
    Blockly.Blocks.texts.HUE = HUE_APPEARANCE
    Blockly.Blocks.colour.HUE = HUE_APPEARANCE
    Blockly.Scrollbar.scrollbarThickness = 5; # 5 makes them disappear. —Winston

    for cmd, def of blockDescriptions
      Blockly.Blocks[cmd] = def
      Blockly.JavaScript[cmd] = def.code

  destroy: ->
    @_shutdown()
    window.removeEventListener("resize", @_onResize)
    @_highlight?.destroy()
    @_highlight = null
    @_lastResetEditabilityState = null
    @_lastOrientation = null
    util.unmark('BlocklyEditor')

  _shutdown: ->
    if @_onChangeBlocklyHandle
      @mainWorkspace?.removeChangeListener(@_onChangeBlocklyHandle)
    @_onChangeBlocklyHandle = null
    @_clearWorkspace()
    @device = null
    @_uninject()

  # Show a device's code in the editor
  open: (device) ->
    return if @device == device
    @_shutdown()
    @device = device
    @_eventManager = device.eventManager
    $(@editorElement).toggleClass('showing-device', device?)
    @_updateBlockly()
    @_eventManager.addEventHandler('device_editability_changed', @_onDeviceEditabilityChanged, this)
    @_eventManager.addEventHandler('camper_app_started', @_onCamperAppEditabilityChanged, this)
    @_eventManager.addEventHandler('camper_app_stopped', @_onCamperAppEditabilityChanged, this)
    @_highlight.open(device)

  # Stop showing a device in the editor
  close: () ->
    return unless @device?
    $(@editorElement).toggleClass('showing-device', false)
    @_clearToolbox()
    if @_eventManager? # no event manager if never opened
      @_eventManager.removeEventHandler('device_editability_changed', this)
      @_eventManager.removeEventHandler('camper_app_started', @_onCamperAppEditabilityChanged, this)
      @_eventManager.removeEventHandler('camper_app_stopped', @_onCamperAppEditabilityChanged, this)
      @_eventManager = null
    @_highlight.close()
    @_shutdown()
    @device = null

  isOpen: ->
    @device?

  isVisible: ->
    @_lastOrientation == "portrait"

  logCode: (event_name) ->
    codeJs = @constructor._workspaceToJavascript(@mainWorkspace)
    for code, i in codeJs
      console.info("The javascript for stack #{i} is:\n-------------------------")
      for line, i in code.split("\n")
        console.info("#{i} : #{line}")

  logCodeXml: ->
    xml = stratego.BlocklyEditor._workspaceToXml(@mainWorkspace)
    console.info('Code as XML: >>>\n\n', xml, '\n\n<<<')

  logApp: ->
    if not @device?
      console.info('Select a device first.')
      return
    appJson = @device.camperApp().serialize()
    appJson = appJson.replace(/\\/g, '\\\\')
    console.info('CamperApp as JSON: >>>\n\n', appJson, '\n\n<<<')

  #
  # Converting between JS and XML
  #

  # headless conversion of codeXml to JS
  @compileXml: (codeXml) ->
    workspace = new Blockly.Workspace()
    @_setWorkspaceXml(workspace, codeXml)
    stratego.Highlighter.ensureUniqueNames(workspace)
    codeJs = @_workspaceToJavascript(workspace)
    xmlWithSequentialIds = @_workspaceToXml(workspace)
    workspace.dispose()
    [codeJs, xmlWithSequentialIds]

  @_isBlockAnEventHandler: (block) ->
    util.stringStartsWith(block.type, 'stratego_when_')

  @_isBlockAFunction: (block) ->
    util.stringStartsWith(block.type, 'procedures_defnoreturn') or util.stringStartsWith(block.type, 'procedures_defreturn')

  @_workspaceToXml: (workspace) ->
    return null if not workspace
    xml = Blockly.Xml.workspaceToDom(workspace)
    xml_text = Blockly.Xml.domToText(xml)

  # Returns an array of javascript programs, one for each stack in the workspace.
  @_workspaceToJavascript: (workspace) ->
    # mostly copied from blockly/core/generator.js:workspaceToCode()
    codeJs = []
    blockStacks = workspace.getTopBlocks(true)
    for block in blockStacks
      # skip blockStacks that don't begin with event handler
      continue if not @_isBlockAnEventHandler(block) and not @_isBlockAFunction(block) # block can be either an event handler or a custom function

      code = []
      Blockly.JavaScript.init(workspace)
      line = Blockly.JavaScript.blockToCode(block)
      if (goog.isArray(line))
        # Value blocks return tuples of code and operator order.
        # Top-level blocks don't care about operator order.
        line = line[0]
      if line
        if block.outputConnection and Blockly.JavaScript.scrubNakedValue
          # This block is a naked value.  Ask the language's code generator if
          # it wants to append a semicolon, or something.
          line = Blockly.JavaScript.scrubNakedValue(line)
        code.push(line)
      code = code.join('\n')  # Blank line between each section.
      code = Blockly.JavaScript.finish(code)
      # Final scrubbing of whitespace.
      code = code.replace(/^\s+\n/, '')
      code = code.replace(/\n\s+$/, '\n')
      code = code.replace(/[ \t]+\n/g, '\n')
      code = stratego.Highlighter.replaceIdsWithNames(code, workspace)
      codeJs.push(code)
    codeJs

  @_setWorkspaceXml: (workspace, codeXml) ->
    try
      Blockly.Xml.domToWorkspace(workspace, Blockly.Xml.textToDom(codeXml))
    catch e
      console.warn('Problem parsing XML program.\nMessage:', e.toString(),
      '\n---\nException:', e,
      '\n---\nProgram:\n', codeXml,
      '\n---\nStack:\n', e.stack)
      workspace.clear()


  #
  # Updating Blockly view
  #

  _onCamperAppEditabilityChanged: (params) ->
    current = @isEditable()
    desired = @device?.isEditable() # no device == not editable
    if current != desired
      @_tryResetEditability()

  _onDeviceEditabilityChanged: (params) ->
    return if params.source != @device
    @_tryResetEditability()

  _tryResetEditability: =>
    return if not @device
    if @shouldDelayEditorUpdate?() # is game in a delay-sensitive place?
      setTimeout(@_tryResetEditability, 250)
    else
      @_resetEditability()

  _getOrientation: =>
    # https://hackernoon.com/onresize-event-broken-in-mobile-safari-d8469027bf4d
    # dimensions are 768x768 immediately after "resize" event
    if window.innerWidth == window.innerHeight
      setTimeout(@_getOrientation, 250)
    else
      newOrientation = util.orientation(window.innerWidth, window.innerHeight)
      if @_lastOrientation != newOrientation
        @_lastOrientation = newOrientation
        @_updateBlockly()

  _onResize: =>
    @_getOrientation()

  # _updateBlockly() and _resetEditability() should contain all Blockly setting changes
  # i.e. don't change anything outside of these two methods. Instead remember what needs to be
  # changed and do that update here.
  #
  # Changing blockly settings is tricky because it borks if you change things
  # when blockly has not yet been injected, or when it's not visible.
  _updateBlockly: ->
    return if not @isVisible() or not @device?

    @_resetEditability()  # first time, this initializes Blockly
    if @device.codeXml()
      @_clearWorkspace()
      stratego.BlocklyEditor._setWorkspaceXml(@mainWorkspace, @device.codeXml())
    @_onChangeBlocklyHandle = @mainWorkspace?.addChangeListener( @_onWorkspaceChange )
    blockAllowance = if @device.maxBlocks? then @device.maxBlocks else Infinity
    @mainWorkspace?.maxBlocks = blockAllowance

  _resetEditability: ->
    $(@editorElement).toggleClass('not-editable', !@device.isEditable())
    $(@editorElement).removeClass('banner-generic banner-player-nearby')
    $(@editorElement).addClass(@_readOnlyBannerCssClass(@device))
    @_updateEditorHeaderText(@device)

    if @device.readOnly
      @_clearToolbox()
    else
      @_setToolbox(@device.toolboxXml)

  isEditable: ->
    not $(@editorElement).hasClass('not-editable')

  # do we show a "moose detected" message?
  _readOnlyBannerCssClass: (device) ->
    if device.isEditable()
      result = ''
    else if device.playerNearby and not device.readOnly
      result = 'banner-player-nearby'
    else
      result = 'banner-generic'
    result

  _editorHeaderText: (device) ->
    gameState = window.codingStudio.game.state.current
    # gameState = $('html').data('levelname')
    editorText = ''

    #in workshop
    if gameState == 'app'
      if device.isEditable()
        result = 'Edit'
      else
        result = 'Code Running'
    #in game
    else
      if device.isEditable()
        result = 'Access granted. Code Unlocked.'
      else if device.playerNearby and not device.readOnly
        result = 'Moose Detected. Code Locked!'
      else
        result = 'Code Locked!'
    result

  _updateEditorHeaderText: (device) ->
    replaceText($('#editor__title'), @_editorHeaderText(device))
    # $('#editor__title').text(@_editorHeaderText(device))

  replaceText = do ->
    dummy = document.createElement('div')
    dummy.innerHTML = 'text'
    TEXT = if dummy.textContent == 'text' then 'textContent' else 'innerText'
    (elems, text) ->
      i = elems.length
      while i--
        elems[i][TEXT] = text
      return


  _clearWorkspace: ->
    @mainWorkspace?.clear()

  _inject: (toolboxXml) ->
    @mainWorkspace = Blockly.inject(@blocklyContainer,
      toolbox: toolboxXml
      grid:
        spacing: 25
        length: 0
        colour: "#fff"
        snap: true
      zoom: enabled: false
      trashcan: true
    )
    @_injected = true

  _uninject: ->
    return unless @blocklyContainer?
    while @blocklyContainer.firstChild?
      @blocklyContainer.removeChild(@blocklyContainer.firstChild)
    if @mainWorkspace?
      @mainWorkspace.dispose(); @mainWorkspace = null
    @_injected = false

  _setToolbox: (xml) ->
    xml = '<xml>\n' + xml + '\n</xml>'
    try
      unless @_injected
        @_inject(xml)
      else
        @mainWorkspace?.updateToolbox(xml)
        if not @mainWorkspace.options.languageTree? then throw 'Blockly has been corrupted.'
    catch e
      console.warn('Problem parsing this XML toolbox: >>>\n', xml, '\n<<<  Exception:', e, e.stack)

  _clearToolbox: ->
    @_setToolbox('')

  _onWorkspaceChange: =>
    if @device
      @_applyBlockLimits()
      stratego.Highlighter.ensureUniqueNames(@mainWorkspace)
      xml = stratego.BlocklyEditor._workspaceToXml(@mainWorkspace)

      if xml.indexOf('x="-') >= 0
        # Blockly sends change events very often. This x-is-negative check triggers when:
        #   (a) editor is expanding from being hidden and it's size is not quite right.
        #       The blocks get negative positions and move to upper-left. See this bug:
        #       https://trello.com/c/6ukNVS8V/658-code-blocks-move-around-when-program-is-started-stopped-and-editor-focus-changed
        #   (b) you are moving a block from the toolbox
        #       it's OK to skip the change since we'll pick it up when they set the block down.
        return # ignoring change

      @device.setCode(xml) # don't pass JS so it's regenerated with sequential IDs

  #
  # count limits for blocks in toolbox
  #

  _countBlocks: ->
    blocks = @mainWorkspace.getAllBlocks()
    count = {}
    for b in blocks
      if count[b.type]? then count[b.type]++ else count[b.type] = 1
    count

  _applyBlockLimits: () ->
    blockCount = @_countBlocks()
    if @device.limit?
      for type, maxCount of @device.limit
        if blockCount[type]? >= maxCount
          @_disableInToolbox(type)
        else
          @_enableInToolbox(type)

  _disableInToolbox: (blockType) ->
    b = @_getBlockFromToolbox(blockType)
    b.setDisabled(true) if b?

  _enableInToolbox: (blockType) ->
    b = @_getBlockFromToolbox(blockType)
    b.setDisabled(false) if b?

  _getBlockFromToolbox: (blockType) ->
    blocks = @mainWorkspace.flyout_.workspace_.getTopBlocks(false)
    for b in blocks
      return b if b.type == blockType
    return false

###
block_definitions.coffee
###


constant = (type, val) ->
  init: ->
    @setColour HUE_ADVANCED
    @appendDummyInput()
      .appendField(val)
    @setInputsInline(true)
    @setOutput(true, type)
  code: (block) ->
    ["'#{val}'", Blockly.JavaScript.ORDER_NONE]

stratego.BlockDefinitions =

  #
  # Blocks with no Device dependency
  #

  stratego_repeat:
    init: ->
      @setColour HUE_FLOW
      @appendDummyInput()
        .appendField("repeat")
        .appendField(new Blockly.FieldDropdown(window.stratego.util.generateFields(1,10)), 'TIMES')
        .appendField("times")
      @appendStatementInput('DO')
      @setPreviousStatement true
      @setNextStatement true
    code: (block) ->
      loopVar = Blockly.JavaScript.variableDB_.getDistinctName('count', Blockly.Variables.NAME_TYPE)
      times = block.getFieldValue('TIMES')
      do_code = Blockly.JavaScript.statementToCode(block, "DO")
      """
      for (var #{loopVar} = 0; #{loopVar} < #{times}; #{loopVar}++) {
        #{do_code}highlightBlock('#{stratego.Highlighter.blockName(block)}');
      }\n
      """

  stratego_repeat_forever:
    init: ->
      @setColour HUE_FLOW
      @appendDummyInput()
        .appendField("repeat forever")
      @appendStatementInput("DO")
      @setPreviousStatement(true)
    code: (block) ->
      do_code = Blockly.JavaScript.statementToCode(block, "DO")
      """
      while (true) {
        #{do_code}
      };
      """

  stratego_if:
    init: ->
      @setColour HUE_LOGIC
      @appendValueInput("IF0")
        .setCheck("Boolean")
        .appendField("if")
      @appendStatementInput("DO0")
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      condition = Blockly.JavaScript.valueToCode(block, 'IF0', Blockly.JavaScript.ORDER_NONE) || 'false'
      branch = Blockly.JavaScript.statementToCode(block, "DO0")
      "if(#{condition}) {\n #{branch}};\n"

  stratego_if_else:
    init: ->
      @setColour HUE_LOGIC
      @appendValueInput("CONDITION")
        .appendField("if")
      @appendStatementInput("DO")
      @appendStatementInput("ELSE")
        .appendField("else")
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      condition = Blockly.JavaScript.valueToCode(block, 'CONDITION', Blockly.JavaScript.ORDER_NONE) || 'false'
      doBranch = Blockly.JavaScript.statementToCode(block, "DO")
      elseBranch = Blockly.JavaScript.statementToCode(block, "ELSE")
      """if(#{condition}) {
      #{doBranch}} else {
      #{elseBranch}};
      """

   stratego_compare_same_type:
    init: ->
      @setColour(HUE_LOGIC)
      @setOutput(true)
      @appendValueInput('A')
      @appendValueInput('B')
        .appendField('=')
      @setInputsInline(true)
    code: (block) ->
      argument0 = Blockly.JavaScript.valueToCode(block, 'A', Blockly.JavaScript.ORDER_ATOMIC) || '0'
      argument1 = Blockly.JavaScript.valueToCode(block, 'B', Blockly.JavaScript.ORDER_ATOMIC) || '0'
      ["compare_same_type(#{argument0}, #{argument1})", Blockly.JavaScript.ORDER_ATOMIC]
      
  stratego_number: # based on Blockly Games pond_math_number
    init: ->
      @setColour HUE_MATH
      @appendDummyInput('DUMMY')
        .appendField(new Blockly.FieldTextInput('0', Blockly.FieldTextInput.numberValidator), 'NUM')
      @setOutput(true, 'Number')
    onchange: ->
      return if not @workspace
      if @outputConnection.targetConnection and @outputConnection.targetConnection.check_
        # Plugged in to parent.
        input = @getInput('DUMMY')
        field = @getField('NUM')
        value = field.getValue()
        if @outputConnection.targetConnection.check_.indexOf('Angle') != -1
          # Parent wants an angle.
          if field.constructor != Blockly.FieldAngle
            input.removeField('NUM')
            input.appendField(new Blockly.FieldAngle(value), 'NUM')
        else
          # Parent wants a number.
          if (field.constructor != Blockly.FieldTextInput)
            input.removeField('NUM')
            input.appendField(new Blockly.FieldTextInput(value,
                Blockly.FieldTextInput.numberValidator), 'NUM')
    code: (block) ->
      code = parseFloat(block.getFieldValue('NUM'))
      return [code, Blockly.JavaScript.ORDER_ATOMIC]

  stratego_angle: # Always an angle
    init: ->
      @setColour HUE_MATH
      @appendDummyInput('DUMMY')
        .appendField(new Blockly.FieldTextInput('0', Blockly.FieldTextInput.numberValidator), 'NUM')
      @setOutput(true, 'Number')
    onchange: ->
      return if not @workspace
      input = @getInput('DUMMY')
      field = @getField('NUM')
      value = field.getValue()
      # Parent wants an angle.
      if field.constructor != Blockly.FieldAngle
        input.removeField('NUM')
        input.appendField(new Blockly.FieldAngle(value), 'NUM')
       
    code: (block) ->
      code = parseFloat(block.getFieldValue('NUM'))
      return [code, Blockly.JavaScript.ORDER_ATOMIC]


  #
  # Device blocks
  #

  stratego_when_started:
    init: ->
      @setColour HUE_EVENT
      @appendDummyInput()
          .appendField("When started")
      @appendStatementInput('DO')
    code: (block) ->
      do_code = Blockly.JavaScript.statementToCode(block, "DO")
      """
      wait();
      #{do_code}
      """

  stratego_wait:
    init: ->
      @setColour HUE_FLOW
      @appendDummyInput()
        .appendField("wait")
      @appendValueInput('TIMES')
        .setCheck("Number")
      @appendDummyInput()
        .appendField("deciseconds")
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      loopVar = Blockly.JavaScript.variableDB_.getDistinctName('count', Blockly.Variables.NAME_TYPE)
      times = Blockly.JavaScript.valueToCode(block, 'TIMES', Blockly.JavaScript.ORDER_ATOMIC)
      """
      for (var #{loopVar} = 0; #{loopVar} < #{times}; #{loopVar}++) {
        wait();
      }\n
      """


  stratego_reset_position:
    init: ->
      @setColour HUE_MOVEMENT
      @appendDummyInput().appendField "reset position"
      @setPreviousStatement true
      @setNextStatement true
    code: (block) ->
      "reset_position();\n"


  #
  # GameDevice blocks
  #

  stratego_when_player_jump:
    init: ->
      @setColour HUE_EVENT
      @appendDummyInput()
          .appendField("When moose jumps")
      @appendStatementInput('DO')
    code: (block) ->
      do_code = Blockly.JavaScript.statementToCode(block, "DO")
      """
      while(true) {
        highlightBlock('#{block.data}');
        wait_for_jump();
      #{do_code}
      }
      """

  stratego_when_sensor_pressed:
    init: ->
      @setColour HUE_EVENT
      @appendDummyInput()
        .appendField "When button pressed"
      @appendStatementInput('DO')
    code: (block) ->
      do_code = Blockly.JavaScript.statementToCode(block, "DO")
      """
      while(true) {
        highlightBlock('#{stratego.Highlighter.blockName(block)}');
        wait_for_sensor_press();
      #{do_code}
      }
      """

  stratego_when_launcher_sensor_pressed:
    init: ->
      @setColour HUE_EVENT
      @appendDummyInput()
        .appendField "When launcher button pressed"
      @appendStatementInput('DO')
    code: (block) ->
      do_code = Blockly.JavaScript.statementToCode(block, "DO")
      """
      while(true) {
        highlightBlock('#{stratego.Highlighter.blockName(block)}');
        wait_for_launcher_sensor_press();
      #{do_code}
      }
      """

  stratego_when_player_nearby:
    init: ->
      @setColour HUE_EVENT
      @appendDummyInput()
        .appendField "When touched by a moose"
      @appendStatementInput('DO')
    code: (block) ->
      do_code = Blockly.JavaScript.statementToCode(block, "DO")
      """
      while(true) {
        highlightBlock('#{stratego.Highlighter.blockName(block)}');
        wait_for_player_nearby();
      #{do_code}
      }
      """

  stratego_move_right:
    init: ->
      @setColour HUE_MOVEMENT
      @appendDummyInput().appendField "move right"
      @setPreviousStatement true
      @setNextStatement true
    code: (block) ->
      "move_right();\n"

  stratego_move_left:
    init: ->
      @setColour HUE_MOVEMENT
      @appendDummyInput().appendField "move left"
      @setPreviousStatement true
      @setNextStatement true
    code: (block) ->
      "move_left();\n"

  stratego_glide_to:
    init: ->
      @setColour HUE_MOVEMENT
      @appendDummyInput()
          .appendField("glide to x:")
      @appendValueInput("X")
          .setCheck("Number")
      @appendDummyInput()
          .appendField("y:")
      @appendValueInput("Y")
          .setCheck("Number")
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      value_x = Blockly.JavaScript.valueToCode(block, 'X', Blockly.JavaScript.ORDER_ATOMIC)
      value_y = Blockly.JavaScript.valueToCode(block, 'Y', Blockly.JavaScript.ORDER_ATOMIC)
      "glide_to(#{value_x}, #{value_y});\n"

  stratego_glide_by:
    init: ->
      @setColour HUE_MOVEMENT
      @appendDummyInput()
          .appendField("glide by x:")
      @appendValueInput("DELTA_X")
          .setCheck("Number")
      @appendDummyInput()
          .appendField("y:")
      @appendValueInput("DELTA_Y")
          .setCheck("Number")
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      deltaX = Blockly.JavaScript.valueToCode(block, 'DELTA_X', Blockly.JavaScript.ORDER_ATOMIC)
      deltaY = Blockly.JavaScript.valueToCode(block, 'DELTA_Y', Blockly.JavaScript.ORDER_ATOMIC)
      "glide_by(#{deltaX}, #{deltaY});\n"

  stratego_glide_down:
    init: ->
      @setColour HUE_MOVEMENT
      @appendDummyInput()
        .appendField('move down')
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      "glide_down(1);\n"

  stratego_glide_up:
    init: ->
      @setColour HUE_MOVEMENT
      @appendDummyInput()
        .appendField('move up')
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      "glide_up(1);\n"

  stratego_glide_right:
    init: ->
      @setColour HUE_MOVEMENT
      @appendDummyInput()
        .appendField('move right')
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      "glide_right(1);\n"

  stratego_glide_left:
    init: ->
      @setColour HUE_MOVEMENT
      @appendDummyInput()
        .appendField('move left')
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      "glide_left(1);\n"

  #
  # Robodillos
  #

  stratego_left: constant('Direction', 'left')
  stratego_right: constant('Direction', 'right')

  stratego_face:
    init: ->
      @setColour HUE_MOVEMENT
      @appendDummyInput()
        .appendField('face')
      @appendValueInput('DIRECTION')
        .setCheck('Direction')
        # .setAlign(Blockly.ALIGN_RIGHT)
        # .appendField('direction');
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      direction = Blockly.JavaScript.valueToCode(block, 'DIRECTION', Blockly.JavaScript.ORDER_NONE)
      "face(#{direction});\n"

  stratego_drive:
    init: ->
      @setColour HUE_MOVEMENT
      @appendDummyInput()
        .appendField('drive')
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      "drive();\n"

  stratego_stop:
    init: ->
      @setColour HUE_MOVEMENT
      @appendDummyInput()
        .appendField('stop')
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      "stop();\n"


  #
  # SnowPile
  #

  stratego_explode:
    init: ->
      @setColour HUE_EVENT
      @appendDummyInput()
        .appendField('explode')
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      "explode();\n"

  #
  # Launcher
  #


  stratego_throw_projectile:
    init: ->
      @setColour HUE_MOVEMENT
      @appendDummyInput()
        .appendField("Throw projectile")
      @appendDummyInput()
        .appendField("Force")
        .appendField(new Blockly.FieldDropdown([["Weak", WEAK_FORCE], ["Medium", MEDIUM_FORCE], ["Hard", HARD_FORCE]]), "FORCE")
      @appendDummyInput()
        .appendField("Angle")
      @appendValueInput('ANGLE')
        .setCheck(['Number', 'Angle'])
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      force = block.getFieldValue('FORCE') | WEAK_FORCE #Weak throw value of 800 by default
      angle = Blockly.JavaScript.valueToCode(this, 'ANGLE', Blockly.JavaScript.ORDER_ATOMIC)
      """
      throw_projectile('#{force}', #{angle});\n
      """

  stratego_throw_projectile_explicit:
    init: ->
      @setColour HUE_MOVEMENT
      @appendDummyInput()
        .appendField("Add force")
      @appendValueInput('FORCE')
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      force = Blockly.JavaScript.valueToCode(this, 'FORCE', Blockly.JavaScript.ORDER_ATOMIC) #Weak throw value of 800 by default
      """
      throw_projectile(#{force});\n
      """

  stratego_load_projectile:
    init: ->
      @setColour HUE_MOVEMENT
      @appendDummyInput()
        .appendField("Load")
      @appendValueInput('PROJECTILE')
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      projectile = Blockly.JavaScript.valueToCode(this, 'PROJECTILE', Blockly.JavaScript.ORDER_ATOMIC)
      """
      load_projectile(#{projectile});\n
      """
  
  stratego_projectiles_dropdown_just_snowball:
    init: ->
      @setColour HUE_APPEARANCE
      @appendDummyInput()
        .appendField(new Blockly.FieldDropdown([["Snowball", stratego.PROJECTILES.SNOWBALL.toString()]]), "PROJECTILE")
        .appendField('Projectile')
      @setOutput(true)
    code: (block) ->
      key = block.getFieldValue('PROJECTILE')
      ["get_projectile(#{key})", Blockly.JavaScript.ORDER_ATOMIC]

  stratego_projectiles_dropdown_2:
    init: ->
      @setColour HUE_APPEARANCE
      @appendDummyInput()
        .appendField(new Blockly.FieldDropdown([["Snowball", stratego.PROJECTILES.SNOWBALL.toString()], 
                                                ["Egg", stratego.PROJECTILES.EGGBALL.toString()]]), "PROJECTILE")
        .appendField('Projectile')
      @setOutput(true)
    code: (block) ->
      key = block.getFieldValue('PROJECTILE')
      ["get_projectile(#{key})", Blockly.JavaScript.ORDER_ATOMIC]

  stratego_projectiles_dropdown_3:
    init: ->
      @setColour HUE_APPEARANCE
      @appendDummyInput()
        .appendField(new Blockly.FieldDropdown([["Snowball", stratego.PROJECTILES.SNOWBALL.toString()], ["Egg", stratego.PROJECTILES.EGGBALL.toString()], 
                                                ["Fireball", stratego.PROJECTILES.FIREBALL.toString()]]), "PROJECTILE")
        .appendField('Projectile')
      @setOutput(true)
    code: (block) ->
      key = block.getFieldValue('PROJECTILE')
      ["get_projectile(#{key})", Blockly.JavaScript.ORDER_ATOMIC]

  stratego_projectiles_dropdown_4:
    init: ->
      @setColour HUE_APPEARANCE
      @appendDummyInput()
        .appendField(new Blockly.FieldDropdown([["Snowball", stratego.PROJECTILES.SNOWBALL.toString()], ["Egg", stratego.PROJECTILES.EGGBALL.toString()], 
                                                ["Fireball", stratego.PROJECTILES.FIREBALL.toString()], ["Robopolli", stratego.PROJECTILES.ROBOPOLLI.toString()]
                                                ]), "PROJECTILE")
        .appendField('Projectile')
      @setOutput(true)
    code: (block) ->
      key = block.getFieldValue('PROJECTILE')
      ["get_projectile(#{key})", Blockly.JavaScript.ORDER_ATOMIC]

  stratego_projectiles_dropdown_all:
    init: ->
      @setColour HUE_APPEARANCE
      @appendDummyInput()
        .appendField(new Blockly.FieldDropdown([["Snowball", stratego.PROJECTILES.SNOWBALL.toString()], ["Egg", stratego.PROJECTILES.EGGBALL.toString()], 
                                                ["Fireball", stratego.PROJECTILES.FIREBALL.toString()], ["Robopolli", stratego.PROJECTILES.ROBOPOLLI.toString()],
                                                ["Rockball", stratego.PROJECTILES.ROCKBALL.toString()]
                                                ]), "PROJECTILE")
        .appendField('Projectile')
      @setOutput(true)
    code: (block) ->
      key = block.getFieldValue('PROJECTILE')
      ["get_projectile(#{key})", Blockly.JavaScript.ORDER_ATOMIC]


  stratego_aim_launcher:
    init: ->
      @setColour HUE_MOVEMENT
      @appendDummyInput()
        .appendField("Aim Launcher at")
      @appendValueInput('ANGLE')
        .setCheck(['Number', 'Angle'])
      @appendDummyInput()
        .appendField("degrees")
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      angle = Blockly.JavaScript.valueToCode(this, 'ANGLE', Blockly.JavaScript.ORDER_ATOMIC)
      """
      aim_launcher(#{angle});\n
      """


  stratego_forces_dropdown:
    init: ->
      @setColour HUE_APPEARANCE
      @appendDummyInput()
        .appendField(new Blockly.FieldDropdown([["Weak", WEAK_FORCE], ["Medium", MEDIUM_FORCE], ["Hard", HARD_FORCE]]), "FORCE")
        .appendField('Force')
      @setOutput(true)
    code: (block) ->
      force = block.getFieldValue('FORCE') | WEAK_FORCE #Weak throw value of 800 by default
      ["get_force(#{force})", Blockly.JavaScript.ORDER_ATOMIC]

  stratego_print:
    init: ->
      @setColour HUE_FLOW
      @appendDummyInput()
        .appendField("Print")
      @appendValueInput('MSG')
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      text = Blockly.JavaScript.valueToCode(block, 'MSG', Blockly.JavaScript.ORDER_ATOMIC)
      """
      print(#{text});\n
      """


  stratego_if_beyond:
    init: ->
      @setColour HUE_LOGIC
      @appendDummyInput()
        .appendField('if beyond')
        .appendField(new Blockly.FieldDropdown([['left limit', 'left'],['right limit', 'right']]), 'DIR')
        @appendStatementInput('DO')
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      direction = block.getFieldValue('DIR')
      condition = 'get_x() < get_leftedge()'
      if direction == 'right'
        condition = 'get_x() > get_rightedge()'
      branch = Blockly.JavaScript.statementToCode(block, "DO")
      "if(#{condition}) {\n #{branch}};\n"

  stratego_if_beyond_x:
    init: ->
      @setColour HUE_LOGIC
      @appendDummyInput()
        .appendField('if beyond')
        .appendField(new Blockly.FieldDropdown([['left limit', 'left'],['right limit', 'right']]), 'DIR')
      @appendValueInput("X")
        .appendField("X: ")
      @appendStatementInput('DO')
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      direction = block.getFieldValue('DIR')
      x = Blockly.JavaScript.valueToCode(block, 'X', Blockly.JavaScript.ORDER_NONE)
      condition = "get_mapped_player_x() < #{x}"
      if direction == 'right'
        condition = "get_mapped_player_x() > #{x}"
      branch = Blockly.JavaScript.statementToCode(block, "DO")
      "if(#{condition}) {\n #{branch}};\n"

  stratego_if_beyond_y:
    init: ->
      @setColour HUE_LOGIC
      @appendDummyInput()
        .appendField('if beyond')
        .appendField(new Blockly.FieldDropdown([['left limit', 'left'],['right limit', 'right']]), 'DIR')
      @appendValueInput("Y")
        .appendField("Y: ")
      @appendStatementInput('DO')
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      direction = block.getFieldValue('DIR')
      y = Blockly.JavaScript.valueToCode(block, 'Y', Blockly.JavaScript.ORDER_NONE)
      condition = "get_mapped_player_y() < #{y}"
      if direction == 'right'
        condition = "get_mapped_player_y() > #{y}"
      branch = Blockly.JavaScript.statementToCode(block, "DO")
      "if(#{condition}) {\n #{branch}};\n"

  stratego_kill_player:
    init: ->
      @setColour HUE_APPEARANCE
      @appendDummyInput().appendField("kill player")
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: ->
      "kill_player();\n"

  #
  # Robodillo Burrows
  #
  stratego_both: constant('Direction', 'both')

  stratego_spawn:
    init: ->
      @setColour HUE_MOVEMENT
      @appendDummyInput()
        .appendField('spawn')
      @appendValueInput('DIRECTION')
        .setCheck('Direction')
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      direction = Blockly.JavaScript.valueToCode(block, 'DIRECTION', Blockly.JavaScript.ORDER_NONE)
      "spawn_robodillo(#{direction});\n"

  stratego_random_direction:
    init: ->
      @setColour HUE_MOVEMENT
      @appendDummyInput()
        .appendField("random direction")
      @setOutput(true)
    code: ->
      ["random_direction()", Blockly.JavaScript.ORDER_NONE]

  #
  # Doors
  #

  stratego_door_close:
    init: ->
      @setColour HUE_MOVEMENT
      @appendDummyInput()
        .appendField('close')
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      "close();\n"

  stratego_door_open:
    init: ->
      @setColour HUE_MOVEMENT
      @appendDummyInput()
        .appendField('open')
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      "open();\n"

  stratego_door_is_closed:
    init: ->
      @setColour HUE_LOGIC
      @appendDummyInput()
        .appendField('door is closed')
      @setOutput(true)
    code: (block) ->
      ["is_closed()", Blockly.JavaScript.ORDER_NONE]

  stratego_finish_level:
    init: ->
      @setColour HUE_MOVEMENT
      @appendDummyInput()
        .appendField('end level')
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      "end_level();\n"

  stratego_player_has_key:
    init: ->
      @setColour HUE_LOGIC
      @appendDummyInput()
        .appendField('moose has a key')
      @setOutput(true)
    code: (block) ->
      ["has_key()", Blockly.JavaScript.ORDER_NONE]

  stratego_player_use_key:
    init: ->
      @setColour HUE_ADVANCED
      @appendDummyInput()
        .appendField('use key')
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      "use_key();\n"


  stratego_launcher_keys_dropdown:
    init: ->
      @setColour HUE_APPEARANCE
      @appendDummyInput()
        .appendField(new Blockly.FieldDropdown([["Round", stratego.KEYS.ROUND.toString()], ["Hourglass", stratego.KEYS.HOURGLASS.toString()], 
                                                ["Square", stratego.KEYS.SQUARE.toString()], ["Pie", stratego.KEYS.PIE.toString()]]), "KEY")
        .appendField('Key')
      @setOutput(true)
    code: (block) ->
      key = block.getFieldValue('KEY')
      ["get_launcher_key(#{key})", Blockly.JavaScript.ORDER_ATOMIC]

  stratego_use_launcher_key:
    init: ->
      @setColour HUE_MATH
      @appendDummyInput()
        .appendField('Unlock')
        .appendField(new Blockly.FieldDropdown([["Egg", stratego.PROJECTILES.EGGBALL.toString()], ["Fireball", stratego.PROJECTILES.FIREBALL.toString()], 
                                                ["Robopolli", stratego.PROJECTILES.ROBOPOLLI.toString()], ["Rockball", stratego.PROJECTILES.ROCKBALL.toString()]]), 
                                                "POWER")
        .appendField('power')
      @setOutput(true)
    code: (block) ->
      power = block.getFieldValue('POWER')
      ["use_launcher_key(#{power})", Blockly.JavaScript.ORDER_ATOMIC]

  stratego_has_launcher_key:
    init: ->
      @setColour HUE_MATH
      @appendDummyInput()
        .appendField(new Blockly.FieldDropdown([["Round", stratego.KEYS.ROUND.toString()], ["Hourglass", stratego.KEYS.HOURGLASS.toString()], 
                                                ["Square", stratego.KEYS.SQUARE.toString()], ["Pie", stratego.KEYS.PIE.toString()]]), "KEY")
        .appendField('Key')
      @setOutput(true)
    code: (block) ->
      key = block.getFieldValue('KEY')
      ["has_launcher_key(#{key})", Blockly.JavaScript.ORDER_ATOMIC]

  stratego_teleport_device_is_locked:
    init: ->
      @setColour HUE_LOGIC
      @appendDummyInput()
        .appendField('teleport device is locked')
      @setOutput(true)
    code: (block) ->
      ["is_locked()", Blockly.JavaScript.ORDER_NONE]

  stratego_unlock_teleport_device:
    init: ->
      @setColour HUE_MOVEMENT
      @appendDummyInput()
        .appendField('unlock device')
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      "unlock_device();\n"

  stratego_lock_teleport_device:
    init: ->
      @setColour HUE_MOVEMENT
      @appendDummyInput()
        .appendField('lock device')
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      "lock_device();\n"

   stratego_new_vector:
    init: ->
      @setColour HUE_MOVEMENT
      @appendValueInput("DIRECTION")
        .setCheck(['Number', 'Angle'])
        .appendField("direction")
      @appendValueInput("LENGTH")
        .setCheck("Number")
        .appendField("length")
      @setInputsInline(true)
      @setOutput(true)


  stratego_unlock_key:
    init: ->
     @jsonInit({
       "message0": 'Unlock key at (X:%1 Y:%2)',
       "args0": [
         {
           "type": "input_value",
           "name": "X"
         },
         {
           "type": "input_value",
           "name": "Y",
         }
       ],
       "previousStatement": null,
       "nextStatement": null,
       "colour": HUE_APPEARANCE,
     })
    code: (block) ->
      x = Blockly.JavaScript.valueToCode(this, 'X', Blockly.JavaScript.ORDER_ATOMIC)
      y = Blockly.JavaScript.valueToCode(this, 'Y', Blockly.JavaScript.ORDER_ATOMIC)
      "unlock_key(#{x}, #{y});\n"

  stratego_sensor_is_color:
    init: ->
      @setColour HUE_LOGIC
      @appendDummyInput()
        .appendField('pressed button is')
        .appendField(new Blockly.FieldDropdown([['yellow', 'YELLOW'],['pink', 'PINK'],['green', 'GREEN']]), 'COLOR')
      @setOutput(true)
    code: (block) ->
      color = block.getFieldValue('COLOR')
      ["(charon_get('event.name') == 'sensorPress' && charon_get('event.color') == '#{color}')", Blockly.JavaScript.ORDER_NONE]

  #
  # CamperDevice blocks
  #

  stratego_tilt:
    init: ->
      @setColour HUE_MOVEMENT
      @appendDummyInput()
        .appendField("tilt")
        .appendField(new Blockly.FieldDropdown([["xy", "XY"], ["xz", "XZ"], ["yz", "YZ"]]), "AXIS")
      @setOutput(true, "Number")
    code: (block) ->
      axis = block.getFieldValue('AXIS')
      ["tilt('#{axis}')", Blockly.JavaScript.ORDER_ATOMIC]

  stratego_sprite_is:
    init: ->
      @setColour(HUE_MOVEMENT)
      @appendDummyInput()
          .appendField("is")
          .appendField(new Blockly.FieldDropdown([
            ["hidden", "HIDDEN"]
            ["pressed", "PRESSED"]
          ]), "PROP_NAME")
      @setOutput(true)
    code: (block) ->
      dropdownName = block.getFieldValue('PROP_NAME');
      functionName = {
        'HIDDEN': 'isHidden'
        'PRESSED': 'isPressed'
      }[dropdownName]
      return ["#{functionName}()", Blockly.JavaScript.ORDER_ATOMIC]


  stratego_move_by:
    init: ->
      @setColour HUE_MOVEMENT
      @appendValueInput("VEC")
        .appendField("move by")
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      vec = Blockly.JavaScript.valueToCode(block, 'VEC', Blockly.JavaScript.ORDER_NONE)
      "move_by(#{vec});\n"

  stratego_artificial_jump:
    init: ->
      @setColour HUE_MOVEMENT
      @appendValueInput("FORCE")
        .appendField("Jump by")
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      force = Blockly.JavaScript.valueToCode(block, 'FORCE', Blockly.JavaScript.ORDER_NONE)
      """
      artificial_jump(#{force});
      while(is_jumping()) {
        highlightBlock('#{block.data}');
      }
      """
  
  # Teleport object to coordinates on screen, recieves either a number or a vector2
  stratego_teleport_to_coordinates:
   init: ->
     @jsonInit({
       "message0": 'Teleport to (X:%1 Y:%2)',
       "args0": [
         {
           "type": "input_value",
           "name": "X"
         },
         {
           "type": "input_value",
           "name": "Y",
         }
       ],
       "previousStatement": null,
       "nextStatement": null,
       "colour": HUE_MOVEMENT,
     })

   code: (block) ->
     x = Blockly.JavaScript.valueToCode(block, 'X', Blockly.JavaScript.ORDER_NONE)
     y = Blockly.JavaScript.valueToCode(block, 'Y', Blockly.JavaScript.ORDER_NONE)
     "teleport_to_coordinates(#{x}, #{y});\n"

  stratego_when_overlap:
    init: ->
      @setColour HUE_EVENT
      @appendDummyInput()
          .appendField("When overlapping")
      @appendStatementInput('DO')
    code: (block) ->
      do_code = Blockly.JavaScript.statementToCode(block, "DO")
      """
      while(true) {
        wait_for_overlap();
      #{do_code}
      }
      """

  stratego_when_pressed:
    init: ->
      @setColour HUE_EVENT
      @appendDummyInput()
          .appendField("When pressed")
      @appendStatementInput('DO')
    code: (block) ->
      do_code = Blockly.JavaScript.statementToCode(block, "DO")
      """
      while(true) {
        highlightBlock('#{stratego.Highlighter.blockName(block)}');
        wait_for_sprite_press();
      #{do_code}
      }
      """
  
  stratego_when_pressed_by_npc:
    init: ->
      @setColour HUE_EVENT
      @appendDummyInput()
          .appendField("When pressed")
      @appendStatementInput('DO')
    code: (block) ->
      do_code = Blockly.JavaScript.statementToCode(block, "DO")
      """
      while(true) {
        highlightBlock('#{stratego.Highlighter.blockName(block)}');
        wait_for_npc_press();
      #{do_code}
      }
      """

  stratego_wait_for_answer:
    init: ->
      @setColour HUE_ADVANCED
      @appendDummyInput()
        .appendField("Ask ")
      @appendValueInput("ANSWER")
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      text = Blockly.JavaScript.valueToCode(block, 'ANSWER', Blockly.JavaScript.ORDER_ATOMIC)
      "wait_for_answer(#{text});\n"

  stratego_get_answer:
    init: ->
      @setColour HUE_ADVANCED
      @appendDummyInput()
        .appendField('Answer')
      @setOutput(true)
    code: (block) ->
      ["get_answer()", Blockly.JavaScript.ORDER_ATOMIC]

  # !!! No longer in toolbox, but keep for summer 2015 in case a camper has it in their app
  stratego_set_color:
    init: ->
      @setColour HUE_APPEARANCE
      @appendDummyInput()
        .appendField("color")
        .appendField(new Blockly.FieldDropdown([["hue", "HUE"], ["saturation", "SATURATION"], ["brightness", "BRIGHTNESS"]]), "AXIS")
      @appendValueInput("VALUE")
        .appendField("to")
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      axis = block.getFieldValue('AXIS')
      value = Blockly.JavaScript.valueToCode(block, 'VALUE', Blockly.JavaScript.ORDER_NONE)
      "set_color('#{axis}', #{value});\n"


  stratego_set_color_2:
    init: ->
      @setColour HUE_APPEARANCE
      @appendValueInput("COLOR")
        .appendField("color")
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      color = Blockly.JavaScript.valueToCode(block, 'COLOR', Blockly.JavaScript.ORDER_ATOMIC)
      "set_color_2(#{color});\n"


  stratego_scale:
    init: ->
      @setColour HUE_APPEARANCE
      @appendValueInput("A")
          .appendField("scale")
      @appendValueInput("B")
          .appendField("by")
      @setInputsInline(true)
      @setOutput(true)  # number or vector
    code: (block) ->
      a = Blockly.JavaScript.valueToCode(block, 'A', Blockly.JavaScript.ORDER_ATOMIC)
      b = Blockly.JavaScript.valueToCode(block, 'B', Blockly.JavaScript.ORDER_ATOMIC)
      ["scale(#{a}, #{b})", Blockly.JavaScript.ORDER_ATOMIC]

  stratego_resize:
    init: ->
      @setColour HUE_APPEARANCE
      @appendValueInput("SIZE")
        .appendField("resize to")
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      size = Blockly.JavaScript.valueToCode(block, 'SIZE', Blockly.JavaScript.ORDER_NONE)
      "resize(#{size});\n"

  stratego_send_message:
    init: ->
      @setColour HUE_ADVANCED
      @appendDummyInput()
        .appendField('send message')
        .appendField(new Blockly.FieldDropdown(stratego.MESSAGE_OPTIONS), 'MESSAGE')
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      message = block.getFieldValue('MESSAGE')
      "send_message('#{message}');\n"

  stratego_send_message_with_data:
    init: ->
      @setColour HUE_ADVANCED
      @appendValueInput("DATA")
        .appendField('send message')
        .appendField(new Blockly.FieldDropdown(stratego.MESSAGE_OPTIONS), 'MESSAGE')
        .appendField('with data')
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      message = block.getFieldValue('MESSAGE')
      data = Blockly.JavaScript.valueToCode(block, 'DATA', Blockly.JavaScript.ORDER_NONE)
      "send_message_with_data('#{message}'," + data + ");\n"

  stratego_when_message:
    init: ->
      @setColour HUE_ADVANCED
      @appendDummyInput()
        .appendField "When message"
        .appendField(new Blockly.FieldDropdown(stratego.MESSAGE_OPTIONS), 'MESSAGE')
        .appendField "received"
      @setInputsInline(true)
      @appendStatementInput('DO')
    code: (block) ->
      message = block.getFieldValue('MESSAGE')
      do_code = Blockly.JavaScript.statementToCode(block, "DO")
      """
      while(true) {
        highlightBlock('#{stratego.Highlighter.blockName(block)}');
        wait_for_message('#{message}');
      #{do_code}
      }
      """

  stratego_message_data:
    init: ->
      @setColour HUE_ADVANCED
      @appendDummyInput()
        .appendField("data from message")
      @setOutput(true)
    code: ->
      ["get_event_message_data()", Blockly.JavaScript.ORDER_ATOMIC]

  stratego_get:
    init: ->
      @setColour HUE_ADVANCED
      @appendDummyInput()
        .appendField(new Blockly.FieldVariable('cubby'), 'VAR')
      @setOutput(true)
    getVars: ->
      [@getFieldValue('VAR')]
    renameVar: (oldName, newName) ->
      if (Blockly.Names.equals(oldName, @getFieldValue('VAR')))
        @setFieldValue(newName, 'VAR')
    code: (block) ->
      varName = Blockly.JavaScript.variableDB_.getName(
        block.getFieldValue('VAR'), Blockly.Variables.NAME_TYPE)
      ["get_variable('#{varName}')", Blockly.JavaScript.ORDER_ATOMIC]

  stratego_set:
    init: ->
      @jsonInit({
        "message0": 'store %1 in %2',
        "args0": [
          {
            "type": "input_value",
            "name": "VALUE"
          },
          {
            "type": "field_variable",
            "name": "VAR",
            "variable": 'cubby'
          }
        ],
        "previousStatement": null,
        "nextStatement": null,
        "colour": HUE_ADVANCED,
      })
    getVars: ->
      [@getFieldValue('VAR')]
    renameVar: (oldName, newName) ->
      if (Blockly.Names.equals(oldName, @getFieldValue('VAR')))
        @setFieldValue(newName, 'VAR')
    code: (block) ->
      argument0 = Blockly.JavaScript.valueToCode(block, 'VALUE',
        Blockly.JavaScript.ORDER_ASSIGNMENT) || '0'
      varName = Blockly.JavaScript.variableDB_.getName(
        block.getFieldValue('VAR'), Blockly.Variables.NAME_TYPE)
      "set_variable('#{varName}', #{argument0});\n"


  stratego_stamp:
    init: ->
      @setColour HUE_APPEARANCE
      @appendDummyInput().appendField("stamp")
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      "stamp();\n"

  stratego_clear:
    init: ->
      @setColour HUE_APPEARANCE
      @appendDummyInput().appendField("clear")
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      "clear();\n"

  stratego_new_vector:
    init: ->
      @setColour HUE_MOVEMENT
      @appendValueInput("DIRECTION")
        .setCheck(['Number', 'Angle'])
        .appendField("direction")
      @appendValueInput("LENGTH")
        .setCheck("Number")
        .appendField("length")
      @setInputsInline(true)
      @setOutput(true)

    code: (block) ->
      dir = Blockly.JavaScript.valueToCode(this, 'DIRECTION', Blockly.JavaScript.ORDER_ATOMIC)
      len = Blockly.JavaScript.valueToCode(this, 'LENGTH', Blockly.JavaScript.ORDER_ATOMIC)
      ["new_vector(#{dir}, #{len})", Blockly.JavaScript.ORDER_ATOMIC]

  math_random_int:
    init: ->
      @setColour HUE_MATH
      @appendValueInput("FROM")
        .setCheck('Number')
        .appendField("random")
      @appendValueInput("TO")
        .setCheck("Number")
        .appendField("to")
      @setInputsInline(true)
      @setOutput(true)

    code: (block) ->
      min = Blockly.JavaScript.valueToCode(this, 'FROM', Blockly.JavaScript.ORDER_ATOMIC)
      max = Blockly.JavaScript.valueToCode(this, 'TO', Blockly.JavaScript.ORDER_ATOMIC)
      ["new_random_number(#{min}, #{max})", Blockly.JavaScript.ORDER_ATOMIC]

  stratego_show:
    init: ->
      @setColour HUE_APPEARANCE
      @appendDummyInput().appendField("show")
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: ->
      "show();\n"

  stratego_hide:
    init: ->
      @setColour HUE_APPEARANCE
      @appendDummyInput().appendField("hide")
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: ->
      "hide();\n"

  stratego_arithmetic:
    init: ->
      OPERATORS = [
        [Blockly.Msg.MATH_ADDITION_SYMBOL, 'ADD'],
        [Blockly.Msg.MATH_SUBTRACTION_SYMBOL, 'MINUS'],
        [Blockly.Msg.MATH_MULTIPLICATION_SYMBOL, 'MULTIPLY'],
        [Blockly.Msg.MATH_DIVISION_SYMBOL, 'DIVIDE'],
        [Blockly.Msg.MATH_POWER_SYMBOL, 'POWER']
      ]
      @setColour(HUE_MATH)
      @setOutput(true)
      @appendValueInput('A')
      @appendValueInput('B')
        .appendField(new Blockly.FieldDropdown(OPERATORS), 'OP')
      @setInputsInline(true)
    code: (block) ->
      operation = block.getFieldValue('OP')
      argument0 = Blockly.JavaScript.valueToCode(block, 'A', Blockly.JavaScript.ORDER_ATOMIC) || '0'
      argument1 = Blockly.JavaScript.valueToCode(block, 'B', Blockly.JavaScript.ORDER_ATOMIC) || '0'

      ["arithmetic('#{operation}', #{argument0}, #{argument1})", Blockly.JavaScript.ORDER_ATOMIC]

  stratego_play_sound:
    init: ->
      @setColour HUE_APPEARANCE
      @appendDummyInput()
        .appendField('play sound')
        .appendField(new Blockly.FieldDropdown(stratego.SOUND_OPTIONS), 'SOUND')
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      sound = block.getFieldValue('SOUND')
      "play_sound('#{sound}');\n"

  stratego_play_drum_sound_for_beats:
    init: ->
      @setColour HUE_APPEARANCE
      @appendValueInput('BEATS')
        .appendField('play drum ')
        .appendField(new Blockly.FieldDropdown(stratego.DRUM_SOUND_OPTIONS), 'SOUND')
        .appendField('for ')     
      @appendDummyInput()
        .appendField('beats')   
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      sound = block.getFieldValue('SOUND')
      beats = Blockly.JavaScript.valueToCode(block, 'BEATS', Blockly.JavaScript.ORDER_NONE)
      "play_drum_sound_for_beats('#{sound}', #{beats});\n"

  stratego_set_tempo:
    init: ->
      @setColour HUE_APPEARANCE
      @appendValueInput('TEMPO')
        .appendField('set tempo to ')
      @appendDummyInput()
        .appendField('beats per min')   
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      tempo = Blockly.JavaScript.valueToCode(block, 'TEMPO', Blockly.JavaScript.ORDER_NONE)
      "set_tempo(#{tempo});\n"

  stratego_say:
    init: ->
      @setColour HUE_APPEARANCE
      @appendDummyInput()
        .appendField("say")
      @appendValueInput("MSG")
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      text = Blockly.JavaScript.valueToCode(block, 'MSG', Blockly.JavaScript.ORDER_ATOMIC)
      "say(#{text});\n"

# Ingame different styles to fit every text

  stratego_bottle_say:
    init: ->
      @setColour HUE_APPEARANCE
      @appendDummyInput()
        .appendField("say")
      @appendValueInput("MSG")
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      text = Blockly.JavaScript.valueToCode(block, 'MSG', Blockly.JavaScript.ORDER_ATOMIC)
      "say(#{text}, #{0.4}, #{1.3});\n"

  stratego_crab_say:
    init: ->
      @setColour HUE_APPEARANCE
      @appendDummyInput()
        .appendField("say")
      @appendValueInput("MSG")
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      text = Blockly.JavaScript.valueToCode(block, 'MSG', Blockly.JavaScript.ORDER_ATOMIC)
      "say(#{text}, #{0.5}, #{0.8});\n"

  stratego_crab_up_say:
    init: ->
      @setColour HUE_APPEARANCE
      @appendDummyInput()
        .appendField("say")
      @appendValueInput("MSG")
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      text = Blockly.JavaScript.valueToCode(block, 'MSG', Blockly.JavaScript.ORDER_ATOMIC)
      "say(#{text}, #{0.5}, #{-1.3});\n"

  stratego_crab_right_say:
    init: ->
      @setColour HUE_APPEARANCE
      @appendDummyInput()
        .appendField("say")
      @appendValueInput("MSG")
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      text = Blockly.JavaScript.valueToCode(block, 'MSG', Blockly.JavaScript.ORDER_ATOMIC)
      "say(#{text}, #{0.9}, #{1});\n"


  stratego_hide_message:
    init: ->
      @setColour HUE_APPEARANCE
      @appendDummyInput().appendField("hide message")
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      "hide_message();\n"

  stratego_rotate:
    init: ->
      @setColour HUE_MOVEMENT
      @appendValueInput("ANGLE")
        .setCheck(['Number', 'Angle'])
        .appendField("rotate")
      @setInputsInline(true)
      @setPreviousStatement(true)
      @setNextStatement(true)
    code: (block) ->
      angle = Blockly.JavaScript.valueToCode(block, 'ANGLE', Blockly.JavaScript.ORDER_ATOMIC)
      "rotate_to(#{angle});\n"



  # NOTE: Returned javascript for procedures should end in with a newline.
  #       Functions, i.e. with `setOutput(true)', should have no newline and include ORDER_xyz

window.stratego.physics =
  immovablePushX: (mover, immovable) ->
    if mover.body.touching.left or mover.body.touching.right
      mover.body.x -= mover.body.overlapX
      mover.body.velocity.x = immovable.body.velocity.x - mover.body.velocity.x * mover.body.bounce.x
      mover.xLockMotion() if mover.xLockMotion?

  immovablePushY: (mover, immovable) ->
    if mover.body.touching.down
      mover.body.y -= mover.body.overlapY
      mover.body.velocity.y = immovable.body.velocity.y - mover.body.velocity.y * mover.body.bounce.y

###
game_device.coffee

Game-specific device features. E.g. functions accessible from sub-interpreter
###


class stratego.GameDevice extends stratego.Device

  constructor: (game, x, y, args...) ->
    super(game, x, y, args...)
    @_readOnly = false  # can a user generally edit this Device's program?
    @variables = {}
    answer = ""

    @inputEnabled = true;
    @events.onInputDown.add(@onDown, this);

  onDown: (sprite, pointer) ->
    @level().switchEditorSpecificDevice(this)

  #
  # editability
  #

  isEditable: ->
    not @readOnly and not @playerNearby

  _updateAppearance: ->
    @glow.visible = @isEditable() if @glow?

  addGlowChild: (anchorX, anchorY, spriteName) ->
    @glow = @game.add.image(0, 0, 'atlas', spriteName)
    @glow.blendMode = PIXI.blendModes.SCREEN
    @glow.anchor.setTo(anchorX, anchorY)
    @glow.alpha = 0.7
    @game.add.tween(@glow)
      .to({alpha: 0.5}, 500)
      .to({alpha: 0.7}, 500)
      .loop()
      .start()
    @addChild(@glow)
    @_updateAppearance()

  _respawn: ->
    @_resetPosition()
    @runCode()


  #
  # default workspace contains "When moose jumps" block
  #

  setDefaultProgram: ->
    @setCode("""
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_player_jump" id="15" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}" movable="false"/>
      </xml>
    """)

  setCode: (codeXml, codeJs=null) ->
    codeJsBefore = @_codeJs
    super(codeXml, codeJs)

    if not stratego.Device._codeStacksEqual(codeJsBefore, @_codeJs)
      @runCode()

  #
  #  Commands i.e. implementation of coding blocks
  #

  # These functions are accessible from sub-interpreter but executed in browser
  # Inputs are sub-interpreter wrapper objects. Return values should also be
  # sub-interpeter wrappers, or `undefined`.
  initNativeFunctions: (machine, interpreter, scope) =>
    super(machine, interpreter, scope)

    device = this  # available to functions below
    nativeFunctions = {

      #--- All devices
#      send_message: (messageName) ->
#        messageNameStr = messageName.data
#        device.eventManager.dispatchEvent(messageNameStr)

      wait_for_jump: ->
        machine.wait_for( 'player_jump', (eventName, params) => device.inCameraView() )
        return

      wait_for_player_nearby: ->
        machine.wait_for( 'playerNearby', (eventName, params) => params.device == device )
        return

      wait_for_sensor_press: ->
        machine.wait_for( 'sensorPress', (eventName, params) => device.inCameraView() and params.source.inCameraView() )
        return

      wait_for_launcher_sensor_press: ->
        machine.wait_for( 'launcherSensorPress', (eventName, params) => device.inCameraView() and params.source.inCameraView() and util.distance(device.body.center, params.source.body.center) < 128 )
        return

      # Pressed editable sensor
      wait_for_sprite_press: ->
        machine.wait_for( 'sensor_device_pressed', (eventName, params) ->  
          params.pressedBy == device.level().player and params.currentDevice == device
        )
        return
      
      wait_for_npc_press: ->
        machine.wait_for( 'sensor_device_pressed_by_npc', (eventName, params) ->
          params.pressedBy != device.level().player and params.currentDevice == device
        )
        return

    #--- Device
      move_right: ->
        device.move(150)
        return

      move_left: ->
        device.move(-150)
        return
      
      show: ->
        device.visible = true
        return

      hide: ->
        device.visible = false
        return
    
      kill_player: ->
        device.level().player.kill()
        return

    #--- Robodillo
      get_leftedge: ->
        leftedge = device.leftEdge
        interpreter.createPrimitive(leftedge)

      get_rightedge: ->
        rightedge = device.rightEdge
        interpreter.createPrimitive(rightedge)

      face: (dir) ->
        device.face(dir.toString())
        return

      drive: ->
        device.drive()
        return

      stop: ->
        device.stop()
        return

    #--- RobodilloBurrow
      spawn_robodillo: (dir) ->
        device.spawnRobodillo(dir.toString())
        return

      random_direction: ->
        interpreter.createPrimitive( device.randomDirection() )

    #--- Door
      has_key: ->
        interpreter.createPrimitive( device.level().player.hasKey() )

      use_key: ->
        device.level().player.useKey()
        return

      unlock_key: (x, y)->
        device.level().unlockKey(x, y)
        return

      use_launcher_key: (power) ->
        return if device.activated
        if power != undefined and device.level().player.hasLauncherKeyType(power.data)
          console.log("Get launcher key -> #{power}")
          device.level().player.useLauncherKey(power.data)
          device.collapse()
          device.level().powerUnlocked = power
          interpreter.createPrimitive("Power unlocked")
        else
          interpreter.createPrimitive("No power unlocked")

      get_launcher_key: (key) ->
        interpreter.createPrimitive(key.data)

      has_launcher_key: (key) ->
        if device.level().player.hasLauncherKeyType(key.data)
          interpreter.createPrimitive(key.data) #device.level().player.hasLauncherKeyType(key.data))
        else 
          interpreter.createPrimitive(false)

      close: ->
        device.close()
        return

      open: ->
        device.open()
        return

      is_closed: ->
        interpreter.createPrimitive(device.isClosed())

      is_locked: ->
        interpreter.createPrimitive(device.isLocked())

      end_level: ->
        device.eventManager.dispatchEvent('collisionPlayerEnd', player: device.level().player)

      unlock_device: ->
        device.unlock()
        return
      
      lock_device: ->
        device.lock()
        return

      load_projectile: (projectileType) ->
        if !projectileType
          device.currentProjectileType = 0
        else
          device.currentProjectileType = +projectileType.data

      get_projectile: (projectileType) ->
        interpreter.createPrimitive(projectileType.data)

      throw_projectile: (force)->
        if not force  
          force = 600
        projX = (device.body.center.x - 30) + 96 * Math.cos(device.throwAngles) # center + r * cos(radAngle) Offset by 30, sprite is a bit off center
        projY = (device.body.center.y - 30) - 96 * Math.sin(device.throwAngles) # center - r * sin(radAngle) Offset by 30, sprite is a bit off center
        projectile = device.getProjectileFromPool(projX, projY, device.currentProjectileType) #new stratego.Projectile(device.game, device.x, device.y, device.currentProjectileType) # spawn projectile
        if projectile != undefined
          projectile.body.velocity.x += Math.cos(device.throwAngles) * force; # Set initial x velocity from throwing block
          projectile.body.velocity.y -= Math.sin(device.throwAngles) * force; # Set initial y velocity from throwing block

      aim_launcher: (angle) ->
        return if not device instanceof stratego.Launcher
        if not angle
          angle = 0
        device.setAnimation(angle)
        radAngle = if isNaN(angle) then 0 else util.degreesToRadians(angle) # Change from degrees to radians
        device.throwAngles = radAngle
      get_force: (force) ->
        interpreter.createPrimitive(force.data)

    #--- Teleport

      # Teleporting to a negative value keep it as it is
      teleport_to_coordinates: (x, y) ->
        y = stratego.TILESET.GRID_HEIGHT - y # Quick fix to y coordinate inverting
        mappedCoordinates = [x * stratego.TILESET.TILE_SIZE, (y * stratego.TILESET.TILE_SIZE) - stratego.TILESET.TILE_SIZE]
        
        if x >= 0
          device.level().player.x = mappedCoordinates[0]
        if y >= 0
          device.level().player.y = mappedCoordinates[1]
        return

      get_mapped_player_x: ->
        x = device.level().player.x
        mappedX = util.player_to_map_coordinates(x, -1, device)[0]
        interpreter.createPrimitive(mappedX)

      get_mapped_player_y: ->
        y = device.level().player.y
        mappedY = util.player_to_map_coordinates(-1, y, device)[1]
        interpreter.createPrimitive(mappedY)    

    #--- SnowPile

      explode: ->
        device.explode()
        return

      arithmetic: (operation, a, b) ->
        operation = operation.data
        a = a.data
        b = b.data
        util.assertContains(['ADD', 'MINUS', 'MULTIPLY', 'DIVIDE', 'POWER'], operation)

        # Calculate using just magnitudes of a, b
        _scalarMath = (operation, a, b) ->
          aMagnitude = util.vecLengthOrNum(a)
          bMagnitude = util.vecLengthOrNum(b)

          result = switch operation
            when 'ADD'          then aMagnitude + bMagnitude
            when 'MINUS'        then aMagnitude - bMagnitude
            when 'MULTIPLY'     then aMagnitude * bMagnitude
            when 'DIVIDE'       then aMagnitude / bMagnitude
            when 'POWER'        then Math.pow(aMagnitude, bMagnitude)
          result

        _vectorMath = (operation, a, b) ->
          result = switch operation
            when 'ADD'          then Vec2.newXY(a.x() + b.x(), a.y() + b.y())
            when 'MINUS'        then Vec2.newXY(a.x() - b.x(), a.y() - b.y())
            when 'MULTIPLY'     then Vec2.newXY(a.x() * b.x(), a.y() * b.y()) # This is NOT dot product. We're making things up.
            when 'DIVIDE'       then Vec2.newXY(a.x() / b.x(), a.y() / b.y())
            when 'POWER'        then Vec2.newXY(Math.pow(a.x(), b.x()), Math.pow(a.y(), b.y()))
          result

        if a instanceof Vec2 # return a vector
          if b instanceof Vec2
            # Vec2 & Vec2
            resultVector = _vectorMath(operation, a, b)
          else
            # Vec2 & number
            resultVector = Vec2.newPolar(a.direction(), _scalarMath(operation, a, b))

          return util.createInterpreterBlob(interpreter, resultVector)

        else
          # number & (number or vector)
          return interpreter.createPrimitive(_scalarMath(operation, a, b))

      new_random_number: (min, max) ->
        min = min.data
        max = max.data + 1 # Add 1 to have min <= n <= max
        n = Math.floor(Math.random() * max) + min
        return interpreter.createPrimitive(n)

      compare_same_type: (a, b) ->
        a = a.data
        b = b.data
      
        # Store original values on temporal variables
        tempA = a 
        tempB = b

        # If it is a COMPLETELY numeric string, parse to integer
        if not isNaN(a) and typeof a is 'string'
          a = if a.match(/^[0-9]{0,}$/) then parseInt(a , 10) else tempA
        else
          a = tempA # isNaN turns variable into "NaN", it should be returned to its original value

        # If it is a COMPLETELY numeric string, parse to integer
        if not isNaN(b) and typeof b is 'string'
          b = if b.match(/^[0-9]{0,}$/) then parseInt(b , 10) else tempB
        else
          b = tempB # isNaN turns variable into "NaN", it should be returned to its original value

        # console.log("a: |#{a}| typeof a: #{typeof a} aNan: #{isNaN(a)} \n b: |#{b}| typeof b: #{typeof b} bNan: #{isNaN(b)}")
        return interpreter.createPrimitive(typeof a == typeof b and a == b)

    #--- Ask/answer
      say: (msg, anchorPointX = 0.5, anchorPointY = 0) ->
        if msg?
          msg = msg.data
          device.showCaption(msg.toString(), anchorPointX, anchorPointY)
        else
          device.showCaption(null)
        return
        
      hide_message: ->
        device.hideCaption()
        return

      send_message: (messageName) ->
        messageNameStr = messageName.data
        device.eventManager.dispatchEvent(messageNameStr)
        return

      send_message_with_data: (messageName, messageParam) ->
        messageNameStr = messageName.data
        messageData = messageParam.data
        if messageData? and typeof messageData == 'object'
          messageData = messageData.toString()
        messageDataObj = {'messageData': messageData}
        device.eventManager.dispatchEvent(messageNameStr, messageDataObj)
        return

      wait_for_message: (messageName) ->
        messageNameStr = messageName
        machine.wait_for(messageNameStr)
        return

      # Directly using get_charon on the block definition
      # didn't let strings to be passed through messages
      get_event_message_data: ->
        nativeVal = machine.charon['event.messageData']
        unless util.isPrimitive(nativeVal)
          throw new stratego.StrategoException("charon[event.messageData] is not a primitive: #{nativeVal}")
        return interpreter.createPrimitive(nativeVal)

      get_variable: (varName) ->
        if varName not of device.variables
          device.variables[varName] = 0
        return interpreter.createPrimitive(device.variables[varName])

      set_variable: (varName, varVal) ->
        device.variables[varName.data] = varVal.data
        return

      wait_for_answer: (input) ->
        message = input.toString()
        if input?
          input = input.data
          device.answer = prompt(input.toString())          
        else
          device.answer = prompt("")
 
        # NaN matches numbers with spaces, turning to NaN when parsed,
        # using regular expression to avoid this case
        if device.answer and device.answer.match(/^[0-9]{0,}$/)
          device.answer = parseInt(device.answer, 10) # Turn to number ONLY if completely numeric
                                                      # otherwise leave string as it is    
      
        return

      get_answer: ->
        if device.answer?
          return interpreter.createPrimitive(device.answer)
        else # If the prompt is closed, return empty text
          return interpreter.createPrimitive("")

    }
    for name, func of nativeFunctions
      interpreter.setProperty(scope, name, interpreter.createNativeFunction(func))

#  subinterpreterFunctions: ->
#    super().concat(
#    )

Object.defineProperty stratego.GameDevice.prototype, "playerNearby",
  get: -> @_playerNearby
  set: (val) ->
    return if @_playerNearby == val
    @_playerNearby = val
    @_updateAppearance()
    @eventManager.dispatchEvent('device_editability_changed', {source: this})

Object.defineProperty stratego.GameDevice.prototype, "readOnly",
  get: -> @_readOnly
  set: (@_readOnly) ->
    @_updateAppearance()

###
bottle.coffee
###

window.stratego = window.stratego or {}

###
Displays temporary message when a nearby sensor is pressed
###
class stratego.Bottle extends stratego.GameDevice
  constructor: (game, x, y) ->
    super(game, x, y, 'atlas', 'bottle/0')
    @isOverlapped = false
    @_enablePhysics()
    @message = 
    @level().eventManager.addEventHandler('overlap', @onOverlap, this)
    @level().eventManager.addEventHandler('overlapDone', @onOverlapDone, this)
    @executeOutOfCameraView = true # Bottles are able to execute out of camera view as they might need to send a message

  _enablePhysics: ->
    super()
    @body.allowGravity = false
    @body.allowRotation = false
    @body.immovable = true
    @body.moves = false  # we take responsiblity for movement
    @body.customSeparateX = true  # we handle colliding with player
    @body.customSeparateY = true  # we handle colliding with player

  @createFromTiledObjectJson: (game, objJson) ->
    newThing = new this(game, objJson.x, objJson.y) # 'this' is the class constructor
    newThing

  onOverlap: (params) ->
    return unless params.target == this
    # @animations.play("#{@color}Press")
    if @inCameraView() and not @isOverlapped
      @isOverlapped = true

  onOverlapDone: (params) ->
    return unless params.target == this
    @isOverlapped = false

  @TOOLBOX:
    SEND_EMPTY_MESSAGE: (messageName) ->
      """
      <block type="stratego_set" id="1291" editable="false">
        <field name="VAR">secretPassword</field>
        <value name="VALUE">
          <block type="text" id="534" movable="false">
            <field name="TEXT"></field>
          </block>
        </value>
      </block>
      <block type="stratego_send_message_with_data" id="49" editable="false">
        <field name="MESSAGE">#{messageName}</field>
        <value name="DATA">
        </value>
      </block>
      <block type="stratego_get" id="1296" editable="false">
        <field name="VAR">secretPassword</field>
      </block>
    """

  @PROGRAM:
    DEFAULT: (message, string) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_started" id="1290" x="-500" y="500">
          <statement name="DO">
            <block type="stratego_set" id="1291">
              <field name="VAR">#{HIDDEN_MESSAGE_NAME}</field>
              <value name="VALUE">
                <block type="text" id="534">
                  <field name="TEXT">#{string} </field>
                </block>
              </value>
            </block>
          </statement>
        </block>

        <block type="stratego_when_message" id="135" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}">
          <field name="MESSAGE">#{message}</field>
          <statement name="DO">
            <block type="stratego_show" id="427">
              <next>
                <block type="stratego_bottle_say" id="533">
                  <value name="MSG">
                    <block type="stratego_get" id="1296">
                      <field name="VAR">#{HIDDEN_MESSAGE_NAME}</field>
                    </block>
                  </value>     
                  <next>
                    <block type="stratego_wait" id="184">
                      <value name="TIMES">
                        <block type="stratego_number" id="185"> 
                          <field name="NUM">#{DEFAULT_CRAB_ASKING_WAIT}</field>
                        </block>
                      </value>
                      <next>
                        <block type="stratego_hide_message" id="425"></block>
                      </next> 
                    </block>
                  </next> 
                </block>
              </next>
            </block>
          </statement>
        </block>
      </xml>
      """

    EMPTY_PRESSED: ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_player_nearby" id="538" x="50" y="#{START_BLOCK_Y}" movable="false">
          <statement name="DO">
            
          </statement>
        </block>
      </xml>
      """

    STORE_MESSAGE: (question, answerVar) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_started" id="1290" x="-500" y="500">
          <statement name="DO">
            <block type="stratego_set" id="1291">
              <field name="VAR">#{HIDDEN_MESSAGE_NAME}</field>
              <value name="VALUE">
                <block type="text" id="534">
                  <field name="TEXT">#{question} </field>
                </block>
              </value>
            </block>
          </statement>
        </block>
        <block type="stratego_when_player_nearby" id="538" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}">
          <statement name="DO">
            <block type="stratego_if" id="115" inline="false">
              <value name="IF0">
                <block type="logic_compare" id="4714" inline="true">
                  <field name="OP">EQ</field>
                  <value name="A">
                    <block type="stratego_get" id="1296">
                      <field name="VAR">#{answerVar}</field>
                    </block>
                  </value>
                  <value name="B">
                    <block type="text" id="534">
                      <field name="TEXT"></field>
                    </block>
                  </value>
                </block>
              </value>
              <statement name="DO0">
                <block type="stratego_wait_for_answer" id='123'>
                  <value name="ANSWER">
                    <block type="stratego_get" id="1296">
                      <field name="VAR">#{HIDDEN_MESSAGE_NAME}</field>
                    </block>
                  </value>
                  <next>
                    <block type="stratego_set" id="1291">
                      <field name="VAR">#{answerVar}</field>
                      <value name="VALUE">
                        <block type="stratego_get_answer"></block>
                      </value>
                      <next>
                        <block type="stratego_if" id="115" inline="false">
                          <value name="IF0">
                            <block type="logic_compare" id="4714" inline="true">
                              <field name="OP">NEQ</field>
                              <value name="A">
                                <block type="stratego_get" id="1296">
                                  <field name="VAR">#{answerVar}</field>
                                </block>
                              </value>
                              <value name="B">
                                <block type="text" id="534">
                                  <field name="TEXT"></field>
                                </block>
                              </value>
                            </block>
                          </value>
                          <statement name="DO0">
                            <block type="stratego_unlock_key" id="533"> 
                              <value name="X">
                                <block type="stratego_number" id="25">
                                  <field name="NUM">#{x}</field>
                                </block>
                              </value>
                              <value name="Y">
                                <block type="stratego_number" id="26">
                                  <field name="NUM">#{y}</field>
                                </block>
                              </value> 
                              <next>
                                <block type="stratego_send_message_with_data" id="135">
                                  <field name="MESSAGE">#{messageName}</field>
                                  <value name="DATA">
                                    <block type="stratego_get" id="1296">
                                      <field name="VAR">#{answerVar}</field>
                                    </block>
                                  </value>
                                </block>
                              </next>
                            </block> 
                          </statement>
                        </block>
                      </next>
                    </block>
                  </next>
                </block>
               </statement>
            </block>
          </statement>
        </block>
      </xml>
      """
###
breakableBlock.coffee
###

window.stratego = window.stratego or {}


class stratego.BreakableBlock extends stratego.Thing

  constructor: (game, x, y) ->
    super(game, x, y, 'atlas', "breakableBlock/iceBlock/3x3/0") # default to 3x3 ice block
    @_enablePhysics()
    @level().eventManager.addEventHandler('overlap', @onOverlap, this)

  update: ->
    super()
    # Destroy animation need the information from the tiled json, so it cannot be initialized on the constructor
    if @destroyAnim == undefined
      @destroyAnim = @animations.add('destroy', util.anim("breakableBlock/#{@spriteName}Block/#{@blockSize}/", 0, 9), 14, false)
      @destroyAnim.onComplete.add(@destroyBreakableBlock, this)

  _enablePhysics: ->
    super()
    @body.allowGravity = false
    @body.allowRotation = false
    @body.immovable = true

  @createFromTiledObjectJson: (game, objJson) ->
    
    newThing = new this(game, objJson.x, objJson.y) # 'this' is the class constructor
    if objJson.width > 64
      newThing.blockSize = '3x3'
      # newThing.frameName = 'iceBlock/3x3/0'
    else
      newThing.blockSize = '1x3'
      # newThing.frameName = 'iceBlock/1x3/0'
      newThing.body.setSize(64, 192, 0, 0) # If breakableBlock block is 1x3, the collider should be updated, the sprite is drawn on the left side of the original 3x3 collider

    if objJson.properties != undefined and objJson.properties.blockType != undefined
      switch objJson.properties.blockType
        when "ice" 
          newThing.blockType = stratego.BREAKABLES.ICE
          newThing.spriteName = "ice"
        when "steel" 
          newThing.blockType = stratego.BREAKABLES.STEEL
          newThing.spriteName = "steel"
        when "rock" 
          newThing.blockType = stratego.BREAKABLES.ROCK
          newThing.spriteName = "rock"
        when "gold" 
          newThing.blockType = stratego.BREAKABLES.GOLD
          newThing.spriteName = "gold"
        when "snow" 
          newThing.blockType = stratego.BREAKABLES.SNOW
          newThing.spriteName = "snow"
        else 
          newThing.blockType = stratego.BREAKABLES.ICE
          newThing.spriteName = "ice"
    else
      newThing.blockType = stratego.BREAKABLES.ICE
      newThing.spriteName = "ice" 

    newThing.frameName = "breakableBlock/#{newThing.spriteName}Block/#{newThing.blockSize}/0"

    newThing

  onOverlap: (params) ->
    return unless params.target == this
    if @inCameraView()
      if params.source instanceof stratego.Projectile 
        return if params.source.destroyed
        # Destroy BreakableBlock only if the right combination of block - projectile collide
        if (params.source.blockType == stratego.PROJECTILES.SNOWBALL and @blockType == stratego.BREAKABLES.ICE) or
           (params.source.blockType == stratego.PROJECTILES.EGGBALL and @blockType == stratego.BREAKABLES.STEEL) or 
           (params.source.blockType == stratego.PROJECTILES.FIREBALL and @blockType == stratego.BREAKABLES.ROCK) or
           (params.source.blockType == stratego.PROJECTILES.ROBOPOLLI and @blockType == stratego.BREAKABLES.GOLD) or
           (params.source.blockType == stratego.PROJECTILES.ROCKBALL and @blockType == stratego.BREAKABLES.SNOW)
          @animations.play('destroy')
          @level().playSound('wall-break')
        params.source.destroyProjectile()
      

  destroyBreakableBlock: ->
    @body.enable = false
    @level().unregisterThing(this)
    @kill()
###
crab.coffee
###

window.stratego = window.stratego or {}

###
Block that asks a question and does something with its answer
###
class stratego.Crab extends stratego.GameDevice
  constructor: (game, x, y) ->
    super(game, x, y, 'atlas', 'crab/0') #TEMPORARY IMAGE
    @isOverlapped = false
    @_enablePhysics()
    @level().eventManager.addEventHandler('overlap', @onOverlap, this)
    @level().eventManager.addEventHandler('overlapDone', @onOverlapDone, this)
    
    # Crab possible questions
    crabQuestions = "Hello, what do you wish to ask me?"
    @executeOutOfCameraView = true # Crabs are able to execute out of camera view as they might need to send a message

  _enablePhysics: ->
    super()
    @body.allowGravity = false
    @body.allowRotation = false
    @body.immovable = true
    @body.moves = false  # we take responsiblity for movement
    @body.customSeparateX = true  # we handle colliding with player
    @body.customSeparateY = true  # we handle colliding with player

  @createFromTiledObjectJson: (game, objJson) ->
    newThing = new this(game, objJson.x, objJson.y) # 'this' is the class constructor
    newThing.animations.add("idle", util.anim("crab/", 0, 1), 6, true)
    newThing.animations.add("kingIdle", util.anim("kingCrab/", 0, 1), 6, true)
    newThing.animations.play("idle")
    newThing

  setAsKing: ->
    @animations.play("kingIdle")

  onOverlap: (params) ->
    return unless params.target == this
    if @inCameraView() and not @isOverlapped
      @isOverlapped = true

  onOverlapDone: (params) ->
    return unless params.target == this
    @isOverlapped = false

  
  @PROGRAM:
    DEFAULT: (answer, nonsense, correctAnswer, strategoSayBlockName = 'stratego_crab_say') ->
      crabQuestions = "Hello, what do you wish to ask me?"
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_started" id="1290" x="-500" y="500">
          <statement name="DO">
            <block type="stratego_set" id="1291">
              <field name="VAR">#{HIDDEN_MESSAGE_NAME}</field>
              <value name="VALUE">
                <block type="text" id="534">
                    <field name="TEXT">#{crabQuestions} </field>
                </block>
              </value>
              <next>
                <block type="stratego_set" id="1292">
                  <field name="VAR">#{CORRECT_ANSWER_NAME}</field>
                  <value name="VALUE">
                    <block type="text" id="535">
                        <field name="TEXT">#{answer}</field>
                    </block>
                  </value>
                  <next>
                    <block type="stratego_set" id="1293">
                      <field name="VAR">#{INCORRECT_ANSWER_NAME}</field>
                      <value name="VALUE">
                        <block type="text" id="536">
                          <field name="TEXT">#{nonsense}</field>
                        </block>
                      </value>
                    </block>
                  </next>
                </block>
              </next>  
            </block>
          </statement>
        </block>

        <block type="stratego_when_player_nearby" id="538" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}">
          <statement name="DO">
            <block type="stratego_wait_for_answer" id='123'>
              <value name="ANSWER">
                <block type="stratego_get" id="1296">
                  <field name="VAR">#{HIDDEN_MESSAGE_NAME}</field>
                </block>
              </value>  
              <next>
                <block type="stratego_if_else" id="147" inline="false">
                  <value name="CONDITION">
                    <block type="logic_compare" id="4714" inline="true">
                      <field name="OP">EQ</field>
                      <value name="A">
                        <block type="stratego_get_answer"></block>
                      </value>
                      <value name="B">
                        <block type="text" id="534">
                          <field name="TEXT">#{correctAnswer}</field>
                        </block>
                      </value>
                    </block>
                  </value>
                  <statement name="DO">
                    <block type="#{strategoSayBlockName}" id="533">
                      <value name="MSG">
                        <block type="stratego_get" id="1296">
                          <field name="VAR">#{CORRECT_ANSWER_NAME}</field>
                        </block>
                      </value>
                    </block>
                  </statement>
                  <statement name="ELSE">
                    <block type="#{strategoSayBlockName}" id="533">
                      <value name="MSG">
                        <block type="stratego_get" id="1296">
                          <field name="VAR">#{INCORRECT_ANSWER_NAME}</field>
                        </block>
                      </value>
                    </block>
                  </statement>
                  <next>
                    <block type="stratego_wait" id="184">
                      <value name="TIMES">
                        <block type="stratego_number" id="185"> 
                          <field name="NUM">#{DEFAULT_CRAB_ASKING_WAIT}</field>
                        </block>
                      </value> 
                      <next>
                        <block type="stratego_hide_message" id="425"></block>
                      </next>
                    </block>
                  </next>     
                </block>
              </next>   
            </block>
          </statement>
        </block>
      </xml>
      """

    SAY_MESSAGE: (message, strategoSayBlockName = 'stratego_crab_say') ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_started" id="1290" x="-500" y="500">
          <statement name="DO">
            <block type="stratego_set" id="1291">
              <field name="VAR">#{HIDDEN_MESSAGE_NAME}</field>
              <value name="VALUE">
                <block type="text" id="534">
                    <field name="TEXT">#{message}</field>
                </block>
              </value> 
            </block>
          </statement>
        </block>

        <block type="stratego_when_player_nearby" id="538" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}">
          <statement name="DO">
            <block type="#{strategoSayBlockName}" id="533">
              <value name="MSG">
                <block type="stratego_get" id="1296">
                  <field name="VAR">#{HIDDEN_MESSAGE_NAME}</field>
                </block>
              </value>
              <next>
                <block type="stratego_wait" id="184">
                  <value name="TIMES">
                    <block type="stratego_number" id="185"> 
                      <field name="NUM">#{DEFAULT_CRAB_ASKING_WAIT}</field>
                    </block>
                  </value> 
                  <next>
                    <block type="stratego_hide_message" id="425"></block>
                  </next>
                </block>
              </next> 
            </block>
          </statement>
        </block>
      </xml>
      """
    
    ASK_QUESTION_UNLOCK_KEY: (answer, nonsense, correctAnswer, x, y, strategoSayBlockName = 'stratego_crab_say') ->
      crabQuestions = "Hello, what do you wish to ask me?"
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_started" id="1290" x="-500" y="500">
          <statement name="DO">
            <block type="stratego_set" id="1291">
              <field name="VAR">#{HIDDEN_MESSAGE_NAME}</field>
              <value name="VALUE">
                <block type="text" id="534">
                    <field name="TEXT">#{crabQuestions} </field>
                </block>
              </value>
              <next>
                <block type="stratego_set" id="1292">
                  <field name="VAR">#{CORRECT_ANSWER_NAME}</field>
                  <value name="VALUE">
                    <block type="text" id="535">
                        <field name="TEXT">#{answer}</field>
                    </block>
                  </value>
                  <next>
                    <block type="stratego_set" id="1293">
                      <field name="VAR">#{INCORRECT_ANSWER_NAME}</field>
                      <value name="VALUE">
                        <block type="text" id="536">
                          <field name="TEXT">#{nonsense}</field>
                        </block>
                      </value>
                    </block>
                  </next>
                </block>
              </next>  
            </block>
          </statement>
        </block>

        <block type="stratego_when_player_nearby" id="538" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}">
          <statement name="DO">
            <block type="stratego_wait_for_answer" id='123'>
              <value name="ANSWER">
                <block type="stratego_get" id="1296">
                  <field name="VAR">#{HIDDEN_MESSAGE_NAME}</field>
                </block>
              </value>  
              <next>
                <block type="stratego_if_else" id="147" inline="false">
                  <value name="CONDITION">
                    <block type="logic_compare" id="4714" inline="true">
                      <field name="OP">EQ</field>
                      <value name="A">
                        <block type="stratego_get_answer"></block>
                      </value>
                      <value name="B">
                        <block type="text" id="534">
                          <field name="TEXT">#{correctAnswer}</field>
                        </block>
                      </value>
                    </block>
                  </value>
                  <statement name="DO">
                    <block type="#{strategoSayBlockName}" id="533">
                      <value name="MSG">
                        <block type="stratego_get" id="1296">
                          <field name="VAR">#{CORRECT_ANSWER_NAME}</field>
                        </block>
                      </value>
                      <next>
                        <block type="stratego_unlock_key" id="533"> 
                          <value name="X">
                            <block type="stratego_number" id="25">
                              <field name="NUM">#{x}</field>
                            </block>
                          </value>
                          <value name="Y">
                            <block type="stratego_number" id="26">
                              <field name="NUM">#{y}</field>
                            </block>
                          </value>  
                        </block> 
                      </next>
                    </block>
                  </statement>
                  <statement name="ELSE">
                    <block type="#{strategoSayBlockName}" id="533">
                      <value name="MSG">
                        <block type="stratego_get" id="1296">
                          <field name="VAR">#{INCORRECT_ANSWER_NAME}</field>
                        </block>
                      </value>
                    </block>
                  </statement>
                  <next>
                    <block type="stratego_wait" id="184">
                      <value name="TIMES">
                        <block type="stratego_number" id="185"> 
                          <field name="NUM">#{DEFAULT_CRAB_ASKING_WAIT}</field>
                        </block>
                      </value> 
                      <next>
                        <block type="stratego_hide_message" id="425"></block>
                      </next>
                    </block>
                  </next>     
                </block>
              </next>   
            </block>
          </statement>
        </block>
      </xml>
      """
    ASK_QUESTION_UNLOCK_KEY_AND_STORE: (question, answerVar, x, y, messageName, strategoSayBlockName = 'stratego_crab_say') ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_started" id="1290" x="-500" y="500">
          <statement name="DO">
            <block type="stratego_set" id="1291">
              <field name="VAR">#{HIDDEN_MESSAGE_NAME}</field>
              <value name="VALUE">
                <block type="text" id="534">
                    <field name="TEXT">#{question} </field>
                </block>
              </value>
            </block>
          </statement>
        </block>
        <block type="stratego_when_player_nearby" id="538" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}">
          <statement name="DO">
            <block type="stratego_if" id="115" inline="false">
              <value name="IF0">
                <block type="logic_compare" id="4714" inline="true">
                  <field name="OP">EQ</field>
                  <value name="A">
                    <block type="stratego_get" id="1296">
                      <field name="VAR">#{answerVar}</field>
                    </block>
                  </value>
                  <value name="B">
                    <block type="text" id="534">
                      <field name="TEXT"></field>
                    </block>
                  </value>
                </block>
              </value>
              <statement name="DO0">
                <block type="stratego_wait_for_answer" id='123'>
                  <value name="ANSWER">
                    <block type="stratego_get" id="1296">
                      <field name="VAR">#{HIDDEN_MESSAGE_NAME}</field>
                    </block>
                  </value>
                  <next>
                    <block type="stratego_set" id="1291">
                      <field name="VAR">#{answerVar}</field>
                      <value name="VALUE">
                        <block type="stratego_get_answer"></block>
                      </value>
                      <next>
                        <block type="stratego_if" id="115" inline="false">
                          <value name="IF0">
                            <block type="logic_compare" id="4714" inline="true">
                              <field name="OP">NEQ</field>
                              <value name="A">
                                <block type="stratego_get" id="1296">
                                  <field name="VAR">#{answerVar}</field>
                                </block>
                              </value>
                              <value name="B">
                                <block type="text" id="534">
                                  <field name="TEXT"></field>
                                </block>
                              </value>
                            </block>
                          </value>
                          <statement name="DO0">
                            <block type="stratego_unlock_key" id="533"> 
                              <value name="X">
                                <block type="stratego_number" id="25">
                                  <field name="NUM">#{x}</field>
                                </block>
                              </value>
                              <value name="Y">
                                <block type="stratego_number" id="26">
                                  <field name="NUM">#{y}</field>
                                </block>
                              </value> 
                              <next>
                                <block type="stratego_send_message_with_data" id="135">
                                  <field name="MESSAGE">#{messageName}</field>
                                  <value name="DATA">
                                    <block type="stratego_get" id="1296">
                                      <field name="VAR">#{answerVar}</field>
                                    </block>
                                  </value>
                                </block>
                              </next>
                            </block> 
                          </statement>
                        </block>
                      </next>
                    </block>
                  </next>
                </block>
               </statement>
            </block>
          </statement>
        </block>
      </xml>
      """

    UNLOCK_KEY_IF_SENT_ANSWERS: (question, answerVar, x, y, correctAnswer, incorrectAnswer, strategoSayBlockName = 'stratego_crab_say') ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_started" id="1290" x="-500" y="500">
          <statement name="DO">
            <block type="stratego_set" id="1291">
              <field name="VAR">#{HIDDEN_MESSAGE_NAME}</field>
              <value name="VALUE">
                <block type="text" id="534">
                    <field name="TEXT">#{question}</field>
                </block>
              </value>
              <next>
                <block type="stratego_set" id="1291">
                  <field name="VAR">#{CORRECT_MESSAGE}</field>
                  <value name="VALUE">
                    <block type="text" id="534">
                        <field name="TEXT">#{correctAnswer}</field>
                    </block>
                  </value>
                  <next>
                    <block type="stratego_set" id="1291">
                      <field name="VAR">#{INCORRECT_MESSAGE}</field>
                      <value name="VALUE">
                        <block type="text" id="534">
                            <field name="TEXT">#{incorrectAnswer}</field>
                        </block>
                      </value>
                    </block>
                  </next>
                </block>
              </next>
            </block>
          </statement>
        </block>

        <!--- STORE MESSAGES RECEIVED -->
        <block type="stratego_when_message" id="135" x="0" y="500">
          <field name="MESSAGE">#{stratego.MESSAGE_OPTIONS[1][0]}</field>
          <statement name="DO">    
            <block type="stratego_set" id="1291">
              <field name="VAR">answer1</field>
              <value name="VALUE">
                <block type="stratego_message_data" id="1294">
                </block>
              </value>
            </block>  
          </statement>
        </block>
        <block type="stratego_when_message" id="135" x="0" y="500">
          <field name="MESSAGE">#{stratego.MESSAGE_OPTIONS[2][0]}</field>
          <statement name="DO">
            <block type="stratego_set" id="1291">
              <field name="VAR">answer2</field>
              <value name="VALUE">
                <block type="stratego_message_data" id="1294">
                </block>
              </value>
            </block>    
          </statement>
        </block>
        <block type="stratego_when_message" id="135" x="0" y="500">
          <field name="MESSAGE">#{stratego.MESSAGE_OPTIONS[3][0]}</field>
          <statement name="DO">
            <block type="stratego_set" id="1291">
              <field name="VAR">answer3</field>
              <value name="VALUE">
                <block type="stratego_message_data" id="1294">
                </block>
              </value>
            </block>    
          </statement>
        </block>


        <block type="stratego_when_player_nearby" id="538" x="0" y="#{START_BLOCK_Y}">
          <statement name="DO">
            <block type="stratego_wait_for_answer" id='123'>
              <value name="ANSWER">
                <block type="stratego_get" id="1296">
                  <field name="VAR">#{HIDDEN_MESSAGE_NAME}</field>
                </block>
              </value>
              <next>
                <block type="stratego_if_else" id="115" inline="false">
                  <value name="CONDITION">
                    <block type="stratego_compare_same_type" id="4714" inline="true">
                      <value name="A">
                        <block type="stratego_get_answer"></block>
                      </value>
                      <value name="B">
                        <block type="stratego_arithmetic" id="1292">
                          <field name="OP">ADD</field>
                          <value name="A">
                            <block type="stratego_get" id="1293">
                              <field name="VAR">answer1</field>
                            </block>
                          </value>
                          <value name="B">
                            <block type="stratego_arithmetic" id="1294">
                              <field name="OP">ADD</field>
                              <value name="A">
                                <block type="stratego_get" id="1295">
                                  <field name="VAR">answer2</field>
                                </block>
                              </value>
                              <value name="B">
                                <block type="stratego_get" id="1296">
                                  <field name="VAR">answer3</field>
                                </block>
                              </value>
                            </block>
                          </value>
                        </block>
                      </value>
                    </block>
                  </value>
                  <statement name="DO">
                    <block type="stratego_unlock_key" id="533"> 
                      <value name="X">
                        <block type="stratego_number" id="25">
                          <field name="NUM">#{x}</field>
                        </block>
                      </value>
                      <value name="Y">
                        <block type="stratego_number" id="26">
                          <field name="NUM">#{y}</field>
                        </block>
                      </value>
                      <next>
                        <block type="#{strategoSayBlockName}" id="533">
                          <value name="MSG">
                            <block type="stratego_get" id="1296">
                              <field name="VAR">#{CORRECT_MESSAGE}</field>
                            </block>
                          </value>      
                        </block>  
                      </next>  
                    </block> 
                  </statement>
                  <statement name="ELSE">
                    <block type="#{strategoSayBlockName}" id="535">
                      <value name="MSG">
                        <block type="stratego_get" id="1296">
                          <field name="VAR">#{INCORRECT_MESSAGE}</field>
                        </block>
                      </value>      
                    </block>  
                  </statement>
                  <next>
                    <block type="stratego_wait" id="184">
                      <value name="TIMES">
                        <block type="stratego_number" id="185"> 
                          <field name="NUM">#{DEFAULT_CRAB_ASKING_WAIT}</field>
                        </block>
                      </value> 
                      <next>
                        <block type="stratego_hide_message" id="425"></block>
                      </next>
                    </block>
                  </next>
                </block>
              </next>
            </block>
          </statement>
        </block>
      </xml>
      """

    CRAB_KING: (question, correctAnswer, incorrectAnswer, blankAnswer, message, strategoSayBlockName = 'stratego_crab_say') ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_started" id="1290" x="-500" y="500">
          <statement name="DO">
            <block type="stratego_set" id="1291">
              <field name="VAR">#{HIDDEN_MESSAGE_NAME}</field>
              <value name="VALUE">
                <block type="text" id="534">
                    <field name="TEXT">#{question}</field>
                </block>
              </value>
              <next>
                <block type="stratego_set" id="1291">
                  <field name="VAR">#{CORRECT_MESSAGE}</field>
                  <value name="VALUE">
                    <block type="text" id="534">
                        <field name="TEXT">#{correctAnswer}</field>
                    </block>
                  </value>
                  <next>
                    <block type="stratego_set" id="1291">
                      <field name="VAR">#{INCORRECT_MESSAGE}</field>
                      <value name="VALUE">
                        <block type="text" id="534">
                            <field name="TEXT">#{incorrectAnswer}</field>
                        </block>
                      </value>
                      <next>
                        <block type="stratego_set" id="1291">
                          <field name="VAR">blankAnswer</field>
                          <value name="VALUE">
                            <block type="text" id="534">
                                <field name="TEXT">#{blankAnswer}</field>
                            </block>
                          </value>
                        </block>
                      </next>
                    </block>
                  </next>
                </block>
              </next>
            </block>
          </statement>
        </block>

        <!--- STORE MESSAGES RECEIVED -->
        <block type="stratego_when_message" id="135" x="500" y="500">
          <field name="MESSAGE">#{message}</field>
          <statement name="DO">    
            <block type="stratego_set" id="1291">
              <field name="VAR">finalAnswer</field>
              <value name="VALUE">
                <block type="stratego_message_data" id="1294">
                </block>
              </value>
            </block>  
          </statement>
        </block>


        <block type="stratego_when_player_nearby" id="538" x="0" y="#{START_BLOCK_Y}">
          <statement name="DO">
            <block type="stratego_wait_for_answer" id='123'>
              <value name="ANSWER">
                <block type="stratego_get" id="1296">
                  <field name="VAR">#{HIDDEN_MESSAGE_NAME}</field>
                </block>
              </value>
              <next>
                <block type="stratego_if_else" id="115" inline="false">
                  <value name="CONDITION">
                    <block type="logic_compare" id="4714" inline="true">
                      <value name="A">
                        <block type="stratego_get" id="1293">
                          <field name="VAR">finalAnswer</field>
                        </block>
                      </value>
                      <value name="B">
                        <block type="text" id="534">
                          <field name="TEXT"></field>
                        </block>
                      </value>
                    </block>
                  </value>
                  <statement name="DO">
                    <block type="#{strategoSayBlockName}" id="535">
                      <value name="MSG">
                        <block type="stratego_get" id="1296">
                          <field name="VAR">blankAnswer</field>
                        </block>
                      </value>      
                    </block>
                  </statement>
                  <statement name="ELSE">
                    <block type="stratego_if_else" id="115" inline="false">
                      <value name="CONDITION">
                        <block type="stratego_compare_same_type" id="4714" inline="true">
                          <value name="A">
                            <block type="stratego_get_answer"></block>
                          </value>
                          <value name="B">
                            <block type="stratego_get" id="1293">
                              <field name="VAR">finalAnswer</field>
                            </block>
                          </value>
                        </block>
                      </value>
                      <statement name="DO">
                        <block type="#{strategoSayBlockName}" id="535">
                          <value name="MSG">
                            <block type="stratego_get" id="1296">
                              <field name="VAR">#{CORRECT_MESSAGE}</field>
                            </block>
                          </value>      
                        </block>
                      </statement>
                      <statement name="ELSE">
                        <block type="#{strategoSayBlockName}" id="535">
                          <value name="MSG">
                            <block type="stratego_get" id="1296">
                              <field name="VAR">#{INCORRECT_MESSAGE}</field>
                            </block>
                          </value>      
                        </block>  
                      </statement>
                    </block>
                  </statement>
                  <next>
                    <block type="stratego_wait" id="184">
                      <value name="TIMES">
                        <block type="stratego_number" id="185"> 
                          <field name="NUM">#{DEFAULT_CRAB_ASKING_WAIT}</field>
                        </block>
                      </value>
                      <next>
                        <block type="stratego_hide_message" id="425"></block>
                      </next> 
                    </block>
                  </next>
                </block>
              </next>
            </block>
          </statement>
        </block>
      </xml>
      """

###
door.coffee
###

window.stratego = window.stratego or {}


###
A door that blocks the player unless unlocked
###
class stratego.Door extends stratego.GameDevice
  CLOSED: 'CLOSED'
  OPEN: 'OPEN'
  MOVING: 'MOVING'

  constructor: (game, x, y) ->
    super(game, x, y, 'atlas', 'door/height2/0')
    @_enablePhysics()
    @body.allowGravity = false
    @body.allowRotation = false
    @body.immovable = true
    @body.moves = false  # we take responsiblity for movement
    @body.customSeparateX = true
    @_state = @CLOSED
    @events.onAnimationComplete.add( ->
      if @animations.currentAnim.name == 'startToOpen'
        @_state = @OPEN
        @animations.play('finishOpen')
      if @animations.currentAnim.name == 'startToClose'
        @_state = @CLOSED
        @animations.play('finishClose')
    , this)
    @setCode(stratego.Door.PROGRAM.DEFAULT())
    @readOnly = true

  @createFromTiledObjectJson: (game, objJson) ->
    newThing = new this(game, objJson.x, objJson.y) # 'this' is the class constructor
    newThing.body.setSize(objJson.width, objJson.height)
    h = objJson.height / stratego.TILESET.TILE_SIZE
    newThing.animations.add('startToOpen', util.anim("door/height#{h}/", 0, 3), 14, false)
    newThing.animations.add('finishOpen', util.anim("door/height#{h}/", 4, 7), 14, false)
    newThing.animations.add('startToClose', util.anim("door/height#{h}/", 7, 4), 14, false)
    newThing.animations.add('finishClose', util.anim("door/height#{h}/", 3, 0), 14, false)
    newThing.animations.add('finalDoor', util.anim("finalDoor/", 0, 0), 1, false)
    newThing.addGlowChild(0, 0, "door/height#{h}/glow")
    newThing.frameName = "door/height#{h}/0"
    newThing

  isClosed: -> @_state == @CLOSED
  isOpen: -> @_state == @OPEN

  open: ->
    if @isClosed()
      @_state = @MOVING
      @animations.play('startToOpen')
      @level().playSound('unlock-door')

  close: ->
    if @isOpen()
      @_state = @MOVING
      @animations.play('startToClose')
      @level().playSound('unlock-door')

  setAsFinalDoor: ->
    @animations.play('finalDoor')


  @TOOLBOX:
    DEFAULT: """
      <block type="stratego_when_player_nearby"></block>
      <block type="stratego_if"></block>
      <block type="stratego_door_is_closed"></block>
      <block type="stratego_player_has_key"></block>
      <block type="stratego_door_open"></block>
      <block type="stratego_door_close"></block>
      <block type="stratego_player_use_key"></block>
    """
    SENSOR: """
      <block type="stratego_when_sensor_pressed"></block>
      <block type="stratego_door_open"></block>
      <block type="stratego_door_close"></block>
      <block type="stratego_if"></block>
      <block type="stratego_sensor_is_color"></block>
    """

  @PROGRAM:
    DEFAULT: ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_player_nearby" id="72" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}" movable="false">
          <statement name="DO">
            <block type="stratego_if" id="73" inline="false">
              <value name="IF0">
                <block type="stratego_door_is_closed" id="85">
                </block>
              </value>
              <statement name="DO0">
                <block type="stratego_if" id="84" inline="false">
                  <value name="IF0">
                    <block type="stratego_player_has_key" id="74">
                    </block>
                  </value>
                  <statement name="DO0">
                    <block type="stratego_player_use_key" id="75">
                      <next>
                        <block type="stratego_door_open" id="76">
                        </block>
                      </next>
                    </block>
                  </statement>
                </block>
              </statement>
            </block>
          </statement>
        </block>
      </xml>
      """
    OPEN_IF_LOCK_IF: (openColor, lockColor) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_sensor_pressed" id="68" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}">
          <statement name="DO">
            <block type="stratego_if" id="86" inline="false">
              <value name="IF0">
                <block type="stratego_sensor_is_color" id="102">
                  <field name="COLOR">#{openColor}</field>
                </block>
              </value>
              <statement name="DO0">
                <block type="stratego_door_open" id="69"></block>
              </statement>
              <next>
                <block type="stratego_if" id="115" inline="false">
                  <value name="IF0">
                    <block type="stratego_sensor_is_color" id="131">
                      <field name="COLOR">#{lockColor}</field>
                    </block>
                  </value>
                  <statement name="DO0">
                    <block type="stratego_door_close" id="156"></block>
                  </statement>
                </block>
              </next>
            </block>
          </statement>
        </block>
      </xml>
      """

    OPEN_IF_PASSWORD: (message, password, correctMsg, incorrectMsg) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">

        <block type="stratego_when_started" id="1290" x="-500" y="500">
          <statement name="DO">
            <block type="stratego_set" id="1291">
              <field name="VAR">#{HIDDEN_MESSAGE_NAME}</field>
              <value name="VALUE">
                <block type="text" id="534">
                  <field name="TEXT">#{message}</field>
                </block>
              </value>
              <next>
                <block type="stratego_set" id="1292">
                  <field name="VAR">#{CORRECT_ANSWER_NAME}</field>
                  <value name="VALUE">
                    <block type="text" id="535">
                      <field name="TEXT">#{correctMsg}</field>
                    </block>
                  </value>
                  <next>
                    <block type="stratego_set" id="1293">
                      <field name="VAR">#{INCORRECT_ANSWER_NAME}</field>
                      <value name="VALUE">
                        <block type="text" id="536">
                          <field name="TEXT">#{incorrectMsg}</field>
                        </block>
                      </value>
                      <next>
                        <block type="stratego_set" id="1293">
                          <field name="VAR">#{ANSWER_NAME}</field>
                          <value name="VALUE">
                            <block type="text" id="536">
                              <field name="TEXT">#{password}</field>
                            </block>
                          </value>
                        </block>
                      </next>
                    </block>
                  </next>
                </block>
              </next>
            </block>
          </statement>
        </block>

        <block type="stratego_when_player_nearby" id="68" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}">
          <statement name="DO">
            <block type="stratego_wait_for_answer" id='123'>
              <value name="ANSWER">
                <block type="stratego_get" id="1296">
                  <field name="VAR">#{HIDDEN_MESSAGE_NAME}</field>
                </block>
              </value>
              <next>
                <block type="stratego_if_else" id="147" inline="false">
                  <value name="CONDITION">
                    <block type="logic_compare" id="4714" inline="true">
                      <field name="OP">EQ</field>
                      <value name="A">
                        <block type="stratego_get_answer"></block>
                      </value>
                      <value name="B">
                        <block type="stratego_get" id="1296">
                          <field name="VAR">#{ANSWER_NAME}</field>
                        </block>
                      </value>
                    </block>
                  </value>
                  <statement name="DO">
                    <block type="stratego_say" id="533">
                      <value name="MSG">
                        <block type="stratego_get" id="1296">
                          <field name="VAR">#{CORRECT_ANSWER_NAME}</field>
                        </block>
                      </value>
                      <next>
                        <block type="stratego_door_open" id="69"></block>
                      </next>
                    </block>
                  </statement>
                  <statement name="ELSE">
                    <block type="stratego_say" id="533">
                      <value name="MSG">
                        <block type="stratego_get" id="1296">
                          <field name="VAR">#{INCORRECT_ANSWER_NAME}</field>
                        </block>
                      </value>
                    </block>
                  </statement>
                  <next>
                    <block type="stratego_wait" id="184">
                      <value name="TIMES">
                        <block type="stratego_number" id="185"> 
                          <field name="NUM">#{DEFAULT_CRAB_ASKING_WAIT}</field>
                        </block>
                      </value> 
                      <next>
                        <block type="stratego_hide_message" id="425"></block>
                      </next>
                    </block>
                  </next>     
                </block>
              </next> 
            </block>
          </statement>
        </block>
      </xml>
      """

    OPEN_AND_CLOSE_IF_MESSAGE_RECIEVED: (openMessage, closeMessage) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_message" id="72" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}" movable="false">
          <field name="MESSAGE">#{openMessage}</field>
          <statement name="DO">
            <block type="stratego_door_open" id="76"></block>
          </statement>
        </block>

        <block type="stratego_when_message" id="72" x="#{START_BLOCK_X}" y="150" movable="false">
          <field name="MESSAGE">#{closeMessage}</field>
          <statement name="DO">
            <block type="stratego_door_close"></block>
          </statement>
        </block>
      </xml>
      """

    OPEN_IF_MESSAGE_RECIEVED: (openMessage) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_message" id="72" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}" movable="false">
          <field name="MESSAGE">#{openMessage}</field>
          <statement name="DO">
            <block type="stratego_door_open" id="76"></block>
          </statement>
        </block>
      </xml>
      """

    END_LEVEL: ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
         <block type="stratego_when_player_nearby" id="68" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}">
          <statement name="DO">
            <block type="stratego_finish_level" id="76"></block>
          </statement>
        </block>
      </xml>
      """

###
editableSensor.coffee
###

window.stratego = window.stratego or {}

###
A platform that can be programmed to do something when pressed
###
class stratego.EditableSensor extends stratego.GameDevice
  constructor: (game, x, y) ->
    super(game, x, y, 'atlas', 'sensorRound/yellow/0')
    @isPressed = false
    @_enablePhysics()
    @addAnimations('yellow')
    @addAnimations('pink')
    @addAnimations('green')
    @addAnimations('blue')
    @addAnimations('magenta')
    @addAnimations('lime')
    @addAnimations('orange')
    @addAnimations('red')
    @level().eventManager.addEventHandler('overlap', @onOverlap, this)
    @level().eventManager.addEventHandler('overlapDone', @onOverlapDone, this)

  _enablePhysics: ->
    super()
    @body.allowGravity = false
    @body.allowRotation = false
    @body.immovable = true
    @body.moves = false
    @body.customSeparateX = true
    @body.customSeparateY = true

  addAnimations: (color) ->
    @animations.add("#{color}Press", util.anim("sensorRound/#{color}/", 0, 1), 14, false)
    @animations.add("#{color}Release", util.anim("sensorRound/#{color}/", 1, 0), 14, false)

  @createFromTiledObjectJson: (game, objJson) ->
    newThing = new this(game, objJson.x, objJson.y)
    
    if objJson.properties == undefined
      newThing.color = 'yellow'
    else if objJson.properties.color == undefined 
      newThing.color = 'yellow'
    else
      newThing.color = objJson.properties.color


    newThing.frameName = 'sensorRound/' + newThing.color + '/0'
    newThing
  
  onOverlap: (params) ->
    return unless params.target == this
    @animations.play("#{@color}Press")
    if @inCameraView() and not @isPressed
      @isPressed = true

      if params.source == @level().player
        @level().eventManager.dispatchEvent( 'sensor_device_pressed',
          color: @color.toUpperCase()
          pressedBy: params.source
          currentDevice: this)
      else
        @level().eventManager.dispatchEvent( 'sensor_device_pressed_by_npc',
          color: @color.toUpperCase()
          pressedBy: params.source
          currentDevice: this)

  onOverlapDone: (params) ->
    return unless params.target == this
    @isPressed = false
    @animations.play("#{@color}Release")

  @TOOLBOX:
    DEFAULT: """
      <block type="stratego_send_message" id="539">
        <field name="MESSAGE">#{stratego.MESSAGE_OPTIONS[0][0]}</field>
      </block>
    """
    

  @PROGRAM:
    DEFAULT: (message) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_pressed" id="538" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}" movable="false">
          <statement name="DO">
            <block type="stratego_send_message" id="539">
              <field name="MESSAGE">#{message}</field>
            </block>
          </statement>
        </block>
      </xml>
      """

    EMPTY_PRESSED: ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_pressed" id="538" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}" movable="false">
          <statement name="DO">
            
          </statement>
        </block>
      </xml>
      """

    EMPTY_PRESSED_BY_NPC: ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_pressed_by_npc" id="538" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}" movable="false">
          <statement name="DO">
            
          </statement>
        </block>
      </xml>
      """



###
elevator.coffee
###

window.stratego = window.stratego or {}

###
A platform that can be programmed to go up and down
###
class stratego.Elevator extends stratego.GameDevice
  constructor: (game, x, y) ->
    super(game, x, y, 'atlas', 'elevator/width2/0')
    @_enablePhysics()
    @uncrash()
    @level().eventManager.addEventHandler('player_respawned', @_respawn, this)

  _enablePhysics: ->
    super()
    @body.allowGravity = false
    @body.allowRotation = false
    @body.immovable = false
    @body.moves = false  # we take responsiblity for movement
    @body.drag = stratego.Player.DRAG
    @body.customSeparateY = true  # we handle colliding with player

  @createFromTiledObjectJson: (game, objJson) ->
    newThing = new this(game, objJson.x, objJson.y) # 'this' is the class constructor
    newThing.body.setSize(objJson.width, objJson.height)
    newThing.name = objJson.name
    w = objJson.width / stratego.TILESET.TILE_SIZE
    newThing.animations.add("hover", util.anim("elevator/width#{w}/", 0, 3), 12, true)
    crash = newThing.animations.add("crash", util.anim("elevator/width#{w}/crash/", 0, 6), 12, false)
    crash.killOnComplete = true
    xOffset = if w == 2 then 0.07 else 0.01
    newThing.addGlowChild(xOffset, 0.11, "elevator/width#{w}/glow")
    newThing.animations.play("hover")
    newThing

  toggleCamera: (params) ->
    if params.source == this
      if not params.inCamera
        @stop() # Stop elevator if it is out of view

  stop: ->
    @body.velocity.x = 0
    @body.velocity.y = 0

  move_to: (x,y) ->
    super(x,y)
    if y < 0 or y > 1536 - @height
      @crash()

  crash: ->
    return if @crashed
    @crashed = true
    @stopCode()
    @level().player.kill() if @level().player.lockedTo == this
    @level().playSound('boom')
    @animations.play('crash')
    @body.enable = false

  uncrash: ->
    @crashed = false
    @animations.play('hover')
    @body.enable = true

  _respawn: ->
    super()
    @uncrash()

  @TOOLBOX:
    DEFAULT: """
      <block type="stratego_glide_up"></block>
      <block type="stratego_glide_down"></block>
      <block type="stratego_repeat"></block>
      <block type="stratego_reset_position"></block>
    """
    DEFAULT_FUNCTIONS: """
      <category name="All" expanded="true">
        <block type="stratego_glide_up"></block>
        <block type="stratego_glide_down"></block>
        <block type="stratego_repeat"></block>
        <block type="stratego_reset_position"></block>
      </category>
      <category name="Functions" custom="PROCEDURE"></category>
    """
    NO_REPEAT: """
      <block type="stratego_glide_up"></block>
      <block type="stratego_glide_down"></block>
      <block type="stratego_reset_position"></block>
    """
    REPEAT_FOREVER: """
      <block type="stratego_glide_up"></block>
      <block type="stratego_glide_down"></block>
      <block type="stratego_repeat"></block>
      <block type="stratego_repeat_forever"></block>
      <block type="stratego_reset_position"></block>
    """
    SENSOR: """
      <block type="stratego_when_sensor_pressed"></block>
      <block type="stratego_glide_down"></block>
      <block type="stratego_glide_up"></block>
    """
    SENSOR_CONDITIONAL: """
      <block type="stratego_when_sensor_pressed"></block>
      <block type="stratego_if"></block>
      <block type="stratego_sensor_is_color"></block>
      <block type="stratego_repeat"></block>
      <block type="stratego_glide_down"></block>
      <block type="stratego_glide_up"></block>
    """

  @PROGRAM:
    FOREVER_DOWN_UP: (amount) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_started" id="135" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}">
          <statement name="DO">
            <block type="stratego_repeat_forever" id="147">
              <statement name="DO">
                <block type="stratego_repeat" id="148">
                  <field name="TIMES">#{amount}</field>
                  <statement name="DO">
                    <block type="stratego_glide_down" id="150">
                    </block>
                  </statement>
                  <next>
                    <block type="stratego_repeat" id="149">
                      <field name="TIMES">#{amount}</field>
                      <statement name="DO">
                        <block type="stratego_glide_up" id="151">
                        </block>
                      </statement>
                    </block>
                  </next>
                </block>
              </statement>
            </block>
          </statement>
        </block>
      </xml>
      """
    FOREVER_UP_DOWN: (amount) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_started" id="135" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}">
          <statement name="DO">
            <block type="stratego_repeat_forever" id="147">
              <statement name="DO">
                <block type="stratego_repeat" id="149">
                  <field name="TIMES">#{amount}</field>
                  <statement name="DO">
                    <block type="stratego_glide_up" id="151">
                    </block>
                  </statement>
                  <next>
                  <block type="stratego_repeat" id="148">
                    <field name="TIMES">#{amount}</field>
                    <statement name="DO">
                      <block type="stratego_glide_down" id="150">
                      </block>
                    </statement>
                  </block>
                  </next>
                </block>
              </statement>
            </block>
          </statement>
        </block>
      </xml>
      """

    UP_DOWN_ONCE_WHEN_SENSOR_FUNCTION: (color, amount) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_sensor_pressed" id="135" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}" deletable="false" movable="true" editable="false">
          <statement name="DO">

          </statement>
        </block>

        <block type="procedures_defnoreturn" id="863" x="438" y="113" editable="true" movable="true">
          <field name="NAME">StartElevator</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
          <statement name="STACK">
            <block type="stratego_repeat" id="149" movable="false" editable="true">
              <field name="TIMES">#{amount}</field>
              <statement name="DO">
                <block type="stratego_glide_up" id="151" movable="false" editable="false">
                </block>
              </statement>
              <next>
                <block type="stratego_repeat" id="148" movable="false" editable="true">
                  <field name="TIMES">#{amount}</field>
                  <statement name="DO">
                    <block type="stratego_glide_down" id="150" movable="false" editable="false">
                    </block>
                  </statement>
                </block>
              </next>
            </block>
          </statement>
        </block>
      </xml>
      """

    FOREVER_UP_DOWN_FUNCTION: (amount) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_started" id="135" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}" deletable="false" editable="false" movable="true">
          <statement name="DO">
            <block type="procedures_callnoreturn" id="860" movable="false" editable="false">
              <mutation name="StartElevator" />
            </block>
          </statement>
        </block>

        <block type="procedures_defnoreturn" id="863" x="438" y="113" editable="true" movable="true">
          <field name="NAME">StartElevator</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
            <statement name="STACK">
              <block type="stratego_repeat_forever" id="147">
              <statement name="DO">
                <block type="stratego_repeat" id="149">
                  <field name="TIMES">#{amount}</field>
                  <statement name="DO">
                    <block type="stratego_glide_up" id="151">
                    </block>
                  </statement>
                  <next>
                    <block type="stratego_repeat" id="148">
                      <field name="TIMES">#{amount}</field>
                      <statement name="DO">
                        <block type="stratego_glide_down" id="150">
                        </block>
                      </statement>
                    </block>
                  </next>
                </block>
              </statement>
            </block>
          </statement>
        </block>
      </xml>
      """

    FOREVER_UP_DOWN_FUNCTION_NOT_STARTED: (amount, editableNumbers = true) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_player_jump" id="135" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}" deletable="false" editable="false" movable="true">
          <statement name="DO">

          </statement>
        </block>

        <block type="procedures_defnoreturn" id="863" x="438" y="113" editable="true" movable="true">
          <field name="NAME">StartElevator</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
            <statement name="STACK">
              <block type="stratego_repeat_forever" id="147" editable="false" movable="false">
              <statement name="DO">
                <block type="stratego_repeat" id="149" editable="#{editableNumbers}" movable="false">
                  <field name="TIMES">#{amount}</field>
                  <statement name="DO">
                    <block type="stratego_glide_up" id="151" editable="false" movable="false">
                    </block>
                  </statement>
                  <next>
                    <block type="stratego_repeat" id="148" editable="#{editableNumbers}" movable="false">
                      <field name="TIMES">#{amount}</field>
                      <statement name="DO">
                        <block type="stratego_glide_down" id="150" editable="false" movable="false">
                        </block>
                      </statement>
                    </block>
                  </next>
                </block>
              </statement>
            </block>
          </statement>
        </block>
      </xml>
      """

    FOREVER_DOWN_UP_FUNCTION_NOT_STARTED: (amount) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_player_jump" id="135" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}" deletable="false" editable="false" movable="true">
          <statement name="DO">

          </statement>
        </block>

        <block type="procedures_defnoreturn" id="863" x="438" y="113" editable="true" movable="true">
          <field name="NAME">StartElevator</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
            <statement name="STACK">
              <block type="stratego_repeat_forever" id="147" editable="false" movable="false">
              <statement name="DO">
                <block type="stratego_repeat" id="149" editable="false" movable="false">
                  <field name="TIMES">#{amount}</field>
                  <statement name="DO">
                    <block type="stratego_glide_down" id="151" editable="false" movable="false">
                    </block>
                  </statement>
                  <next>
                    <block type="stratego_repeat" id="148" editable="false" movable="false">
                      <field name="TIMES">#{amount}</field>
                      <statement name="DO">
                        <block type="stratego_glide_up" id="150" editable="false" movable="false">
                        </block>
                      </statement>
                    </block>
                  </next>
                </block>
              </statement>
            </block>
          </statement>
        </block>
      </xml>
      """
    
    SENSORS: (s1_color, s1_block, s2_color, s2_block) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_sensor_pressed" id="53" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}">
          <statement name="DO">
            <block type="stratego_if" id="54" inline="false">
              <value name="IF0">
                <block type="stratego_sensor_is_color" id="55">
                  <field name="COLOR">#{s1_color}</field>
                </block>
              </value>
              <statement name="DO0">
                <block type="#{s1_block}" id="56">
                </block>
              </statement>
              <next>
                <block type="stratego_if" id="57" inline="false">
                  <value name="IF0">
                    <block type="stratego_sensor_is_color" id="58">
                      <field name="COLOR">#{s2_color}</field>
                    </block>
                  </value>
                  <statement name="DO0">
                    <block type="#{s2_block}" id="59">
                    </block>
                  </statement>
                </block>
              </next>
            </block>
          </statement>
        </block>
      </xml>
      """
    SENSOR_REPEAT: (s1_color, s1_block, s1_repeat, s2_color, s2_block, s2_repeat) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_sensor_pressed" id="53" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}">
          <statement name="DO">
            <block type="stratego_if" id="54" inline="false">
              <value name="IF0">
                <block type="stratego_sensor_is_color" id="55">
                  <field name="COLOR">#{s1_color}</field>
                </block>
              </value>
              <statement name="DO0">
                <block type="stratego_repeat" id="148">
                  <field name="TIMES">#{s1_repeat}</field>
                  <statement name="DO">
                    <block type="#{s1_block}" id="56">
                    </block>
                  </statement>
                </block>
              </statement>
              <next>
                <block type="stratego_if" id="57" inline="false">
                  <value name="IF0">
                    <block type="stratego_sensor_is_color" id="58">
                      <field name="COLOR">#{s2_color}</field>
                    </block>
                  </value>
                  <statement name="DO0">
                    <block type="stratego_repeat" id="148">
                      <field name="TIMES">#{s2_repeat}</field>
                      <statement name="DO">
                        <block type="#{s2_block}" id="56">
                        </block>
                      </statement>
                    </block>
                  </statement>
                </block>
              </next>
            </block>
          </statement>
        </block>
      </xml>
      """
    SENSOR_EMPTY: ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_sensor_pressed" id="1" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}" movable="false">
        </block>
      </xml>
      """

###
Key.coffee
###

# imports
phaser = Phaser
util = stratego.util


###
Keys are for unlocking Doors
###
class stratego.Key extends stratego.Thing
  constructor: (game, x, y) ->
    super(game, x, y, 'atlas', 'key/0')
    @_enablePhysics()
    @animations.add('spin', util.anim('key/', 0, 5), 8, true)
    @animations.add('spinLocked', util.anim('key/locked/', 0, 5), 8, true)
    @animations.play('spinLocked')
    @level().eventManager.addEventHandler('overlap', @onOverlap, this)

  _enablePhysics: ->
    super()
    @body.allowGravity = false
    @body.allowRotation = false
    @body.immovable = true
    @body.moves = false  # we take responsiblity for movement
    @body.customSeparateX = true  # we handle colliding with player
    @body.customSeparateY = true  # we handle colliding with player

  onOverlap: (params) ->
    return unless params.target == this
    if params.source.canPickupKey() and @alive and not @locked
      params.source.pickupKey(this)
      @kill()

  setTileId: (id) ->
    super(id)
    if @tileId == stratego.TILESET.LOCKED_KEY
      @lock()
    else
      @unlock()

  unlock: ->
    @locked = false
    @animations.stop('spinLocked')
    @animations.play('spin')
  
  lock: ->
    @locked = true
    @animations.stop('spin')
    @animations.play('spinLocked')
###
Keystone.coffee
###

# imports
phaser = Phaser
util = stratego.util


###
Keystones "unlock" different projectile types when opened with the correct key
###
class stratego.Keystone extends stratego.GameDevice
  constructor: (game, x, y) ->
    super(game, x, y, 'atlas', 'keystone/round/0')
    @isPressed = false
    @_enablePhysics()

    @level().eventManager.addEventHandler('overlap', @onOverlap, this)

  _enablePhysics: ->
    super()
    @body.allowGravity = false
    @body.allowRotation = false
    @body.immovable = true
    @body.moves = false  # we take responsiblity for movement
    @body.customSeparateX = false 
    @body.customSeparateY = false 

  @createFromTiledObjectJson: (game, objJson) ->
    newThing = new this(game, objJson.x, objJson.y) # 'this' is the class constructor

    if objJson.properties != undefined and objJson.properties.blockType != undefined
      switch objJson.properties.blockType
        when "round" 
          newThing.blockType = stratego.KEYS.ROUND
          newThing.spriteName = "round"
        when "hourglass" 
          newThing.blockType = stratego.KEYS.HOURGLASS
          newThing.spriteName = "hourglass"
        when "square" 
          newThing.blockType = stratego.KEYS.SQUARE
          newThing.spriteName = "square"
        when "pie" 
          newThing.blockType = stratego.KEYS.PIE
          newThing.spriteName = "pie"
        else 
          newThing.blockType = stratego.KEYS.ROUND
          newThing.spriteName = "round"
    else
      newThing.blockType = stratego.KEYS.ROUND
      newThing.spriteName = "round" 

    newThing.frameName = "keystone/#{newThing.spriteName}/0"
    newThing.collapseAnim = newThing.animations.add("collapse", util.anim("keystone/#{newThing.spriteName}/", 0, 8), 5)
    newThing.collapseAnim.onComplete.add(newThing.destroyKeystone, newThing)

    newThing

  collapse: ->  
    @body.enable = false
    @level().playSound('keystone-power-unlocked')
    @animations.play("collapse")
    @activated = true

  destroyKeystone: ->
    @level().unregisterThing(this)
    @kill()

  onOverlap: (params) ->
    return unless params.target == this
    if @inCameraView() and not @isPressed
       @isPressed = true

  @TOOLBOX:
    DEFAULT: """
      <category name="All" expanded="true">
        <block type="stratego_angle" editable="true">
          <field name="NUM">45</field>
        </block>
        <block type="stratego_forces_dropdown">
          <field name="FORCE">600</field>
        </block>
        <block type="stratego_load_projectile"></block>
        <block type="stratego_aim_launcher"></block>
        <block type="stratego_throw_projectile_explicit">
          <value name="FORCE">
          </value>
        </block>
        <block type="stratego_launcher_keys_dropdown"></block>
        <block type="stratego_say">
          <value name="MSG">
            <block type="text">
              <field name="TEXT">hello</field>
            </block>
          </value>
        </block>
        <block type="logic_compare"></block>
        <block type="stratego_arithmetic"></block>
      </category>
      <category name="Variables" custom="VARIABLE"></category>
      <category name="Functions" custom="PROCEDURE"></category>
    """

  @PROGRAM:
    DEFAULT: (keyType) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_player_nearby" id="503" deletable="false" x="13" y="13">
          <statement name="DO">
            <block type="stratego_say" id="504">
              <value name="MSG">
                <block type="procedures_callreturn" id="505">
                  <mutation name="unlockPower">
                    <arg name="key" />
                  </mutation>
                  <value name="ARG0">
                    <block type="stratego_launcher_keys_dropdown" id="641">
                      <field name="KEY">#{keyType}</field>
                    </block>
                  </value>
                </block>
              </value>
              <next>
                <block type="stratego_wait" id="184">
                  <value name="TIMES">
                    <block type="stratego_number" id="185"> 
                      <field name="NUM">50</field>
                    </block>
                  </value> 
                  <next>
                    <block type="stratego_hide_message" id="425"></block>
                  </next>
                </block>
              </next> 
            </block>
          </statement>
        </block>
        <block type="procedures_defreturn" id="506" x="246" y="118">
          <mutation>
            <arg name="key" />
          </mutation>
          <field name="NAME">unlockPower</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
          <statement name="STACK">
            <block type="procedures_ifreturn" id="507">
              <mutation value="1" />
              <value name="CONDITION">
                <block type="logic_compare" id="508">
                  <field name="OP">EQ</field>
                  <value name="A">
                    <block type="variables_get" id="509">
                      <field name="VAR">key</field>
                    </block>
                  </value>
                  <value name="B">
                    <block type="stratego_has_launcher_key" id="510">
                      <field name="KEY">1</field>
                    </block>
                  </value>
                </block>
              </value>
              <value name="VALUE">
                <block type="stratego_use_launcher_key" id="511">
                  <field name="POWER">1</field>
                </block>
              </value>
              <next>
                <block type="procedures_ifreturn" id="512">
                  <mutation value="1" />
                  <value name="CONDITION">
                    <block type="logic_compare" id="513">
                      <field name="OP">EQ</field>
                      <value name="A">
                        <block type="variables_get" id="514">
                          <field name="VAR">key</field>
                        </block>
                      </value>
                      <value name="B">
                        <block type="stratego_has_launcher_key" id="515">
                          <field name="KEY">2</field>
                        </block>
                      </value>
                    </block>
                  </value>
                  <value name="VALUE">
                    <block type="stratego_use_launcher_key" id="516">
                      <field name="POWER">2</field>
                    </block>
                  </value>
                  <next>
                    <block type="procedures_ifreturn" id="517">
                      <mutation value="1" />
                      <value name="CONDITION">
                        <block type="logic_compare" id="518">
                          <field name="OP">EQ</field>
                          <value name="A">
                            <block type="variables_get" id="519">
                              <field name="VAR">key</field>
                            </block>
                          </value>
                          <value name="B">
                            <block type="stratego_has_launcher_key" id="520">
                              <field name="KEY">3</field>
                            </block>
                          </value>
                        </block>
                      </value>
                      <value name="VALUE">
                        <block type="stratego_use_launcher_key" id="521">
                          <field name="POWER">3</field>
                        </block>
                      </value>
                      <next>
                        <block type="procedures_ifreturn" id="522">
                          <mutation value="1" />
                          <value name="CONDITION">
                            <block type="logic_compare" id="523">
                              <field name="OP">EQ</field>
                              <value name="A">
                                <block type="variables_get" id="524">
                                  <field name="VAR">key</field>
                                </block>
                              </value>
                              <value name="B">
                                <block type="stratego_has_launcher_key" id="525">
                                  <field name="KEY">4</field>
                                </block>
                              </value>
                            </block>
                          </value>
                          <value name="VALUE">
                            <block type="stratego_use_launcher_key" id="526">
                              <field name="POWER">4</field>
                            </block>
                          </value>
                        </block>
                      </next>
                    </block>
                  </next>
                </block>
              </next>
            </block>
          </statement>
          <value name="RETURN">
            <block type="text" id="367">
              <field name="TEXT">No power unlocked!</field>
            </block>
          </value>
        </block>
      </xml>
      """

###
launcher.coffee
###

window.stratego = window.stratego or {}

###
An object that can be programmed to throw projectiles when pressed
###
class stratego.Launcher extends stratego.GameDevice

  POOL_SIZE = 10
  throwAngles = 0

  constructor: (game, x, y) ->
    super(game, x, y, 'atlas', 'launcher/30')
    @_enablePhysics()
    @animations.add("0", ["launcher/0"], 14, false)
    @animations.add("15", ["launcher/15"], 14, false)
    @animations.add("30", ["launcher/30"], 14, false)
    @animations.add("45", ["launcher/45"], 14, false)
    @animations.add("60", ["launcher/60"], 14, false)
    @animations.add("75", ["launcher/75"], 14, false)
    @animations.add("90", ["launcher/90"], 14, false)
    @animations.add("105", ["launcher/105"], 14, false)
    @animations.add("120", ["launcher/120"], 14, false)
    @animations.add("135", ["launcher/135"], 14, false)
    @animations.add("150", ["launcher/150"], 14, false)
    @animations.add("165", ["launcher/165"], 14, false)
    @animations.add("180", ["launcher/180"], 14, false)
    @currentProjectileType = stratego.PROJECTILES.SNOWBALL
    @setProjectilePool()

  setProjectilePool: ->
    if not @level().projectilePool or @level().projectilePool.length == 0 # Initialize pool just once
      @level().projectilePool = @game.add.group(@level().depthGroup['devices'])
      @level().projectilePool.addChild(new stratego.Projectile(@game)) for i in [1..POOL_SIZE]
      p.destroyProjectile() for p in @level().projectilePool.children
      @level().projectilePool.callAll('kill')

  getProjectileFromPool: (newX, newY, type) ->
    r = @level().projectilePool.getFirstDead()
    throw new stratego.StrategoException('Launcher: Pool exhausted!') unless r?
    r.reviveProjectile(newX, newY, type)
    r

  _enablePhysics: ->
    super()
    @body.allowGravity = false
    @body.allowRotation = false
    @body.immovable = true
    @body.moves = false
    @body.customSeparateX = true
    @body.customSeparateY = true

  @createFromTiledObjectJson: (game, objJson) ->
    newThing = new this(game, objJson.x, objJson.y)
    newThing 
    
  setAnimation: (degrees) ->
    degrees180 = if degrees > 180 then (if degrees < 270 then 180 else 0) else degrees
    animDegrees = Math.round(degrees180/15) * 15;
    @animations.play("#{animDegrees}")

  @TOOLBOX:
    DEFAULT: """
      <category name="All" expanded="true">
        <block type="stratego_angle" editable="true">
          <field name="NUM">45</field>
        </block>
        <block type="stratego_throw_projectile"></block>
        <block type="stratego_wait">
          <value name="TIMES">
            <block type="stratego_number">
              <field name="NUM">10</field>
            </block>
          </value>
        </block>
      </category>
      <category name="Functions" custom="PROCEDURE"></category>
    """
    THROW_PROJECTILE_AND_NUMBER: """
      <category name="All" expanded="true">
        <block type="stratego_angle">
          <field name="NUM">45</field>
        </block>
        <block type="stratego_forces_dropdown">
          <field name="FORCE">600</field>
        </block>
        <block type="stratego_projectiles_dropdown_just_snowball">
          <field name="PROJECTILE">0</field>
        </block>
        <block type="stratego_wait">
          <value name="TIMES">
            <block type="stratego_number">
              <field name="NUM">10</field>
            </block>
          </value>
        </block>
      </category>
      <category name="Functions" custom="PROCEDURE"></category>
    """

    WITH_PARAMS: (projectilesDropdown) ->
      """
        <category name="All" expanded="true">
          <block type="stratego_angle" editable="true">
            <field name="NUM">45</field>
          </block>
          <block type="stratego_forces_dropdown">
            <field name="FORCE">600</field>
          </block>
          <block type="stratego_load_projectile">
            <value name="PROJECTILE">
              <block type="#{projectilesDropdown}" id="234">
                <field name="PROJECTILE">0</field>
              </block>
            </value>
          </block>
          <block type="#{projectilesDropdown}">
            <field name="PROJECTILE">0</field>
          </block>
          <block type="stratego_aim_launcher"></block>
          <block type="stratego_throw_projectile_explicit">
            <value name="FORCE">
            </value>
          </block>
          <block type="stratego_wait">
            <value name="TIMES">
              <block type="stratego_number">
                <field name="NUM">10</field>
              </block>
            </value>
          </block>
        </category>
        <category name="Variables" custom="VARIABLE"></category>
        <category name="Functions" custom="PROCEDURE"></category>
      """
    

  @PROGRAM:
    DEFAULT: (message) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_launcher_sensor_pressed" deletable="false" x="88" y="38">
        </block>
      </xml>
      """

    EXPLICIT_PROJECTILE_PROCEDURE: (force, angle, editableForce, editableAngle) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_launcher_sensor_pressed" id="538" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}" deletable="false" movable="true" editable="false">
          <statement name="DO">
            
          </statement>
        </block>

        <block type="procedures_defnoreturn" id="863" x="438" y="113" movable="true">
          <field name="NAME">ThrowSnowball</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
          <statement name="STACK">
            <block type="stratego_load_projectile" >
              <value name="PROJECTILE">
                <block type="stratego_projectiles_dropdown_just_snowball" id="234">
                  <field name="PROJECTILE">0</field>
                </block>
              </value>
                <next>
                  <block type="stratego_aim_launcher" editable="#{editableAngle}">
                    <value name="ANGLE">
                      <block type="stratego_number" id="260">
                        <field name="NUM">#{angle}</field>
                      </block>
                    </value>
                    <next>
                      <block type="stratego_throw_projectile_explicit" id="866"  >
                        <value name="FORCE">
                          <block type="stratego_forces_dropdown" id="861" editable="#{editableForce}">
                            <field name="FORCE">#{force}</field>
                          </block>
                        </value>
                      </block>
                    </next>
                  </block>
                </next>
            </block>
          </statement>
        </block>
      </xml>
      """

    PROJECTILE_PROCEDURE_WITH_PARAMS: ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_launcher_sensor_pressed" id="957" deletable="false" editable="false" x="150" y="25">
        </block>
        <block type="procedures_defnoreturn" id="961" x="434" y="126" deletable="false" editable="true" >
          <mutation>
            <arg name="angle" />
            <arg name="force" />
          </mutation>
          <field name="NAME">throwSnowball</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
          <statement name="STACK">
            <block type="stratego_load_projectile" id="962" movable="false">
              <value name="PROJECTILE">
                <block type="stratego_projectiles_dropdown_just_snowball" id="963" movable="false">
                  <field name="PROJECTILE">0</field>
                </block>
              </value>
              <next>
                <block type="stratego_aim_launcher" id="964" movable="false">
                  <value name="ANGLE">
                    <block type="variables_get" id="965" movable="false" editable="false">
                      <field name="VAR">angle</field>
                    </block>
                  </value>
                  <next>
                    <block type="stratego_throw_projectile_explicit" id="966" movable="false">
                        <value name="FORCE">
                          <block type="variables_get" id="967" movable="false" editable="false">
                            <field name="VAR">force</field>
                          </block>
                        </value>
                    </block>
                  </next>
                </block>
              </next>
            </block>
          </statement>
        </block>
      </xml>
      """

    EMPTY_WITH_PARAMETERS: ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_launcher_sensor_pressed" deletable="false" editable="true" x="150" y="20">
        </block>

        <block type="procedures_defnoreturn" deletable="false" id="212" x="400" y="200">
          <mutation>
            <arg name="angle" />
            <arg name="force" />
          </mutation>
          <field name="NAME">throwProjectile</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
        </block>
      </xml>
      """

    EMPTY_PARAMETERS_ON_PRESSED: -> # Launcher 2 Snow 2
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_launcher_sensor_pressed" deletable="false" editable="true" x="400" y="20">
          <statement name="DO">
            <block type="procedures_callnoreturn" movable="false">
              <mutation name="throwProjectile">
                <arg name="angle" />
                <arg name="force" />
              </mutation>
              <value name="ARG0">
                <block type="stratego_angle" movable="false">
                  <field name="NUM">45</field>
                </block>
              </value>
              <value name="ARG1">
                <block type="stratego_forces_dropdown" movable="false">
                  <field name="FORCE">600</field>
                </block>
              </value>
            </block>
          </statement>
        </block>

        <block type="procedures_defnoreturn" deletable="false" id="212" x="400" y="200">
          <mutation>
            <arg name="angle" />
            <arg name="force" />
          </mutation>
          <field name="NAME">throwProjectile</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
          <statement name="STACK">
            <block type="stratego_load_projectile" id="962" movable="false">
              <value name="PROJECTILE">
                <block type="stratego_projectiles_dropdown_just_snowball" id="963" movable="false">
                  <field name="PROJECTILE">0</field>
                </block>
              </value>
              <next>
                <block type="stratego_aim_launcher" id="964" movable="false">
                  <next>
                    <block type="stratego_throw_projectile_explicit" id="966" movable="false">
                    </block>
                  </next>
                </block>
              </next>
            </block>
          </statement>
        </block>
      </xml>
      """

    EMPTY_FUNCTION_ON_PRESSED_WITH_PARAMETERS: -> # Launcher 1 Snow 3
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_launcher_sensor_pressed" deletable="false" editable="true" x="150" y="20">
          <statement name="DO">
            <block type="procedures_callnoreturn" movable="false">
              <mutation name="throwProjectile">
                <arg name="angle" />
                <arg name="force" />
              </mutation>
              <value name="ARG0">
                <block type="stratego_angle" movable="false">
                  <field name="NUM">45</field>
                </block>
              </value>
              <value name="ARG1">
                <block type="stratego_forces_dropdown" movable="false">
                  <field name="FORCE">600</field>
                </block>
              </value>
            </block>
          </statement>
        </block>

        <block type="procedures_defnoreturn" deletable="false" id="212" x="400" y="200">
          <mutation>
            <arg name="angle" />
            <arg name="force" />
          </mutation>
          <field name="NAME">throwProjectile</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
        </block>
      </xml>
      """
    
    EMPTY_SNOWBALL_CHICKENEGG_CHOICE: -> # Launcher 2 Snow 3
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_launcher_sensor_pressed" deletable="false" x="88" y="38">

        </block>
        <block type="procedures_defnoreturn" deletable="false" editable="true" x="463" y="63">
          <mutation>
            <arg name="snowAngle" />
            <arg name="snowForce" />
          </mutation>
          <field name="NAME">throwSnowball</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
          <statement name="STACK">
            <block type="stratego_load_projectile" editable="false" movable="false">
              <value name="PROJECTILE">
                <block type="stratego_projectiles_dropdown_2" id="234">
                  <field name="PROJECTILE">0</field>
                </block>
              </value>
              <next>
                <block type="stratego_aim_launcher" editable="false" movable="false">
                  <value name="ANGLE">
                    <block type="variables_get" editable="false" movable="false">
                      <field name="VAR">snowAngle</field>
                    </block>
                  </value>
                  <next>
                    <block type="stratego_throw_projectile_explicit" editable="false" movable="false">
                        <value name="FORCE">
                          <block type="variables_get" editable="false" movable="false">
                            <field name="VAR">snowForce</field>
                          </block>
                        </value>
                    </block>
                  </next>
                </block>
              </next>
            </block>
          </statement>
        </block>
        <block type="procedures_defnoreturn" x="13" y="137" deletable="false" editable="true">
          <mutation>
            <arg name="eggAngle" />
            <arg name="eggForce" />
          </mutation>
          <field name="NAME">throwEgg</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
          <statement name="STACK">
            <block type="stratego_load_projectile" editable="false" movable="false">
              <value name="PROJECTILE">
                <block type="stratego_projectiles_dropdown_2" id="234">
                  <field name="PROJECTILE">1</field>
                </block>
              </value>
              <next>
                <block type="stratego_aim_launcher" editable="false" movable="false">
                    <value name="ANGLE">
                      <block type="variables_get" editable="false" movable="false">
                        <field name="VAR">eggAngle</field>
                      </block>
                    </value>
                    <next>
                      <block type="stratego_throw_projectile_explicit" editable="false" movable="false">
                          <value name="FORCE">
                            <block type="variables_get" editable="false" movable="false">
                              <field name="VAR">eggForce</field>
                            </block>
                          </value>
                      </block>
                    </next>
                </block>
              </next>
            </block>
          </statement>
        </block>
      </xml>
      """

    GENERIC_THROW_OBJECT_CHICKEN_FIREBALL_SNOWBALL: -> # Launcher 3 Snow 3
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_launcher_sensor_pressed" id="1722" deletable="false" x="63" y="13">

        </block>
        <block type="procedures_defnoreturn" id="1729" x="438" y="38" deletable="false" editable="false">
          <field name="NAME">throwEgg</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
          <statement name="STACK">
            <block type="procedures_callnoreturn" id="1730" editable="false" movable="false">
              <mutation name="throwObject">
                <arg name="object" />
                <arg name="angle" />
                <arg name="force" />
              </mutation>
              <value name="ARG0">
                <block type="stratego_projectiles_dropdown_3" id="1731" editable="false" movable="false">
                  <field name="PROJECTILE">1</field>
                </block>
              </value>
            </block>
          </statement>
        </block>
        <block type="procedures_defnoreturn" id="1732" x="38" y="88" deletable="false" editable="true">
            <mutation>
              <arg name="object" />
              <arg name="angle" />
              <arg name="force" />
            </mutation>
            <field name="NAME">throwObject</field>
            <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
            <statement name="STACK">
              <block type="stratego_load_projectile" id="1733" editable="false" movable="false">
                <value name="PROJECTILE">
                  <block type="variables_get" id="1734" editable="false" movable="false">
                    <field name="VAR">object</field>
                  </block>
                </value>
                <next>
                  <block type="stratego_aim_launcher" id="1735" editable="false" movable="false">
                    <value name="ANGLE">
                      <block type="variables_get" id="1736" editable="false" movable="false">
                        <field name="VAR">angle</field>
                      </block>
                    </value>
                    <next>
                      <block type="stratego_throw_projectile_explicit" id="1737" editable="false" movable="false">
                        <value name="FORCE">
                          <block type="variables_get" id="1738" editable="false" movable="false">
                            <field name="VAR">force</field>
                          </block>
                        </value>
                      </block>
                    </next>
                  </block>
                </next>
              </block>
            </statement>
        </block>
        <block type="procedures_defnoreturn" id="1723" x="438" y="188" deletable="false" editable="true">
          <field name="NAME">throwFireball</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
          <statement name="STACK">
            <block type="procedures_callnoreturn" id="1724" editable="false" movable="false">
              <mutation name="throwObject">
                <arg name="object" />
                <arg name="angle" />
                <arg name="force" />
              </mutation>
              <value name="ARG0">
                <block type="stratego_projectiles_dropdown_3" id="1725" editable="false" movable="false">
                  <field name="PROJECTILE">2</field>
                </block>
              </value>
            </block>
          </statement>
        </block>
        <block type="procedures_defnoreturn" id="1726" x="57" y="260" deletable="false" editable="true">
          <field name="NAME">throwSnowball</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
          <statement name="STACK">
            <block type="procedures_callnoreturn" id="1727" editable="false" movable="false">
              <mutation name="throwObject">
                <arg name="object" />
                <arg name="angle" />
                <arg name="force" />
              </mutation>
              <value name="ARG0">
                <block type="stratego_projectiles_dropdown_3" id="1728" editable="false" movable="false">
                  <field name="PROJECTILE">0</field>
                </block>
              </value>
            </block>
          </statement>
        </block>
      </xml>
      """

    GENERIC_THROW_OBJECT_ROBOPOLLI_CHICKEN_FIREBALL_SNOWBALL_EMPTY: -> # Launcher 4 Snow 3
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_launcher_sensor_pressed" id="1652" x="50" y="63" deletable="false">
        </block>
        <block type="procedures_defnoreturn" id="1653" x="420" y="213" deletable="false">
          <field name="NAME">throwFireball</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
        </block>
        <block type="procedures_defnoreturn" id="1656" x="420" y="13" deletable="false">
          <field name="NAME">throwSnowball</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
        </block>
        <block type="procedures_defnoreturn" id="1659" x="50" y="188" deletable="false" editable="true">
          <mutation>
            <arg name="object" />
            <arg name="angle" />
            <arg name="force" />
          </mutation>
          <field name="NAME">throwObject</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
          <statement name="STACK">
            <block type="stratego_load_projectile" id="1660" editable="false" movable="false">
              <value name="PROJECTILE">
                <block type="variables_get" id="1849" editable="false" movable="false">
                  <field name="VAR">object</field>
                </block>
              </value>
              <next>
                <block type="stratego_aim_launcher" id="1661" editable="false" movable="false">
                  <value name="ANGLE">
                    <block type="variables_get" id="1702" editable="false" movable="false">
                      <field name="VAR">angle</field>
                    </block>
                  </value>
                  <next>
                    <block type="stratego_throw_projectile_explicit" id="1662" editable="false" movable="false">
                      <value name="FORCE">
                        <block type="variables_get" id="1783" editable="false" movable="false">
                          <field name="VAR">force</field>
                        </block>
                      </value>
                    </block>
                  </next>
                </block>
              </next>
            </block>
          </statement>
        </block>
        <block type="procedures_defnoreturn" id="1663" x="420" y="113" deletable="false">
          <field name="NAME">throwEgg</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
        </block>
        <block type="procedures_defnoreturn" id="1666" x="420" y="313" deletable="false">
          <field name="NAME">throwRobopolli</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
        </block>
      </xml>
      """

    GENERIC_THROW_OBJECT_ROCK_FIREBALL_ROBOPOLLI_EMPTY: -> # Launcher 5 Snow 3
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="procedures_defnoreturn"  deletable="false" x="413" y="40">
          <field name="NAME">throwSnowball</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
        </block>

        <block type="stratego_when_launcher_sensor_pressed" deletable="false" x="38" y="40">
        </block>
        
        <block type="procedures_defnoreturn" deletable="false" x="413" y="120">
          <field name="NAME">throwEgg</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
        </block>

        <block type="procedures_defnoreturn" deletable="false" editable="true" x="38" y="188">
          <mutation>
            <arg name="object" />
            <arg name="angle" />
            <arg name="force" />
          </mutation>
          <field name="NAME">throwObject</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
          <statement name="STACK">
            <block type="stratego_load_projectile" id="580" movable="false" editable="false">
              <value name="PROJECTILE">
                <block type="variables_get" movable="false" editable="false">
                  <field name="VAR">object</field>
                </block>
              </value>
              <next>
                <block type="stratego_aim_launcher" movable="false" editable="false">
                  <value name="ANGLE">
                    <block type="variables_get" movable="false" editable="false">
                      <field name="VAR">angle</field>
                    </block>
                  </value>
                  <next>
                    <block type="stratego_throw_projectile_explicit" movable="false" editable="false">
                      <value name="FORCE">
                        <block type="variables_get" movable="false" editable="false">
                          <field name="VAR">force</field>
                        </block>
                      </value>
                    </block>
                  </next>
                </block>
              </next>
            </block>
          </statement>
        </block>

        <block type="procedures_defnoreturn" deletable="false" x="413" y="200">
          <field name="NAME">throwFireball</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
        </block>

        <block type="procedures_defnoreturn"  deletable="false" x="413" y="280">
          <field name="NAME">throwRobopolli</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
        </block>
      </xml>
      """

    GENERIC_THROW_OBJECT_CHICKEN_SNOWBALL_EMPTY: -> # Launcher 6 Snow 3
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_launcher_sensor_pressed" id="257" deletable="false" x="113" y="38">
        </block>
        <block type="procedures_defnoreturn" id="258" deletable="false" editable="true" x="394" y="185">
          <mutation>
            <arg name="object" />
            <arg name="angle" />
            <arg name="force" />
          </mutation>
          <field name="NAME">throwObject</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
          <statement name="STACK">
            <block type="stratego_load_projectile" id="259" movable="false" editable="false">
              <value name="PROJECTILE">
                <block type="variables_get" id="260" movable="false" editable="false">
                  <field name="VAR">object</field>
                </block>
              </value>
              <next>
                <block type="stratego_aim_launcher" id="261" movable="false" editable="false">
                  <value name="ANGLE">
                    <block type="variables_get" id="262" movable="false" editable="false">
                      <field name="VAR">angle</field>
                    </block>
                  </value>
                  <next>
                    <block type="stratego_throw_projectile_explicit" id="263" movable="false" editable="false">
                      <value name="FORCE">
                        <block type="variables_get" id="264" movable="false" editable="false">
                          <field name="VAR">force</field>
                        </block>
                      </value>
                    </block>
                  </next>
                </block>
              </next>
            </block>
          </statement>
        </block>
      </xml>
      """

###
LauncherKey.coffee
###

# imports
phaser = Phaser
util = stratego.util


###
Special keys to 'unlock' different projectile types
###
class stratego.LauncherKey extends stratego.Thing
  constructor: (game, x, y) ->
    super(game, x, y, 'atlas', 'launcherKey/round/0')
    @_enablePhysics()
    @level().eventManager.addEventHandler('overlap', @onOverlap, this)

  _enablePhysics: ->
    super()
    @body.allowGravity = false
    @body.allowRotation = false
    @body.immovable = true
    @body.moves = false  # we take responsiblity for movement
    @body.customSeparateX = true  # we handle colliding with player
    @body.customSeparateY = true  # we handle colliding with player

  setTileId: (id) ->
    super(id)
    switch id
      when stratego.TILESET.ROUND_KEY 
        @keyType = stratego.KEYS.ROUND
        @spriteName = "round"
      when stratego.TILESET.HOURGLASS_KEY
        @keyType = stratego.KEYS.HOURGLASS
        @spriteName = "hourglass"
      when stratego.TILESET.SQUARE_KEY
        @keyType = stratego.KEYS.SQUARE
        @spriteName = "square"
      when stratego.TILESET.PIE_KEY 
        @keyType = stratego.KEYS.PIE
        @spriteName = "pie"
    @frameName = "launcherKey/#{@spriteName}/0"

    @animations.add('spin', util.anim("launcherKey/#{@spriteName}/", 0, 5), 8, true)
    @animations.play('spin')

  onOverlap: (params) ->
    return unless params.target == this
    if @inCameraView() and not @isOverlapped
      if params.source instanceof stratego.Player
        params.source.pickupLauncherKey(@keyType)
        @isOverlapped = true
        @kill()


###
player.coffee

Player - the mysterious, magnificent, miniature moose
###
window.stratego = window.stratego or {}

# imports
phaser = Phaser
util = stratego.util
Point = phaser.Point

class stratego.Player extends stratego.Thing
  @DRAG = new Point(800, 1)
  @MAX_X_VEL = 400
  @JUMP_AMOUNT = 480
  @JUMP_BOOST_AMOUNT = 90
  @RESPAWN_DELAY = 500 # milliseconds
  @IDLE_TIMEOUT = 4500 # milliseconds

  @jumpAnim: (facing, velocity) ->
    if velocity == 0
      if facing == 'left' then 'jumpUpLeft' else 'jumpUpRight'
    else
      if facing == 'left' then 'jumpLeft' else 'jumpRight'

  @idleAnim: (facing) ->
    anims =
      left: ['blinkLeft', 'doubleBlinkLeft', 'shakeLeft']
      right: ['blinkRight', 'doubleBlinkRight', 'shakeRight']
    util.randomOf( anims[facing] )

  @offset: (direction) ->
    map = {
      left: 39
      right: 22
    }
    map[direction]


  constructor: (game, startTile) ->
    super(game, startTile.worldX, startTile.worldY, 'atlas', 'moose/walk/right/0')
    @velocity = 0
    @_enablePhysics()
    @body.maxVelocity.y = 1100
    @body.drag = stratego.Player.DRAG
    @face('right')
    @lastJumpTime = 0
    @lastMoveTime = @game.time.now
    @checkpoint = startTile
    @xMoveLockCounter = 0
    @deaths = 0

    @_doorKeys = []
    @_launcherKeys = []

    @animations.add('right', util.anim('moose/walk/right/', 0, 2), 12, true)
    @animations.add('left', util.anim('moose/walk/left/', 0, 2), 12, true)
    @animations.add('jumpRight', util.anim('moose/jump/right/', 0, 8), 12, false)
    @animations.add('jumpLeft', util.anim('moose/jump/left/', 0, 8), 12, false)
    @animations.add('jumpUpRight', util.anim('moose/jump/upRight/', 0, 5), 12, false)
    @animations.add('jumpUpLeft', util.anim('moose/jump/upLeft/', 0, 5), 12, false)

    blinkRightAnim = util.anim('moose/idle/blinkRight/', 0, 1)
    @animations.add('blinkRight', blinkRightAnim, 8, false)
    @animations.add('doubleBlinkRight', blinkRightAnim.concat(blinkRightAnim), 8, false)

    blinkLeftAnim = util.anim('moose/idle/blinkLeft/', 0, 1)
    @animations.add('blinkLeft', blinkLeftAnim, 8, false)
    @animations.add('doubleBlinkLeft', blinkLeftAnim.concat(blinkLeftAnim), 8, false)

    @animations.add('shakeRight', util.anim('moose/idle/shakeRight/', 0, 7), 12, false)
    @animations.add('shakeLeft', util.anim('moose/idle/shakeLeft/', 0, 7), 12, false)
    @animations.add('pop', util.anim('pop/', 0, 3), 12, false)

    @level().eventManager.addEventHandler( 'collisionPlayerTile', @_onCollision, this)
    @level().eventManager.addEventHandler( 'collisionPlayerNpc', @_onCollision, this)
    @level().eventManager.addEventHandler( 'collisionPlayerThing', @_onCollision, this)

    @events.onKilled.add( @_onKilled, this )

  xCoordinate: ->
    Math.round(@x / stratego.TILESET.TILE_SIZE)

  numKeys: ->
    @_doorKeys.length + @_launcherKeys.length

  hasKey: ->
    @_doorKeys.length > 0

  pickupKey: (key) ->
    @_doorKeys.push(key)
    @level().pickupKey()

  useKey: ->
    key = @_doorKeys.pop()
    @level().useKey() if key?
    key

  resetKeys: ->
    for key in @_doorKeys
      key.reset(key.x, key.y)
    @_doorKeys = []
    @level().refreshKeyDisplay()

  hasLauncherKeyType: (keyType) ->
    keyType in @_launcherKeys

  pickupLauncherKey: (key) ->
    @_launcherKeys.push(key)
    @level().pickupLauncherKey()

  useLauncherKey: (keyType) ->
    @_launcherKeys.splice(@_launcherKeys.indexOf(keyType), 1)
    @level().useKey()

  isTouchingGround: ->
    @body.touching.down or @body.blocked.down

  jump: (time, opts) ->
    return if time <= @lastJumpTime or not @alive

    @lastJumpTime = time
    @lastMoveTime = @game.time.now

    if @isTouchingGround()
      @cancelLock()
      @body.velocity.y = -stratego.Player.JUMP_AMOUNT
      @jumpBoosted = false
      @level().playSound('boing')
      @jumping = true
      @animations.play( stratego.Player.jumpAnim( @facing, @body.velocity.x ) )
      @level().eventManager.dispatchEvent('player_jump', {source:this})

    @_boostJump() if opts.boost and not @jumpBoosted

  face: (direction) ->
    @facing = direction
    @body.setSize(65, 128, stratego.Player.offset(direction), 0)

  preUpdate: ->
    super()
    @jumping = false

  update: ->
    super()
    return unless @alive

    @updateLock()
    @checkThingOverlaps()
    @_checkCheckpoint()

    @_applyVelocity()

    if @game.time.now - @lastMoveTime > stratego.Player.IDLE_TIMEOUT
      @_idle()

    @xMoveLockCounter-- if @xMoveLockCounter > 0

  move: (velocity) ->
    return unless @alive
    @stopped = false
    @lastMoveTime = @game.time.now

    # TODO: EPSILON HERE?
    if velocity == 0
      @stop()
    else
      sign = stratego.util.sign(velocity)
      @velocity = sign * Math.min( Math.abs(velocity), stratego.Player.MAX_X_VEL)

      direction = if sign == -1 then 'left' else 'right'
      @face(direction)
      @animations.play(direction) if @isTouchingGround() and not @jumping

    @_applyVelocity( )

  stop: ->
    @stopped = true
    @velocity = 0
    if @animations.name in ['left', 'right']
      @animations.stop()
      @frameName = "moose/walk/#{@facing}/0"

  _boostJump: ->
    @body.velocity.y -= stratego.Player.JUMP_BOOST_AMOUNT
    @jumpBoosted = true

  _applyVelocity: () ->
    @body.velocity.x = @velocity unless @stopped or @xMoveLockCounter > 0

  _checkCheckpoint: ->
    x = @x + @width * 0.5
    y = @y + @height * 0.75
    tile = @level().tileAt(x, y)
    if tile? and tile.index == stratego.TILESET.FIRST_GID + stratego.TILESET.CHECKPOINT
      @checkpoint = tile

  _idle: ->
    @animations.play(stratego.Player.idleAnim(@facing))
    @lastMoveTime = @game.time.now

  _onCollision: () ->
    return unless @alive
    @animations.play(@facing) if @isTouchingGround() and not @jumping and @velocity != 0

  _onKilled: ->
    @body.velocity.x = @body.velocity.y = @velocity = 0
    @animations.play('pop')
    @exists = true
    @level().playSound('pop')
    @game.camera.unfollow()
    @game.add.tween(@game.camera).to( { x:@checkpoint.worldX - @game.camera.view.halfWidth },
                                  stratego.Player.RESPAWN_DELAY,
                                  phaser.Easing.Quadratic.InOut,
                                  true)
    @deaths++
    setTimeout(@_onRespawn, stratego.Player.RESPAWN_DELAY)

  _onRespawn: =>
    @frameName = "moose/walk/#{@facing}/0"
    @resetKeys()
    @reset(@checkpoint.worldX, @checkpoint.worldY - @body.height)
    @game.camera.follow(this, phaser.Camera.FOLLOW_PLATFORMER)
    @level().eventManager.dispatchEvent('player_respawned', {source:this})


  xLockMotion: () ->
    @xMoveLockCounter = 2

###
Projectile.coffee
###

window.stratego = window.stratego or {}


class stratego.Projectile extends stratego.Thing
  constructor: (game, x, y, blockType) ->
    super(game, x, y, 'atlas', "projectile/snowball/0")
    @updateBlockType(blockType)
    @destroyed = false
    @isOverlapped = false
    @_enablePhysics()
    @level().eventManager.addEventHandler('overlap', @onOverlap, this)

  update: ->
    super()
    if not @destroyed
      @checkThingOverlaps() # Check overlaps for collision detection

  _enablePhysics: ->
    super()
    @body.velocity.setTo(0, 0)
    @body.allowGravity = true
    @body.allowRotation = false
    @body.immovable = false
    @level().registerThing(this) # Register the newly created projectile as a thing

  updateBlockType: (type) ->
    @blockType = type
    switch type
      when stratego.PROJECTILES.SNOWBALL
        @spriteName = "snowball"
      when stratego.PROJECTILES.EGGBALL
        @spriteName = "eggball"
      when stratego.PROJECTILES.FIREBALL
        @spriteName = "fireball"
      when stratego.PROJECTILES.ROBOPOLLI
        @spriteName = "robopolli"
      when stratego.PROJECTILES.ROCKBALL
        @spriteName = "rockball"
      else
        @blockType = stratego.PROJECTILES.SNOWBALL # Unknown or undefined blockType, default to snowball
        @spriteName = "snowball"
    @frameName = "projectile/#{@spriteName}/0"
    @updateRotationAnim()

  updateRotationAnim: ->
    if not @spriteName  
      @spriteName = "snowball"
    @rotateAnim = @animations.add('rotate', util.anim("projectile/#{@spriteName}/", 0, 3), 14, true)
    @animations.play('rotate')    

  destroyProjectile: ->
    return if @destroyed
    @level().unregisterThing(this)
    @kill()
    @destroyed = true

  reviveProjectile: (newX, newY, type) ->
    @destroyed = false
    @_enablePhysics()
    @updateBlockType(type)
    @reset(newX, newY)
    @game.time.events.add(Phaser.Timer.SECOND * 3, @destroyProjectile, this);

  onOverlap: (params) ->
    return unless params.target == this
    if params.source in @level().things
      @destroyProjectile()

###
raft.coffee
###

window.stratego = window.stratego or {}

###
A platform that can be programmed to go up and down
###
class stratego.Raft extends stratego.GameDevice
  constructor: (game, x, y) ->
    super(game, x, y, 'atlas', 'raft/0')
    @_enablePhysics()
    @level().eventManager.addEventHandler('player_respawned', @_respawn, this)

  _enablePhysics: ->
    super()
    @body.allowGravity = false
    @body.allowRotation = false
    @body.immovable = false
    @body.moves = false  # we take responsiblity for movement
    @body.drag = stratego.Player.DRAG
    @body.customSeparateX = true  # we handle colliding with player
    @body.customSeparateY = true  # we handle colliding with player

  @createFromTiledObjectJson: (game, objJson) ->
    newThing = new this(game, objJson.x, objJson.y) # 'this' is the class constructor
    newThing.body.setSize(objJson.width, objJson.height)
    newThing.name = objJson.name
    newThing

  toggleCamera: (params) ->
    if params.source == this
      if not params.inCamera
        @stop() # Stop raft if it is out of view

  stop: ->
    @body.velocity.x = 0
    @body.velocity.y = 0


  move_to: (x,y) ->
    super(x,y)
    if y < 0 or y > 1536 - @height
      @crash()

  crash: ->
    @stopCode()

  _respawn: ->
    super()

  @TOOLBOX:
    DEFAULT: """
      <block type="stratego_glide_right"></block>
      <block type="stratego_glide_left"></block>
      <block type="stratego_repeat"></block>
      <block type="stratego_reset_position"></block>
    """
    NO_REPEAT: """
      <block type="stratego_glide_right"></block>
      <block type="stratego_glide_left"></block>
      <block type="stratego_reset_position"></block>
    """
    REPEAT_FOREVER: """
      <block type="stratego_glide_right"></block>
      <block type="stratego_glide_left"></block>
      <block type="stratego_repeat"></block>
      <block type="stratego_repeat_forever"></block>
      <block type="stratego_reset_position"></block>
    """
###
robodillo_burrow.coffee
###

window.stratego = window.stratego or {}


###
They just keep coming out
###
class stratego.RobodilloBurrow extends stratego.GameDevice

  EXTRA_HEIGHT = 23 #pixels taller than a 64px tile
  SPAWN_EVERY = 3000 #milliseconds
  POOL_SIZE = 20 #robodillos per burrow

  constructor: (game, @direction, x, y) ->
    super(game, x * stratego.TILESET.TILE_SIZE, y * stratego.TILESET.TILE_SIZE - EXTRA_HEIGHT, 'atlas','burrow/left/0')
    @_enablePhysics()
    @body.immovable = true
    @level().registerThing(this)
    @lastSpawnTime = @game.time.now

    @dillos = @game.add.group(@level().depthGroup['devices'])
    @dillos.addChild(new stratego.Robodillo(@game)) for i in [1..POOL_SIZE]
    @dillos.callAll('kill')

    @animations.add('left', util.anim('burrow/left/', 0, 2), 6)
    @animations.add('right', util.anim('burrow/right/', 0, 2), 6)
    @animations.add('both', util.anim('burrow/both/', 0, 4), 6)
    @animations.play(@direction)

    @readOnly = true
    @manualOverrideMode = false
    @directionPicker = null

    if @direction == 'left'
      @toolboxXml = stratego.RobodilloBurrow.TOOLBOX.DEFAULT_LEFT
    if @direction == 'right'
      @toolboxXml = stratego.RobodilloBurrow.TOOLBOX.DEFAULT_RIGHT

    @level().eventManager.addEventHandler('player_respawned', @_removeLivingRobodillos, this) # Kill every spawned robodillo when player respawns

  spawnRobodillo: (direction) ->
    @animations.play(@direction)
    r = @_getRobodillo()
    switch direction
      when 'right' then r.zombie('right')
      when 'left' then r.zombie('left')
      when 'both'
        r.zombie('right')
        r2 = @_getRobodillo()
        r2.zombie('left')
        r2.runCode() # Run code to refresh the "OnStart" block, otherwise it won't re-trigger it when respawning for a second time 
    r.runCode() # Run code to refresh the "OnStart" block, otherwise it won't re-trigger it when respawning for a second time 

  randomDirection: ->
    if @directionPicker? then @directionPicker() else util.randomOf(['left', 'right'])

  _getRobodillo: ->
    r = @dillos.getFirstDead()
    throw new stratego.StrategoException('RobodilloBurrow: Pool exhausted!') unless r?
    r.reset(@x + 64, @y + EXTRA_HEIGHT)

  _removeLivingRobodillos: ->
    r = @dillos.getFirstAlive()
    while (r != null)
      r.kill()
      r = @dillos.getFirstAlive()

  update: ->
    super()
    return if @manualOverrideMode
    if @game.time.now - @lastSpawnTime > SPAWN_EVERY and @inCameraView() # Keep spawning robodillos only if inside camera view
      @spawnRobodillo(@direction)
      @lastSpawnTime = @game.time.now

  @TOOLBOX:
    DEFAULT: """
      <block type="stratego_when_sensor_pressed"></block>
      <block type="stratego_spawn"></block>
      <block type="stratego_left"></block>
      <block type="stratego_right"></block>
      <block type="stratego_both"></block>
      <block type="stratego_random_direction"></block>
      """
    DEFAULT_LEFT: """
      <block type="stratego_when_sensor_pressed"></block>
      <block type="stratego_spawn"></block>
      <block type="stratego_left"></block>
    """
    DEFAULT_RIGHT: """
      <block type="stratego_when_sensor_pressed"></block>
      <block type="stratego_spawn"></block>
      <block type="stratego_right"></block>
    """


  @PROGRAM:
    SENSOR_SPAWN: (spawnColor, spawnDirection) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
          <block type="stratego_when_sensor_pressed" id="1" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}">
              <statement name="DO">
                  <block type="stratego_if" id="2" inline="false">
                      <value name="IF0">
                          <block type="stratego_sensor_is_color" id="3">
                              <field name="COLOR">#{spawnColor}</field>
                          </block>
                      </value>
                      <statement name="DO0">
                          <block type="stratego_spawn" id="4">
                            <value name="DIRECTION">
                              <block type="#{spawnDirection}" id="5">
                              </block>
                            </value>
                          </block>
                      </statement>
                  </block>
              </statement>
          </block>
      </xml>
      """
    RANDOM_SPAWN:
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_sensor_pressed" id="587" x="23" y="34">
          <statement name="DO">
            <block type="stratego_if" id="588" inline="false">
              <value name="IF0">
                <block type="stratego_sensor_is_color" id="589">
                  <field name="COLOR">YELLOW</field>
                </block>
              </value>
              <statement name="DO0">
                <block type="stratego_spawn" id="596" inline="true">
                  <value name="DIRECTION">
                    <block type="stratego_random_direction" id="665">
                    </block>
                  </value>
                </block>
              </statement>
            </block>
          </statement>
        </block>
      </xml>
      """

###
robodillo.coffee
###

window.stratego = window.stratego or {}


###
NPC that pushes the player around
###
class stratego.Robodillo extends stratego.GameDevice

  constructor: (game, goal1, goal2, y, respawn = false) ->
    if goal1? and goal2? then x = (goal1 + goal2) / 2 else x = -1000
    y = 1000 unless y?
    super(game, x * stratego.TILESET.TILE_SIZE, y * stratego.TILESET.TILE_SIZE, 'atlas', 'robodillo/left/0')
    @initialX = x
    @initialY = y
    @animations.add('left', util.anim('robodillo/left/', 0, 2), 12, true)
    @animations.add('right', util.anim('robodillo/right/', 0, 2), 12, true)

    isSnowmodillo = false

    @animations.add('pop', util.anim('pop/', 0, 3), 12, false)
    @addGlowChild(0.03, 0.13, 'robodillo/glow')
    @_enablePhysics()
    @speed = stratego.Player.MAX_X_VEL / 3
    @level().registerNpc(this)
    @readOnly = true
    @driving = false
    @facing = 'left'
    @respawn = respawn

    if goal1? and goal2?
      @leftEdge = (goal1 * stratego.TILESET.TILE_SIZE)
      @rightEdge = (goal2 * stratego.TILESET.TILE_SIZE)
      @setCode(stratego.Robodillo.PROGRAM.GOAL_PATROL)

    @events.onKilled.add( @_onKilled, this )
    @events.onAnimationComplete.add( ->
      if @animations.currentAnim.name == 'pop'
        @exists = false
    , this)

  # allow burrows to create robos with no program (and thus no Machine instance)
  setDefaultProgram: ->
    return

  _enablePhysics: ->
    super()
    @body.customSeparateX = true
    @body.collideWorldBounds = false # Avoid robodillos to be clamped to the inside of the screen when resetting their position

  @createFromTiledObjectJson: (game, objJson) ->
    goal1 = objJson.x / stratego.TILESET.TILE_SIZE
# Move goal2 a tile left so that the robodillo stays within his path
    goal2 = (objJson.x + (objJson.width - stratego.TILESET.TILE_SIZE)) / stratego.TILESET.TILE_SIZE
    tileY = objJson.y / stratego.TILESET.TILE_SIZE
    respawn = false
    if objJson.properties != undefined and objJson.properties.respawn != undefined
      respawn = objJson.properties.respawn
    newThing = new this(game, goal1, goal2, tileY, respawn) # 'this' is the class constructor

  reset: (x, y) ->
    super(x, y)
    @level().registerNpc(this)
    this

  update: ->
    super()
    return unless @alive
    @updateLock()
    @checkThingOverlaps()
    @drive() if @driving

  toggleCamera: (params) ->
    if params.source == this
      if not params.inCamera
        @stop() # Stop robodillo if it is out of view

  avoidColliding: ->
    if @driving
      tile = null
      tileCenter = [@left + 32, @bottom - 32] # @x and @y give a value close to the border with the next tile, get the center
      if (@facing == "left" and @level().tileAt(tileCenter[0] - 64, tileCenter[1]) != null) 
        # Check the next tile to the left when moving left
        tile = @level().tileAt(tileCenter[0] - 64, tileCenter[1])
      if (@facing == "right" and @level().tileAt(tileCenter[0] + 64, tileCenter[1]) != null)
        # Check the next tile to the right when moving right
        tile = @level().tileAt(tileCenter[0] + 64, tileCenter[1])
      if tile != null
        switch tile.index - stratego.TILESET.FIRST_GID  
          when stratego.TILESET.SOLID
            @body.velocity.x = 0 # Stop robodillo when colliding with a solid block

  drive: ->
    @driving = true
    @animations.play(@facing)
    @body.velocity.x = @_facingSign() * @speed
    @avoidColliding() # Check for collisions after moving, to stop immediately after moving

  stop: ->
    @driving = false
    @animations.stop()
    @body.velocity.x = 0

  face: (dir) ->
    util.assertContains(['left', 'right'], dir)
    @facing = dir
    @animations.play(@facing)
    if @driving
      @body.velocity.x = @_facingSign() * @speed
    else
      @animations.stop()

  reverse: ->
    @face( { left: 'right', right: 'left'}[@facing] )

  _facingSign: ->
    if @facing == 'left' then -1 else 1

  _onKilled: ->
    @body.velocity.x = @body.velocity.y = 0
    @animations.play('pop')
    @exists = true
    @level().unregisterNpc(this)

    # Respawn the robodillo and stop his movement
    if @respawn
      @_respawn()

  _respawn: ->
    @reset(@initialX * stratego.TILESET.TILE_SIZE , @initialY * stratego.TILESET.TILE_SIZE) # Reset to initial position
    @triggerSnowmodillo(@isSnowmodillo) # Set initial frame to avoid last dying animation frame from getting stuck
    @runCode() # Refresh code execution to avoid the robodillo to continue driving
    @stop() # Stop robodillo's movement

  zombie: (dir) ->
    @face(dir)
    @setCode(stratego.Robodillo.PROGRAM.SINGLE_ACTION('stratego_drive'))

  # Dynamically change robodillo to look like a snowmodillo, or go back to be a regular one
  triggerSnowmodillo: (isSnow) ->
    @isSnowmodillo = isSnow
    @frameName = if isSnow then 'robodillo/leftSnowmodillo/0' else 'robodillo/left/0'
    if isSnow
      @animations.add('left', util.anim('robodillo/leftSnowmodillo/', 0, 2), 12, true)
      @animations.add('right', util.anim('robodillo/rightSnowmodillo/', 0, 2), 12, true)
    else 
      @animations.add('left', util.anim('robodillo/left/', 0, 2), 12, true)
      @animations.add('right', util.anim('robodillo/right/', 0, 2), 12, true)

  @TOOLBOX:
    DEFAULT: """
      <block type="stratego_when_started"></block>
      <block type="stratego_repeat_forever"></block>
      <block type="stratego_if_beyond"></block>
      <block type="stratego_left"></block>
      <block type="stratego_right"></block>
      <block type="stratego_face"></block>
      <block type="stratego_drive"></block>
      <block type="stratego_stop"></block>
    """
    SENSOR: """
      <block type="stratego_when_sensor_pressed"></block>
      <block type="stratego_if"></block>
      <block type="stratego_sensor_is_color"></block>
      <block type="stratego_left"></block>
      <block type="stratego_right"></block>
      <block type="stratego_face"></block>
      <block type="stratego_drive"></block>
      <block type="stratego_stop"></block>
    """
    SENSOR_AND_PLAYER: """
      <block type="stratego_when_player_jump"></block>
      <block type="stratego_when_sensor_pressed"></block>
      <block type="stratego_if"></block>
      <block type="stratego_sensor_is_color"></block>
      <block type="stratego_left"></block>
      <block type="stratego_right"></block>
      <block type="stratego_face"></block>
      <block type="stratego_drive"></block>
      <block type="stratego_stop"></block>
    """

    PLOW_FUNCTIONS: """
      <category name="All" expanded="true">
        <block type="stratego_left"></block>
        <block type="stratego_right"></block>
        <block type="stratego_face"></block>
        <block type="stratego_drive"></block>
        <block type="stratego_stop"></block>
      </category>
      <category name="Functions" custom="PROCEDURE"></category>
    """

    PLOW_FUNCTIONS_REPEAT_X: """
      <category name="All" expanded="true">
        <block type="stratego_left"></block>
        <block type="stratego_right"></block>
        <block type="stratego_face"></block>
        <block type="stratego_drive"></block>
        <block type="stratego_stop"></block>
        <block type="stratego_repeat"></block>
      </category>
      <category name="Functions" custom="PROCEDURE"></category>
    """

  @PROGRAM:
    SINGLE_ACTION: (action) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_started" id="28" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}">
          <statement name="DO">
            <block type="#{action}" id="29">
            </block>
          </statement>
        </block>
      </xml>
      """
    GOAL_PATROL:
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_started" id="77" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}">
          <statement name="DO">
            <block type="stratego_face" id="78" inline="true">
              <value name="DIRECTION">
                <block type="stratego_left" id="79">
                </block>
              </value>
              <next>
                <block type="stratego_repeat_forever" id="80">
                  <statement name="DO">
                    <block type="stratego_drive" id="81">
                      <next>
                        <block type="stratego_if_beyond" id="82">
                          <field name="DIR">left</field>
                          <statement name="DO">
                            <block type="stratego_stop" id="83">
                              <next>
                                <block type="stratego_face" id="84" inline="true">
                                  <value name="DIRECTION">
                                    <block type="stratego_right" id="85">
                                    </block>
                                  </value>
                                </block>
                              </next>
                            </block>
                          </statement>
                          <next>
                            <block type="stratego_if_beyond" id="86">
                              <field name="DIR">right</field>
                              <statement name="DO">
                                <block type="stratego_stop" id="87">
                                  <next>
                                    <block type="stratego_face" id="88" inline="true">
                                      <value name="DIRECTION">
                                        <block type="stratego_left" id="89">
                                        </block>
                                      </value>
                                    </block>
                                  </next>
                                </block>
                              </statement>
                            </block>
                          </next>
                        </block>
                      </next>
                    </block>
                  </statement>
                </block>
              </next>
            </block>
          </statement>
        </block>
      </xml>
      """
    SENSOR_ACTION: (action) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_sensor_pressed" id="28" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}">
        <statement name="DO">
          <block type="#{action}" id="29">
          </block>
        </statement>
        </block>
      </xml>
      """
    SENSOR_PATROL: (leftColor, rightColor) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_sensor_pressed" id="118" x="69" y="20">
          <statement name="DO">
            <block type="stratego_stop" id="161">
              <next>
                <block type="stratego_if" id="234" inline="false">
                  <value name="IF0">
                    <block type="stratego_sensor_is_color" id="238">
                      <field name="COLOR">#{rightColor}</field>
                    </block>
                  </value>
                  <statement name="DO0">
                    <block type="stratego_face" id="243" inline="true">
                      <value name="DIRECTION">
                        <block type="stratego_left" id="249">
                        </block>
                      </value>
                      <next>
                        <block type="stratego_drive" id="262">
                        </block>
                      </next>
                    </block>
                  </statement>
                  <next>
                    <block type="stratego_if" id="270" inline="false">
                      <value name="IF0">
                        <block type="stratego_sensor_is_color" id="287">
                          <field name="COLOR">#{leftColor}</field>
                        </block>
                      </value>
                      <statement name="DO0">
                        <block type="stratego_face" id="306" inline="true">
                          <value name="DIRECTION">
                            <block type="stratego_right" id="442">
                            </block>
                          </value>
                          <next>
                            <block type="stratego_drive" id="329">
                            </block>
                          </next>
                        </block>
                      </statement>
                    </block>
                  </next>
                </block>
              </next>
            </block>
          </statement>
        </block>
      </xml>
      """

    SENSOR_PATROL_START_IMMEDIATELY: (leftColor, rightColor) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_started" id="135" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}">
          <statement name="DO">
            <block type="stratego_drive" id="262">
            </block>
          </statement>
        </block>
        <block type="stratego_when_sensor_pressed" id="118" x="69" y="20">
          <statement name="DO">
            <block type="stratego_stop" id="161">
              <next>
                <block type="stratego_if" id="234" inline="false">
                  <value name="IF0">
                    <block type="stratego_sensor_is_color" id="238">
                      <field name="COLOR">#{rightColor}</field>
                    </block>
                  </value>
                  <statement name="DO0">  
                    <block type="stratego_face" id="243" inline="true">
                      <value name="DIRECTION">
                        <block type="stratego_left" id="249">
                        </block>
                      </value>
                      <next>
                        <block type="stratego_drive" id="262">
                        </block>
                      </next>
                    </block>
                  </statement>
                  <next>
                    <block type="stratego_if" id="270" inline="false">
                      <value name="IF0">
                        <block type="stratego_sensor_is_color" id="287">
                          <field name="COLOR">#{leftColor}</field>
                        </block>
                      </value>
                      <statement name="DO0">
                        <block type="stratego_face" id="306" inline="true">
                          <value name="DIRECTION">
                            <block type="stratego_right" id="442">
                            </block>
                          </value>
                          <next>
                            <block type="stratego_drive" id="329">
                            </block>
                          </next>
                        </block>
                      </statement>
                    </block>
                  </next>
                </block>
              </next>
            </block>
          </statement>
        </block>
      </xml>
      """

    WAIT_FOR_PLOW: (defaultRepeatTimes) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_player_jump" id="131" x="150" y="25" editable="false" movable="true" deletable="false">
          <statement name="DO">
            <block type="stratego_face" id="132" editable="true" movable="false">
              <value name="DIRECTION">
                <block type="stratego_left" id="133" editable="true" movable="true">
                </block>
              </value>
              <next>
                <block type="stratego_repeat" id="274" editable="true" movable="false">
                  <field name="TIMES">#{defaultRepeatTimes}</field>
                  <next>
                    <block type="stratego_repeat" id="328" editable="true" movable="false">
                      <field name="TIMES">#{defaultRepeatTimes}</field>
                      <next>
                        <block type="stratego_stop" id="206" editable="false" movable="false">
                        </block>
                      </next>
                    </block>
                  </next>
                </block>
              </next>
            </block>
          </statement>
        </block>
        <block type="procedures_defnoreturn" id="458" x="388" y="13" editable="true" movable="true" deletable="false">
          <field name="NAME">plowLeft</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
          <statement name="STACK">
            <block type="stratego_stop" id="141" editable="false" movable="false">
              <next>
                <block type="stratego_face" id="142" editable="false" movable="false">
                  <value name="DIRECTION">
                    <block type="stratego_left" id="143" editable="false" movable="false">
                    </block>
                  </value>
                  <next>
                    <block type="stratego_drive" id="135" editable="false" movable="false">
                    </block>
                  </next>
                </block>
              </next>
            </block>
          </statement>
        </block>
        <block type="procedures_defnoreturn" id="511" x="390" y="143" editable="true" movable="true" deletable="false">
          <field name="NAME">plowRight</field>
          <comment pinned="false" h="80" w="160">#{FUNCTION_HELP_DEFAULT_TEXT}</comment>
          <statement name="STACK">
            <block type="stratego_stop" id="137" editable="false" movable="false">
              <next>
                <block type="stratego_face" id="138" editable="false" movable="false">
                  <value name="DIRECTION">
                    <block type="stratego_right" id="139" editable="false" movable="false">
                    </block>
                  </value>
                  <next>
                    <block type="stratego_drive" id="135" editable="false" movable="false">
                    </block>
                  </next>
                </block>
              </next>
            </block>
          </statement>
        </block>
      </xml>
      """

###
scorpion.coffee
###

window.stratego = window.stratego or {}


###
NPC that kills the player
###
class stratego.Scorpion extends stratego.GameDevice

  constructor: (game, goal1, goal2, y) ->
    if goal1? and goal2? then x = (goal1 + goal2) / 2 else x = -1000
    y = 1000 unless y?
    super(game, x * stratego.TILESET.TILE_SIZE, y * stratego.TILESET.TILE_SIZE, 'atlas', 'scorpion/left/0')
    @animations.add('left', util.anim('scorpion/left/', 0, 3), 12, true)
    @animations.add('right', util.anim('scorpion/right/', 0, 3), 12, true)
    @animations.add('pop', util.anim('pop/', 0, 3), 12, false)
    @_enablePhysics()
    @body.customSeparateX = true
    @speed = stratego.Player.MAX_X_VEL / 3
    @level().registerNpc(this)
    @readOnly = true
    @driving = false
    @facing = 'left'

    if goal1? and goal2?
      @leftEdge = (goal1 * stratego.TILESET.TILE_SIZE)
      @rightEdge = (goal2 * stratego.TILESET.TILE_SIZE)
      @setCode(stratego.Robodillo.PROGRAM.GOAL_PATROL)

    @events.onKilled.add( @_onKilled, this )
    @events.onAnimationComplete.add( ->
      if @animations.currentAnim.name == 'pop'
        @exists = false
    , this)
    
  # allow burrows to create robos with no program (and thus no Machine instance)
  setDefaultProgram: ->
    return

  @createFromTiledObjectJson: (game, objJson) ->
    goal1 = objJson.x / stratego.TILESET.TILE_SIZE
    goal2 = (objJson.x + objJson.width) / stratego.TILESET.TILE_SIZE
    tileY = objJson.y / stratego.TILESET.TILE_SIZE
    newThing = new this(game, goal1, goal2, tileY) # 'this' is the class constructor

  reset: (x, y) ->
    super(x, y)
    @level().registerNpc(this)
    this

  update: ->
    super()
    return unless @alive
    @updateLock()
    @checkThingOverlaps()
    @drive() if @driving

  toggleCamera: (params) ->
    if params.source == this
      if not params.inCamera
        @stop() # Stop scorpion if it is out of view

  drive: ->
    @driving = true
    @animations.play(@facing)
    @body.velocity.x = @_facingSign() * @speed

  stop: ->
    @driving = false
    @animations.stop()
    @body.velocity.x = 0

  face: (dir) ->
    util.assertContains(['left', 'right'], dir)
    @facing = dir
    @animations.play(@facing)
    if @driving
      @body.velocity.x = @_facingSign() * @speed
    else
      @animations.stop()

  reverse: ->
    @face( { left: 'right', right: 'left'}[@facing] )

  _facingSign: ->
    if @facing == 'left' then -1 else 1

  _onKilled: ->
    @body.velocity.x = @body.velocity.y = 0
    @animations.play('pop')
    @exists = true
    @level().unregisterNpc(this)


  @TOOLBOX:
    DEFAULT: """
      <block type="stratego_when_started"></block>
      <block type="stratego_repeat_forever"></block>
      <block type="stratego_if_beyond"></block>
      <block type="stratego_left"></block>
      <block type="stratego_right"></block>
      <block type="stratego_face"></block>
      <block type="stratego_drive"></block>
      <block type="stratego_stop"></block>
    """
    SENSOR: """
      <block type="stratego_when_sensor_pressed"></block>
      <block type="stratego_if"></block>
      <block type="stratego_sensor_is_color"></block>
      <block type="stratego_left"></block>
      <block type="stratego_right"></block>
      <block type="stratego_face"></block>
      <block type="stratego_drive"></block>
      <block type="stratego_stop"></block>
    """
    SENSOR_AND_PLAYER: """
      <block type="stratego_when_player_jump"></block>
      <block type="stratego_when_sensor_pressed"></block>
      <block type="stratego_if"></block>
      <block type="stratego_sensor_is_color"></block>
      <block type="stratego_left"></block>
      <block type="stratego_right"></block>
      <block type="stratego_face"></block>
      <block type="stratego_drive"></block>
      <block type="stratego_stop"></block>
    """


  @PROGRAM:
    SINGLE_ACTION: (action) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_started" id="28" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}">
        <statement name="DO">
          <block type="#{action}" id="29">
          </block>
        </statement>
        </block>
      </xml>
      """
    GOAL_PATROL:
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_started" id="77" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}">
          <statement name="DO">
            <block type="stratego_face" id="78" inline="true">
              <value name="DIRECTION">
                <block type="stratego_left" id="79">
                </block>
              </value>
              <next>
                <block type="stratego_repeat_forever" id="80">
                  <statement name="DO">
                    <block type="stratego_drive" id="81">
                      <next>
                        <block type="stratego_if_beyond" id="82">
                          <field name="DIR">left</field>
                          <statement name="DO">
                            <block type="stratego_stop" id="83">
                              <next>
                                <block type="stratego_face" id="84" inline="true">
                                  <value name="DIRECTION">
                                    <block type="stratego_right" id="85">
                                    </block>
                                  </value>
                                </block>
                              </next>
                            </block>
                          </statement>
                          <next>
                            <block type="stratego_if_beyond" id="86">
                              <field name="DIR">right</field>
                              <statement name="DO">
                                <block type="stratego_stop" id="87">
                                  <next>
                                    <block type="stratego_face" id="88" inline="true">
                                      <value name="DIRECTION">
                                        <block type="stratego_left" id="89">
                                        </block>
                                      </value>
                                    </block>
                                  </next>
                                </block>
                              </statement>
                            </block>
                          </next>
                        </block>
                      </next>
                    </block>
                  </statement>
                </block>
              </next>
            </block>
          </statement>
        </block>
      </xml>
      """
    SENSOR_ACTION: (action) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_sensor_pressed" id="28" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}">
        <statement name="DO">
          <block type="#{action}" id="29">
          </block>
        </statement>
        </block>
      </xml>
      """
    SENSOR_PATROL: (leftColor, rightColor) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_sensor_pressed" id="118" x="69" y="20">
          <statement name="DO">
            <block type="stratego_stop" id="161">
              <next>
                <block type="stratego_if" id="234" inline="false">
                  <value name="IF0">
                    <block type="stratego_sensor_is_color" id="238">
                      <field name="COLOR">#{rightColor}</field>
                    </block>
                  </value>
                  <statement name="DO0">
                    <block type="stratego_face" id="243" inline="true">
                      <value name="DIRECTION">
                        <block type="stratego_left" id="249">
                        </block>
                      </value>
                      <next>
                        <block type="stratego_drive" id="262">
                        </block>
                      </next>
                    </block>
                  </statement>
                  <next>
                    <block type="stratego_if" id="270" inline="false">
                      <value name="IF0">
                        <block type="stratego_sensor_is_color" id="287">
                          <field name="COLOR">#{leftColor}</field>
                        </block>
                      </value>
                      <statement name="DO0">
                        <block type="stratego_face" id="306" inline="true">
                          <value name="DIRECTION">
                            <block type="stratego_right" id="442">
                            </block>
                          </value>
                          <next>
                            <block type="stratego_drive" id="329">
                            </block>
                          </next>
                        </block>
                      </statement>
                    </block>
                  </next>
                </block>
              </next>
            </block>
          </statement>
        </block>
      </xml>
      """

###
sensor.coffee
###

# imports
phaser = Phaser
util = stratego.util


###
Sensors send events that player code can listen for
###
class stratego.Sensor extends stratego.Thing
  constructor: (game, x, y) ->
    super(game, x, y, 'atlas', 'sensor/yellow/0')
    @isPressed = false
    @_enablePhysics()
    @addAnimations('yellow')
    @addAnimations('pink')
    @addAnimations('green')
    @addAnimations('launcher')

    @level().eventManager.addEventHandler('overlap', @onOverlap, this)
    @level().eventManager.addEventHandler('overlapDone', @onOverlapDone, this)

  _enablePhysics: ->
    super()
    @body.allowGravity = false
    @body.allowRotation = false
    @body.immovable = true
    @body.moves = false  # we take responsiblity for movement
    @body.customSeparateX = true  # we handle colliding with player
    @body.customSeparateY = true  # we handle colliding with player

  addAnimations: (color) ->
    @animations.add("#{color}Press", util.anim("sensor/#{color}/", 0, 4), 14, false)
    @animations.add("#{color}Release", util.anim("sensor/#{color}/", 4, 0), 14, false)

  @createFromTiledObjectJson: (game, objJson) ->
    newThing = new this(game, objJson.x, objJson.y)
    if objJson.properties == undefined
      newThing.color = 'yellow'
    else if objJson.properties.color == undefined 
      newThing.color = 'yellow'
    else
      newThing.color = objJson.properties.color

    newThing.frameName = 'sensor/' + newThing.color + '/0'

    if objJson.properties != undefined and objJson.properties.exclusivePress != undefined
      newThing.exclusivePress = objJson.properties.exclusivePress

    if objJson.properties != undefined and objJson.properties.horizontalFlip != undefined
      newThing.anchor.setTo(0.5, 0.5) # Set anchor to the center of the sprite before rescaling it
      newThing.scale.y = if objJson.properties.horizontalFlip then -1 else 1

    newThing

  onOverlap: (params) ->
    return unless params.target == this
    return if @exclusivePress != undefined and params.source.constructor.name.toLowerCase() != @exclusivePress.toLowerCase()
    @animations.play("#{@color}Press")
    if @inCameraView() and not @isPressed
      @isPressed = true
      return if @color == "launcher" and params.source not instanceof stratego.Player
      eventName = if @color != "launcher" then "sensorPress" else "launcherSensorPress" # Dispatch a different event when the sensor is used for launchers
      @level().eventManager.dispatchEvent( eventName,
        source: this
        color: @color.toUpperCase()
        pressedBy: params.source
      )

  onOverlapDone: (params) ->
    return unless params.target == this
    @isPressed = false
    @animations.play("#{@color}Release")

###
SnowPile.coffee
###

window.stratego = window.stratego or {}

class stratego.SnowPile extends stratego.Thing
  constructor: (game, x, y) ->
    super(game, x, y, 'atlas', 'snowPile/0')
    @_enablePhysics()
    @level().eventManager.addEventHandler('overlap', @onOverlap, this)

  _enablePhysics: ->
    super()
    @body.allowGravity = false
    @body.allowRotation = false
    @body.immovable = true

  @createFromTiledObjectJson: (game, objJson) ->
    newThing = new this(game, objJson.x, objJson.y) # 'this' is the class constructor
    newThing.width = objJson.width
    newThing.height = objJson.height

    # Flip animation when snowpile is plowed from right to left
    if objJson.properties != undefined and objJson.properties.rightToLeft != undefined and objJson.properties.rightToLeft
      newThing.rightToLeft = true
      newThing.destroyAnim = newThing.animations.add('plow', util.anim('snowPile/rightToLeft/', 0, 11), 3, false)
    else
      newThing.rightToLeft = false
      newThing.destroyAnim = newThing.animations.add('plow', util.anim('snowPile/', 0, 11), 3, false)
    
    newThing.destroyAnim.onComplete.add(newThing.destroySnowPile, newThing)

    newThing

  destroySnowPile: ->
    @kill()

  onOverlap: (params) ->
    return unless params.target == this 
    return unless params.source instanceof stratego.Robodillo
    if @alive
      @level().playSound('snow-plow')
      @animations.play('plow') 

###
teleportDevice.coffee
###

window.stratego = window.stratego or {}


###
A door that blocks the player unless unlocked
###
class stratego.teleportDevice extends stratego.GameDevice
  LOCKED: 'LOCKED'
  UNLOCKED: 'UNLOCKED'

  constructor: (game, x, y) ->
    super(game, x, y, 'atlas', 'teleportDevice/unlocked/0')
    @_enablePhysics()
    @body.allowGravity = false
    @body.allowRotation = false
    @body.immovable = true
    @body.moves = false  # we take responsiblity for movement
    @body.customSeparateX = true
    @_state = @UNLOCKED
    @readOnly = true

  @createFromTiledObjectJson: (game, objJson) ->
    newThing = new this(game, objJson.x, objJson.y) # 'this' is the class constructor
    newThing.body.setSize(objJson.width, objJson.height)
    newThing.animations.add('locked', util.anim("teleportDevice/locked/", 0, 2), 6, true)
    newThing.animations.add('unlocked', util.anim("teleportDevice/unlocked/", 0, 2), 6, true)
    newThing.animations.play('unlocked')
    newThing

  isLocked: -> @_state == @LOCKED
  isUnlocked: -> @_state == @UNLOCKED

  unlock: ->
    if @isLocked()
      @_state = @UNLOCKED
      @animations.play('unlocked')

  lock: ->
    if @isUnlocked()
      @_state = @LOCKED
      @animations.play('locked')

  @TOOLBOX:
    DEFAULT: """
      <block type="stratego_when_player_nearby"></block>
      <block type="stratego_if"></block>
      <block type="stratego_door_is_closed"></block>
      <block type="stratego_player_has_key"></block>
      <block type="stratego_door_open"></block>
      <block type="stratego_door_close"></block>
      <block type="stratego_player_use_key"></block>
    """
    SENSOR: """
      <block type="stratego_when_sensor_pressed"></block>
      <block type="stratego_door_open"></block>
      <block type="stratego_door_close"></block>
      <block type="stratego_if"></block>
      <block type="stratego_sensor_is_color"></block>
    """

    NUMBER: """
      <block type="stratego_number" editable="true">
        <field name="NUM">0</field>
      </block>
    """

    LOCKED_NUMBER_LIST: (xList) -> 
      str = ""
      for i in xList
        str += """<block type="stratego_number" editable="false">
                    <field name="NUM">#{i}</field>
                  </block>"""
      str


  @PROGRAM:
    DEFAULT: (x, y) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_player_nearby" id="72" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}" movable="false">
          <statement name="DO">
            <block type="stratego_teleport_to_coordinates">
              <value name="X">
                <block type="stratego_number">
                  <field name="NUM">#{x}</field>
                </block>
              </value>
              <value name="Y">
                <block type="stratego_number">
                  <field name="NUM">#{y}</field>
                </block>
              </value>
            </block>
          </statement>
        </block>
      </xml>

      """
    
    TELEPORT_X_AXIS: (originalY) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_player_nearby" id="4" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}" editable="false" movable="false" deletable="false">
          <statement name="DO">
            <block type="stratego_teleport_to_coordinates" editable="false" movable="false" deletable="false">
              <value name="X">
                
              </value>
              <value name="Y">
                <block type="stratego_number" editable="false" movable="false">
                  <field name="NUM">#{originalY}</field>
                </block>
              </value>
            </block>
          </statement>
        </block>
      </xml>
      """


    TELEPORT_Y_AXIS: (originalX) ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">        
        <block type="stratego_when_player_nearby" id="4" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}" editable="false" movable="false" deletable="false">
          <statement name="DO">
            <block type="stratego_teleport_to_coordinates" editable="false" movable="false">
              <value name="X">
                <block type="stratego_number" editable="false" movable="false">
                  <field name="NUM">#{originalX}</field>
                </block>
              </value>
              <value name="Y">

              </value>
            </block>
          </statement>
        </block>
      </xml>
      """


    TELEPORT_EMPTY: ->
      """
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_player_nearby" id="4" x="#{START_BLOCK_X}" y="#{START_BLOCK_Y}" editable="false" movable="false" deletable="false">
          <statement name="DO">
            <block type="stratego_teleport_to_coordinates" editable="false" movable="false" deletable="false">
              <value name="X">

              </value>
              <value name="Y">

              </value>
            </block>
          </statement>
        </block>
      </xml>
      """
###
proximity_checker.coffee
###

class stratego.ProximityChecker
  constructor: (@level, @eventManager) ->
    @_prevNearbys = []
    @_overlaps = []
    util.mark('ProximityChecker')

  shutdown: ->
    @_prevNearbys = null
    @_overlaps = null
    @eventManager = null
    @level = null
    util.unmark('ProximityChecker')

  update: (player, things) ->
    devices = (thing for thing in things when thing instanceof stratego.GameDevice)
    nearbys = @findAdjacentDevices(player, devices)
    for n in nearbys
      n.playerNearby = true
      @eventManager.dispatchEvent('playerNearby', device: n, player: player)
    noLongerNearby = _.difference(@_prevNearbys, nearbys)
    @_prevNearbys = nearbys

    for n in noLongerNearby
      n.playerNearby = false

  findAdjacentDevices: (player, devices) ->
    MARGIN = 16
    x = player.body.x - MARGIN
    y = player.body.y - MARGIN
    width = player.body.width + 2*MARGIN
    height = player.body.height + 2*MARGIN
    halfWidth = width / 2
    halfHeight = height / 2
    samples = [
      [x, y],              [x + halfWidth, y],              [x + width, y],
      [x, y + halfHeight],                                  [x + width, y + halfHeight],
      [x, y + height],     [x + halfWidth, y + height],     [x + width, y + height],
                           [x + halfWidth, y + height + 10]
    ]

    _.filter( devices, (device) ->
      b = device.body
      _.some( samples, (sample) ->
        phaser.Rectangle.containsRaw(b.x, b.y, b.width, b.height, sample[0], sample[1])
      )
    )

  findOverlap: (thing, otherThings) ->
    overlap = @findAdjacentDevices(thing, otherThings)[0]
    oldOverlap = @_overlaps[thing._thingId]
    if oldOverlap? and overlap != oldOverlap
      @eventManager.dispatchEvent('overlapDone', target: oldOverlap, source: thing)
      @_overlaps.splice(thing._thingId, 1)
    if overlap? and overlap != oldOverlap
      @eventManager.dispatchEvent('overlap', target: overlap, source: thing)
      @_overlaps[thing._thingId] = overlap

###
collision_manager.coffee
###

class stratego.CollisionManager
  constructor: (@game, @eventManager) ->
    util.mark('CollisionManager')

  shutdown: ->
    @game = null
    @eventManager = null
    util.unmark('CollisionManager')

  update: (player, things, npcs, mapLayer) ->
    @game.physics.arcade.collide(player, mapLayer, @_onCollisionPlayerTile, null, this)
    @game.physics.arcade.collide(player, things, @_onCollisionPlayerThing, null, this)
    @game.physics.arcade.collide(player, npcs, @_onCollisionPlayerNpc, null, this)
    @game.physics.arcade.collide(npcs, mapLayer, @_onCollisionNpcTile, null, this)
    @game.physics.arcade.collide(npcs, npcs, @_onCollisionNpcNpc, ((a, b) -> !_.isEqual(a, b)), this)
    @game.physics.arcade.collide(npcs, things, @_onCollisionNpcThing, null, this)
    @game.physics.arcade.collide(things, mapLayer, @_onCollisionThingTile, null, this)
    @game.physics.arcade.collide(things, things, @_onCollisionThingThing, ((a, b) -> !_.isEqual(a, b)), this)

  _onCollisionPlayerTile: (player, tile) ->
    @eventManager.dispatchEvent( 'collisionPlayerTile',
      player: player
      tile: tile
    )

    switch tile.index - stratego.TILESET.FIRST_GID
      when stratego.TILESET.FIRE, stratego.TILESET.POISON
        player.kill() if player.alive

      when stratego.TILESET.END
        @eventManager.dispatchEvent('collisionPlayerEnd', player: player)

      when stratego.TILESET.ICE
        player.body.drag = new Point(100, 1)

      when stratego.TILESET.SOLID
        player.body.drag = stratego.Player.DRAG
      
  _onCollisionPlayerNpc: (player, npc) ->
    raise 'expected player' if player not instanceof stratego.Player

    @eventManager.dispatchEvent( 'collisionPlayerNpc',
      player: player
      npc: npc
    )

    if npc instanceof stratego.Robodillo
      @_onCollisionPlayerRobodillo(player, npc)
    else if npc instanceof stratego.Scorpion
      @_onCollisionPlayerScorpion(player, npc)

  _onCollisionPlayerRobodillo: (player, robodillo) ->
    physics.immovablePushY(robodillo, player)
    physics.immovablePushX(player, robodillo)
    if player.onTopOf(robodillo)
      player.ride(robodillo)

    if robodillo.onTopOf(player)
      player.kill()

    playerBorderTile = if robodillo.facing == "left" then player.level().tileAt(player.body.left, player.body.center.y) else player.level().tileAt(player.body.right, player.body.center.y)

    # When a robodillo is moving towards a player and there's a solid block behind him, he should die
    if (robodillo.rightOf(player) and robodillo.facing == "left" and robodillo.driving and playerBorderTile? and playerBorderTile.index == 11) or
        (player.rightOf(robodillo) and robodillo.facing == "right" and robodillo.driving and playerBorderTile? and playerBorderTile.index == 11)
      player.kill() if player.alive
    
  _onCollisionPlayerScorpion: (player, scorpion) ->
    player.kill()

  _onCollisionPlayerThing: (player, thing) ->
    raise 'expected player' if player not instanceof stratego.Player

    @eventManager.dispatchEvent( 'collisionPlayerThing',
      player: player
      thing: thing
    )

    if thing instanceof stratego.Elevator or thing instanceof stratego.Raft
      player.body.drag = stratego.Player.DRAG
      @_onCollisionRiderElevator(player, thing)
    else if thing instanceof stratego.Door
      @_onCollisionPlayerDoor(player, thing)
    else if thing instanceof stratego.Projectile 
      thing.destroyProjectile()
    else if thing instanceof stratego.SnowPile
      if player.body.touching.left && player.body.touching.right
        player.kill() if player.alive

  _onCollisionNpcNpc: (a, b) ->
    if (a instanceof stratego.Robodillo) and (b instanceof stratego.Robodillo)
      physics.immovablePushY(a, b)
      physics.immovablePushX(a, b)

      a.ride(b) if a.onTopOf(b)
      b.ride(a) if b.onTopOf(a)

      if a.sideBySide(b)
        guy.reverse() for guy in [a,b]

  _onCollisionNpcThing: (npc, thing) ->
    if thing instanceof stratego.Elevator
      @_onCollisionRiderElevator(npc, thing)
    if npc instanceof stratego.Robodillo and thing instanceof stratego.Door
      if thing.isClosed()
        npc.reverse()

    # Kill projectile when colliding with any npc
    if thing instanceof stratego.Projectile
      thing.destroyProjectile()

  _onCollisionRiderElevator: (rider, elevator) ->
    if elevator.onTopOf(rider)
      rider.kill() if rider.alive
    if (not rider.isLocked() and rider.body.y + rider.body.height < elevator.body.y + @game.physics.arcade.TILE_BIAS)
      rider.lockTo(elevator)

    upTile = rider.level().tileAt(rider.body.center.x, rider.body.top)
    if upTile? and upTile.index == 11
      rider.kill() if rider.alive

  _onCollisionPlayerDoor: (player, door) ->
    if door.isClosed()
      physics.immovablePushX(player, door)

  _onCollisionNpcTile: (npc, tile) ->
    switch tile.index - stratego.TILESET.FIRST_GID
      when stratego.TILESET.FIRE
        npc.kill()

  _onCollisionThingTile: (thing, tile) ->
    switch tile.index - stratego.TILESET.FIRST_GID

      when stratego.TILESET.FIRE
        if thing instanceof stratego.Elevator
          thing.crash()
      when stratego.TILESET.SOLID
        if thing instanceof stratego.Raft 
          thing.crash()
    
    # Kill projectile when colliding with any tile
    if thing instanceof stratego.Projectile
      thing.destroyProjectile()

  _onCollisionThingThing: (thing1, thing2) ->
    if thing1 instanceof stratego.Elevator and thing2 instanceof stratego.Elevator
      thing1.crash()
      thing2.crash()

    # Kill projectile if it collides with anything other than the launcher, as it always initially collides with it when spawning
    if thing1 instanceof stratego.Projectile and thing2 not instanceof stratego.Launcher
      thing1.destroyProjectile()
    if thing2 instanceof stratego.Projectile and thing1 not instanceof stratego.Launcher
      thing2.destroyProjectile()
class stratego.CamperAppUI

  @appTitle: (app) ->
    if app.title?
      app.title
    else if app.state == 'shared'
      "Shared App"
    else if app.slot?
      "App #{app.slot + 1}"
    else
      "App"

  @iconSrc: (app) ->
    if app.icon? then "slug/sprites/#{app.icon}.png" else "art/workshop/app-detail/gears.png"

class stratego.CamperAppManager
  constructor: (@camper) ->
    @camper.apps = @camper.apps || []

  addCamperApp: (response) ->
    unless @_indexForId(response.id) >= 0
      @camper.apps.push(response)

  appForSlot: (slot) ->
    _.find(@camper.apps, (app) -> app.slot == slot)

  appForId: (id) ->
    _.find(@camper.apps, (app) -> app.id == id)

  appCount: () ->
    @camper.apps.length

  editingApp: () ->
    _.find(@camper.apps, (app) -> app.state == 'unsaved')

  # helpers

  _indexForId: (id) ->
    _.findIndex(@camper.apps, (app) -> app.id == id)

  _indexForSlot: (slot) ->
    _.findIndex(@camper.apps, (app) -> app.slot == slot)

  _deleteAtIndex: (index) ->
    if index >= 0
      @camper.apps.splice(index, 1)

class stratego.CamperAppToolbar
  constructor: (@camperManager, @app, options) ->
    @onBackgroundSelect = options.onBackgroundSelect
    @onSpriteSelect = options.onSpriteSelect
    @onPhotoBackgroundClick = options.onPhotoBackgroundClick
    @onPhotoSpriteClick = options.onPhotoSpriteClick
    @onGridSwitchClick = options.onGridSwitchClick
    @allowBackgrounds = options.allowBackgrounds
    @allowPhotoBackgrounds = options.allowPhotoBackgrounds
    @allowPhotoSprite = options.allowPhotoSprite

    @toolbarOpen = false
    @selectedSpriteCategory = 'trans'

    @_initUISelectors()
    @_initUIHandlers()
    @_initUIDisplay()

  shutdown: ->
    @_shutdownUIHandlers()
    @_resetUIDisplay()

  _initUISelectors: () =>
    @ui =
      backgrounds:
        list: $('#app-editor__backgrounds')
        background: $('.background')
        modal:
          overlay: $('#modal-overlay')
          closeButton: $("#close-button--modal")

      sprites:
        palettes: $("#sprite-palettes")
        lists: $(".sprite-palettes__sprite-list")
        sprite: $(".sprite")

      toolbar:
        wrapper: $('#editor-toolbar')
        control: $('#editor-toolbar__toolbar-control')
        backgrounds:
          wrapper: $("#editor-toolbar__background-category-list")
          illustrated: $("#editor-toolbar__background-category-illustrated")
          cameraButton: $("#editor-toolbar__background-category-camera")
          gridSwitchButton: $("#editor-toolbar__background-category-grid-switch")
        sprites:
          categories: $(".editor-toolbar__sprite-category")
          cameraButton: $("#editor-toolbar__camera-button")

  _initUIHandlers: ->
    # toolbar
    @ui.toolbar.sprites.cameraButton.on('click', @onPhotoSpriteClick)
    @ui.toolbar.backgrounds.cameraButton.on('click', @onPhotoBackgroundClick)
    @ui.toolbar.backgrounds.gridSwitchButton.on('click', @onGridSwitchClick)
    @ui.toolbar.backgrounds.illustrated.on('click', @_openBackgroundModal)
    @ui.toolbar.control.on('click', @_onToolbarControlClick )
    @ui.toolbar.sprites.categories.on('click', @_onSpriteCategoryClick )

    # background/sprite selection
    @ui.backgrounds.modal.closeButton.on('click', @_closeBackgroundModal)
    @ui.backgrounds.background.on('click', @_onBackgroundClick )
    @ui.sprites.sprite.on('click', @_onSpriteClick )

  _shutdownUIHandlers: ->
    # toolbar
    @ui.toolbar.sprites.cameraButton.off('click')
    @ui.toolbar.backgrounds.cameraButton.off('click')
    @ui.toolbar.backgrounds.gridSwitchButton.off('click')
    @ui.toolbar.backgrounds.illustrated.off('click')
    @ui.toolbar.control.off('click')
    @ui.toolbar.sprites.categories.off('click')

    # background/sprite selection
    @ui.backgrounds.modal.closeButton.off('click')
    @ui.backgrounds.background.off('click')
    @ui.sprites.sprite.off('click')

  _initUIDisplay: ->
    unless @allowPhotoSprite
      @ui.toolbar.sprites.cameraButton.hide()

    unless @allowBackgrounds
      @ui.toolbar.backgrounds.wrapper.hide()

    unless @allowPhotoBackgrounds
      @ui.toolbar.backgrounds.cameraButton.hide()

  _resetUIDisplay: ->
    @ui.toolbar.backgrounds.wrapper.show()
    @ui.toolbar.sprites.cameraButton.show()
    @close()
    @hide()

  # UI Handlers

  _openBackgroundModal: =>
    @close() # close sprites toolbar
    @ui.backgrounds.modal.overlay.show()
    @ui.backgrounds.list.show()

  _closeBackgroundModal: =>
    @ui.backgrounds.modal.overlay.hide()
    @ui.backgrounds.list.hide()

  close: () ->
    @toolbarOpen = false
    @ui.sprites.palettes.addClass('closed')
    @ui.toolbar.wrapper.addClass('closed')

  open: () ->
    @toolbarOpen = true
    @ui.sprites.palettes.removeClass('closed')
    @ui.toolbar.wrapper.removeClass('closed')

  show: () ->
    @ui.toolbar.wrapper.show()

  hide: () ->
    @ui.toolbar.wrapper.fadeOut(300)

  _onToolbarControlClick: () =>
    if @toolbarOpen then @close() else @open()

  _onSpriteClick: (e) =>
    @onSpriteSelect(e)
    @close()

  _onSpriteCategoryClick: (e) =>
    $category = $(e.currentTarget)
    categoryName = $category.data('category')

    if @toolbarOpen and @selectedSpriteCategory is categoryName
      @close()
    else
      @selectedSpriteCategory = categoryName
      @_selectSpriteCategory($category)
      @_selectSpriteList(categoryName)
      @open()

  _selectSpriteCategory: ($category) ->
    @ui.toolbar.sprites.categories.removeClass('selected')
    $category.addClass('selected')

  _selectSpriteList: (categoryName) ->
    @ui.sprites.lists.hide()
    selectedSpriteList = @ui.sprites.lists.filter("[data-category=#{categoryName}]")
    selectedSpriteList.show()

  _onBackgroundClick: (e) =>
    @onBackgroundSelect(e)
    @_closeBackgroundModal()

class stratego.CamperAppTitleEditor
  constructor: (@camperManager, @app, @dialog, @onIconEditorOpen=null, @onIconEditorClose=null) ->
    @_initUISelectors()
    @_initUIDefaults()
    @_initUIHandlers()
    @_initUIDisplay()

    toolbarOptions =
      allowBackgrounds: false
      allowPhotoSprite: false
      onSpriteSelect: @_onSpriteSelect

    @spritePaletteOpen = false
    @toolbar = new stratego.CamperAppToolbar(@camperManager, @app, toolbarOptions)

  shutdown: ->
    @_shutdownUIHandlers()
    @_resetUIDisplay()
    @toolbar.shutdown()

  _initUISelectors: () =>
    @ui =
      appTitle: $("#app-detail__title")

      icon:
        editButton: $('#app-detail__edit-icon-button')
        instructions: $('#app-detail__edit-icon-instruct')

  _initUIDefaults: () =>
    @ui.defaults =
      appTitle: @ui.appTitle.text()
      icon:
        instructions:
          edit: @ui.icon.instructions.text()
          cancel: 'Cancel'

  # UI HANDLERS

  _initUIHandlers: () =>
    @ui.icon.editButton.on('click', @_onEditIcon)

    unless @app.state == 'shared'
      @ui.appTitle.on('focus', @_onTitleFocus)
      @ui.appTitle.on('blur', @_onTitleSave)
      @ui.appTitle.on('keydown', @_onTitleKeydown)

  _shutdownUIHandlers: () =>
    @ui.icon.editButton.off('click')
    @ui.appTitle.off('focus')
    @ui.appTitle.off('blur')
    @ui.appTitle.off('keydown')

  _onEditIcon: =>
    if @spritePaletteOpen
      @_closeSpritePalette()
    else
      @_openSpritePalette()

  _onSpriteSelect: (event) =>
    spriteName = $(event.delegateTarget).data('sprite')
    iconSrc = "slug/sprites/#{spriteName}.png"

    @_updateApp(icon: spriteName)
      .then => @_setIcon(iconSrc)
      .finally => @_closeSpritePalette()

  _onTitleFocus: (event) =>
    @previousTitle = $(event.target).text()

  _onTitleKeydown: (event) =>
    if event.keyCode == 13
      event.target.blur()
      @_onTitleSave(event)

  _onTitleSave: (event) =>
    title = $(event.target).text()
    return if title == @previousTitle
    return if @savingTitle

    @savingTitle = true
    @_updateApp(title: title)
      .catch =>
        @ui.appTitle.text(@previousTitle)
      .finally =>
        @savingTitle = false

  # UI DISPLAY

  _initUIDisplay: () =>
    appTitle = stratego.CamperAppUI.appTitle(@app)
    @ui.appTitle.text(appTitle)

    unless @app.state == 'shared'
      @_setIcon(stratego.CamperAppUI.iconSrc(@app))
      @ui.icon.editButton.show()
      @ui.appTitle.attr('contenteditable','true')

  _resetUIDisplay: () =>
    @ui.appTitle.text(@ui.defaults.appTitle)
    @ui.icon.editButton.hide()
    @ui.appTitle.attr('contenteditable','false')

    @_closeSpritePalette()

  # UI HELPERS

  _openSpritePalette: =>
    @spritePaletteOpen = true
    @ui.icon.instructions.text(@ui.defaults.icon.instructions.cancel)
    @toolbar.close()
    @toolbar.show()
    @toolbar.open()
    @onIconEditorOpen?()

  _closeSpritePalette: =>
    @spritePaletteOpen = false
    @ui.icon.instructions.text(@ui.defaults.icon.instructions.edit)
    @toolbar.close()
    @toolbar.hide()
    @onIconEditorClose?()

  _setIcon: (iconSrc) =>
    @ui.icon.editButton.children('img').attr('src', iconSrc)

  # API

  _updateApp: (attrs) =>
    ActivityIndicator?.show('saving')
    @camperManager.camper()
    .then (camper) =>
      @camperManager.updateApp(@app.id, attrs)
    .catch (error) =>
      @dialog.displayError("Can't Update App", error)
      console.error(error)
      deferred = Q.defer()
      deferred.reject()
      deferred.promise
    .finally =>
      ActivityIndicator?.hide()

###
camper_app_editor.coffee
###

class stratego.CamperAppEditor extends phaser.State
  MODES =
    EDIT: 0
    PREVIEW: 1
    DEBUG: 2

  constructor: (@camperManager, @app) ->
    super()
    @_previouslySavedAppJson = @app.source
    @_mode = MODES.EDIT
    @eventManager = new stratego.EventManager()
    @camperApp = new stratego.CamperApp(@app.source, @eventManager, @camperManager)

  preload: (game) ->
    throw new Error('Expected camperApp to be loaded by now.') if not @camperApp?

    game.load.image('deleteBtn', 'art/delete-button.png')
    ActivityIndicator?.show('loading assets...')
    @camperApp.preload(@game, published: false, editor: true)

  create:  ->
    ActivityIndicator?.hide()  # from preload
    @dialog = new stratego.CamperAppDialog()
    @game.scale.scaleMode = phaser.ScaleManager.SHOW_ALL
    @startTime = @game.time.now

    if phaser.Device.touch
      @_pointers = @game.input.pointers
    else
      @_pointers = [@game.input.mousePointer]

    # spotlight & delete btn
    @gfx = @game.add.graphics(0, 0, @camperApp.depthGroup()['graphics'])
    @_deleteBtn = @_initDeleteButton()

    @_initUISelectors()
    @_initUIHandlers()
    @_initUIDisplay()

    toolbarOptions =
      allowBackgrounds: true
      allowPhotoBackgrounds: false
      allowPhotoSprite: false
      onPhotoBackgroundClick: @_onPhotoBackgroundClick
      onPhotoSpriteClick: @_onPhotoSpriteClick
      onSpriteSelect: @_onSpriteSelect
      onBackgroundSelect: @_onBackgroundSelect
      onGridSwitchClick: @_onGridSwitchClick

    if @camperApp.showGrid
      @ui.gridSwitchButton.addClass('selected')
      @ui.gridSwitchButton.removeClass('unselected')
    else
      @ui.gridSwitchButton.removeClass('selected')
      @ui.gridSwitchButton.addClass('unselected')

    @toolbar = new stratego.CamperAppToolbar(@camperManager, @app, toolbarOptions)
    @toolbar.show()
    $('#editor-toolbar__sprite-category-trans').click();
    @_autoSaver = setInterval(@save, 2*60*1000)

    # camper app
    @eventManager.addEventHandler('deviceAdded', @_onDeviceAdded, this)
    @eventManager.addEventHandler('camper_app_stopped', @_onCamperAppStopped, this)
    @eventManager.addEventHandler('camper_app_started', @_onCamperAppStarted, this)
    @camperApp.create()

    #after completion of camperApp create select device
    @_selectDeviceByDefault()

  # Phaser callback. Web UI should already have been reset.
  shutdown: ->
    @_blocklyEditor().close()

    @gfx.destroy() if @gfx?
    @gfx = null

    @camperApp.eventManager.removeAllEventHandlers(this)
    @camperApp?.destroy()
    @camperApp = null
    @selectedDevice = null
    @previousSelectedDevice = null

    clearInterval @_autoSaver

    @_shutdownDeleteButton()
    @eventManager.destroy(); @eventManager = null

  elapsedTime: ->
    (@game.time.now - @startTime)/1000

  _shutdownUI: ->
    @_resetUIDisplay()
    @_shutdownUIHandlers()
    @toolbar.shutdown()
    @dialog.close(); @dialog = null

  _initUISelectors: () =>
    @ui =
      backButton: $("#editor__back-button")
      editor:
        editorElement: $('#editorElement')
        debugButton: $('#startBtn')
        previewButton: $('#editor__play')
        headerText: $('#editor__title')
        previousDevice: $("#editor__focus-buttons--prev")
        nextDevice: $("#editor__focus-buttons--next")
        interactionButtons: $('#editor__interaction-toolbar button')
      gridSwitchButton: $('#editor-toolbar__background-category-grid-switch')

  _resetUIDisplay: () ->
    @_setMode(MODES.EDIT)
    @_enableBackButton()

  # called every frame
  update: ->
    @_handleTouchesToSelectDevice(@_pointers)
    @camperApp?.update()

    # spotlight
    @gfx.clear()
    blocklyEditorIsVisible = @_blocklyEditor().isVisible()
    if @selectedDevice and blocklyEditorIsVisible
      stratego.drawSpotlight(@gfx, @selectedDevice)
    @_updateDeleteButton(@selectedDevice, blocklyEditorIsVisible)

  _blocklyEditor: ->
    @game.app.blocklyEditor

  # UI display

  _initUIDisplay: ->
    if (typeof window.screen.lockOrientation == 'function')
      window.screen.lockOrientation('portrait')

  _resetUIDisplay: () =>
    if (typeof window.screen.lockOrientation == 'function')
      window.screen.unlockOrientation()

  _selectDeviceByDefault: ->
    @ui.editor.nextDevice.click()

  # UI handlers

  _initUIHandlers: ->
    @ui.backButton.on('click', @_onBack)
    @ui.editor.previousDevice.on('click', @_onNextDeviceLeft)
    @ui.editor.nextDevice.on('click', @_onNextDeviceRight)
    @ui.editor.previewButton.on('click', @_onPlayClick)
    @ui.editor.debugButton.on('click', @_onDebugClick)
    if (typeof window.screen.lockOrientation == 'function')
      window.screen.lockOrientation('portrait')

  _shutdownUIHandlers: ->
    @ui.backButton.off('click')
    @ui.editor.previousDevice.off('click')
    @ui.editor.nextDevice.off('click')
    @ui.editor.previewButton.off('click')
    @ui.editor.debugButton.off('click')
    if (typeof window.screen.lockOrientation == 'function')
      window.screen.unlockOrientation()

  _onBack: =>
    if @app.slot?
      @_onMainMenu()
    else
      @dialog.displaySaveConfirm(@_onSaveConfirm, @_onDeleteConfirm)

  _onMainMenu: =>
    ActivityIndicator?.show('saving...')
    @save()
    .then =>
      @_shutdownUI()
      @eventManager.dispatchEvent('requestLevel', level: 'appMenu')
    .catch (e) =>
      @dialog.displayError("Can't Save", e)
    .finally ->
      ActivityIndicator?.hide()

  _onSaveConfirm: =>
    ActivityIndicator?.show(' ')
    @save()
    .then =>
      @_shutdownUI()
      @eventManager.dispatchEvent('requestLevel', level: 'appSaveMenu', camperAppId: @app.id, appJson: @camperApp.serialize())
    .catch (e) =>
      @dialog.displayError("Can't Save", e)
    .finally ->
      ActivityIndicator?.hide()

  _onDeleteConfirm: =>
    @_deleteApp()
    .then =>
      @_shutdownUI()
      @eventManager.dispatchEvent('quitAppEditor', camperAppId: @app.id)
    .finally ->
      ActivityIndicator?.hide()

  _onDebugClick: =>
    if @camperApp.isRunning()
      @toolbar.open()
      @camperApp.stop()
    else
      @_setMode(MODES.DEBUG)
      @toolbar.close()
      @camperApp.run()

  _onPlayClick: =>
    if @camperApp.isRunning()
      @toolbar.open()
      @camperApp.stop()
    else
      @_setMode(MODES.PREVIEW)
      @toolbar.close()
      @camperApp.run()

  _onSpriteSelect: (e) =>
    offset = $(e.currentTarget).offset()
    device = @camperApp.addDevice($(e.currentTarget).data('sprite'), offset.left, offset.top)
    @_selectDevice(device)
    @_deal(device)

  _onBackgroundSelect: (e) =>
    cacheKey = $(e.currentTarget).data('background')
    @camperApp.setBackground(cacheKey)

  _onPhotoSpriteClick: =>
    @toolbar.hide()
    @_disableBackButton()
    @photoSprite()
      .done() # finalize promise

  _onPhotoBackgroundClick: =>
    @toolbar.hide()
    @_disableBackButton()
    @photoBackground()
      .done() # finalize promise

  _onGridSwitchClick: =>
    @camperApp.toggleGrid()
    if @camperApp.showGrid
      @ui.gridSwitchButton.addClass('selected')
      @ui.gridSwitchButton.removeClass('unselected')
    else
      @ui.gridSwitchButton.removeClass('selected')
      @ui.gridSwitchButton.addClass('unselected')

  _enableEditorInteractionToolbar: (enable) ->
    @ui.editor.interactionButtons.prop('disabled', not enable)

  _disableBackButton: () ->
    @ui.backButton.addClass('disabled')

  _enableBackButton: () ->
    @ui.backButton.removeClass('disabled')

  # Compare strings, but ignore CR which are inserted by Mancala
  _isJsonEqual: (a, b) ->
    a = a.replace(/\r/g, '')
    b = b.replace(/\r/g, '')
    a == b

  #
  # Editing vs. Running mode
  #

  isEditMode: ->
    @_mode == MODES.EDIT

  _setMode: (newMode) ->
    @_mode = newMode

  _onCamperAppStopped: =>
    @_setMode(MODES.EDIT)
    @_setEditMode()

  _onCamperAppStarted: =>
    if @_mode == MODES.PREVIEW
      @_setPreviewMode()
    else if @_mode == MODES.DEBUG
      @_setDebugMode()

  _setPreviewMode: () ->
    @ui.editor.editorElement.addClass('app-preview')
    @toolbar.hide()
    @_setDebugButtonIsRunning(false)
    @_setPreviewButtonIsRunning(true)
    @_setDeviceFocusButtonsEnabled(false)
    @_selectDevice(null)
    @_blocklyEditor().close()
    @ui.editor.headerText.text(' ')
    @_setAllDevicesEditable(false)

  _setDebugMode: () ->
    @ui.editor.editorElement.removeClass('app-preview')
    @toolbar.show()
    @_setDebugButtonIsRunning(true)
    @_setPreviewButtonIsRunning(false)
    @_setDeviceFocusButtonsEnabled(true)
    @_setAllDevicesEditable(false)

  _setEditMode: () ->
    @ui.editor.editorElement.removeClass('app-preview')
    @toolbar.show()
    @_setDebugButtonIsRunning(false)
    @_setPreviewButtonIsRunning(false)
    @_setDeviceFocusButtonsEnabled(true)
    @_selectDevice(@previousSelectedDevice) if @selectedDevice == null
    @_setAllDevicesEditable(true)

  _setDebugButtonIsRunning: (isRunning) ->
    if isRunning
      @ui.editor.debugButton.addClass('app-running')
      @ui.editor.previewButton.prop("disabled", true)
    else
      @ui.editor.debugButton.removeClass('app-running')
      @ui.editor.previewButton.prop("disabled", false)

  _setPreviewButtonIsRunning: (isRunning) ->
    if isRunning
      @ui.editor.previewButton.addClass('app-running')
      @ui.editor.debugButton.prop("disabled", true)
    else
      @ui.editor.previewButton.removeClass('app-running')
      @ui.editor.debugButton.prop("disabled", false)

  _setDeviceFocusButtonsEnabled: (isEnabled) ->
    @ui.editor.nextDevice.prop("disabled", not isEnabled)
    @ui.editor.previousDevice.prop("disabled", not isEnabled)

  _onDeviceAdded: (event) ->
    @_setDeviceEditable(event.device, true)

  _setAllDevicesEditable: (wantEditable) ->
    for device in @camperApp.devices
      @_setDeviceEditable(device, wantEditable)

  _setDeviceEditable: (device, wantEditable) ->
    device.inputEnabled = true
    if wantEditable
      device.input.enableDrag(false, true)
      device.events.onDragStop.add(@_onPhaserDragStop, this)
    else
      device.input.disableDrag()
      device.events.onDragStop.remove(@_onPhaserDragStop, this)

  _onPhaserDragStop: (camperDevice) ->
    # During edit mode, dragging Device should set its initial position
    camperDevice.firstLoc.x = camperDevice.x
    camperDevice.firstLoc.y = camperDevice.y



  #
  # Delete button
  #

  _initDeleteButton: ->
    deleteBtn = new phaser.Button(@game, 200, 200, 'deleteBtn', (source, pointer) =>
      @_blocklyEditor().close()
      @camperApp._removeDevice(@selectedDevice)
      @_selectDevice(null)
    )
    deleteBtn.visible = false
    deleteBtn.anchor = new Phaser.Point(0.5, 0.5)
    @game.stage.addChild(deleteBtn)
    deleteBtn

  _shutdownDeleteButton: ->
    @_deleteBtn?.destroy()
    @_deleteBtn = null

  _updateDeleteButton: (device, blocklyEditorIsVisible) ->
    if not device? or not blocklyEditorIsVisible or not @isEditMode()
      @_deleteBtn?.visible = false
    else if @_deleteBtn?
      @_deleteBtn.visible = true
      spotlightDiameter = stratego.spotlightDiameter(device)
      r = spotlightDiameter / 2
      [deviceCenterX, deviceCenterY] = stratego.spotlightCenter(device)
      @_deleteBtn.x = deviceCenterX + r/Math.sqrt(2)
      @_deleteBtn.y = deviceCenterY - r/Math.sqrt(2)

  _deal: (device) ->
    size_half = 400
    center_x = @game.width / 2
    low_x = center_x - size_half
    high_x = center_x + size_half

    center_y = @game.height / 2
    low_y = center_y - size_half
    high_y = center_y + size_half

    dest =
      x: Math.floor(Math.random() * (high_x - low_x)) + low_x
      y: Math.floor(Math.random() * (high_y - low_y)) + low_y
    device.firstLoc = dest

    tween = @game.add.tween(device)
    tween.to(dest, 200)
    tween.start()


  #
  # Selecting Devices for editing
  #

  _getDeviceList: ->
    @camperApp.devices #.sort (a, b) -> a.x - b.x # ordered left to right

  _onNextDeviceLeft: =>
    @_nextDevice('left')

  _onNextDeviceRight: =>
    @_nextDevice('right')

  _nextDevice: (direction) ->
    throw new Error('not a direction') if direction not in ['left', 'right']
    sign = { 'left': -1, 'right': 1 }[direction]

    devices = @_getDeviceList()
    selection = if @selectedDevice? then _.filter(devices, (dev) => sign*dev.x > sign*@selectedDevice.x) else devices
    selection = devices if _.isEmpty(selection)
    device = _.min( selection , (dev) -> sign*dev.x )
    @_selectDevice(device)

  _selectDevice: (device) ->
    @previousSelectedDevice = @selectedDevice
    @selectedDevice = device
    @_updateDeleteButton(@selectedDevice, @_blocklyEditor().isVisible())
    if device
      @_blocklyEditor().open(device)

  _downPointers: (pointers) ->
    (pointer for pointer in pointers when pointer.isDown)

  _touchedDevice: (downpointers) ->
    for pointer in downpointers
      return pointer.targetObject.sprite if (pointer.targetObject?.sprite?) and (pointer.targetObject.sprite in @_getDeviceList())
      for device in @_getDeviceList()
        if device.getBounds().contains(pointer.x, pointer.y)
          return device

  _handleTouchesToSelectDevice: (pointers) ->
    return if @_mode == MODES.PREVIEW
    device = @_touchedDevice(@_downPointers(pointers))
    @_selectDevice(device) if device?


  # API

  save: =>
    appJson = @camperApp.serialize()
    if @_isJsonEqual(appJson, @_previouslySavedAppJson)
      return Q()  # not changed
    @_previouslySavedAppJson = appJson
    promise = @_uploadApp(appJson, @app.id)
    promise

  photoSprite: ->
    SPRITE_SIZE = 512
    rect =
      x: (IPAD_SHORT - SPRITE_SIZE) * 0.5, y: (IPAD_LONG - SPRITE_SIZE) * 0.5
      width: SPRITE_SIZE, height: SPRITE_SIZE

    promise = @camperManager.camper()
    .then (camper) =>
      @_enableEditorInteractionToolbar(false)
      stratego.Camera.takePhotoAndUpload(rect, camper.id, @game.cache, 'sprite', @camperManager.serverConfig).then ([imageUrlAtS3, cacheKey]) =>
        @camperApp.addAsset(cacheKey, stratego.AssetType.IMAGE, imageUrlAtS3)
        device = @camperApp.addDevice(cacheKey, 100, 100)
        @_deal(device)
    .finally =>
      @_enableEditorInteractionToolbar(true)
      @toolbar.show()
      @_enableBackButton()
    .catch (e) =>
      return if e instanceof stratego.CancelledPhotoError
      @dialog.displayError("Can't take photo", e)
    promise

  photoBackground: ->
    BACKGROUND_SIZE = 1024
    gameScreenRect = util.gameBoundingRect(@game)
    rect =
      x: gameScreenRect.left,
      y: (IPAD_LONG - gameScreenRect.height) * 0.5
      # width: gameScreenRect.width,
      # height: gameScreenRect.height
      # Flipping these values because there seems to be a weird issue with
      # react-webcam on an iPad. (Mike Sela 10/18/2022)
      # https://stackoverflow.com/questions/72767008/why-do-the-height-and-width-settings-in-react-webcam-become-reversed
      width: gameScreenRect.height,
      height: gameScreenRect.width

    promise = @camperManager.camper()
      .then (camper) =>
        @_enableEditorInteractionToolbar(false)
        stratego.Camera.takePhotoAndUpload(rect, camper.id, @game.cache, 'background', @camperManager.serverConfig)
      .then ([imageUrlAtS3, cacheKey]) =>
        @camperApp.addAsset(cacheKey, stratego.AssetType.IMAGE, imageUrlAtS3)
        @camperApp.setBackground(cacheKey)
      .catch (e) =>
        return if e instanceof stratego.CancelledPhotoError
        @dialog.displayError("Can't take photo", e)
        console.error(e)
      .finally =>
        @_enableEditorInteractionToolbar(true)
        @toolbar.show()
        @_enableBackButton()
    promise

  # Save app to Mancala for later editing
  _uploadApp: (appJson) ->
    return if @sendingSave

    @sendingSave = true
    @camperManager.camper()
    .then (camper) =>
      savePromise = if @app.id?
          @camperManager.updateApp(@app.id, source: appJson)
        else
          @camperManager.createApp(appJson)
      savePromise.then (data) =>
        @app = @camperManager.app(data.id)
      .catch (e) =>
        @dialog.displayError("Can't save app", e)
    .catch (e) =>
      @dialog.displayError("Can't connect", e)
    .finally =>
      @sendingSave = false

  # soft-delete app from Mancala
  _deleteApp: () ->
    return Q.when() if @deletingApp
    return Q.when() unless @app.id?

    @deletingApp = true
    @camperManager.camper()
    .then( (camper) =>
      @camperManager.deleteApp(@app.id)
    ).catch( (e) =>
      @dialog.displayError("Can't delete app", e)
    ).finally( =>
      @deletingApp = false
    )

# these are just key value pairs
# to extract the value for a new / modified template:
#  - build / run in web browser
#  - go to the workshop and edit desired app (template to be)
#  - run the following from the browser developer console - codingStudio.blocklyEditor.logApp()
#  - replace template json for individual template with result of above
#  - change name of template if applicable

stratego.TEMPLATES =
  'Simon Says': ''' {
    "devices": [
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"240\\" x=\\"150\\" y=\\"25\\"><data>qufnzo-1k2z68d7592nii4h7f</data><statement name=\\"DO\\"><block type=\\"stratego_say\\" id=\\"241\\"><data>-1uda5zex1f9-53ghqxmbz45u</data><value name=\\"MSG\\"><block type=\\"text\\" id=\\"242\\"><field name=\\"TEXT\\">Simon says 10 🐾 ⬆️!</field><data>-2hnroc-378rcj-am98ozu4zd3m</data></block></value></block></statement></block></xml>",
        "_codeJs": [
          "highlightBlock('qufnzo-1k2z68d7592nii4h7f');\\nwait();\\n  highlightBlock('-1uda5zex1f9-53ghqxmbz45u');\\n  say('Simon says 10 🐾 ⬆️!');\\n"
        ],
        "key": "animals_06_mouse",
        "firstLoc": {
          "x": 1028.7786458333335,
          "y": 298.77864583333337
        }
      },
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"226\\" x=\\"150\\" y=\\"25\\"><data>-v5bbwr-shyrco-tk34bji8gx56</data><statement name=\\"DO\\"><block type=\\"controls_repeat_ext\\" id=\\"227\\"><data>1k9opc-95t9f5u6iqiy-sfymlf</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"228\\"><field name=\\"NUM\\">10</field><data>m425vhjue8ltjmy4brz1pstw</data></block></value><statement name=\\"DO\\"><block type=\\"stratego_artificial_jump\\" id=\\"229\\"><data>tmjfs3z073sc-4fwewg-6yl1hp</data><value name=\\"FORCE\\"><block type=\\"stratego_number\\" id=\\"230\\"><field name=\\"NUM\\">50</field><data>-echwyybovahewe6b9l6uteu</data></block></value></block></statement></block></statement></block></xml>",
        "_codeJs": [
          "highlightBlock('-v5bbwr-shyrco-tk34bji8gx56');\\nwait();\\n  highlightBlock('1k9opc-95t9f5u6iqiy-sfymlf');\\n  for (var count = 0; count < 10; count++) {\\n    highlightBlock('tmjfs3z073sc-4fwewg-6yl1hp');\\n    artificial_jump(50);\\n    while(is_jumping()) {\\n      highlightBlock('tmjfs3z073sc-4fwewg-6yl1hp');\\n    }  highlightBlock('1k9opc-95t9f5u6iqiy-sfymlf');\\n  }\\n"
        ],
        "key": "animals_09_dragon",
        "firstLoc": {
          "x": 428.7760009765625,
          "y": 722.6666666666667
        }
      }
    ],
    "assets": [],
    "backgroundKey": "bg-forest",
    "showGrid": false
  }
  '''

  'Monkey Business': ''' {
    "devices": [
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"1609\\" x=\\"47\\" y=\\"15\\"><data>-zg98xytcpfn1x85zrh-2h8zl9</data><statement name=\\"DO\\"><block type=\\"stratego_repeat_forever\\" id=\\"1610\\"><data>ao92nqyg2g00dbw70lwcmcuc</data><statement name=\\"DO\\"><block type=\\"controls_repeat_ext\\" id=\\"1611\\"><data>-13jhi6-e15oim1bcmqu-4xpjy</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"1612\\"><field name=\\"NUM\\">16</field><data>1dmu6z-q087cujrdd44jx8cod</data></block></value><statement name=\\"DO\\"><block type=\\"stratego_move_by\\" id=\\"1613\\"><data>-dw6vyo-7amgee-h8uvx39rp0vw</data><value name=\\"VEC\\"><block type=\\"stratego_new_vector\\" id=\\"1614\\"><data>-4xvebx-n3o2jmhm5ruk-9vs9io</data><value name=\\"DIRECTION\\"><block type=\\"stratego_number\\" id=\\"1615\\"><field name=\\"NUM\\">0</field><data>wpdth1-m0mcse6oz54cjbhvv4</data></block></value><value name=\\"LENGTH\\"><block type=\\"stratego_number\\" id=\\"1616\\"><field name=\\"NUM\\">100</field><data>yzvtv0vm2u3j2cz3hx72ov5v</data></block></value></block></value></block></statement><next><block type=\\"stratego_wait\\" id=\\"1617\\"><data>-g7obb0-hi68jc-6tc78b-yico9n</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"1618\\"><field name=\\"NUM\\">10</field><data>sfd0kkgwv4sgsamfv6bfnu3p</data></block></value><next><block type=\\"controls_repeat_ext\\" id=\\"1619\\"><data>-lg75iv-si6n2o-wr1bju-qzjwdz</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"1620\\"><field name=\\"NUM\\">16</field><data>-k1950xan4wg5-9ywqmq-hlad7i</data></block></value><statement name=\\"DO\\"><block type=\\"stratego_move_by\\" id=\\"1621\\"><data>i8fwpz788tam-y6iaoy-tdmpxa</data><value name=\\"VEC\\"><block type=\\"stratego_new_vector\\" id=\\"1622\\"><data>mxrntr-qu8mtr-196sjo-rif9qg</data><value name=\\"DIRECTION\\"><block type=\\"stratego_number\\" id=\\"1623\\"><field name=\\"NUM\\">180</field><data>-datti9-kvk95saijqzn-gyj923</data></block></value><value name=\\"LENGTH\\"><block type=\\"stratego_number\\" id=\\"1624\\"><field name=\\"NUM\\">100</field><data>-exqp9b-wfxhwy-uggso1-lvznju</data></block></value></block></value></block></statement></block></next></block></next></block></statement></block></statement></block></xml>",
        "_codeJs": [
          "highlightBlock('-zg98xytcpfn1x85zrh-2h8zl9');\\nwait();\\n  highlightBlock('ao92nqyg2g00dbw70lwcmcuc');\\n  while (true) {\\n      highlightBlock('-13jhi6-e15oim1bcmqu-4xpjy');\\n    for (var count = 0; count < 16; count++) {\\n      highlightBlock('-dw6vyo-7amgee-h8uvx39rp0vw');\\n      move_by(new_vector(0, 100));\\n      highlightBlock('-13jhi6-e15oim1bcmqu-4xpjy');\\n    }\\n    highlightBlock('-g7obb0-hi68jc-6tc78b-yico9n');\\n    for (var count2 = 0; count2 < 10; count2++) {\\n      wait();\\n    }\\n    highlightBlock('-lg75iv-si6n2o-wr1bju-qzjwdz');\\n    for (var count3 = 0; count3 < 16; count3++) {\\n      highlightBlock('i8fwpz788tam-y6iaoy-tdmpxa');\\n      move_by(new_vector(180, 100));\\n      highlightBlock('-lg75iv-si6n2o-wr1bju-qzjwdz');\\n    }\\n\\n  };"
        ],
        "key": "shapes_18_raft",
        "firstLoc": {
          "x": 190.66666666666666,
          "y": 1356.8
        }
      },
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"2721\\" x=\\"150\\" y=\\"25\\"><data>-eku6c1qkx6sw-9xad4du3xbc</data><statement name=\\"DO\\"><block type=\\"stratego_repeat_forever\\" id=\\"2722\\"><data>ct8q8-jrn225-v9ba8o-4ee43s</data><statement name=\\"DO\\"><block type=\\"stratego_play_sound\\" id=\\"2723\\"><field name=\\"SOUND\\">boing</field><data>-twmwpx-ip83md-kcwfkgafill5</data><next><block type=\\"stratego_rotate\\" id=\\"2724\\"><data>y8tzpp-1n2wm9kolb8r-qtm5je</data><value name=\\"ANGLE\\"><block type=\\"stratego_number\\" id=\\"2725\\"><field name=\\"NUM\\">90</field><data>-dxynuz-cxmrkxled8tidzcg8</data></block></value><next><block type=\\"stratego_wait\\" id=\\"2726\\"><data>k1f5snghlit6-xo3o7g-vh54lq</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"2727\\"><field name=\\"NUM\\">10</field><data>tly0w4-mkh662j3hawbmrksgt</data></block></value><next><block type=\\"stratego_rotate\\" id=\\"2728\\"><data>s1qsr2bx905whfsieryyskzu</data><value name=\\"ANGLE\\"><block type=\\"stratego_number\\" id=\\"2729\\"><field name=\\"NUM\\">0</field><data>-nj2wo0l0gtvy-yboxi0-zera4d</data></block></value><next><block type=\\"stratego_wait\\" id=\\"2730\\"><data>-1026i16e3i0dlpwx9dn1ak0g</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"2731\\"><field name=\\"NUM\\">10</field><data>np2jup-wrdko0eiq6mt-xzlb72</data></block></value></block></next></block></next></block></next></block></next></block></statement></block></statement></block></xml>",
        "_codeJs": [
          "highlightBlock('-eku6c1qkx6sw-9xad4du3xbc');\\nwait();\\n  highlightBlock('ct8q8-jrn225-v9ba8o-4ee43s');\\n  while (true) {\\n      highlightBlock('-twmwpx-ip83md-kcwfkgafill5');\\n    play_sound('boing');\\n    highlightBlock('y8tzpp-1n2wm9kolb8r-qtm5je');\\n    rotate_to(90);\\n    highlightBlock('k1f5snghlit6-xo3o7g-vh54lq');\\n    for (var count = 0; count < 10; count++) {\\n      wait();\\n    }\\n    highlightBlock('s1qsr2bx905whfsieryyskzu');\\n    rotate_to(0);\\n    highlightBlock('-1026i16e3i0dlpwx9dn1ak0g');\\n    for (var count2 = 0; count2 < 10; count2++) {\\n      wait();\\n    }\\n\\n  };"
        ],
        "key": "animals_22_monkey",
        "firstLoc": {
          "x": 1705,
          "y": 429.6666666666667
        }
      },
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"1640\\" x=\\"150\\" y=\\"25\\"><data>ud8xrz-rga47jdo6u7u-f7lwgv</data></block></xml>",
        "_codeJs": [
          "highlightBlock('ud8xrz-rga47jdo6u7u-f7lwgv');\\nwait();\\n"
        ],
        "key": "animals_21_toucan",
        "firstLoc": {
          "x": 1284,
          "y": 545.3333333333333
        }
      },
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"1644\\" x=\\"150\\" y=\\"25\\"><data>-lx2rt8mlauh132aczcadh8ax</data></block></xml>",
        "_codeJs": [
          "highlightBlock('-lx2rt8mlauh132aczcadh8ax');\\nwait();\\n"
        ],
        "key": "__missing",
        "firstLoc": {
          "x": null,
          "y": null
        }
      },
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"2272\\" x=\\"63\\" y=\\"38\\"><data>a90cfy-1tnrf9-caii9x-o3s3y0</data><statement name=\\"DO\\"><block type=\\"controls_repeat_ext\\" id=\\"2273\\"><data>aa1ajoj4x402x0a3uc-4d9ek8</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"2274\\"><field name=\\"NUM\\">14</field><data>ne8b5j2qfx97-prkdlm-wpg4m5</data></block></value><statement name=\\"DO\\"><block type=\\"stratego_move_by\\" id=\\"2275\\"><data>-w7uj8x-6yiehhmql1br-wfe92s</data><value name=\\"VEC\\"><block type=\\"stratego_new_vector\\" id=\\"2276\\"><data>xlvrog-ejk0o76xldgg9cqecg</data><value name=\\"DIRECTION\\"><block type=\\"stratego_number\\" id=\\"2277\\"><field name=\\"NUM\\">0</field><data>-cb1bwn9txy6p5mu12t-gvns7h</data></block></value><value name=\\"LENGTH\\"><block type=\\"stratego_number\\" id=\\"2278\\"><field name=\\"NUM\\">100</field><data>-kvld77-ejapjl6j8arz-lj4w84</data></block></value></block></value></block></statement><next><block type=\\"stratego_artificial_jump\\" id=\\"2279\\"><data>-88e8ds-aizarv-12ocm6-20zlhz</data><value name=\\"FORCE\\"><block type=\\"stratego_number\\" id=\\"2280\\"><field name=\\"NUM\\">50</field><data>86225v-6e19fz-waiswsbnl8ok</data></block></value><next><block type=\\"stratego_move_by\\" id=\\"2281\\"><data>-1ezl4kje1eqj-nhrcgx-iek35u</data><value name=\\"VEC\\"><block type=\\"stratego_new_vector\\" id=\\"2282\\"><data>9o46w5-rxznv3h3jdtd-5owqrf</data><value name=\\"DIRECTION\\"><block type=\\"stratego_number\\" id=\\"2283\\"><field name=\\"NUM\\">90</field><data>37rcoa-bwkv2o-5ubm9e-9ianz3</data></block></value><value name=\\"LENGTH\\"><block type=\\"stratego_number\\" id=\\"2284\\"><field name=\\"NUM\\">79</field><data>-nl49da-3uulru-nzap87-glyi81</data></block></value></block></value><next><block type=\\"stratego_wait\\" id=\\"2285\\"><data>ptrnaz-inzdcne1dui67so9qf</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"2286\\"><field name=\\"NUM\\">10</field><data>-h9cqnj-f8096ozadqx4-35nbwo</data></block></value></block></next></block></next></block></next></block></statement></block></xml>",
        "_codeJs": [
          "highlightBlock('a90cfy-1tnrf9-caii9x-o3s3y0');\\nwait();\\n  highlightBlock('aa1ajoj4x402x0a3uc-4d9ek8');\\n  for (var count = 0; count < 14; count++) {\\n    highlightBlock('-w7uj8x-6yiehhmql1br-wfe92s');\\n    move_by(new_vector(0, 100));\\n    highlightBlock('aa1ajoj4x402x0a3uc-4d9ek8');\\n  }\\n  highlightBlock('-88e8ds-aizarv-12ocm6-20zlhz');\\n  artificial_jump(50);\\n  while(is_jumping()) {\\n    highlightBlock('-88e8ds-aizarv-12ocm6-20zlhz');\\n  }highlightBlock('-1ezl4kje1eqj-nhrcgx-iek35u');\\n  move_by(new_vector(90, 79));\\n  highlightBlock('ptrnaz-inzdcne1dui67so9qf');\\n  for (var count2 = 0; count2 < 10; count2++) {\\n    wait();\\n  }\\n"
        ],
        "key": "animals_05_moose",
        "firstLoc": {
          "x": 211.0000000000001,
          "y": 1241.3333333333335
        }
      }
    ],
    "assets": [],
    "backgroundKey": "bg-levelsand",
    "showGrid": false
  }
  '''

  'Surprise': ''' {
    "devices": [
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"1252\\" x=\\"38\\" y=\\"38\\"><data>kcmt0es18fhv39x61-92p3b8</data><statement name=\\"DO\\"><block type=\\"stratego_hide\\" id=\\"1253\\"><data>5v2iadaxk0tu-auj4omp2iw23</data></block></statement></block><block type=\\"stratego_when_message\\" id=\\"1254\\" x=\\"38\\" y=\\"113\\"><field name=\\"MESSAGE\\">high-five</field><data>-el11w3-ijvgbhkxy0cw-ltcdjd</data><statement name=\\"DO\\"><block type=\\"stratego_show\\" id=\\"1255\\"><data>-vzdlfm-wu50e2-djmncbqvdwdc</data><next><block type=\\"stratego_play_sound\\" id=\\"1256\\"><field name=\\"SOUND\\">slide</field><data>-77e3yqavowcn-1lrmkstx86r5</data></block></next></block></statement></block><block type=\\"stratego_when_message\\" id=\\"1257\\" x=\\"38\\" y=\\"238\\"><field name=\\"MESSAGE\\">shrug</field><data>um27ik-x15jrq-8s9v59-c3kwtn</data><statement name=\\"DO\\"><block type=\\"stratego_hide\\" id=\\"1258\\"><data>c8vlgeeakhr-kcp2p2-achdwe</data></block></statement></block></xml>",
        "_codeJs": [
          "highlightBlock('kcmt0es18fhv39x61-92p3b8');\\nwait();\\n  highlightBlock('5v2iadaxk0tu-auj4omp2iw23');\\n  hide();\\n",
          "highlightBlock('-el11w3-ijvgbhkxy0cw-ltcdjd');\\nwhile(true) {\\n  highlightBlock('-el11w3-ijvgbhkxy0cw-ltcdjd');\\n  wait_for_message('high-five');\\n  highlightBlock('-vzdlfm-wu50e2-djmncbqvdwdc');\\n  show();\\n  highlightBlock('-77e3yqavowcn-1lrmkstx86r5');\\n  play_sound('slide');\\n\\n}",
          "highlightBlock('um27ik-x15jrq-8s9v59-c3kwtn');\\nwhile(true) {\\n  highlightBlock('um27ik-x15jrq-8s9v59-c3kwtn');\\n  wait_for_message('shrug');\\n  highlightBlock('c8vlgeeakhr-kcp2p2-achdwe');\\n  hide();\\n\\n}"
        ],
        "key": "people_07_ghost",
        "firstLoc": {
          "x": 1736.333333333333,
          "y": 519.3333333333334
        }
      },
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_pressed\\" id=\\"2357\\" x=\\"38\\" y=\\"13\\"><data>bgr6vkyeh6ztxyfj6h-u3s5jb</data><statement name=\\"DO\\"><block type=\\"stratego_send_message\\" id=\\"2358\\"><field name=\\"MESSAGE\\">wink</field><data>7cvsh9fveuevbmw5qw-mogwh0</data></block></statement></block></xml>",
        "_codeJs": [
          "highlightBlock('bgr6vkyeh6ztxyfj6h-u3s5jb');\\nwhile(true) {\\n  highlightBlock('bgr6vkyeh6ztxyfj6h-u3s5jb');\\n  wait_for_sprite_press();\\n  highlightBlock('7cvsh9fveuevbmw5qw-mogwh0');\\n  send_message('wink');\\n\\n}"
        ],
        "key": "shapes_14_flower",
        "firstLoc": {
          "x": 700.6666666666667,
          "y": 1273.0000000000002
        }
      },
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_pressed\\" id=\\"2365\\" x=\\"38\\" y=\\"38\\"><data>vcmzgq-khhof92q7lzw-swwgz0</data><statement name=\\"DO\\"><block type=\\"stratego_send_message\\" id=\\"2366\\"><field name=\\"MESSAGE\\">high-five</field><data>pukqyv-u3rm4py6ilot-dg3tkd</data></block></statement></block></xml>",
        "_codeJs": [
          "highlightBlock('vcmzgq-khhof92q7lzw-swwgz0');\\nwhile(true) {\\n  highlightBlock('vcmzgq-khhof92q7lzw-swwgz0');\\n  wait_for_sprite_press();\\n  highlightBlock('pukqyv-u3rm4py6ilot-dg3tkd');\\n  send_message('high-five');\\n\\n}"
        ],
        "key": "shapes_15_mushroom",
        "firstLoc": {
          "x": 922.0000000000001,
          "y": 1281.6666666666667
        }
      },
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_pressed\\" id=\\"2361\\" x=\\"38\\" y=\\"38\\"><data>snvgceahsge-khh7sjji34i</data><statement name=\\"DO\\"><block type=\\"stratego_send_message\\" id=\\"2362\\"><field name=\\"MESSAGE\\">fist-bump</field><data>jdoe5lptxhkhsgjkd24m58ah</data></block></statement></block></xml>",
        "_codeJs": [
          "highlightBlock('snvgceahsge-khh7sjji34i');\\nwhile(true) {\\n  highlightBlock('snvgceahsge-khh7sjji34i');\\n  wait_for_sprite_press();\\n  highlightBlock('jdoe5lptxhkhsgjkd24m58ah');\\n  send_message('fist-bump');\\n\\n}"
        ],
        "key": "shapes_14_flower",
        "firstLoc": {
          "x": 1208,
          "y": 1270.3333333333335
        }
      },
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"1363\\" x=\\"38\\" y=\\"13\\"><data>-7zrd5oi61u57-w8mh92-amnerw</data><statement name=\\"DO\\"><block type=\\"stratego_hide\\" id=\\"1364\\"><data>azgare-96jk2tgtfzxr3w38ji</data></block></statement></block><block type=\\"stratego_when_message\\" id=\\"1365\\" x=\\"38\\" y=\\"113\\"><field name=\\"MESSAGE\\">wink</field><data>g5g61k9p5fvm84gq7x9rugda</data><statement name=\\"DO\\"><block type=\\"stratego_show\\" id=\\"1366\\"><data>-eda0d1oziij7-xzoadp12l9en</data><next><block type=\\"stratego_play_sound\\" id=\\"1367\\"><field name=\\"SOUND\\">pop</field><data>-fm4sko-ksj0p7-j86h7awro7et</data></block></next></block></statement></block><block type=\\"stratego_when_message\\" id=\\"1368\\" x=\\"37\\" y=\\"238\\"><field name=\\"MESSAGE\\">shrug</field><data>spyx5n877dvgkwe1tc-p7kfwe</data><statement name=\\"DO\\"><block type=\\"stratego_hide\\" id=\\"1369\\"><data>2zpxdpw26430-vbo196kowa12</data></block></statement></block></xml>",
        "_codeJs": [
          "highlightBlock('-7zrd5oi61u57-w8mh92-amnerw');\\nwait();\\n  highlightBlock('azgare-96jk2tgtfzxr3w38ji');\\n  hide();\\n",
          "highlightBlock('g5g61k9p5fvm84gq7x9rugda');\\nwhile(true) {\\n  highlightBlock('g5g61k9p5fvm84gq7x9rugda');\\n  wait_for_message('wink');\\n  highlightBlock('-eda0d1oziij7-xzoadp12l9en');\\n  show();\\n  highlightBlock('-fm4sko-ksj0p7-j86h7awro7et');\\n  play_sound('pop');\\n\\n}",
          "highlightBlock('spyx5n877dvgkwe1tc-p7kfwe');\\nwhile(true) {\\n  highlightBlock('spyx5n877dvgkwe1tc-p7kfwe');\\n  wait_for_message('shrug');\\n  highlightBlock('2zpxdpw26430-vbo196kowa12');\\n  hide();\\n\\n}"
        ],
        "key": "steve",
        "firstLoc": {
          "x": 1077.3333333333333,
          "y": 572.0000000000001
        }
      },
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"1377\\" x=\\"63\\" y=\\"13\\"><data>aps576crg8li-bufyl2gyn6qq</data><statement name=\\"DO\\"><block type=\\"stratego_hide\\" id=\\"1378\\"><data>m13j32-9aetckqa9nam-xgmxsw</data></block></statement></block><block type=\\"stratego_when_message\\" id=\\"1379\\" x=\\"63\\" y=\\"113\\"><field name=\\"MESSAGE\\">fist-bump</field><data>-38n6m5-bzbekiwaczg7myqkvx</data><statement name=\\"DO\\"><block type=\\"stratego_show\\" id=\\"1380\\"><data>r7k65kbs6elrhaole5-9ziydq</data><next><block type=\\"stratego_play_sound\\" id=\\"1381\\"><field name=\\"SOUND\\">tada</field><data>-fuk6k8-nly3ului19tijcnh4q</data></block></next></block></statement></block><block type=\\"stratego_when_message\\" id=\\"1382\\" x=\\"62\\" y=\\"238\\"><field name=\\"MESSAGE\\">shrug</field><data>-cxqss4-mhpqmvbkj8c2pe2ppu</data><statement name=\\"DO\\"><block type=\\"stratego_hide\\" id=\\"1383\\"><data>3n4les-53h3gh-3k43rx-j2koii</data></block></statement></block></xml>",
        "_codeJs": [
          "highlightBlock('aps576crg8li-bufyl2gyn6qq');\\nwait();\\n  highlightBlock('m13j32-9aetckqa9nam-xgmxsw');\\n  hide();\\n",
          "highlightBlock('-38n6m5-bzbekiwaczg7myqkvx');\\nwhile(true) {\\n  highlightBlock('-38n6m5-bzbekiwaczg7myqkvx');\\n  wait_for_message('fist-bump');\\n  highlightBlock('r7k65kbs6elrhaole5-9ziydq');\\n  show();\\n  highlightBlock('-fuk6k8-nly3ului19tijcnh4q');\\n  play_sound('tada');\\n\\n}",
          "highlightBlock('-cxqss4-mhpqmvbkj8c2pe2ppu');\\nwhile(true) {\\n  highlightBlock('-cxqss4-mhpqmvbkj8c2pe2ppu');\\n  wait_for_message('shrug');\\n  highlightBlock('3n4les-53h3gh-3k43rx-j2koii');\\n  hide();\\n\\n}"
        ],
        "key": "kate",
        "firstLoc": {
          "x": 1318.3333333333335,
          "y": 720.0000000000001
        }
      },
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"2341\\" x=\\"38\\" y=\\"13\\"><data>wonog2me2v6l-t4dsdg2ho8yc</data><statement name=\\"DO\\"><block type=\\"stratego_say\\" id=\\"2342\\"><data>-8a2gtocnyebr-4a7461-i8m1rt</data><value name=\\"MSG\\"><block type=\\"text\\" id=\\"2343\\"><field name=\\"TEXT\\">Press a 🌷</field><data>-gwz1w8pdr5sp-guo3nb-1ax6ao</data></block></value><next><block type=\\"stratego_wait\\" id=\\"2344\\"><data>-g8y3ty-2bagme-i7r5su-3h6ioi</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"2345\\"><field name=\\"NUM\\">10</field><data>-9rbualqw59pv-qqe1tablph4v</data></block></value><next><block type=\\"stratego_say\\" id=\\"2346\\"><data>-8hcc23s7ed30-mwk5qi-6ie7ar</data><value name=\\"MSG\\"><block type=\\"text\\" id=\\"2347\\"><field name=\\"TEXT\\">or 🍄</field><data>-yn5k4z75qiujmzlmfb-nknm6j</data></block></value><next><block type=\\"stratego_wait\\" id=\\"2348\\"><data>-yz93md-y7gfda-nrnrrkhrvhhb</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"2349\\"><field name=\\"NUM\\">10</field><data>hb3pin-t36swk6jliuj74e45q</data></block></value><next><block type=\\"stratego_say\\" id=\\"2350\\"><data>s04bl4-u1s902-ms539ei9vln6</data></block></next></block></next></block></next></block></next></block></statement></block><block type=\\"stratego_say\\" id=\\"2351\\" x=\\"438\\" y=\\"163\\"><data>hdd3tr-j1bylsu2eulg-l00uiz</data><value name=\\"MSG\\"><block type=\\"text\\" id=\\"2352\\"><field name=\\"TEXT\\">hello</field><data>-kw46yv-82jjunu88jk8-6d0x97</data></block></value></block><block type=\\"stratego_when_pressed\\" id=\\"2353\\" x=\\"58\\" y=\\"264\\"><data>-fks7jc-lovb42-vlyoai-tnb9hk</data><statement name=\\"DO\\"><block type=\\"stratego_send_message\\" id=\\"2354\\"><field name=\\"MESSAGE\\">shrug</field><data>rwmyypbvozrc-xu0cgrv634lq</data></block></statement></block></xml>",
        "_codeJs": [
          "highlightBlock('wonog2me2v6l-t4dsdg2ho8yc');\\nwait();\\n  highlightBlock('-8a2gtocnyebr-4a7461-i8m1rt');\\n  say('Press a 🌷');\\n  highlightBlock('-g8y3ty-2bagme-i7r5su-3h6ioi');\\n  for (var count = 0; count < 10; count++) {\\n    wait();\\n  }\\n  highlightBlock('-8hcc23s7ed30-mwk5qi-6ie7ar');\\n  say('or 🍄');\\n  highlightBlock('-yz93md-y7gfda-nrnrrkhrvhhb');\\n  for (var count2 = 0; count2 < 10; count2++) {\\n    wait();\\n  }\\n  highlightBlock('s04bl4-u1s902-ms539ei9vln6');\\n  say();\\n",
          "highlightBlock('-fks7jc-lovb42-vlyoai-tnb9hk');\\nwhile(true) {\\n  highlightBlock('-fks7jc-lovb42-vlyoai-tnb9hk');\\n  wait_for_sprite_press();\\n  highlightBlock('rwmyypbvozrc-xu0cgrv634lq');\\n  send_message('shrug');\\n\\n}"
        ],
        "key": "space_01_star",
        "firstLoc": {
          "x": 364,
          "y": 744.6666666666667
        }
      }
    ],
    "assets": [],
    "backgroundKey": "bg-storefront",
    "showGrid": false
  }
  '''

  'Fortune Teller': ''' {
    "devices": [
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"procedures_defreturn\\" id=\\"1648\\" x=\\"13\\" y=\\"13\\"><field name=\\"NAME\\">DivineAnswer</field><data>-7ncb94-g2o401q1gahpx6a76s</data><statement name=\\"STACK\\"><block type=\\"stratego_set\\" id=\\"1649\\"><field name=\\"VAR\\">random</field><data>-d8yilc-2j5zdlp6bts8-go8rv1</data><value name=\\"VALUE\\"><block type=\\"math_random_int\\" id=\\"1650\\"><data>p11iil-vjuzhigpzze6pixmy</data><value name=\\"FROM\\"><block type=\\"stratego_number\\" id=\\"1651\\"><field name=\\"NUM\\">1</field><data>s4lmxmlaxiosd1b28u-mecpt8</data></block></value><value name=\\"TO\\"><block type=\\"stratego_number\\" id=\\"1652\\"><field name=\\"NUM\\">4</field><data>-b4ud68lk5ph49ms1k7-jdxlw2</data></block></value></block></value><next><block type=\\"procedures_ifreturn\\" id=\\"1653\\"><mutation value=\\"1\\"></mutation><data>1pbne5-3x7e2zldlxyjp19lf</data><value name=\\"CONDITION\\"><block type=\\"logic_compare\\" id=\\"1654\\"><field name=\\"OP\\">EQ</field><data>-erbgx4-vdtqjxc0mzcsi6v63d</data><value name=\\"A\\"><block type=\\"stratego_get\\" id=\\"1655\\"><field name=\\"VAR\\">random</field><data>-e5aff2-vtrrw92zffid-gi89eo</data></block></value><value name=\\"B\\"><block type=\\"stratego_number\\" id=\\"1656\\"><field name=\\"NUM\\">1</field><data>ovmekrdz0mf7-kclsovjdlq0r</data></block></value></block></value><value name=\\"VALUE\\"><block type=\\"text\\" id=\\"1657\\"><field name=\\"TEXT\\">Yes</field><data>f930kf-glazr6pjsu9qnwqw2y</data></block></value><next><block type=\\"procedures_ifreturn\\" id=\\"1658\\"><mutation value=\\"1\\"></mutation><data>r8xe1one2ejabj6h8a-hcacba</data><value name=\\"CONDITION\\"><block type=\\"logic_compare\\" id=\\"1659\\"><field name=\\"OP\\">EQ</field><data>piyy81-rhqlaa-40pto6-3gh7en</data><value name=\\"A\\"><block type=\\"stratego_get\\" id=\\"1660\\"><field name=\\"VAR\\">random</field><data>n6zohbqp3pn2-pezv0p-qcdyr</data></block></value><value name=\\"B\\"><block type=\\"stratego_number\\" id=\\"1661\\"><field name=\\"NUM\\">2</field><data>w5xnzn6ji47lv0g29u-tgmn8d</data></block></value></block></value><value name=\\"VALUE\\"><block type=\\"text\\" id=\\"1662\\"><field name=\\"TEXT\\">No</field><data>6rek0p11w4n4ni6et9-71vh7c</data></block></value><next><block type=\\"procedures_ifreturn\\" id=\\"1663\\"><mutation value=\\"1\\"></mutation><data>-e620klo6jnjf-3hs8dz-icgy8q</data><value name=\\"CONDITION\\"><block type=\\"logic_compare\\" id=\\"1664\\"><field name=\\"OP\\">EQ</field><data>-xdxvlg-fjgufk5ur6v0n6266d</data><value name=\\"A\\"><block type=\\"stratego_get\\" id=\\"1665\\"><field name=\\"VAR\\">random</field><data>-x53383-ll8t6adu5nusfe0uvo</data></block></value><value name=\\"B\\"><block type=\\"stratego_number\\" id=\\"1666\\"><field name=\\"NUM\\">3</field><data>75nt05-mf47l1zd1ikd-3lhon</data></block></value></block></value><value name=\\"VALUE\\"><block type=\\"text\\" id=\\"1667\\"><field name=\\"TEXT\\">Maybe</field><data>-76aghmh2yaeoe6pgohkwv3rc</data></block></value><next><block type=\\"procedures_ifreturn\\" id=\\"1668\\"><mutation value=\\"1\\"></mutation><data>m8vmgx-jepefamyz4omf0ylgv</data><value name=\\"CONDITION\\"><block type=\\"logic_compare\\" id=\\"1669\\"><field name=\\"OP\\">EQ</field><data>lxw0ce-r6us0o-mmil7qp5pp1f</data><value name=\\"A\\"><block type=\\"stratego_get\\" id=\\"1670\\"><field name=\\"VAR\\">random</field><data>-smvevzjtn2x4-eo3v2pj5cw8s</data></block></value><value name=\\"B\\"><block type=\\"stratego_number\\" id=\\"1671\\"><field name=\\"NUM\\">4</field><data>-wgd5hu-pb4a0f-m2b7zi-l3fypu</data></block></value></block></value><value name=\\"VALUE\\"><block type=\\"text\\" id=\\"1672\\"><field name=\\"TEXT\\">Signs point to yes</field><data>-40yq3ejeb0yq-8hirfb-n81vm6</data></block></value></block></next></block></next></block></next></block></next></block></statement><value name=\\"RETURN\\"><block type=\\"text\\" id=\\"1673\\"><field name=\\"TEXT\\">I cannot say </field><data>8e97zy-51rrs4a702pluu4xbj</data></block></value></block><block type=\\"stratego_when_message\\" id=\\"1674\\" x=\\"429\\" y=\\"4\\"><field name=\\"MESSAGE\\">wave</field><data>-aqejx63zks17-5q5i6d-f8yfpm</data><statement name=\\"DO\\"><block type=\\"stratego_say\\" id=\\"1675\\"><data>-gzjtei-enqwlq-io3ymr-y1p5z3</data><value name=\\"MSG\\"><block type=\\"procedures_callreturn\\" id=\\"1676\\"><mutation name=\\"DivineAnswer\\"></mutation><data>1j9pnq-uk0x1bcq5qrw-tcqtlj</data></block></value><next><block type=\\"stratego_send_message\\" id=\\"1677\\"><field name=\\"MESSAGE\\">wink</field><data>-i4gjpsog9jj2ymgoeqlc6czh</data><next><block type=\\"stratego_wait\\" id=\\"1678\\"><data>-3pfs7nxwrdxls4brazz73mae</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"1679\\"><field name=\\"NUM\\">5</field><data>-ru7t41-ax9euw-neahl8s7wt9l</data></block></value><next><block type=\\"stratego_say\\" id=\\"1680\\"><data>-96wiricbnkk260fjou-xcz0t5</data></block></next></block></next></block></next></block></statement></block><block type=\\"stratego_say\\" id=\\"1681\\" x=\\"688\\" y=\\"913\\"><data>-t0m0qh-y2emagrvktmm59a153</data></block></xml>",
        "_codeJs": [
          "var random;\\n\\nfunction math_random_int(a, b) {\\n  if (a > b) {\\n    // Swap a and b to ensure a is smaller.\\n    var c = a;\\n    a = b;\\n    b = c;\\n  }\\n  return Math.floor(Math.random() * (b - a + 1) + a);\\n}\\n\\nfunction DivineAnswer() {\\n  highlightBlock('-7ncb94-g2o401q1gahpx6a76s');\\n  highlightBlock('-d8yilc-2j5zdlp6bts8-go8rv1');\\n  set_variable('random', math_random_int(1, 4));\\n  highlightBlock('1pbne5-3x7e2zldlxyjp19lf');\\n  if (get_variable('random') == 1) {\\n    return 'Yes';\\n  }\\n  highlightBlock('r8xe1one2ejabj6h8a-hcacba');\\n  if (get_variable('random') == 2) {\\n    return 'No';\\n  }\\n  highlightBlock('-e620klo6jnjf-3hs8dz-icgy8q');\\n  if (get_variable('random') == 3) {\\n    return 'Maybe';\\n  }\\n  highlightBlock('m8vmgx-jepefamyz4omf0ylgv');\\n  if (get_variable('random') == 4) {\\n    return 'Signs point to yes';\\n  }\\n  return 'I cannot say ';\\n}\\n",
          "var random;\\n\\n\\nhighlightBlock('-aqejx63zks17-5q5i6d-f8yfpm');\\nwhile(true) {\\n  highlightBlock('-aqejx63zks17-5q5i6d-f8yfpm');\\n  wait_for_message('wave');\\n  highlightBlock('-gzjtei-enqwlq-io3ymr-y1p5z3');\\n  say((DivineAnswer()));\\n  highlightBlock('-i4gjpsog9jj2ymgoeqlc6czh');\\n  send_message('wink');\\n  highlightBlock('-3pfs7nxwrdxls4brazz73mae');\\n  for (var count = 0; count < 5; count++) {\\n    wait();\\n  }\\n  highlightBlock('-96wiricbnkk260fjou-xcz0t5');\\n  say();\\n\\n}"
        ],
        "key": "space_04_saturn",
        "firstLoc": {
          "x": 996.0000000000002,
          "y": 677.0000000000002
        }
      },
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"1333\\" x=\\"63\\" y=\\"13\\"><data>8lmfqz-uh7q2d-72i2zncwbtzy</data><statement name=\\"DO\\"><block type=\\"procedures_callnoreturn\\" id=\\"1334\\"><mutation name=\\"flashThreeTimes\\"></mutation><data>viuygf-8csof2-z04zijlthbdt</data></block></statement></block><block type=\\"procedures_defnoreturn\\" id=\\"1335\\" x=\\"362\\" y=\\"63\\"><field name=\\"NAME\\">flashThreeTimes</field><data>ky4wy8-lmgvpfcd9qrc-cj3u64</data><statement name=\\"STACK\\"><block type=\\"controls_repeat_ext\\" id=\\"1336\\"><data>-fa35bv4x5mj1a0ovaufug7d4</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"1337\\"><field name=\\"NUM\\">3</field><data>lenl25-k6ysu4-jiho74-g401ic</data></block></value><statement name=\\"DO\\"><block type=\\"stratego_show\\" id=\\"1338\\"><data>s8ij6f-8clox3mgwt0b75ffpg</data><next><block type=\\"stratego_wait\\" id=\\"1339\\"><data>-g3hqve-2lk180-tn8nwm-tjpiij</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"1340\\"><field name=\\"NUM\\">2</field><data>-59tdre-kvlq959nmxpv-phaplv</data></block></value><next><block type=\\"stratego_hide\\" id=\\"1341\\"><data>-3nfk6uc7vw3o-lq9ac93lyhwe</data></block></next></block></next></block></statement></block></statement></block><block type=\\"stratego_when_message\\" id=\\"1342\\" x=\\"62\\" y=\\"106\\"><field name=\\"MESSAGE\\">wink</field><data>2kehdy-pn3p7iea0p4l-7a0r3n</data><statement name=\\"DO\\"><block type=\\"stratego_set_color_2\\" id=\\"1343\\"><data>8g01xe91j3214uz3zf-tbvclz</data><value name=\\"COLOR\\"><block type=\\"colour_picker\\" id=\\"1344\\"><field name=\\"COLOUR\\">#99ffff</field><data>1ow67xdm9e8muhn6v7r87yue</data></block></value><next><block type=\\"procedures_callnoreturn\\" id=\\"1345\\"><mutation name=\\"flashThreeTimes\\"></mutation><data>u0b4qto9pvac-hvfbv0-j4ganz</data></block></next></block></statement></block></xml>",
        "_codeJs": [
          "highlightBlock('8lmfqz-uh7q2d-72i2zncwbtzy');\\nwait();\\n  highlightBlock('viuygf-8csof2-z04zijlthbdt');\\n  flashThreeTimes();\\n",
          "function flashThreeTimes() {\\n  highlightBlock('ky4wy8-lmgvpfcd9qrc-cj3u64');\\n  highlightBlock('-fa35bv4x5mj1a0ovaufug7d4');\\n  for (var count2 = 0; count2 < 3; count2++) {\\n    highlightBlock('s8ij6f-8clox3mgwt0b75ffpg');\\n    show();\\n    highlightBlock('-g3hqve-2lk180-tn8nwm-tjpiij');\\n    for (var count = 0; count < 2; count++) {\\n      wait();\\n    }\\n    highlightBlock('-3nfk6uc7vw3o-lq9ac93lyhwe');\\n    hide();\\n    highlightBlock('-fa35bv4x5mj1a0ovaufug7d4');\\n  }\\n}\\n",
          "highlightBlock('2kehdy-pn3p7iea0p4l-7a0r3n');\\nwhile(true) {\\n  highlightBlock('2kehdy-pn3p7iea0p4l-7a0r3n');\\n  wait_for_message('wink');\\n  highlightBlock('8g01xe91j3214uz3zf-tbvclz');\\n  set_color_2('#99ffff');\\n  highlightBlock('u0b4qto9pvac-hvfbv0-j4ganz');\\n  flashThreeTimes();\\n\\n}"
        ],
        "key": "space_06_lightning",
        "firstLoc": {
          "x": 1481.3333333333335,
          "y": 408.6666666666667
        }
      },
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"1571\\" x=\\"38\\" y=\\"88\\"><data>xljva3skufw7-9qcdktbdd1cl</data><statement name=\\"DO\\"><block type=\\"procedures_callnoreturn\\" id=\\"1572\\"><mutation name=\\"FlashThreeTimes\\"></mutation><data>-wr8ltc-xq6novs984ml-x4mpkt</data></block></statement></block><block type=\\"procedures_defnoreturn\\" id=\\"1573\\" x=\\"280\\" y=\\"140\\"><field name=\\"NAME\\">FlashThreeTimes</field><data>-f7jcc4i33rxq2sh9cz1y90pm</data><statement name=\\"STACK\\"><block type=\\"controls_repeat_ext\\" id=\\"1574\\"><data>y2vpjx-l9i0v83uby2n-85s8qu</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"1575\\"><field name=\\"NUM\\">3</field><data>ern031-efet3drr82m-ervzqo</data></block></value><statement name=\\"DO\\"><block type=\\"stratego_show\\" id=\\"1576\\"><data>-c6kyy9-lfzbxb-bz2gk57p0x8p</data><next><block type=\\"stratego_wait\\" id=\\"1577\\"><data>-lyyw8u-dunan2i0azug8ie4dp</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"1578\\"><field name=\\"NUM\\">2</field><data>-82ypzaqz8uz3gzu8k8-v88n2b</data></block></value><next><block type=\\"stratego_hide\\" id=\\"1579\\"><data>-5ef68uwl2cod-jzxnzb-n35tor</data></block></next></block></next></block></statement></block></statement></block><block type=\\"stratego_when_message\\" id=\\"1580\\" x=\\"38\\" y=\\"188\\"><field name=\\"MESSAGE\\">wink</field><data>a5qqep280ocph3y0h3-uoolf4</data><statement name=\\"DO\\"><block type=\\"stratego_set_color_2\\" id=\\"1581\\"><data>-66stdk8pw3ci-ydxyr8-ok09p</data><value name=\\"COLOR\\"><block type=\\"colour_picker\\" id=\\"1582\\"><field name=\\"COLOUR\\">#ccffff</field><data>-n07sp9y275g3jvfaszz7glfa</data></block></value><next><block type=\\"procedures_callnoreturn\\" id=\\"1583\\"><mutation name=\\"FlashThreeTimes\\"></mutation><data>h58wsv-b4i6w7-mwz8v3spdrv9</data></block></next></block></statement></block></xml>",
        "_codeJs": [
          "highlightBlock('xljva3skufw7-9qcdktbdd1cl');\\nwait();\\n  highlightBlock('-wr8ltc-xq6novs984ml-x4mpkt');\\n  FlashThreeTimes();\\n",
          "function FlashThreeTimes() {\\n  highlightBlock('-f7jcc4i33rxq2sh9cz1y90pm');\\n  highlightBlock('y2vpjx-l9i0v83uby2n-85s8qu');\\n  for (var count2 = 0; count2 < 3; count2++) {\\n    highlightBlock('-c6kyy9-lfzbxb-bz2gk57p0x8p');\\n    show();\\n    highlightBlock('-lyyw8u-dunan2i0azug8ie4dp');\\n    for (var count = 0; count < 2; count++) {\\n      wait();\\n    }\\n    highlightBlock('-5ef68uwl2cod-jzxnzb-n35tor');\\n    hide();\\n    highlightBlock('y2vpjx-l9i0v83uby2n-85s8qu');\\n  }\\n}\\n",
          "highlightBlock('a5qqep280ocph3y0h3-uoolf4');\\nwhile(true) {\\n  highlightBlock('a5qqep280ocph3y0h3-uoolf4');\\n  wait_for_message('wink');\\n  highlightBlock('-66stdk8pw3ci-ydxyr8-ok09p');\\n  set_color_2('#ccffff');\\n  highlightBlock('h58wsv-b4i6w7-mwz8v3spdrv9');\\n  FlashThreeTimes();\\n\\n}"
        ],
        "key": "space_06_lightning",
        "firstLoc": {
          "x": 576.3333333333334,
          "y": 435.66666666666674
        }
      },
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"1599\\" x=\\"38\\" y=\\"13\\"><data>w4x181-v77ukhwzwubvmc6s2e</data><statement name=\\"DO\\"><block type=\\"procedures_callnoreturn\\" id=\\"1600\\"><mutation name=\\"Flash\\"><arg name=\\"flashCount\\"></arg></mutation><data>k9mexy-8l0ddkw7orlodjdxy2</data><value name=\\"ARG0\\"><block type=\\"stratego_number\\" id=\\"1601\\"><field name=\\"NUM\\">3</field><data>q3v0199olqcmlatum6-9on9xo</data></block></value></block></statement></block><block type=\\"procedures_defnoreturn\\" id=\\"1602\\" x=\\"293\\" y=\\"11\\"><mutation><arg name=\\"flashCount\\"></arg></mutation><field name=\\"NAME\\">Flash</field><data>-5ka0kn6c8qgd-6m9q7a-pdyez7</data><statement name=\\"STACK\\"><block type=\\"controls_repeat_ext\\" id=\\"1603\\"><data>-e6q54okhqrhwm48gg-ccchml</data><value name=\\"TIMES\\"><block type=\\"variables_get\\" id=\\"1604\\"><field name=\\"VAR\\">flashCount</field><data>czu3l0-ndokraczatmvgvdyci</data></block></value><statement name=\\"DO\\"><block type=\\"stratego_show\\" id=\\"1605\\"><data>wu4whn-3n3zvfrx8lmo-776wut</data><next><block type=\\"stratego_wait\\" id=\\"1606\\"><data>67zwqfoh90vd-po06pho7vse5</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"1607\\"><field name=\\"NUM\\">2</field><data>-ww1a13-3qyv8j-nu1rwrfyc2y7</data></block></value><next><block type=\\"stratego_hide\\" id=\\"1608\\"><data>-7j8ltz2rutueoszr6wcbll23</data></block></next></block></next></block></statement></block></statement></block><block type=\\"stratego_when_message\\" id=\\"1609\\" x=\\"38\\" y=\\"138\\"><field name=\\"MESSAGE\\">wink</field><data>-cy69stonf1d36tlhul-l74uxl</data><statement name=\\"DO\\"><block type=\\"stratego_play_sound\\" id=\\"1610\\"><field name=\\"SOUND\\">tada</field><data>-o9xg2mdbsf33-eqilf6-wnmmwq</data><next><block type=\\"procedures_callnoreturn\\" id=\\"1611\\"><mutation name=\\"Flash\\"><arg name=\\"flashCount\\"></arg></mutation><data>-4jfd0fkvl208-n4f3fi-233453</data><value name=\\"ARG0\\"><block type=\\"stratego_number\\" id=\\"1612\\"><field name=\\"NUM\\">5</field><data>-atdpz8-nyqi6ryiks9h4pxh5l</data></block></value><next><block type=\\"stratego_send_message\\" id=\\"1613\\"><field name=\\"MESSAGE\\">thumbs-up</field><data>-d12me09iiwism16krwdrwvtz</data></block></next></block></next></block></statement></block></xml>",
        "_codeJs": [
          "var flashCount;\\n\\n\\nhighlightBlock('w4x181-v77ukhwzwubvmc6s2e');\\nwait();\\n  highlightBlock('k9mexy-8l0ddkw7orlodjdxy2');\\n  Flash(3);\\n",
          "var flashCount;\\n\\nfunction Flash(flashCount) {\\n  highlightBlock('-5ka0kn6c8qgd-6m9q7a-pdyez7');\\n  highlightBlock('-e6q54okhqrhwm48gg-ccchml');\\n  for (var count2 = 0; count2 < flashCount; count2++) {\\n    highlightBlock('wu4whn-3n3zvfrx8lmo-776wut');\\n    show();\\n    highlightBlock('67zwqfoh90vd-po06pho7vse5');\\n    for (var count = 0; count < 2; count++) {\\n      wait();\\n    }\\n    highlightBlock('-7j8ltz2rutueoszr6wcbll23');\\n    hide();\\n    highlightBlock('-e6q54okhqrhwm48gg-ccchml');\\n  }\\n}\\n",
          "var flashCount;\\n\\n\\nhighlightBlock('-cy69stonf1d36tlhul-l74uxl');\\nwhile(true) {\\n  highlightBlock('-cy69stonf1d36tlhul-l74uxl');\\n  wait_for_message('wink');\\n  highlightBlock('-o9xg2mdbsf33-eqilf6-wnmmwq');\\n  play_sound('tada');\\n  highlightBlock('-4jfd0fkvl208-n4f3fi-233453');\\n  Flash(5);\\n  highlightBlock('-d12me09iiwism16krwdrwvtz');\\n  send_message('thumbs-up');\\n\\n}"
        ],
        "key": "space_06_lightning",
        "firstLoc": {
          "x": 1045.6666666666665,
          "y": 304
        }
      },
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"1701\\" x=\\"38\\" y=\\"13\\"><data>-7w0o1u1iqxcf-eprenb82nce8</data><statement name=\\"DO\\"><block type=\\"stratego_say\\" id=\\"1702\\"><data>-tqxpfu-ghm690o221t2-z06onb</data><value name=\\"MSG\\"><block type=\\"text\\" id=\\"1703\\"><field name=\\"TEXT\\">Ask the planet a question</field><data>-1xu4kjr67147-uaxb6y-ym6hp6</data></block></value><next><block type=\\"stratego_wait\\" id=\\"1704\\"><data>k72w8sqeoznkxl1yw2jm2tnh</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"1705\\"><field name=\\"NUM\\">10</field><data>-ll4h17g04u77-csmvwapn8ycc</data></block></value><next><block type=\\"stratego_say\\" id=\\"1706\\"><data>-hd0o79a6j24w48olvc-ifjzf2</data><value name=\\"MSG\\"><block type=\\"text\\" id=\\"1707\\"><field name=\\"TEXT\\">Then tap the star to receive your answer.</field><data>53go49-9z8c39-8hmrvf-9c5ifn</data></block></value><next><block type=\\"stratego_wait\\" id=\\"1708\\"><data>-fdau0a-pkdoj9-t8et5o-fk27cb</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"1709\\"><field name=\\"NUM\\">10</field><data>-z8aefx-7x3l4z-m9v1ms-1de1yi</data></block></value><next><block type=\\"stratego_say\\" id=\\"1710\\"><data>-cx5we65aa3oq-66lt34vqpwv0</data></block></next></block></next></block></next></block></next></block></statement></block><block type=\\"stratego_when_message\\" id=\\"1711\\" x=\\"251\\" y=\\"181\\"><field name=\\"MESSAGE\\">thumbs-up</field><data>lhzprd6450qw-s85pgm45m3mj</data><statement name=\\"DO\\"><block type=\\"stratego_say\\" id=\\"1712\\"><data>-kgariu-18omgd-m8f3ef-5qnx2q</data><value name=\\"MSG\\"><block type=\\"text\\" id=\\"1713\\"><field name=\\"TEXT\\">You may ask another question </field><data>-hnwnfxtrm3cq5lipw8ty7goa</data></block></value><next><block type=\\"stratego_wait\\" id=\\"1714\\"><data>-4dzomb-b1m7lvvyiv2y6u7z00</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"1715\\"><field name=\\"NUM\\">10</field><data>-9n6lghywyca2-71v10d-ihn7ii</data></block></value><next><block type=\\"stratego_say\\" id=\\"1716\\"><data>-1mfmy3-2xb2tqniziit-6z28fk</data></block></next></block></next></block></statement></block><block type=\\"stratego_when_pressed\\" id=\\"1717\\" x=\\"38\\" y=\\"263\\"><data>-enu7b6-mgr4sk-py9i2pw895j8</data><statement name=\\"DO\\"><block type=\\"stratego_send_message\\" id=\\"1718\\"><field name=\\"MESSAGE\\">wave</field><data>-3zejp2pe7o8j-ffp7hneoeyud</data><next><block type=\\"stratego_play_sound\\" id=\\"1719\\"><field name=\\"SOUND\\">boing</field><data>-us9dynlnms76-fayae1-oilikv</data></block></next></block></statement></block></xml>",
        "_codeJs": [
          "highlightBlock('-7w0o1u1iqxcf-eprenb82nce8');\\nwait();\\n  highlightBlock('-tqxpfu-ghm690o221t2-z06onb');\\n  say('Ask the planet a question');\\n  highlightBlock('k72w8sqeoznkxl1yw2jm2tnh');\\n  for (var count = 0; count < 10; count++) {\\n    wait();\\n  }\\n  highlightBlock('-hd0o79a6j24w48olvc-ifjzf2');\\n  say('Then tap the star to receive your answer.');\\n  highlightBlock('-fdau0a-pkdoj9-t8et5o-fk27cb');\\n  for (var count2 = 0; count2 < 10; count2++) {\\n    wait();\\n  }\\n  highlightBlock('-cx5we65aa3oq-66lt34vqpwv0');\\n  say();\\n",
          "highlightBlock('lhzprd6450qw-s85pgm45m3mj');\\nwhile(true) {\\n  highlightBlock('lhzprd6450qw-s85pgm45m3mj');\\n  wait_for_message('thumbs-up');\\n  highlightBlock('-kgariu-18omgd-m8f3ef-5qnx2q');\\n  say('You may ask another question ');\\n  highlightBlock('-4dzomb-b1m7lvvyiv2y6u7z00');\\n  for (var count = 0; count < 10; count++) {\\n    wait();\\n  }\\n  highlightBlock('-1mfmy3-2xb2tqniziit-6z28fk');\\n  say();\\n\\n}",
          "highlightBlock('-enu7b6-mgr4sk-py9i2pw895j8');\\nwhile(true) {\\n  highlightBlock('-enu7b6-mgr4sk-py9i2pw895j8');\\n  wait_for_sprite_press();\\n  highlightBlock('-3zejp2pe7o8j-ffp7hneoeyud');\\n  send_message('wave');\\n  highlightBlock('-us9dynlnms76-fayae1-oilikv');\\n  play_sound('boing');\\n\\n}"
        ],
        "key": "space_01_star",
        "firstLoc": {
          "x": 1001.6666666666665,
          "y": 1212.9999999999998
        }
      }
    ],
    "assets": [],
    "backgroundKey": "bg-starburst",
    "showGrid": false
  }
  '''

  'Lost Stone': ''' {
    "devices": [
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"2546\\" x=\\"13\\" y=\\"-12\\"><data>-3p0tvrozxoyt-19riit-bslxkf</data><statement name=\\"DO\\"><block type=\\"stratego_wait\\" id=\\"2547\\"><data>-psnnnuh0rtpw-b5tq46-2woz36</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"2548\\"><field name=\\"NUM\\">24</field><data>mdhm3g-gna7we-iutznea6is5p</data></block></value><next><block type=\\"stratego_hide\\" id=\\"2549\\"><data>aa5mucscayxe-i3y1j6-nz0o3s</data><next><block type=\\"stratego_set\\" id=\\"2550\\"><field name=\\"VAR\\">hidingSpot</field><data>wj2xug-272cei-a58oob23vvx9</data><value name=\\"VALUE\\"><block type=\\"math_random_int\\" id=\\"2551\\"><data>9dyfkp-tj2kbf98nh6oq9nk3r</data><value name=\\"FROM\\"><block type=\\"stratego_number\\" id=\\"2552\\"><field name=\\"NUM\\">1</field><data>-9to7cug6s5y3-imtf634lzhgp</data></block></value><value name=\\"TO\\"><block type=\\"stratego_number\\" id=\\"2553\\"><field name=\\"NUM\\">5</field><data>m4e8098zxrso-eyomr5-oj9kig</data></block></value></block></value><next><block type=\\"stratego_send_message_with_data\\" id=\\"2554\\"><field name=\\"MESSAGE\\">smile</field><data>5tagz6-3w0kvv-fkcrqu-26tgj6</data><value name=\\"DATA\\"><block type=\\"stratego_get\\" id=\\"2555\\"><field name=\\"VAR\\">hidingSpot</field><data>57al64-2engj9-kjsibq8w1k9</data></block></value></block></next></block></next></block></next></block></statement></block><block type=\\"procedures_defnoreturn\\" id=\\"2556\\" x=\\"389\\" y=\\"5\\"><field name=\\"NAME\\">HideStone</field><data>jn7i46-psvrkxakbx0t-nsm8ly</data><statement name=\\"STACK\\"><block type=\\"stratego_if\\" id=\\"2557\\"><data>xlzksd-jna8xn-jk8i4k8kcslz</data><value name=\\"IF0\\"><block type=\\"logic_compare\\" id=\\"2558\\"><field name=\\"OP\\">EQ</field><data>-i3zcapctlvaov1fg12-nsdqou</data><value name=\\"A\\"><block type=\\"stratego_get\\" id=\\"2559\\"><field name=\\"VAR\\">hidingSpot</field><data>3s5ptionbulru6liqgy7awm0</data></block></value><value name=\\"B\\"><block type=\\"stratego_number\\" id=\\"2560\\"><field name=\\"NUM\\">1</field><data>9anbg8-qrlaqavyfbfbu1hum</data></block></value></block></value><statement name=\\"DO0\\"><block type=\\"stratego_teleport_to_coordinates\\" id=\\"2561\\"><data>n0r6nf-k8of7g-ni4gcm-t8xwcq</data><value name=\\"X\\"><block type=\\"stratego_number\\" id=\\"2562\\"><field name=\\"NUM\\">8</field><data>-v0l2t4efiofcyr944m-r7jtoo</data></block></value><value name=\\"Y\\"><block type=\\"stratego_number\\" id=\\"2563\\"><field name=\\"NUM\\">10</field><data>vms767lijhkwurlzi-ytnbg</data></block></value></block></statement><next><block type=\\"stratego_if\\" id=\\"2564\\"><data>-3ofe6do4oal2-x0rma3ad05bj</data><value name=\\"IF0\\"><block type=\\"logic_compare\\" id=\\"2565\\"><field name=\\"OP\\">EQ</field><data>-uxtb9w-txv9hu-rzsbh4u9zd35</data><value name=\\"A\\"><block type=\\"stratego_get\\" id=\\"2566\\"><field name=\\"VAR\\">hidingSpot</field><data>-ve7vbb-wjotnh-inhcef-i0ux5o</data></block></value><value name=\\"B\\"><block type=\\"stratego_number\\" id=\\"2567\\"><field name=\\"NUM\\">2</field><data>y86dz-yztx6f-6lfnfb-gjvhos</data></block></value></block></value><statement name=\\"DO0\\"><block type=\\"stratego_teleport_to_coordinates\\" id=\\"2568\\"><data>-e32ti9bfjgyv928tji-wb8hhz</data><value name=\\"X\\"><block type=\\"stratego_number\\" id=\\"2569\\"><field name=\\"NUM\\">3</field><data>junoytuf2nyobljznp-uom474</data></block></value><value name=\\"Y\\"><block type=\\"stratego_number\\" id=\\"2570\\"><field name=\\"NUM\\">21</field><data>-ve0ojy-rqztg8dknphbcpcdax</data></block></value></block></statement><next><block type=\\"stratego_if\\" id=\\"2571\\"><data>aex8yq-nfv1s05omge1-xm1s1s</data><value name=\\"IF0\\"><block type=\\"logic_compare\\" id=\\"2572\\"><field name=\\"OP\\">EQ</field><data>gdygkfuoo0f9f0e3ul-ndsnme</data><value name=\\"A\\"><block type=\\"stratego_get\\" id=\\"2573\\"><field name=\\"VAR\\">hidingSpot</field><data>kbbh95tu3znl-mitywn-7y84gp</data></block></value><value name=\\"B\\"><block type=\\"stratego_number\\" id=\\"2574\\"><field name=\\"NUM\\">3</field><data>-s3oaez-pv53nfriv3di7l09nn</data></block></value></block></value><statement name=\\"DO0\\"><block type=\\"stratego_teleport_to_coordinates\\" id=\\"2575\\"><data>-dccqap-wemww2-unabfh1xoxqn</data><value name=\\"X\\"><block type=\\"stratego_number\\" id=\\"2576\\"><field name=\\"NUM\\">12</field><data>pg9v59ta3dzxkawata-ml8vx7</data></block></value><value name=\\"Y\\"><block type=\\"stratego_number\\" id=\\"2577\\"><field name=\\"NUM\\">19</field><data>-g9e0vi-ab6ycu-fnr8ld17sr48</data></block></value></block></statement><next><block type=\\"stratego_if\\" id=\\"2578\\"><data>ig31vvi2ixfq-pupjbszh0bdu</data><value name=\\"IF0\\"><block type=\\"logic_compare\\" id=\\"2579\\"><field name=\\"OP\\">EQ</field><data>d12dhhfd6u5-4c24mi-b7igqc</data><value name=\\"A\\"><block type=\\"stratego_get\\" id=\\"2580\\"><field name=\\"VAR\\">hidingSpot</field><data>-ah45d3hfx1rl-bt0kd7dbq1ol</data></block></value><value name=\\"B\\"><block type=\\"stratego_number\\" id=\\"2581\\"><field name=\\"NUM\\">4</field><data>-ke2lar-xb6gbz7lkqrmtlj8k5</data></block></value></block></value><statement name=\\"DO0\\"><block type=\\"stratego_teleport_to_coordinates\\" id=\\"2582\\"><data>-8dkios94ofeyss32m4hrsdl0</data><value name=\\"X\\"><block type=\\"stratego_number\\" id=\\"2583\\"><field name=\\"NUM\\">26</field><data>1lous7-z35klz-73hpi8-dmmp7e</data></block></value><value name=\\"Y\\"><block type=\\"stratego_number\\" id=\\"2584\\"><field name=\\"NUM\\">18</field><data>7ix7zq4tn5aa-aqvity54oarq</data></block></value></block></statement><next><block type=\\"stratego_if\\" id=\\"2585\\"><data>-mvxu367vseousrpaut7jvvj3</data><value name=\\"IF0\\"><block type=\\"logic_compare\\" id=\\"2586\\"><field name=\\"OP\\">EQ</field><data>-ijsl3z-4au9x3xeyptxpie9bz</data><value name=\\"A\\"><block type=\\"stratego_get\\" id=\\"2587\\"><field name=\\"VAR\\">hidingSpot</field><data>iw3f67yx5azxvnd3a5-9xgtl6</data></block></value><value name=\\"B\\"><block type=\\"stratego_number\\" id=\\"2588\\"><field name=\\"NUM\\">5</field><data>mh8bbp-d505hx-pbgqt5rah8d</data></block></value></block></value><statement name=\\"DO0\\"><block type=\\"stratego_teleport_to_coordinates\\" id=\\"2589\\"><data>l3fdy1gudt4s76b41yynwpp7</data><value name=\\"X\\"><block type=\\"stratego_number\\" id=\\"2590\\"><field name=\\"NUM\\">28</field><data>bw5yrl6gjet-xty6c6qel815</data></block></value><value name=\\"Y\\"><block type=\\"stratego_number\\" id=\\"2591\\"><field name=\\"NUM\\">8</field><data>sgyaee-jj7wsa-52089657fzzx</data></block></value></block></statement></block></next></block></next></block></next></block></next></block></statement></block><block type=\\"stratego_when_message\\" id=\\"2592\\" x=\\"13\\" y=\\"188\\"><field name=\\"MESSAGE\\">smile</field><data>hiu7ogx3ksew-xbbskmovibf1</data><statement name=\\"DO\\"><block type=\\"procedures_callnoreturn\\" id=\\"2593\\"><mutation name=\\"HideStone\\"></mutation><data>-n84u5ei4m1v21v2289d242s8</data></block></statement></block><block type=\\"stratego_when_message\\" id=\\"2594\\" x=\\"13\\" y=\\"263\\"><field name=\\"MESSAGE\\">fist-bump</field><data>d0gftml79jny6w2ymvek8hhd</data><statement name=\\"DO\\"><block type=\\"stratego_show\\" id=\\"2595\\"><data>fa6txniigzb9-n2206c-2u3bbp</data><next><block type=\\"stratego_wait\\" id=\\"2596\\"><data>8hh1p4r5059p-6akxwb-xlvh8w</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"2597\\"><field name=\\"NUM\\">10</field><data>-wl4f0l-tk59boyywuwo-l2unni</data></block></value><next><block type=\\"stratego_reset_position\\" id=\\"2598\\"><data>y1sng1s2jnw8-h6nniy-heuwek</data></block></next></block></next></block></statement></block><block type=\\"stratego_when_message\\" id=\\"2599\\" x=\\"538\\" y=\\"838\\"><field name=\\"MESSAGE\\">wink</field><data>-gych0wbufy6phpzhno-ikdxna</data><statement name=\\"DO\\"><block type=\\"stratego_show\\" id=\\"2600\\"><data>ypy9v0-wgqkyphfxfv5-dvcoxo</data></block></statement></block></xml>",
        "_codeJs": [
          "var hidingSpot;\\n\\nfunction math_random_int(a, b) {\\n  if (a > b) {\\n    // Swap a and b to ensure a is smaller.\\n    var c = a;\\n    a = b;\\n    b = c;\\n  }\\n  return Math.floor(Math.random() * (b - a + 1) + a);\\n}\\n\\n\\nhighlightBlock('-3p0tvrozxoyt-19riit-bslxkf');\\nwait();\\n  highlightBlock('-psnnnuh0rtpw-b5tq46-2woz36');\\n  for (var count = 0; count < 24; count++) {\\n    wait();\\n  }\\n  highlightBlock('aa5mucscayxe-i3y1j6-nz0o3s');\\n  hide();\\n  highlightBlock('wj2xug-272cei-a58oob23vvx9');\\n  set_variable('hidingSpot', math_random_int(1, 5));\\n  highlightBlock('5tagz6-3w0kvv-fkcrqu-26tgj6');\\n  send_message_with_data('smile',get_variable('hidingSpot'));\\n",
          "var hidingSpot;\\n\\nfunction HideStone() {\\n  highlightBlock('jn7i46-psvrkxakbx0t-nsm8ly');\\n  highlightBlock('xlzksd-jna8xn-jk8i4k8kcslz');\\n  if(get_variable('hidingSpot') == 1) {\\n     highlightBlock('n0r6nf-k8of7g-ni4gcm-t8xwcq');\\n    teleport_to_coordinates(8, 10);\\n  };\\n  highlightBlock('-3ofe6do4oal2-x0rma3ad05bj');\\n  if(get_variable('hidingSpot') == 2) {\\n     highlightBlock('-e32ti9bfjgyv928tji-wb8hhz');\\n    teleport_to_coordinates(3, 21);\\n  };\\n  highlightBlock('aex8yq-nfv1s05omge1-xm1s1s');\\n  if(get_variable('hidingSpot') == 3) {\\n     highlightBlock('-dccqap-wemww2-unabfh1xoxqn');\\n    teleport_to_coordinates(12, 19);\\n  };\\n  highlightBlock('ig31vvi2ixfq-pupjbszh0bdu');\\n  if(get_variable('hidingSpot') == 4) {\\n     highlightBlock('-8dkios94ofeyss32m4hrsdl0');\\n    teleport_to_coordinates(26, 18);\\n  };\\n  highlightBlock('-mvxu367vseousrpaut7jvvj3');\\n  if(get_variable('hidingSpot') == 5) {\\n     highlightBlock('l3fdy1gudt4s76b41yynwpp7');\\n    teleport_to_coordinates(28, 8);\\n  };\\n}\\n",
          "var hidingSpot;\\n\\n\\nhighlightBlock('hiu7ogx3ksew-xbbskmovibf1');\\nwhile(true) {\\n  highlightBlock('hiu7ogx3ksew-xbbskmovibf1');\\n  wait_for_message('smile');\\n  highlightBlock('-n84u5ei4m1v21v2289d242s8');\\n  HideStone();\\n\\n}",
          "var hidingSpot;\\n\\n\\nhighlightBlock('d0gftml79jny6w2ymvek8hhd');\\nwhile(true) {\\n  highlightBlock('d0gftml79jny6w2ymvek8hhd');\\n  wait_for_message('fist-bump');\\n  highlightBlock('fa6txniigzb9-n2206c-2u3bbp');\\n  show();\\n  highlightBlock('8hh1p4r5059p-6akxwb-xlvh8w');\\n  for (var count = 0; count < 10; count++) {\\n    wait();\\n  }\\n  highlightBlock('y1sng1s2jnw8-h6nniy-heuwek');\\n  reset_position();\\n\\n}",
          "var hidingSpot;\\n\\n\\nhighlightBlock('-gych0wbufy6phpzhno-ikdxna');\\nwhile(true) {\\n  highlightBlock('-gych0wbufy6phpzhno-ikdxna');\\n  wait_for_message('wink');\\n  highlightBlock('ypy9v0-wgqkyphfxfv5-dvcoxo');\\n  show();\\n\\n}"
        ],
        "key": "shapes_13_treasure",
        "firstLoc": {
          "x": 1171.9999999999998,
          "y": 640.9999999999999
        }
      },
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"727\\" x=\\"88\\" y=\\"38\\"><data>hsun20-3gqlfg-bjssrf-2fts8x</data><statement name=\\"DO\\"><block type=\\"stratego_wait\\" id=\\"728\\"><data>6486vc-3q7p2fjlds5t16kk4w</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"729\\"><field name=\\"NUM\\">60</field><data>-n95cfd46md1p4thbj8-vepfd3</data></block></value><next><block type=\\"stratego_repeat_forever\\" id=\\"730\\"><data>zda0xzpedpt5etnvh-lefvje</data><statement name=\\"DO\\"><block type=\\"stratego_move_by\\" id=\\"731\\"><data>-hy6yqz-mrn29ylzkqn3w50etf</data><value name=\\"VEC\\"><block type=\\"stratego_arithmetic\\" id=\\"732\\"><field name=\\"OP\\">ADD</field><data>-941ob-x4g998-e2tr6wnrdi5</data><value name=\\"A\\"><block type=\\"stratego_tilt\\" id=\\"733\\"><field name=\\"AXIS\\">XY</field><data>-fsm5ge-xg0p6asqdudlxbi08w</data></block></value><value name=\\"B\\"><block type=\\"stratego_number\\" id=\\"734\\"><field name=\\"NUM\\">40</field><data>4ja2rc-1vtsw1hbg5xa-cl1nx7</data></block></value></block></value></block></statement></block></next></block></statement></block><block type=\\"stratego_when_message\\" id=\\"735\\" x=\\"84\\" y=\\"224\\"><field name=\\"MESSAGE\\">fist-bump</field><data>jjq1lw-dd8ybo9eo5f7wp7x2i</data><statement name=\\"DO\\"><block type=\\"stratego_reset_position\\" id=\\"736\\"><data>7a4ohq-mkmwnk-sfilqc-y7e745</data></block></statement></block></xml>",
        "_codeJs": [
          "highlightBlock('hsun20-3gqlfg-bjssrf-2fts8x');\\nwait();\\n  highlightBlock('6486vc-3q7p2fjlds5t16kk4w');\\n  for (var count = 0; count < 60; count++) {\\n    wait();\\n  }\\n  highlightBlock('zda0xzpedpt5etnvh-lefvje');\\n  while (true) {\\n      highlightBlock('-hy6yqz-mrn29ylzkqn3w50etf');\\n    move_by(arithmetic('ADD', tilt('XY'), 40));\\n\\n  };",
          "highlightBlock('jjq1lw-dd8ybo9eo5f7wp7x2i');\\nwhile(true) {\\n  highlightBlock('jjq1lw-dd8ybo9eo5f7wp7x2i');\\n  wait_for_message('fist-bump');\\n  highlightBlock('7a4ohq-mkmwnk-sfilqc-y7e745');\\n  reset_position();\\n\\n}"
        ],
        "key": "animals_11_chicken",
        "firstLoc": {
          "x": 1067.333333333333,
          "y": 1212.8
        }
      },
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"251\\" x=\\"13\\" y=\\"-12\\"><data>-cmrrej-8c7wv2-ea21qw-3v2jgr</data><statement name=\\"DO\\"><block type=\\"stratego_wait\\" id=\\"252\\"><data>-4ium1dfobhyc-ibmthm2zuv18</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"253\\"><field name=\\"NUM\\">24</field><data>ibwiuubp3qdrza56bb-14xd6m</data></block></value><next><block type=\\"controls_repeat_ext\\" id=\\"254\\"><data>-lxr69w-wrjvhtqnrw2fcl7not</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"255\\"><field name=\\"NUM\\">2</field><data>-686bvcb9cxvd-vuoi5rbmdbvd</data></block></value><statement name=\\"DO\\"><block type=\\"stratego_resize\\" id=\\"256\\"><data>-semo-e205bnbod7i9-77zgyz</data><value name=\\"SIZE\\"><block type=\\"stratego_number\\" id=\\"257\\"><field name=\\"NUM\\">8</field><data>xg6uh6-9bww3q5c54z74rn3v3</data></block></value><next><block type=\\"stratego_set_color_2\\" id=\\"258\\"><data>-7bg99i-i0o6zdt93uge13dlgy</data><value name=\\"COLOR\\"><block type=\\"colour_picker\\" id=\\"259\\"><field name=\\"COLOUR\\">#ffff99</field><data>-7lo48k-5j7j8q-fwxmcd-f767fy</data></block></value><next><block type=\\"stratego_wait\\" id=\\"260\\"><data>coqcmj-qkuzrnh2bwqx-c1kp8i</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"261\\"><field name=\\"NUM\\">2</field><data>-cvqbps8141s2-lpzabb7hip7n</data></block></value><next><block type=\\"stratego_resize\\" id=\\"262\\"><data>rgf8s3-qxb87wtwc5k7-p11nha</data><value name=\\"SIZE\\"><block type=\\"stratego_number\\" id=\\"263\\"><field name=\\"NUM\\">5</field><data>nl87vw-nlqxeo-b5dibbrpd8xk</data></block></value></block></next></block></next></block></next></block></statement><next><block type=\\"stratego_say\\" id=\\"264\\"><data>-pepy1z-tmxqq3qnqytl-dh8xlp</data><value name=\\"MSG\\"><block type=\\"text\\" id=\\"265\\"><field name=\\"TEXT\\">Tilt to start the search</field><data>ko76ws7t77k6-iigq7g9kc7e9</data></block></value><next><block type=\\"stratego_wait\\" id=\\"266\\"><data>-yjut28cukiuq7riv6wgveqbm</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"267\\"><field name=\\"NUM\\">10</field><data>gd88e5-f1r6ym-94ybzx-uanfth</data></block></value><next><block type=\\"stratego_say\\" id=\\"268\\"><data>-1goqb6ri7haq5z6f8y-xd4sjm</data><next><block type=\\"stratego_resize\\" id=\\"269\\"><data>qbc42b1u4ya-5f6h7hu4i731</data><value name=\\"SIZE\\"><block type=\\"stratego_number\\" id=\\"270\\"><field name=\\"NUM\\">3</field><data>oc9j7k28o7sx-4iqzwvkh36xf</data></block></value></block></next></block></next></block></next></block></next></block></next></block></statement></block><block type=\\"stratego_when_message\\" id=\\"271\\" x=\\"263\\" y=\\"13\\"><field name=\\"MESSAGE\\">fist-bump</field><data>fb3qz2ja7oz1ybjy7v-kbh0r8</data><statement name=\\"DO\\"><block type=\\"stratego_play_sound\\" id=\\"272\\"><field name=\\"SOUND\\">tada</field><data>rzukgt-8el2yluobvdvmbqvoc</data><next><block type=\\"stratego_say\\" id=\\"273\\"><data>lztx9jvjlrh286tkn-a8dhlc</data><value name=\\"MSG\\"><block type=\\"text\\" id=\\"274\\"><field name=\\"TEXT\\">FOUND❕❕</field><data>okrowjpmbstprabh90u0gvzw</data></block></value><next><block type=\\"stratego_wait\\" id=\\"275\\"><data>-sx3b4q-ar2g29-3deq5u-ffzk6z</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"276\\"><field name=\\"NUM\\">10</field><data>gu3pfbwz0pnqge15q6czybtm</data></block></value><next><block type=\\"stratego_say\\" id=\\"277\\"><data>nddd2lyr8u146wr9c7dasnnp</data></block></next></block></next></block></next></block></statement></block><block type=\\"stratego_when_message\\" id=\\"278\\" x=\\"365\\" y=\\"164\\"><field name=\\"MESSAGE\\">shrug</field><data>-19xnw2fpzz2irnk27p9gtj7e</data><statement name=\\"DO\\"><block type=\\"stratego_play_sound\\" id=\\"279\\"><field name=\\"SOUND\\">tape</field><data>-mrpbavg2ctft-pxy4x9u2ooji</data><next><block type=\\"stratego_say\\" id=\\"280\\"><data>-coikzivkf6wb1xyia4hhpwmb</data><value name=\\"MSG\\"><block type=\\"text\\" id=\\"281\\"><field name=\\"TEXT\\">UH UH</field><data>-kt7o7fau1sk3-3g8ai8oq6qlx</data></block></value><next><block type=\\"stratego_wait\\" id=\\"282\\"><data>-beg9owhfevay-42undh-j3d0yi</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"283\\"><field name=\\"NUM\\">10</field><data>-tpxqd1eg98bn234xpc-fskvs0</data></block></value><next><block type=\\"stratego_say\\" id=\\"284\\"><data>-buc94xsvvvdlfed6nz-3ohcz5</data></block></next></block></next></block></next></block></statement></block></xml>",
        "_codeJs": [
          "highlightBlock('-cmrrej-8c7wv2-ea21qw-3v2jgr');\\nwait();\\n  highlightBlock('-4ium1dfobhyc-ibmthm2zuv18');\\n  for (var count = 0; count < 24; count++) {\\n    wait();\\n  }\\n  highlightBlock('-lxr69w-wrjvhtqnrw2fcl7not');\\n  for (var count3 = 0; count3 < 2; count3++) {\\n    highlightBlock('-semo-e205bnbod7i9-77zgyz');\\n    resize(8);\\n    highlightBlock('-7bg99i-i0o6zdt93uge13dlgy');\\n    set_color_2('#ffff99');\\n    highlightBlock('coqcmj-qkuzrnh2bwqx-c1kp8i');\\n    for (var count2 = 0; count2 < 2; count2++) {\\n      wait();\\n    }\\n    highlightBlock('rgf8s3-qxb87wtwc5k7-p11nha');\\n    resize(5);\\n    highlightBlock('-lxr69w-wrjvhtqnrw2fcl7not');\\n  }\\n  highlightBlock('-pepy1z-tmxqq3qnqytl-dh8xlp');\\n  say('Tilt to start the search');\\n  highlightBlock('-yjut28cukiuq7riv6wgveqbm');\\n  for (var count4 = 0; count4 < 10; count4++) {\\n    wait();\\n  }\\n  highlightBlock('-1goqb6ri7haq5z6f8y-xd4sjm');\\n  say();\\n  highlightBlock('qbc42b1u4ya-5f6h7hu4i731');\\n  resize(3);\\n",
          "highlightBlock('fb3qz2ja7oz1ybjy7v-kbh0r8');\\nwhile(true) {\\n  highlightBlock('fb3qz2ja7oz1ybjy7v-kbh0r8');\\n  wait_for_message('fist-bump');\\n  highlightBlock('rzukgt-8el2yluobvdvmbqvoc');\\n  play_sound('tada');\\n  highlightBlock('lztx9jvjlrh286tkn-a8dhlc');\\n  say('FOUND❕❕');\\n  highlightBlock('-sx3b4q-ar2g29-3deq5u-ffzk6z');\\n  for (var count = 0; count < 10; count++) {\\n    wait();\\n  }\\n  highlightBlock('nddd2lyr8u146wr9c7dasnnp');\\n  say();\\n\\n}",
          "highlightBlock('-19xnw2fpzz2irnk27p9gtj7e');\\nwhile(true) {\\n  highlightBlock('-19xnw2fpzz2irnk27p9gtj7e');\\n  wait_for_message('shrug');\\n  highlightBlock('-mrpbavg2ctft-pxy4x9u2ooji');\\n  play_sound('tape');\\n  highlightBlock('-coikzivkf6wb1xyia4hhpwmb');\\n  say('UH UH');\\n  highlightBlock('-beg9owhfevay-42undh-j3d0yi');\\n  for (var count = 0; count < 10; count++) {\\n    wait();\\n  }\\n  highlightBlock('-buc94xsvvvdlfed6nz-3ohcz5');\\n  say();\\n\\n}"
        ],
        "key": "space_01_star",
        "firstLoc": {
          "x": 1053.3333333333333,
          "y": 1335.4666666666665
        }
      },
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"512\\" x=\\"0\\" y=\\"18\\"><data>5kev455ggcf0texf8p-gpkd63</data><statement name=\\"DO\\"><block type=\\"stratego_set\\" id=\\"513\\"><field name=\\"VAR\\">hiddenHere?</field><data>-a1xf38-nqh5zr-y1ddnu-to7s2j</data><value name=\\"VALUE\\"><block type=\\"stratego_number\\" id=\\"514\\"><field name=\\"NUM\\">0</field><data>-615n0v9qlqy5-da9wf3fjlj2l</data></block></value></block></statement></block><block type=\\"stratego_when_message\\" id=\\"515\\" x=\\"263\\" y=\\"13\\"><field name=\\"MESSAGE\\">smile</field><data>qkxesg-3oigx85kpikvy08v</data><statement name=\\"DO\\"><block type=\\"stratego_if_else\\" id=\\"516\\"><data>2sp96c-ft9q9u-x25n83-zdq5k7</data><value name=\\"CONDITION\\"><block type=\\"logic_compare\\" id=\\"517\\"><field name=\\"OP\\">EQ</field><data>j7cd38cqt64q-wh7g63-dyiqet</data><value name=\\"A\\"><block type=\\"stratego_get\\" id=\\"518\\"><field name=\\"VAR\\">hiddenHere?</field><data>-n2heknq2tmok-khlwyxql2d1a</data></block></value><value name=\\"B\\"><block type=\\"stratego_number\\" id=\\"519\\"><field name=\\"NUM\\">5</field><data>-nw02npacmdpt-kthqid68r1tm</data></block></value></block></value><statement name=\\"DO\\"><block type=\\"stratego_set\\" id=\\"520\\"><field name=\\"VAR\\">hiddenHere?</field><data>5n92pxhsdse0-ochjsf-wcdij3</data><value name=\\"VALUE\\"><block type=\\"stratego_number\\" id=\\"521\\"><field name=\\"NUM\\">1</field><data>yo4kre-wrspvhescywd4atmck</data></block></value></block></statement><statement name=\\"ELSE\\"><block type=\\"stratego_set\\" id=\\"522\\"><field name=\\"VAR\\">hiddenHere?</field><data>3b8furxg9zbf-iodgqod66hm7</data><value name=\\"VALUE\\"><block type=\\"stratego_number\\" id=\\"523\\"><field name=\\"NUM\\">0</field><data>-djdc3kbs5ca8-s38ab3b7vzet</data></block></value></block></statement></block></statement></block><block type=\\"stratego_when_overlap\\" id=\\"524\\" x=\\"13\\" y=\\"188\\"><data>-qpm94a-1orb3n-vzd0nh7xfmo6</data><statement name=\\"DO\\"><block type=\\"stratego_if_else\\" id=\\"525\\"><data>iqv6wq-8ymaea-tbmzyf-fxv761</data><value name=\\"CONDITION\\"><block type=\\"logic_compare\\" id=\\"526\\"><field name=\\"OP\\">EQ</field><data>la507h-fljj3h-qf6i4w-e25npx</data><value name=\\"A\\"><block type=\\"stratego_get\\" id=\\"527\\"><field name=\\"VAR\\">hiddenHere?</field><data>7st2v8jtt3e2i2klwuebh3r4</data></block></value><value name=\\"B\\"><block type=\\"stratego_number\\" id=\\"528\\"><field name=\\"NUM\\">1</field><data>-3i5ht8roxi68-ct6uuq44zau</data></block></value></block></value><statement name=\\"DO\\"><block type=\\"stratego_send_message\\" id=\\"529\\"><field name=\\"MESSAGE\\">fist-bump</field><data>j7y9yd-3xne4x-mhdqwc-7w7znn</data></block></statement><statement name=\\"ELSE\\"><block type=\\"stratego_send_message\\" id=\\"530\\"><field name=\\"MESSAGE\\">shrug</field><data>-4xyr8h-5gshoj-rfabei-b9blm9</data></block></statement></block></statement></block></xml>",
        "_codeJs": [
          "var hiddenHere_;\\n\\n\\nhighlightBlock('5kev455ggcf0texf8p-gpkd63');\\nwait();\\n  highlightBlock('-a1xf38-nqh5zr-y1ddnu-to7s2j');\\n  set_variable('hiddenHere_', 0);\\n",
          "var hiddenHere_;\\n\\n\\nhighlightBlock('qkxesg-3oigx85kpikvy08v');\\nwhile(true) {\\n  highlightBlock('qkxesg-3oigx85kpikvy08v');\\n  wait_for_message('smile');\\n  highlightBlock('2sp96c-ft9q9u-x25n83-zdq5k7');\\n  if(get_variable('hiddenHere_') == 5) {\\n    highlightBlock('5n92pxhsdse0-ochjsf-wcdij3');\\n    set_variable('hiddenHere_', 1);\\n  } else {\\n    highlightBlock('3b8furxg9zbf-iodgqod66hm7');\\n    set_variable('hiddenHere_', 0);\\n  };\\n}",
          "var hiddenHere_;\\n\\n\\nhighlightBlock('-qpm94a-1orb3n-vzd0nh7xfmo6');\\nwhile(true) {\\n  wait_for_overlap();\\n  highlightBlock('iqv6wq-8ymaea-tbmzyf-fxv761');\\n  if(get_variable('hiddenHere_') == 1) {\\n    highlightBlock('j7y9yd-3xne4x-mhdqwc-7w7znn');\\n    send_message('fist-bump');\\n  } else {\\n    highlightBlock('-4xyr8h-5gshoj-rfabei-b9blm9');\\n    send_message('shrug');\\n  };\\n}"
        ],
        "key": "shapes_06_x",
        "firstLoc": {
          "x": 1808.9999999999998,
          "y": 962.0000000000001
        }
      },
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"698\\" x=\\"13\\" y=\\"13\\"><data>hlhbhr-w6oivj66w66g-iyicfi</data><statement name=\\"DO\\"><block type=\\"stratego_set\\" id=\\"699\\"><field name=\\"VAR\\">hiddenHere?</field><data>-3becvvhbsa515rje9xlojy8z</data><value name=\\"VALUE\\"><block type=\\"stratego_number\\" id=\\"700\\"><field name=\\"NUM\\">0</field><data>f3680o-81x8j7e7h4gg-tkdc3z</data></block></value></block></statement></block><block type=\\"stratego_when_message\\" id=\\"701\\" x=\\"316\\" y=\\"12\\"><field name=\\"MESSAGE\\">smile</field><data>-bbboy7-7wz6kf14019890u7dr</data><statement name=\\"DO\\"><block type=\\"stratego_if_else\\" id=\\"702\\"><data>-troi4f-2bzemnh4lvrfq6wk5a</data><value name=\\"CONDITION\\"><block type=\\"logic_compare\\" id=\\"703\\"><field name=\\"OP\\">EQ</field><data>5tbwmn-weyfjh3kjxs7-5ujs7f</data><value name=\\"A\\"><block type=\\"stratego_message_data\\" id=\\"704\\"><data>n3hfla-megrzmrpeemb3g6udu</data></block></value><value name=\\"B\\"><block type=\\"stratego_number\\" id=\\"705\\"><field name=\\"NUM\\">1</field><data>xelfds-kmztzw6b879o-s2o64i</data></block></value></block></value><statement name=\\"DO\\"><block type=\\"stratego_set\\" id=\\"706\\"><field name=\\"VAR\\">hiddenHere?</field><data>-f9f5soji5pgy5hugjy-tg1apb</data><value name=\\"VALUE\\"><block type=\\"stratego_number\\" id=\\"707\\"><field name=\\"NUM\\">1</field><data>hhcnfbahwvzy-gf56pja2uza5</data></block></value></block></statement><statement name=\\"ELSE\\"><block type=\\"stratego_set\\" id=\\"708\\"><field name=\\"VAR\\">hiddenHere?</field><data>-7003qa2m7sag-u1nxq6-shtctd</data><value name=\\"VALUE\\"><block type=\\"stratego_number\\" id=\\"709\\"><field name=\\"NUM\\">0</field><data>po2rc2-lx6ba6-h56ivt-57yhaf</data></block></value></block></statement></block></statement></block><block type=\\"stratego_when_overlap\\" id=\\"710\\" x=\\"13\\" y=\\"113\\"><data>goajkvkjxa4y-if9vor-s556p1</data><statement name=\\"DO\\"><block type=\\"stratego_if_else\\" id=\\"711\\"><data>p5mhfu-72zfyx-voo24j-ts24mq</data><value name=\\"CONDITION\\"><block type=\\"logic_compare\\" id=\\"712\\"><field name=\\"OP\\">EQ</field><data>qtzg33lwlzz2d7rymnxr22z</data><value name=\\"A\\"><block type=\\"stratego_get\\" id=\\"713\\"><field name=\\"VAR\\">hiddenHere?</field><data>xxfg15x8h2ni27pn47-o7a6mo</data></block></value><value name=\\"B\\"><block type=\\"stratego_number\\" id=\\"714\\"><field name=\\"NUM\\">1</field><data>-i2i5id76stq3itkkaj-7qpeww</data></block></value></block></value><statement name=\\"DO\\"><block type=\\"stratego_send_message\\" id=\\"715\\"><field name=\\"MESSAGE\\">fist-bump</field><data>-fl9q1a-gan6i67yjijj-6aw3fb</data></block></statement><statement name=\\"ELSE\\"><block type=\\"stratego_send_message\\" id=\\"716\\"><field name=\\"MESSAGE\\">shrug</field><data>-j0yutxt14xn5-x8j8s6-kegz4q</data></block></statement></block></statement></block></xml>",
        "_codeJs": [
          "var hiddenHere_;\\n\\n\\nhighlightBlock('hlhbhr-w6oivj66w66g-iyicfi');\\nwait();\\n  highlightBlock('-3becvvhbsa515rje9xlojy8z');\\n  set_variable('hiddenHere_', 0);\\n",
          "var hiddenHere_;\\n\\n\\nhighlightBlock('-bbboy7-7wz6kf14019890u7dr');\\nwhile(true) {\\n  highlightBlock('-bbboy7-7wz6kf14019890u7dr');\\n  wait_for_message('smile');\\n  highlightBlock('-troi4f-2bzemnh4lvrfq6wk5a');\\n  if(get_event_message_data() == 1) {\\n    highlightBlock('-f9f5soji5pgy5hugjy-tg1apb');\\n    set_variable('hiddenHere_', 1);\\n  } else {\\n    highlightBlock('-7003qa2m7sag-u1nxq6-shtctd');\\n    set_variable('hiddenHere_', 0);\\n  };\\n}",
          "var hiddenHere_;\\n\\n\\nhighlightBlock('goajkvkjxa4y-if9vor-s556p1');\\nwhile(true) {\\n  wait_for_overlap();\\n  highlightBlock('p5mhfu-72zfyx-voo24j-ts24mq');\\n  if(get_variable('hiddenHere_') == 1) {\\n    highlightBlock('-fl9q1a-gan6i67yjijj-6aw3fb');\\n    send_message('fist-bump');\\n  } else {\\n    highlightBlock('-j0yutxt14xn5-x8j8s6-kegz4q');\\n    send_message('shrug');\\n  };\\n}"
        ],
        "key": "shapes_06_x",
        "firstLoc": {
          "x": 514.6666666666665,
          "y": 881.3333333333334
        }
      },
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_message\\" id=\\"550\\" x=\\"313\\" y=\\"13\\"><field name=\\"MESSAGE\\">smile</field><data>uo22cb-ccriv5-vrodys-an2aw4</data><statement name=\\"DO\\"><block type=\\"stratego_if_else\\" id=\\"551\\"><data>-g4fljt7qrl78ehliwb8k4gfu</data><value name=\\"CONDITION\\"><block type=\\"logic_compare\\" id=\\"552\\"><field name=\\"OP\\">EQ</field><data>-1rblxr-5hrgts-spq0rx-5ohovn</data><value name=\\"A\\"><block type=\\"stratego_message_data\\" id=\\"553\\"><data>87mpd2-2sl9ckss70ex-o6x3m9</data></block></value><value name=\\"B\\"><block type=\\"stratego_number\\" id=\\"554\\"><field name=\\"NUM\\">4</field><data>hamh33i0wqtl16rb6y-70bzmv</data></block></value></block></value><statement name=\\"DO\\"><block type=\\"stratego_set\\" id=\\"555\\"><field name=\\"VAR\\">hiddenHere?</field><data>4gm6lf60mcpsq1j1s6tarxhu</data><value name=\\"VALUE\\"><block type=\\"stratego_number\\" id=\\"556\\"><field name=\\"NUM\\">1</field><data>-v43dh3gkoavtcwe865-x8o3xh</data></block></value></block></statement><statement name=\\"ELSE\\"><block type=\\"stratego_set\\" id=\\"557\\"><field name=\\"VAR\\">cubby</field><data>-sktyjug2tonwal5331-oz6rx</data><value name=\\"VALUE\\"><block type=\\"stratego_number\\" id=\\"558\\"><field name=\\"NUM\\">0</field><data>-akyps4dhq5h92185901kbms0</data></block></value></block></statement></block></statement></block><block type=\\"stratego_when_started\\" id=\\"559\\" x=\\"13\\" y=\\"38\\"><data>-mu6ra34k5eae-gcjf2t-ey479q</data><statement name=\\"DO\\"><block type=\\"stratego_set\\" id=\\"560\\"><field name=\\"VAR\\">hiddenHere?</field><data>-h708bih9uv5l19auairzk27</data><value name=\\"VALUE\\"><block type=\\"stratego_number\\" id=\\"561\\"><field name=\\"NUM\\">0</field><data>tne7ox-jqwx32w71vi5-yirpx3</data></block></value></block></statement></block><block type=\\"stratego_when_overlap\\" id=\\"562\\" x=\\"13\\" y=\\"138\\"><data>7nhtq6-krlihw-14h2uqne8lwi</data><statement name=\\"DO\\"><block type=\\"stratego_if_else\\" id=\\"563\\"><data>-d7163n5hh8lfyyukg83kpkgd</data><value name=\\"CONDITION\\"><block type=\\"logic_compare\\" id=\\"564\\"><field name=\\"OP\\">EQ</field><data>o3wrmelu9v9pco53uy-xla9ki</data><value name=\\"A\\"><block type=\\"stratego_get\\" id=\\"565\\"><field name=\\"VAR\\">hiddenHere?</field><data>-6utol2ch3acm-8andsw3176x8</data></block></value><value name=\\"B\\"><block type=\\"stratego_number\\" id=\\"566\\"><field name=\\"NUM\\">1</field><data>oqieilroj7w8-7scr16-2p1po6</data></block></value></block></value><statement name=\\"DO\\"><block type=\\"stratego_send_message\\" id=\\"567\\"><field name=\\"MESSAGE\\">fist-bump</field><data>jl40j59rdu77enewoxyjzmh</data></block></statement><statement name=\\"ELSE\\"><block type=\\"stratego_send_message\\" id=\\"568\\"><field name=\\"MESSAGE\\">shrug</field><data>-7xy4c0-hlvjyy-i3r2nh-tne4j8</data></block></statement></block></statement></block></xml>",
        "_codeJs": [
          "var hiddenHere_;\\nvar cubby;\\n\\n\\nhighlightBlock('uo22cb-ccriv5-vrodys-an2aw4');\\nwhile(true) {\\n  highlightBlock('uo22cb-ccriv5-vrodys-an2aw4');\\n  wait_for_message('smile');\\n  highlightBlock('-g4fljt7qrl78ehliwb8k4gfu');\\n  if(get_event_message_data() == 4) {\\n    highlightBlock('4gm6lf60mcpsq1j1s6tarxhu');\\n    set_variable('hiddenHere_', 1);\\n  } else {\\n    highlightBlock('-sktyjug2tonwal5331-oz6rx');\\n    set_variable('cubby', 0);\\n  };\\n}",
          "var hiddenHere_;\\nvar cubby;\\n\\n\\nhighlightBlock('-mu6ra34k5eae-gcjf2t-ey479q');\\nwait();\\n  highlightBlock('-h708bih9uv5l19auairzk27');\\n  set_variable('hiddenHere_', 0);\\n",
          "var hiddenHere_;\\nvar cubby;\\n\\n\\nhighlightBlock('7nhtq6-krlihw-14h2uqne8lwi');\\nwhile(true) {\\n  wait_for_overlap();\\n  highlightBlock('-d7163n5hh8lfyyukg83kpkgd');\\n  if(get_variable('hiddenHere_') == 1) {\\n    highlightBlock('jl40j59rdu77enewoxyjzmh');\\n    send_message('fist-bump');\\n  } else {\\n    highlightBlock('-7xy4c0-hlvjyy-i3r2nh-tne4j8');\\n    send_message('shrug');\\n  };\\n}"
        ],
        "key": "shapes_06_x",
        "firstLoc": {
          "x": 1745.0000000000002,
          "y": 340.3333333333333
        }
      },
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"1817\\" x=\\"13\\" y=\\"13\\"><data>-70iz9o-urbqkseopexe-e235a0</data><statement name=\\"DO\\"><block type=\\"stratego_set\\" id=\\"1818\\"><field name=\\"VAR\\">hiddenHere?</field><data>-avw8inq66nw5w15oj9onadpx</data><value name=\\"VALUE\\"><block type=\\"stratego_number\\" id=\\"1819\\"><field name=\\"NUM\\">0</field><data>-oa4n52-c74aym-kk4a9y78jioh</data></block></value></block></statement></block><block type=\\"stratego_when_message\\" id=\\"1820\\" x=\\"324\\" y=\\"17\\"><field name=\\"MESSAGE\\">smile</field><data>-fv6ya5-m9z5xukisvsw-q4axgt</data><statement name=\\"DO\\"><block type=\\"stratego_if_else\\" id=\\"1821\\"><data>-mcfenthn1mo9-w2d0rrkkavjh</data><value name=\\"CONDITION\\"><block type=\\"logic_compare\\" id=\\"1822\\"><field name=\\"OP\\">EQ</field><data>-2ah2u865z34-sqfmjg-o8e5yo</data><value name=\\"A\\"><block type=\\"stratego_message_data\\" id=\\"1823\\"><data>o1298i5r76pgs7nsm3-d6cubo</data></block></value><value name=\\"B\\"><block type=\\"stratego_number\\" id=\\"1824\\"><field name=\\"NUM\\">2</field><data>-lljhwc-lf12df-egoslwqblhcz</data></block></value></block></value><statement name=\\"DO\\"><block type=\\"stratego_set\\" id=\\"1825\\"><field name=\\"VAR\\">hiddenHere?</field><data>-a89mza-eh7rs7936a747c76zn</data><value name=\\"VALUE\\"><block type=\\"stratego_number\\" id=\\"1826\\"><field name=\\"NUM\\">1</field><data>25y68br34znzbf7lysgxsmxs</data></block></value></block></statement><statement name=\\"ELSE\\"><block type=\\"stratego_set\\" id=\\"1827\\"><field name=\\"VAR\\">hiddenHere?</field><data>tkgpqeqirjjz-4leeqhdbm8v2</data><value name=\\"VALUE\\"><block type=\\"stratego_number\\" id=\\"1828\\"><field name=\\"NUM\\">0</field><data>-166rd4i0ligxijfm3a-nuf9ut</data></block></value></block></statement></block></statement></block><block type=\\"stratego_when_overlap\\" id=\\"1829\\" x=\\"13\\" y=\\"113\\"><data>6k0n0h-4tizey-r0usw4qy4rq</data><statement name=\\"DO\\"><block type=\\"stratego_if_else\\" id=\\"1830\\"><data>-xwiudrjnwt4-vo1u48-r2bhp0</data><value name=\\"CONDITION\\"><block type=\\"logic_compare\\" id=\\"1831\\"><field name=\\"OP\\">EQ</field><data>378eff-sc3try-8k0px0lj87sb</data><value name=\\"A\\"><block type=\\"stratego_get\\" id=\\"1832\\"><field name=\\"VAR\\">hiddenHere?</field><data>-ndqz0x-9hcwfsowt8yh-ludytf</data></block></value><value name=\\"B\\"><block type=\\"stratego_number\\" id=\\"1833\\"><field name=\\"NUM\\">1</field><data>-1radwk-enpg5g-fg1sj1iv9s42</data></block></value></block></value><statement name=\\"DO\\"><block type=\\"stratego_send_message\\" id=\\"1834\\"><field name=\\"MESSAGE\\">fist-bump</field><data>95csg6brbdlh3pkghi-dnzd6l</data></block></statement><statement name=\\"ELSE\\"><block type=\\"stratego_send_message\\" id=\\"1835\\"><field name=\\"MESSAGE\\">shrug</field><data>xka1gh-vw2qwp16xdv36lpd5r</data></block></statement></block></statement></block></xml>",
        "_codeJs": [
          "var hiddenHere_;\\n\\n\\nhighlightBlock('-70iz9o-urbqkseopexe-e235a0');\\nwait();\\n  highlightBlock('-avw8inq66nw5w15oj9onadpx');\\n  set_variable('hiddenHere_', 0);\\n",
          "var hiddenHere_;\\n\\n\\nhighlightBlock('-fv6ya5-m9z5xukisvsw-q4axgt');\\nwhile(true) {\\n  highlightBlock('-fv6ya5-m9z5xukisvsw-q4axgt');\\n  wait_for_message('smile');\\n  highlightBlock('-mcfenthn1mo9-w2d0rrkkavjh');\\n  if(get_event_message_data() == 2) {\\n    highlightBlock('-a89mza-eh7rs7936a747c76zn');\\n    set_variable('hiddenHere_', 1);\\n  } else {\\n    highlightBlock('tkgpqeqirjjz-4leeqhdbm8v2');\\n    set_variable('hiddenHere_', 0);\\n  };\\n}",
          "var hiddenHere_;\\n\\n\\nhighlightBlock('6k0n0h-4tizey-r0usw4qy4rq');\\nwhile(true) {\\n  wait_for_overlap();\\n  highlightBlock('-xwiudrjnwt4-vo1u48-r2bhp0');\\n  if(get_variable('hiddenHere_') == 1) {\\n    highlightBlock('95csg6brbdlh3pkghi-dnzd6l');\\n    send_message('fist-bump');\\n  } else {\\n    highlightBlock('xka1gh-vw2qwp16xdv36lpd5r');\\n    send_message('shrug');\\n  };\\n}"
        ],
        "key": "shapes_06_x",
        "firstLoc": {
          "x": 295.00000000000006,
          "y": 203.00000000000009
        }
      },
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"198\\" x=\\"13\\" y=\\"13\\"><data>o3euof-8xpnzmqx1xbaw8plmv</data><statement name=\\"DO\\"><block type=\\"stratego_set\\" id=\\"199\\"><field name=\\"VAR\\">hiddenHere?</field><data>en5usvkva42x8cb83o-kdzw79</data><value name=\\"VALUE\\"><block type=\\"stratego_number\\" id=\\"200\\"><field name=\\"NUM\\">0</field><data>-wapxnoad22248o1y1oitlk48</data></block></value></block></statement></block><block type=\\"stratego_when_message\\" id=\\"201\\" x=\\"316\\" y=\\"14\\"><field name=\\"MESSAGE\\">smile</field><data>-6pe7xw994omm7vec1o-q270fb</data><statement name=\\"DO\\"><block type=\\"stratego_if_else\\" id=\\"202\\"><data>vo557ql6c95ib2vhfwmmh606</data><value name=\\"CONDITION\\"><block type=\\"logic_compare\\" id=\\"203\\"><field name=\\"OP\\">EQ</field><data>x5cj47hi4yv-lj9fh8-f2gh41</data><value name=\\"A\\"><block type=\\"stratego_message_data\\" id=\\"204\\"><data>-zgx7wqgc58xlpzx24ol2sd4x</data></block></value><value name=\\"B\\"><block type=\\"stratego_number\\" id=\\"205\\"><field name=\\"NUM\\">3</field><data>k3fepp78r3pdn9c11y-7flou2</data></block></value></block></value><statement name=\\"DO\\"><block type=\\"stratego_set\\" id=\\"206\\"><field name=\\"VAR\\">hiddenHere?</field><data>uzdqjuynaeu7eoeyow-siuxzl</data><value name=\\"VALUE\\"><block type=\\"stratego_number\\" id=\\"207\\"><field name=\\"NUM\\">1</field><data>-837skr-e74tmj-pcb72a-anc0xt</data></block></value></block></statement><statement name=\\"ELSE\\"><block type=\\"stratego_set\\" id=\\"208\\"><field name=\\"VAR\\">hiddenHere?</field><data>gi4ei4b9gzhsjyp0ap20v6q3</data><value name=\\"VALUE\\"><block type=\\"stratego_number\\" id=\\"209\\"><field name=\\"NUM\\">0</field><data>-drh5xdtis467bo9xci-r3c3z</data></block></value></block></statement></block></statement></block><block type=\\"stratego_when_overlap\\" id=\\"210\\" x=\\"13\\" y=\\"163\\"><data>-g8otj3bo6a7a-m6hi9u-ohqf6s</data><statement name=\\"DO\\"><block type=\\"stratego_if_else\\" id=\\"211\\"><data>h5fxpjj60g9q-6zrpa2-3gl43n</data><value name=\\"CONDITION\\"><block type=\\"logic_compare\\" id=\\"212\\"><field name=\\"OP\\">EQ</field><data>zdcjbevxotcygmka84-w5rfye</data><value name=\\"A\\"><block type=\\"stratego_get\\" id=\\"213\\"><field name=\\"VAR\\">hiddenHere?</field><data>4yv1mn-w57gbe-zfdguoji5gfd</data></block></value><value name=\\"B\\"><block type=\\"stratego_number\\" id=\\"214\\"><field name=\\"NUM\\">1</field><data>jzzs9k7bvbbt-mohkgc-q5dema</data></block></value></block></value><statement name=\\"DO\\"><block type=\\"stratego_send_message\\" id=\\"215\\"><field name=\\"MESSAGE\\">fist-bump</field><data>86q42hiwm8et-nkl6q8-rnzrcm</data></block></statement><statement name=\\"ELSE\\"><block type=\\"stratego_send_message\\" id=\\"216\\"><field name=\\"MESSAGE\\">shrug</field><data>sntith-fljww1zg1pmj-bbgd3e</data></block></statement></block></statement></block></xml>",
        "_codeJs": [
          "var hiddenHere_;\\n\\n\\nhighlightBlock('o3euof-8xpnzmqx1xbaw8plmv');\\nwait();\\n  highlightBlock('en5usvkva42x8cb83o-kdzw79');\\n  set_variable('hiddenHere_', 0);\\n",
          "var hiddenHere_;\\n\\n\\nhighlightBlock('-6pe7xw994omm7vec1o-q270fb');\\nwhile(true) {\\n  highlightBlock('-6pe7xw994omm7vec1o-q270fb');\\n  wait_for_message('smile');\\n  highlightBlock('vo557ql6c95ib2vhfwmmh606');\\n  if(get_event_message_data() == 3) {\\n    highlightBlock('uzdqjuynaeu7eoeyow-siuxzl');\\n    set_variable('hiddenHere_', 1);\\n  } else {\\n    highlightBlock('gi4ei4b9gzhsjyp0ap20v6q3');\\n    set_variable('hiddenHere_', 0);\\n  };\\n}",
          "var hiddenHere_;\\n\\n\\nhighlightBlock('-g8otj3bo6a7a-m6hi9u-ohqf6s');\\nwhile(true) {\\n  wait_for_overlap();\\n  highlightBlock('h5fxpjj60g9q-6zrpa2-3gl43n');\\n  if(get_variable('hiddenHere_') == 1) {\\n    highlightBlock('86q42hiwm8et-nkl6q8-rnzrcm');\\n    send_message('fist-bump');\\n  } else {\\n    highlightBlock('sntith-fljww1zg1pmj-bbgd3e');\\n    send_message('shrug');\\n  };\\n}"
        ],
        "key": "shapes_06_x",
        "firstLoc": {
          "x": 798.6666666666669,
          "y": 331.0000000000001
        }
      },
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"1856\\" x=\\"38\\" y=\\"20\\"><data>-n97zgaqq3nygbsyp2ynhhbyc</data><statement name=\\"DO\\"><block type=\\"stratego_say\\" id=\\"1857\\"><data>-7x6xl5dgc6sf-tdkwn1-bfgbrd</data><value name=\\"MSG\\"><block type=\\"text\\" id=\\"1858\\"><field name=\\"TEXT\\">The Lost Stone will be hidden</field><data>-fhwxnf-gxynt9lzedd5-v5wqsy</data></block></value><next><block type=\\"stratego_wait\\" id=\\"1859\\"><data>-3nnp9kswkjt8myikdm1jx1ll</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"1860\\"><field name=\\"NUM\\">10</field><data>29yr0h-m50z3z-wyq6fr-xc877w</data></block></value><next><block type=\\"stratego_say\\" id=\\"1861\\"><data>cs5uft-6qicf3-m2dg75-1fo0tq</data><value name=\\"MSG\\"><block type=\\"text\\" id=\\"1862\\"><field name=\\"TEXT\\">X marks the spot</field><data>-nlkxk3i6uzd7ajewv4-5dyqrg</data></block></value><next><block type=\\"stratego_wait\\" id=\\"1863\\"><data>-ouheie3ija3cdb2t0o-dl9cyx</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"1864\\"><field name=\\"NUM\\">10</field><data>wkdlak-uajbup7ss3h8-s207m5</data></block></value><next><block type=\\"stratego_say\\" id=\\"1865\\"><data>-j9heoch8rz99r38fgrpe9yp</data><next><block type=\\"stratego_play_sound\\" id=\\"1866\\"><field name=\\"SOUND\\">slide</field><data>-e5yaldfy7a47-e3qg5r44dpfz</data><next><block type=\\"stratego_hide\\" id=\\"1867\\"><data>-j13m21bmhpazgjik1p-idnnwv</data></block></next></block></next></block></next></block></next></block></next></block></next></block></statement></block><block type=\\"stratego_when_message\\" id=\\"1868\\" x=\\"324\\" y=\\"120\\"><field name=\\"MESSAGE\\">fist-bump</field><data>-j3827s2yrfj5ewn0f2-6rqe0m</data><statement name=\\"DO\\"><block type=\\"stratego_say\\" id=\\"1869\\"><data>xf3yue-4i2nh7-yrtip7h2ukfw</data><value name=\\"MSG\\"><block type=\\"text\\" id=\\"1870\\"><field name=\\"TEXT\\">Found</field><data>dxftauqr59gj-1cnxek-voebuo</data></block></value><next><block type=\\"stratego_show\\" id=\\"1871\\"><data>fy2tscazdfursbqld4-rd3wvh</data><next><block type=\\"stratego_wait\\" id=\\"1872\\"><data>69x795uv71e1sv08u6d88o78</data><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"1873\\"><field name=\\"NUM\\">5</field><data>-6ys398-t903kg-7ubj4r-do1vsr</data></block></value><next><block type=\\"stratego_say\\" id=\\"1874\\"><data>8ti44z-o50i5oh3yrik5smkop</data><value name=\\"MSG\\"><block type=\\"text\\" id=\\"1875\\"><field name=\\"TEXT\\">Restart app to play again</field><data>msa7os1j0k4u-3rt8u1-xul99g</data></block></value></block></next></block></next></block></next></block></statement></block></xml>",
        "_codeJs": [
          "highlightBlock('-n97zgaqq3nygbsyp2ynhhbyc');\\nwait();\\n  highlightBlock('-7x6xl5dgc6sf-tdkwn1-bfgbrd');\\n  say('The Lost Stone will be hidden');\\n  highlightBlock('-3nnp9kswkjt8myikdm1jx1ll');\\n  for (var count = 0; count < 10; count++) {\\n    wait();\\n  }\\n  highlightBlock('cs5uft-6qicf3-m2dg75-1fo0tq');\\n  say('X marks the spot');\\n  highlightBlock('-ouheie3ija3cdb2t0o-dl9cyx');\\n  for (var count2 = 0; count2 < 10; count2++) {\\n    wait();\\n  }\\n  highlightBlock('-j9heoch8rz99r38fgrpe9yp');\\n  say();\\n  highlightBlock('-e5yaldfy7a47-e3qg5r44dpfz');\\n  play_sound('slide');\\n  highlightBlock('-j13m21bmhpazgjik1p-idnnwv');\\n  hide();\\n",
          "highlightBlock('-j3827s2yrfj5ewn0f2-6rqe0m');\\nwhile(true) {\\n  highlightBlock('-j3827s2yrfj5ewn0f2-6rqe0m');\\n  wait_for_message('fist-bump');\\n  highlightBlock('xf3yue-4i2nh7-yrtip7h2ukfw');\\n  say('Found');\\n  highlightBlock('fy2tscazdfursbqld4-rd3wvh');\\n  show();\\n  highlightBlock('69x795uv71e1sv08u6d88o78');\\n  for (var count = 0; count < 5; count++) {\\n    wait();\\n  }\\n  highlightBlock('8ti44z-o50i5oh3yrik5smkop');\\n  say('Restart app to play again');\\n\\n}"
        ],
        "key": "space_08_dark-cloud",
        "firstLoc": {
          "x": 1071.333333333333,
          "y": 667.6666666666667
        }
      }
    ],
    "assets": [],
    "backgroundKey": "bg-labyrinth",
    "showGrid": false
  }
  '''

  'Blank': '''{
    "devices": [
      {
        "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"8\\" x=\\"150\\" y=\\"25\\"><data>y04b5d-x14bln5tcg5wn6gvar</data></block></xml>",
        "_codeJs": [
          "highlightBlock('y04b5d-x14bln5tcg5wn6gvar');\\nwait();\\n"
        ],
        "key": "animals_05_moose",
        "firstLoc": {
          "x": 963,
          "y": 628
        }
      }
    ],
    "assets": []
  }
  '''

stratego.BONUS_TEMPLATES =

  'forest3' :
    appJson: '''
      {
        "devices": [
          {
            "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"1829\\" x=\\"25\\" y=\\"28\\"><statement name=\\"DO\\"><block type=\\"stratego_say\\" id=\\"1830\\" inline=\\"true\\"><value name=\\"MSG\\"><block type=\\"text\\" id=\\"1831\\"><field name=\\"TEXT\\">Tap to move</field></block></value><next><block type=\\"controls_repeat_ext\\" id=\\"1832\\" inline=\\"true\\"><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"1833\\"><field name=\\"NUM\\">20</field></block></value><next><block type=\\"stratego_say\\" id=\\"1834\\" inline=\\"true\\"></block></next></block></next></block></statement></block><block type=\\"stratego_when_message\\" id=\\"1835\\" x=\\"262\\" y=\\"95\\"><field name=\\"MESSAGE\\">high-five</field><statement name=\\"DO\\"><block type=\\"stratego_set_color_2\\" id=\\"1836\\" inline=\\"false\\"><value name=\\"COLOR\\"><block type=\\"colour_picker\\" id=\\"1837\\"><field name=\\"COLOUR\\">#ff0000</field></block></value><next><block type=\\"stratego_reset_position\\" id=\\"1838\\"><next><block type=\\"stratego_set_color_2\\" id=\\"1839\\" inline=\\"false\\"><value name=\\"COLOR\\"><block type=\\"colour_picker\\" id=\\"1840\\"><field name=\\"COLOUR\\">#ffffff</field></block></value></block></next></block></next></block></statement></block><block type=\\"stratego_when_pressed\\" id=\\"1841\\" x=\\"22\\" y=\\"250\\"><statement name=\\"DO\\"><block type=\\"stratego_move_by\\" id=\\"1842\\" inline=\\"true\\"><value name=\\"VEC\\"><block type=\\"stratego_new_vector\\" id=\\"1843\\" inline=\\"true\\"><value name=\\"DIRECTION\\"><block type=\\"stratego_number\\" id=\\"1844\\"><field name=\\"NUM\\">0</field></block></value><value name=\\"LENGTH\\"><block type=\\"stratego_number\\" id=\\"1845\\"><field name=\\"NUM\\">50</field></block></value></block></value></block></statement></block></xml>",
            "_codeJs": [
              "highlightBlock('1829');\\nwait();\\n  highlightBlock('1830');\\n  say('Tap to move');\\n  highlightBlock('1832');\\n  for (var count = 0; count < 20; count++) {\\n    highlightBlock('1832');\\n  }\\n  highlightBlock('1834');\\n  say();\\n",
              "highlightBlock('1835');\\nwhile(true) {\\n  highlightBlock('1835');\\n  wait_for_message('high-five');\\n  highlightBlock('1836');\\n  set_color_2('#ff0000');\\n  highlightBlock('1838');\\n  reset_position();\\n  highlightBlock('1839');\\n  set_color_2('#ffffff');\\n\\n}",
              "highlightBlock('1841');\\nwhile(true) {\\n  highlightBlock('1841');\\n  wait_for_sprite_press();\\n  highlightBlock('1842');\\n  move_by(new_vector(0, 50));\\n\\n}"
            ],
            "key": "moose",
            "firstLoc": {
              "x": 292.79999999999967,
              "y": 734.9999999999999
            }
          },
          {
            "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_overlap\\" id=\\"737\\" x=\\"6\\" y=\\"17\\"><statement name=\\"DO\\"><block type=\\"stratego_send_message\\" id=\\"738\\"><field name=\\"MESSAGE\\">high-five</field><next><block type=\\"stratego_set_color_2\\" id=\\"739\\" inline=\\"false\\"><value name=\\"COLOR\\"><block type=\\"colour_picker\\" id=\\"740\\"><field name=\\"COLOUR\\">#ff0000</field></block></value><next><block type=\\"stratego_resize\\" id=\\"741\\" inline=\\"true\\"><value name=\\"SIZE\\"><block type=\\"stratego_number\\" id=\\"742\\"><field name=\\"NUM\\">10</field></block></value><next><block type=\\"stratego_resize\\" id=\\"743\\" inline=\\"true\\"><value name=\\"SIZE\\"><block type=\\"stratego_number\\" id=\\"744\\"><field name=\\"NUM\\">5</field></block></value><next><block type=\\"stratego_set_color_2\\" id=\\"745\\" inline=\\"false\\"><value name=\\"COLOR\\"><block type=\\"colour_picker\\" id=\\"746\\"><field name=\\"COLOUR\\">#ffffff</field></block></value></block></next></block></next></block></next></block></next></block></statement></block><block type=\\"stratego_when_started\\" id=\\"747\\" x=\\"212\\" y=\\"43\\"><statement name=\\"DO\\"><block type=\\"stratego_resize\\" id=\\"748\\" inline=\\"true\\"><value name=\\"SIZE\\"><block type=\\"stratego_number\\" id=\\"749\\"><field name=\\"NUM\\">7</field></block></value><next><block type=\\"stratego_repeat_forever\\" id=\\"750\\"><statement name=\\"DO\\"><block type=\\"controls_repeat_ext\\" id=\\"751\\" inline=\\"true\\"><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"752\\"><field name=\\"NUM\\">11</field></block></value><statement name=\\"DO\\"><block type=\\"stratego_move_by\\" id=\\"753\\" inline=\\"true\\"><value name=\\"VEC\\"><block type=\\"stratego_new_vector\\" id=\\"754\\" inline=\\"false\\"><value name=\\"DIRECTION\\"><block type=\\"stratego_number\\" id=\\"755\\"><field name=\\"NUM\\">90</field></block></value><value name=\\"LENGTH\\"><block type=\\"stratego_number\\" id=\\"756\\"><field name=\\"NUM\\">100</field></block></value></block></value></block></statement><next><block type=\\"stratego_reset_position\\" id=\\"757\\"></block></next></block></statement></block></next></block></statement></block></xml>",
            "_codeJs": [
              "highlightBlock('737');\\nwhile(true) {\\n  wait_for_overlap();\\n  highlightBlock('738');\\n  send_message('high-five');\\n  highlightBlock('739');\\n  set_color_2('#ff0000');\\n  highlightBlock('741');\\n  resize(10);\\n  highlightBlock('743');\\n  resize(5);\\n  highlightBlock('745');\\n  set_color_2('#ffffff');\\n\\n}",
              "highlightBlock('747');\\nwait();\\n  highlightBlock('748');\\n  resize(7);\\n  highlightBlock('750');\\n  while (true) {\\n      highlightBlock('751');\\n    for (var count = 0; count < 11; count++) {\\n      highlightBlock('753');\\n      move_by(new_vector(90, 100));\\n      highlightBlock('751');\\n    }\\n    highlightBlock('757');\\n    reset_position();\\n\\n  };"
            ],
            "key": "forest3-bonus-car",
            "firstLoc": {
              "x": 1218.3333333333333,
              "y": 1356.8
            }
          },
          {
            "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_overlap\\" id=\\"4007\\" x=\\"26\\" y=\\"23\\"><statement name=\\"DO\\"><block type=\\"controls_repeat_ext\\" id=\\"4008\\" inline=\\"true\\"><value name=\\"TIMES\\"><block type=\\"stratego_number\\" id=\\"4009\\"><field name=\\"NUM\\">3</field></block></value><statement name=\\"DO\\"><block type=\\"stratego_resize\\" id=\\"4010\\" inline=\\"true\\"><value name=\\"SIZE\\"><block type=\\"stratego_number\\" id=\\"4011\\"><field name=\\"NUM\\">10</field></block></value><next><block type=\\"stratego_set_color_2\\" id=\\"4012\\" inline=\\"false\\"><value name=\\"COLOR\\"><block type=\\"math_random_int\\" id=\\"4013\\" inline=\\"true\\"><value name=\\"FROM\\"><block type=\\"stratego_number\\" id=\\"4014\\"><field name=\\"NUM\\">0</field></block></value><value name=\\"TO\\"><block type=\\"stratego_number\\" id=\\"4015\\"><field name=\\"NUM\\">10</field></block></value></block></value><next><block type=\\"stratego_resize\\" id=\\"4016\\" inline=\\"true\\"><value name=\\"SIZE\\"><block type=\\"stratego_number\\" id=\\"4017\\"><field name=\\"NUM\\">15</field></block></value><next><block type=\\"stratego_set_color_2\\" id=\\"4018\\" inline=\\"false\\"><value name=\\"COLOR\\"><block type=\\"math_random_int\\" id=\\"4019\\" inline=\\"true\\"><value name=\\"FROM\\"><block type=\\"stratego_number\\" id=\\"4020\\"><field name=\\"NUM\\">0</field></block></value><value name=\\"TO\\"><block type=\\"stratego_number\\" id=\\"4021\\"><field name=\\"NUM\\">10</field></block></value></block></value><next><block type=\\"stratego_resize\\" id=\\"4022\\" inline=\\"true\\"><value name=\\"SIZE\\"><block type=\\"stratego_number\\" id=\\"4023\\"><field name=\\"NUM\\">20</field></block></value><next><block type=\\"stratego_set_color_2\\" id=\\"4024\\" inline=\\"false\\"><value name=\\"COLOR\\"><block type=\\"math_random_int\\" id=\\"4025\\" inline=\\"true\\"><value name=\\"FROM\\"><block type=\\"stratego_number\\" id=\\"4026\\"><field name=\\"NUM\\">0</field></block></value><value name=\\"TO\\"><block type=\\"stratego_number\\" id=\\"4027\\"><field name=\\"NUM\\">10</field></block></value></block></value></block></next></block></next></block></next></block></next></block></next></block></statement></block></statement></block><block type=\\"stratego_when_started\\" id=\\"4028\\" x=\\"230\\" y=\\"14\\"><statement name=\\"DO\\"><block type=\\"stratego_set_color_2\\" id=\\"4029\\" inline=\\"false\\"><value name=\\"COLOR\\"><block type=\\"colour_picker\\" id=\\"4030\\"><field name=\\"COLOUR\\">#ffff66</field></block></value></block></statement></block></xml>",
            "_codeJs": [
              "function math_random_int(a, b) {\\n  if (a > b) {\\n    // Swap a and b to ensure a is smaller.\\n    var c = a;\\n    a = b;\\n    b = c;\\n  }\\n  return Math.floor(Math.random() * (b - a + 1) + a);\\n}\\n\\n\\nhighlightBlock('4007');\\nwhile(true) {\\n  wait_for_overlap();\\n  highlightBlock('4008');\\n  for (var count = 0; count < 3; count++) {\\n    highlightBlock('4010');\\n    resize(10);\\n    highlightBlock('4012');\\n    set_color_2((math_random_int(0, 10)));\\n    highlightBlock('4016');\\n    resize(15);\\n    highlightBlock('4018');\\n    set_color_2((math_random_int(0, 10)));\\n    highlightBlock('4022');\\n    resize(20);\\n    highlightBlock('4024');\\n    set_color_2((math_random_int(0, 10)));\\n    highlightBlock('4008');\\n  }\\n\\n}",
              "function math_random_int(a, b) {\\n  if (a > b) {\\n    // Swap a and b to ensure a is smaller.\\n    var c = a;\\n    a = b;\\n    b = c;\\n  }\\n  return Math.floor(Math.random() * (b - a + 1) + a);\\n}\\n\\n\\nhighlightBlock('4028');\\nwait();\\n  highlightBlock('4029');\\n  set_color_2('#ffff66');\\n"
            ],
            "key": "pie",
            "firstLoc": {
              "x": 1879.6666666666667,
              "y": 667.0000000000001
            }
          }
        ],
        "assets": [
          {
            "key": "PHOTO--tryhohyb1k2e-80ejq5yf5xoj",
            "type": "IMAGE",
            "url": "https://s3.amazonaws.com/skc-mancala/production/coding_studio_templates/forest3-bonus-background.JPG"
          },
          {
            "key": "forest3-bonus-car",
            "type": "IMAGE",
            "url": "https://s3.amazonaws.com/skc-mancala/production/coding_studio_templates/forest3-bonus-car.png"
          }
        ],
        "backgroundKey": "PHOTO--tryhohyb1k2e-80ejq5yf5xoj"
      }
    '''
  'boat1' :
    appJson: '''
      {
        "devices": [
          {
            "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"4699\\" x=\\"51\\" y=\\"41\\"><statement name=\\"DO\\"><block type=\\"stratego_set\\" id=\\"4700\\" inline=\\"true\\"><field name=\\"VAR\\">cubby</field><value name=\\"VALUE\\"><block type=\\"stratego_number\\" id=\\"4701\\"><field name=\\"NUM\\">5</field></block></value><next><block type=\\"stratego_repeat_forever\\" id=\\"4702\\"><statement name=\\"DO\\"><block type=\\"stratego_if\\" id=\\"4703\\" inline=\\"false\\"><value name=\\"IF0\\"><block type=\\"stratego_sprite_is\\" id=\\"4704\\"><field name=\\"PROP_NAME\\">PRESSED</field></block></value><statement name=\\"DO0\\"><block type=\\"stratego_set\\" id=\\"4705\\" inline=\\"true\\"><field name=\\"VAR\\">cubby</field><value name=\\"VALUE\\"><block type=\\"stratego_arithmetic\\" id=\\"4706\\" inline=\\"true\\"><field name=\\"OP\\">MULTIPLY</field><value name=\\"A\\"><block type=\\"stratego_get\\" id=\\"4707\\"><field name=\\"VAR\\">cubby</field></block></value><value name=\\"B\\"><block type=\\"stratego_number\\" id=\\"4708\\"><field name=\\"NUM\\">1.2</field></block></value></block></value><next><block type=\\"stratego_say\\" id=\\"4709\\" inline=\\"true\\"></block></next></block></statement><next><block type=\\"stratego_if\\" id=\\"4710\\" inline=\\"false\\"><value name=\\"IF0\\"><block type=\\"logic_negate\\" id=\\"4711\\" inline=\\"false\\"><value name=\\"BOOL\\"><block type=\\"stratego_sprite_is\\" id=\\"4712\\"><field name=\\"PROP_NAME\\">PRESSED</field></block></value></block></value><statement name=\\"DO0\\"><block type=\\"stratego_if\\" id=\\"4713\\" inline=\\"false\\"><value name=\\"IF0\\"><block type=\\"logic_compare\\" id=\\"4714\\" inline=\\"true\\"><field name=\\"OP\\">GT</field><value name=\\"A\\"><block type=\\"stratego_get\\" id=\\"4715\\"><field name=\\"VAR\\">cubby</field></block></value><value name=\\"B\\"><block type=\\"stratego_number\\" id=\\"4716\\"><field name=\\"NUM\\">1</field></block></value></block></value><statement name=\\"DO0\\"><block type=\\"stratego_set\\" id=\\"4717\\" inline=\\"true\\"><field name=\\"VAR\\">cubby</field><value name=\\"VALUE\\"><block type=\\"stratego_arithmetic\\" id=\\"4718\\" inline=\\"true\\"><field name=\\"OP\\">MULTIPLY</field><value name=\\"A\\"><block type=\\"stratego_get\\" id=\\"4719\\"><field name=\\"VAR\\">cubby</field></block></value><value name=\\"B\\"><block type=\\"stratego_number\\" id=\\"4720\\"><field name=\\"NUM\\">0.9</field></block></value></block></value><next><block type=\\"stratego_say\\" id=\\"4721\\" inline=\\"true\\"><value name=\\"MSG\\"><block type=\\"text\\" id=\\"4722\\"><field name=\\"TEXT\\">Help! I'm shrinking. Press on me!</field></block></value></block></next></block></statement></block></statement><next><block type=\\"stratego_resize\\" id=\\"4723\\" inline=\\"true\\"><value name=\\"SIZE\\"><block type=\\"stratego_get\\" id=\\"4724\\"><field name=\\"VAR\\">cubby</field></block></value></block></next></block></next></block></statement></block></next></block></statement></block></xml>",
            "_codeJs": [
              "var cubby;\\n\\n\\nhighlightBlock('4699');\\nwait();\\n  highlightBlock('4700');\\n  set_variable('cubby', 5);\\n  highlightBlock('4702');\\n  while (true) {\\n      highlightBlock('4703');\\n    if(isPressed()) {\\n       highlightBlock('4705');\\n      set_variable('cubby', arithmetic('MULTIPLY', get_variable('cubby'), 1.2));\\n      highlightBlock('4709');\\n      say();\\n    };\\n    highlightBlock('4710');\\n    if(!isPressed()) {\\n       highlightBlock('4713');\\n      if(get_variable('cubby') > 1) {\\n         highlightBlock('4717');\\n        set_variable('cubby', arithmetic('MULTIPLY', get_variable('cubby'), 0.9));\\n        highlightBlock('4721');\\n        say('Help! I\\\\'m shrinking. Press on me!');\\n      };\\n    };\\n    highlightBlock('4723');\\n    resize(get_variable('cubby'));\\n\\n  };"
            ],
            "key": "bread",
            "firstLoc": {
              "x": 1010.6666666666666,
              "y": 780.3333333333333
            }
          }
        ],
        "assets": []
      }
    '''

  'boat3' :
    appJson: '''
      {
        "devices": [
          {
            "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"17807\\" x=\\"6\\" y=\\"15\\"><statement name=\\"DO\\"><block type=\\"stratego_set\\" id=\\"17808\\" inline=\\"true\\"><field name=\\"VAR\\">velocity</field><value name=\\"VALUE\\"><block type=\\"stratego_new_vector\\" id=\\"17809\\" inline=\\"true\\"><value name=\\"DIRECTION\\"><block type=\\"stratego_number\\" id=\\"17810\\"><field name=\\"NUM\\">90</field></block></value><value name=\\"LENGTH\\"><block type=\\"stratego_number\\" id=\\"17811\\"><field name=\\"NUM\\">0</field></block></value></block></value><next><block type=\\"stratego_repeat_forever\\" id=\\"17812\\"><statement name=\\"DO\\"><block type=\\"stratego_move_by\\" id=\\"17813\\" inline=\\"true\\"><value name=\\"VEC\\"><block type=\\"stratego_get\\" id=\\"17814\\"><field name=\\"VAR\\">velocity</field></block></value></block></statement></block></next></block></statement></block><block type=\\"stratego_when_message\\" id=\\"17815\\" x=\\"366\\" y=\\"19\\"><field name=\\"MESSAGE\\">wink</field><statement name=\\"DO\\"><block type=\\"stratego_set\\" id=\\"17816\\" inline=\\"true\\"><field name=\\"VAR\\">direction</field><value name=\\"VALUE\\"><block type=\\"stratego_message_data\\" id=\\"17817\\"></block></value><next><block type=\\"stratego_set\\" id=\\"17818\\" inline=\\"true\\"><field name=\\"VAR\\">velocity</field><value name=\\"VALUE\\"><block type=\\"stratego_arithmetic\\" id=\\"17819\\" inline=\\"true\\"><field name=\\"OP\\">ADD</field><value name=\\"A\\"><block type=\\"stratego_get\\" id=\\"17820\\"><field name=\\"VAR\\">velocity</field></block></value><value name=\\"B\\"><block type=\\"stratego_new_vector\\" id=\\"17821\\" inline=\\"false\\"><value name=\\"DIRECTION\\"><block type=\\"stratego_get\\" id=\\"17822\\"><field name=\\"VAR\\">direction</field></block></value><value name=\\"LENGTH\\"><block type=\\"stratego_number\\" id=\\"17823\\"><field name=\\"NUM\\">5</field></block></value></block></value></block></value></block></next></block></statement></block></xml>",
            "_codeJs": [
              "var velocity;\\nvar direction;\\n\\n\\nhighlightBlock('17807');\\nwait();\\n  highlightBlock('17808');\\n  set_variable('velocity', new_vector(90, 0));\\n  highlightBlock('17812');\\n  while (true) {\\n      highlightBlock('17813');\\n    move_by(get_variable('velocity'));\\n\\n  };",
              "var velocity;\\nvar direction;\\n\\n\\nhighlightBlock('17815');\\nwhile(true) {\\n  highlightBlock('17815');\\n  wait_for_message('wink');\\n  highlightBlock('17816');\\n  set_variable('direction', eval(charon_get('event.messageData')));\\n  highlightBlock('17818');\\n  set_variable('velocity', arithmetic('ADD', get_variable('velocity'), new_vector(get_variable('direction'), 5)));\\n\\n}"
            ],
            "key": "moose",
            "firstLoc": {
              "x": 1058.6666666666667,
              "y": 676.8000000000001
            }
          },
          {
            "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"17289\\" x=\\"61\\" y=\\"43\\"><statement name=\\"DO\\"><block type=\\"stratego_repeat_forever\\" id=\\"17290\\"><statement name=\\"DO\\"><block type=\\"stratego_if\\" id=\\"17291\\" inline=\\"false\\"><value name=\\"IF0\\"><block type=\\"stratego_sprite_is\\" id=\\"17292\\"><field name=\\"PROP_NAME\\">PRESSED</field></block></value><statement name=\\"DO0\\"><block type=\\"stratego_send_message_with_data\\" id=\\"17293\\" inline=\\"false\\"><field name=\\"MESSAGE\\">wink</field><value name=\\"DATA\\"><block type=\\"stratego_number\\" id=\\"17294\\"><field name=\\"NUM\\">90</field></block></value><next><block type=\\"stratego_set_color_2\\" id=\\"17295\\" inline=\\"false\\"><value name=\\"COLOR\\"><block type=\\"colour_picker\\" id=\\"17296\\"><field name=\\"COLOUR\\">#33cc00</field></block></value></block></next></block></statement><next><block type=\\"stratego_if\\" id=\\"17297\\" inline=\\"false\\"><value name=\\"IF0\\"><block type=\\"logic_negate\\" id=\\"17298\\" inline=\\"false\\"><value name=\\"BOOL\\"><block type=\\"stratego_sprite_is\\" id=\\"17299\\"><field name=\\"PROP_NAME\\">PRESSED</field></block></value></block></value><statement name=\\"DO0\\"><block type=\\"stratego_set_color_2\\" id=\\"17300\\" inline=\\"false\\"><value name=\\"COLOR\\"><block type=\\"colour_picker\\" id=\\"17301\\"><field name=\\"COLOUR\\">#ff9900</field></block></value></block></statement></block></next></block></statement></block></statement></block></xml>",
            "_codeJs": [
              "highlightBlock('17289');\\nwait();\\n  highlightBlock('17290');\\n  while (true) {\\n      highlightBlock('17291');\\n    if(isPressed()) {\\n       highlightBlock('17293');\\n      send_message_with_data('wink',90);\\n      highlightBlock('17295');\\n      set_color_2('#33cc00');\\n    };\\n    highlightBlock('17297');\\n    if(!isPressed()) {\\n       highlightBlock('17300');\\n      set_color_2('#ff9900');\\n    };\\n\\n  };"
            ],
            "key": "soccer",
            "firstLoc": {
              "x": 1070.6666666666667,
              "y": 88.66666666666714
            }
          },
          {
            "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"17163\\" x=\\"62\\" y=\\"92\\"><statement name=\\"DO\\"><block type=\\"stratego_repeat_forever\\" id=\\"17164\\"><statement name=\\"DO\\"><block type=\\"stratego_if\\" id=\\"17165\\" inline=\\"false\\"><value name=\\"IF0\\"><block type=\\"stratego_sprite_is\\" id=\\"17166\\"><field name=\\"PROP_NAME\\">PRESSED</field></block></value><statement name=\\"DO0\\"><block type=\\"stratego_send_message_with_data\\" id=\\"17167\\" inline=\\"false\\"><field name=\\"MESSAGE\\">wink</field><value name=\\"DATA\\"><block type=\\"stratego_number\\" id=\\"17168\\"><field name=\\"NUM\\">270</field></block></value><next><block type=\\"stratego_set_color_2\\" id=\\"17169\\" inline=\\"false\\"><value name=\\"COLOR\\"><block type=\\"colour_picker\\" id=\\"17170\\"><field name=\\"COLOUR\\">#009900</field></block></value></block></next></block></statement><next><block type=\\"stratego_if\\" id=\\"17171\\" inline=\\"false\\"><value name=\\"IF0\\"><block type=\\"logic_negate\\" id=\\"17172\\" inline=\\"false\\"><value name=\\"BOOL\\"><block type=\\"stratego_sprite_is\\" id=\\"17173\\"><field name=\\"PROP_NAME\\">PRESSED</field></block></value></block></value><statement name=\\"DO0\\"><block type=\\"stratego_set_color_2\\" id=\\"17174\\" inline=\\"false\\"><value name=\\"COLOR\\"><block type=\\"colour_picker\\" id=\\"17175\\"><field name=\\"COLOUR\\">#ffcc33</field></block></value></block></statement></block></next></block></statement></block></statement></block></xml>",
            "_codeJs": [
              "highlightBlock('17163');\\nwait();\\n  highlightBlock('17164');\\n  while (true) {\\n      highlightBlock('17165');\\n    if(isPressed()) {\\n       highlightBlock('17167');\\n      send_message_with_data('wink',270);\\n      highlightBlock('17169');\\n      set_color_2('#009900');\\n    };\\n    highlightBlock('17171');\\n    if(!isPressed()) {\\n       highlightBlock('17174');\\n      set_color_2('#ffcc33');\\n    };\\n\\n  };"
            ],
            "key": "string",
            "firstLoc": {
              "x": 1055.6666666666672,
              "y": 1408
            }
          },
          {
            "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"17100\\" x=\\"15\\" y=\\"35\\"><statement name=\\"DO\\"><block type=\\"stratego_repeat_forever\\" id=\\"17101\\"><statement name=\\"DO\\"><block type=\\"stratego_if\\" id=\\"17102\\" inline=\\"false\\"><value name=\\"IF0\\"><block type=\\"stratego_sprite_is\\" id=\\"17103\\"><field name=\\"PROP_NAME\\">PRESSED</field></block></value><statement name=\\"DO0\\"><block type=\\"stratego_send_message_with_data\\" id=\\"17104\\" inline=\\"false\\"><field name=\\"MESSAGE\\">wink</field><value name=\\"DATA\\"><block type=\\"stratego_number\\" id=\\"17105\\"><field name=\\"NUM\\">0</field></block></value><next><block type=\\"stratego_set_color_2\\" id=\\"17106\\" inline=\\"false\\"><value name=\\"COLOR\\"><block type=\\"colour_picker\\" id=\\"17107\\"><field name=\\"COLOUR\\">#009900</field></block></value></block></next></block></statement><next><block type=\\"stratego_if\\" id=\\"17108\\" inline=\\"false\\"><value name=\\"IF0\\"><block type=\\"logic_negate\\" id=\\"17109\\" inline=\\"false\\"><value name=\\"BOOL\\"><block type=\\"stratego_sprite_is\\" id=\\"17110\\"><field name=\\"PROP_NAME\\">PRESSED</field></block></value></block></value><statement name=\\"DO0\\"><block type=\\"stratego_set_color_2\\" id=\\"17111\\" inline=\\"false\\"><value name=\\"COLOR\\"><block type=\\"colour_picker\\" id=\\"17112\\"><field name=\\"COLOUR\\">#ffcc33</field></block></value></block></statement></block></next></block></statement></block></statement></block></xml>",
            "_codeJs": [
              "highlightBlock('17100');\\nwait();\\n  highlightBlock('17101');\\n  while (true) {\\n      highlightBlock('17102');\\n    if(isPressed()) {\\n       highlightBlock('17104');\\n      send_message_with_data('wink',0);\\n      highlightBlock('17106');\\n      set_color_2('#009900');\\n    };\\n    highlightBlock('17108');\\n    if(!isPressed()) {\\n       highlightBlock('17111');\\n      set_color_2('#ffcc33');\\n    };\\n\\n  };"
            ],
            "key": "steve",
            "firstLoc": {
              "x": 1866.1333333333332,
              "y": 688.6666666666667
            }
          },
          {
            "_codeXml": "<xml xmlns=\\"http://www.w3.org/1999/xhtml\\"><block type=\\"stratego_when_started\\" id=\\"17226\\" x=\\"43\\" y=\\"28\\"><statement name=\\"DO\\"><block type=\\"stratego_repeat_forever\\" id=\\"17227\\"><statement name=\\"DO\\"><block type=\\"stratego_if\\" id=\\"17228\\" inline=\\"false\\"><value name=\\"IF0\\"><block type=\\"stratego_sprite_is\\" id=\\"17229\\"><field name=\\"PROP_NAME\\">PRESSED</field></block></value><statement name=\\"DO0\\"><block type=\\"stratego_send_message_with_data\\" id=\\"17230\\" inline=\\"false\\"><field name=\\"MESSAGE\\">wink</field><value name=\\"DATA\\"><block type=\\"stratego_number\\" id=\\"17231\\"><field name=\\"NUM\\">180</field></block></value><next><block type=\\"stratego_set_color_2\\" id=\\"17232\\" inline=\\"false\\"><value name=\\"COLOR\\"><block type=\\"colour_picker\\" id=\\"17233\\"><field name=\\"COLOUR\\">#33cc00</field></block></value></block></next></block></statement><next><block type=\\"stratego_if\\" id=\\"17234\\" inline=\\"false\\"><value name=\\"IF0\\"><block type=\\"logic_negate\\" id=\\"17235\\" inline=\\"false\\"><value name=\\"BOOL\\"><block type=\\"stratego_sprite_is\\" id=\\"17236\\"><field name=\\"PROP_NAME\\">PRESSED</field></block></value></block></value><statement name=\\"DO0\\"><block type=\\"stratego_set_color_2\\" id=\\"17237\\" inline=\\"false\\"><value name=\\"COLOR\\"><block type=\\"colour_picker\\" id=\\"17238\\"><field name=\\"COLOUR\\">#ffcc00</field></block></value></block></statement></block></next></block></statement></block></statement></block></xml>",
            "_codeJs": [
              "highlightBlock('17226');\\nwait();\\n  highlightBlock('17227');\\n  while (true) {\\n      highlightBlock('17228');\\n    if(isPressed()) {\\n       highlightBlock('17230');\\n      send_message_with_data('wink',180);\\n      highlightBlock('17232');\\n      set_color_2('#33cc00');\\n    };\\n    highlightBlock('17234');\\n    if(!isPressed()) {\\n       highlightBlock('17237');\\n      set_color_2('#ffcc00');\\n    };\\n\\n  };"
            ],
            "key": "kate",
            "firstLoc": {
              "x": 122.13333333333334,
              "y": 705.3333333333333
            }
          }
        ],
        "assets": []
      }
    '''

class stratego.CamperAppDetail extends phaser.State

  constructor: (@camperManager, @app) ->
    super()
    @slot = null
    @eventManager = new stratego.EventManager()
    @camperApp = new stratego.CamperApp(@app.source, @eventManager, @camperManager)

  preload: (game) ->
    ActivityIndicator?.show('loading assets...')
    @camperApp.preload(@game, published: false, editor: false)

  create: ->
    ActivityIndicator?.hide()  # from preload

    if phaser.Device.touch
      @_pointers = @game.input.pointers
    else
      @_pointers = [@game.input.mousePointer]

    @camperManager.camper()
      .then (@camper) =>
        @camperApp.create()
        @_initUISelectors()
        @_initUIDefaults()
        @_initUIHandlers()
        @_initUIDisplay()
        @titleEditor = new stratego.CamperAppTitleEditor(@camperManager, @app, @dialog, @_onIconEditorOpen, @_onIconEditorClose)
        @eventManager.addEventHandler('camper_app_stopped', @_onCamperAppStopped, this)
        @eventManager.addEventHandler('camper_app_started', @_onCamperAppStarted, this)
      .done()

  # Phaser callback. Web UI should already have been reset.
  shutdown: ->
    @camperApp.eventManager.removeAllEventHandlers(this)
    @camperApp?.destroy()
    @camperApp = null
    @eventManager.destroy(); @eventManager = null
    @dialog = null

  _shutdownUI: ->
    @shuttingDownUI = true
    @_shutdownUIHandlers()
    @_resetUIDisplay()
    @titleEditor.shutdown()
    @shuttingDownUI = false

  # called every frame
  update: ->
    @camperApp?.update()

  _onIconEditorOpen: () =>
    @ui.share.toolbar.hide()

  _onIconEditorClose: () =>
    @ui.share.toolbar.show() unless @shuttingDownUI

  _initUISelectors: () =>
    @ui =
      backButton: $("#workshop__back-button")
      editButton: $("#app-detail__edit-button")
      playButton: $("#app-detail__play-button")
      deleteButton: $("#manage-app-toolbar__delete-button")
      deleteButtonText: $("#manage-app-toolbar__delete-button-text")
      appAuthor: $("#app-detail__author")

      publish:
        publishButton: $('#manage-app-toolbar__upload-button')

      share:
        toolbar: $("#app-detail__manage-app-toolbar")
        shareButton: $("#manage-app-toolbar__share-button")

  _initUIDefaults: () =>
    @ui.defaults =
      appAuthor: @ui.appAuthor.text()
      playButton: @ui.playButton.text()
      deleteButtonText: @ui.deleteButtonText.text()

  # UI Handlers

  _initUIHandlers: () =>
    @ui.backButton.on('click', @_onBack)
    @ui.editButton.on('click', @_onEditApp)
    @ui.playButton.on('click', @_onPlay)
    @ui.deleteButton.on('click', @_onDelete)
    @ui.share.shareButton.on('click', @_onShare)
    @ui.publish.publishButton.on('click', @_onPublish)
    @dialog = new stratego.CamperAppDialog()

  _shutdownUIHandlers: () =>
    @ui.backButton.off('click')
    @ui.editButton.off('click')
    @ui.playButton.off('click')
    @ui.deleteButton.off('click')
    @ui.share.shareButton.off('click')
    @ui.publish.publishButton.off('click')

  _onPlay: () =>
    if @camperApp.isRunning()
      @camperApp.stop()
    else
      @camperApp.run()

  _onCamperAppStopped: =>
    @ui.playButton.removeClass('playing-js').text('Play')

  _onCamperAppStarted: =>
    @ui.playButton.addClass('playing-js').text('Stop')

  _onShare: () =>
    @friend = null
    @dialog.displayShare(@camper, @_onShareScan)

  _onPublish: () =>
    appJson = @camperApp.serialize()
    ActivityIndicator?.show('publishing')

    @_publishApp(appJson)
    .then( =>
      @dialog.displayPublishSuccess()
    , (exc) =>
      @dialog.displayError("Can't publish", exc)
      console.error(exc)
    ).then( =>
      ActivityIndicator?.hide()
      setTimeout( =>
        1500 )
    )

  # Publish app for parents' viewing pleasure.
  _publishApp: (appJson) ->
    return if @sendingSlug

    try 
      @sendingSlug = true
      indexPolicy = await stratego.Mancala.getS3PostPolicy(@camperManager.camperId, "StrategoApp", @camperManager.serverConfig, "text/html")
      DEFAULT_ICON = 'animals_05_moose'
      keyUrl = "#{indexPolicy.postUrl}#{indexPolicy.fields.key}"
      finishedAppUrl = stratego.S3Manager.replaceFilename(keyUrl, 'index.html')
      includedBackground = @camperApp.getBackgroundKey()

      metadata =
        appID: @app.id
        appTitle: @app.title
        appIconKey: @app.icon || DEFAULT_ICON
        appBackgroundKey: includedBackground
        appBackgroundPhotoURL: @camperApp.getPhotoBackgroundUrl()
        appHost: window.location.origin

      response = await ky.get("/slug/index.html")
      htmlContents = await response.text()
      htmlContents = htmlContents.replace(/@@HOST@@/g, window.location.origin)

      await stratego.S3Manager.uploadFile(htmlContents, 'index.html', indexPolicy)
      await stratego.S3Manager.uploadFile(appJson, 'app.json', indexPolicy)
      camper = await @camperManager.camper()
      await stratego.UnoApi.createFile(camper, finishedAppUrl, metadata, @camperManager.serverConfig)
    finally
      @sendingSlug = false


  _onDelete: () =>
    @dialog.displayDeleteApp(@app, @_deleteApp)

  _onShareScan: () =>
    ActivityIndicator?.show('finding friend')
    @camperManager.getFriend()
    .then (camper) =>
      @friend = camper
      if @friend.id == @camper.id
        @dialog.displayScanAgain(@_onShareScan)
      else
        @dialog.displayShareConfirm(@friend, @_onShareConfirm(@friend))
    .catch (error) =>
      unless error instanceof stratego.CancelledScanError
        @dialog.displayError("Can't find camper", error)
    .finally =>
      ActivityIndicator?.hide()

  _onShareConfirm: (friend) =>
    =>
      ActivityIndicator?.show('sharing')
      @camperManager.shareApp(@app, friend)
        .then @_onShareSuccess(friend)
        .catch (error) =>
          @dialog.displayError("Can't share", error)
          console.error(error)
        .finally =>
          ActivityIndicator?.hide()

  _onShareSuccess: (friend) =>
    (response) =>
      @dialog.displayShareSuccess(friend)

  # Only reset web UI. Phaser callbacks fire later.
  _onBack: =>
    @_shutdownUI()
    @eventManager.dispatchEvent('requestLevel', level: 'appMenu')

  # Only reset web UI. Phaser callbacks fire later.
  _onEditApp: () =>
    if @app.state == 'shared'
      ActivityIndicator?.show(' ')
      @camperManager.copyApp(@app)
        .then (data) =>
          @_shutdownUI()
          copy = @camperManager.app(data.id)
          @eventManager.dispatchEvent('requestLevel', level: 'app', app: copy)
        .catch (error) =>
          @dialog.displayError("Can't Open App", error)
          console.error(error)
        .finally =>
          ActivityIndicator?.hide()
    else
      @_shutdownUI()
      @eventManager.dispatchEvent('requestLevel', level: 'app', app: @app)


  # UI Display

  _initUIDisplay: () =>
    appAuthor = appTitle = deleteButton = null

    if @app.state == 'shared'
      appAuthor = @app.parent.camper
      @ui.deleteButtonText.text('Remove')
      @ui.share.shareButton.hide()
      @ui.publish.publishButton.hide()
    else
      appAuthor = @camper

    @ui.appAuthor.text("By #{appAuthor.first_name} #{appAuthor.last_name}")
    @ui.share.toolbar.show()

  _resetUIDisplay: () =>
    @ui.appAuthor.text(@ui.defaults.appAuthor)
    @ui.playButton.removeClass('playing-js').text(@ui.defaults.playButton)
    @ui.deleteButtonText.text(@ui.defaults.deleteButtonText)
    @ui.share.toolbar.hide()
    @ui.share.shareButton.show()
    @ui.publish.publishButton.show()
    @dialog.close()

  # API

  _deleteApp: () =>
    return if @deletingApp

    @deletingApp = true
    ActivityIndicator?.show('deleting')
    @camperManager.camper()
    .then (camper) =>
      @camperManager.deleteApp(@app.id)
      # if @app.state == 'shared'
      #   @camperManager.deleteSharedApp(@app.id)
      # else
      #   @camperManager.deleteApp(@app.id)
    .then (response) =>
      @_shutdownUI()
      @eventManager.dispatchEvent('requestLevel', level: 'appMenu')
    .catch (e) =>
      @dialog.displayError("Can't delete app", e)
    .finally =>
      @deletingApp = false
      ActivityIndicator?.hide()

class stratego.CamperAppGrid

  #GRID----------------------------------------
  #based on 12 col grid with 20 gutter @ 2048x1536px layout
  @COL: 138
  @GUTTER: 36
  @ITEMS_PER_ROW: 4

  #LAYYOUT GROUPS
  @QUARTER: (@COL * 3) + (@GUTTER * 2)
  @HALF = (@COL * 6) + (@GUTTER * 5)
  @HEADER_OFFSET_Y = (@GUTTER * 16)

  #app thumbnials
  @APP_THUMB = (@COL * 2) + @GUTTER
  @APP_SPACING = @APP_THUMB + @GUTTER

  #offset apps group by 25% plus the gutter and half width of app
  @QUARTER_OFFSET = @QUARTER + @GUTTER + (@APP_THUMB * 0.5)

  #sprite center anchorpoint
  @MIDDLE = x: 0.5, y: 0.5

  constructor: (@game, @camper, @offset, @landing) ->
    @buttons = []

  addButtons: (onClick) =>
    manager = new stratego.CamperAppManager(@camper)

    for slot in [0..7]
      camperApp = manager.appForSlot(slot)
      button = @_buildButtonFor(slot, camperApp, onClick)

      @buttons.push button

  _buildButtonFor: (slot, camperApp, onClick) ->
    x = @_getX(slot)
    y = @_getY(slot)

    image = if camperApp? then 'app' else 'empty'
    imageDown = if @landing == false or camperApp? then image + '__active' else image
    button = @game.add.button(x, y, 'app_menu', onClick, this, image, image, imageDown, image)
    button.slot = slot
    button.anchor = @constructor.MIDDLE
    @_addCamperAppTo(button, camperApp) if camperApp?
    button

  _getX: (slot) ->
    @offset + ((slot % @constructor.ITEMS_PER_ROW) * @constructor.APP_SPACING)

  _getY: (slot) ->
    @constructor.HEADER_OFFSET_Y + Math.floor(slot / @constructor.ITEMS_PER_ROW) * @constructor.APP_SPACING

  _addCamperAppTo: (button, camperApp) ->
    button.app = camperApp
    style = {font: "42px BMedium", fill: "#ffffff", wordWrap: true, wordWrapWidth: 152, align: "center"}
    appName = if camperApp.title? then camperApp.title else "App #{camperApp.slot + 1}"
    text = new Phaser.Text(@game, 0, 96, appName, style)
    text.anchor.set(0.5)
    button.addChild(text)

  _center_y: =>
    @game.height * 0.5

class stratego.CamperTemplateGrid

  #GRID----------------------------------------
  #based on 12 col grid with 20 gutter @ 2048x1536px layout
  @COL: 138
  @GUTTER: 36
  @ITEMS_PER_ROW: 3

  #LAYYOUT GROUPS
  @QUARTER: (@COL * 3) + (@GUTTER * 2)
  @HALF = (@COL * 6) + (@GUTTER * 5)
  @HEADER_OFFSET_Y = (@GUTTER * 16)

  #app thumbnials
  @TEMPLATE_THUMB = (@COL * 3) + (@GUTTER * 2)
  @TEMPLATE_SPACING = @TEMPLATE_THUMB + @GUTTER

  #offset apps group by 25% plus the gutter and half width of template
  @OFFSET = (@COL * 2) + (@TEMPLATE_THUMB * 0.5)

  #sprite center anchorpoint
  @MIDDLE = x: 0.5, y: 0.5

  constructor: (@game, @camper) ->
    @buttons = []

  # Template buttons
  addButtons: (onClick) =>
    i = 0
    for name, appJson of stratego.TEMPLATES
      button = @_buildButtonFor(i, name, appJson, onClick)
      @buttons.push button
      i += 1

  _buildButtonFor: (slot, name, appJson, onClick) ->
    template_button_assets =
      'Simon Says': 'template/simon'
      'Monkey Business': 'template/monkey'
      'Surprise': 'template/surprise'
      'Fortune Teller': 'template/fortune'
      'Lost Stone': 'template/lost-stone'
      'Blank': 'template/blank'

    x = @_getX(slot)
    y = @_getY(slot)

    image = template_button_assets[name]
    button = @game.add.button(x, y, 'app_menu', onClick, this, image, image, image + '__active', image)
    button.anchor = stratego.CamperTemplateGrid.MIDDLE
    button.appJson = appJson
    button.templateName = name
    button

  _getX: (slot) ->
    @constructor.OFFSET + ((slot % @constructor.ITEMS_PER_ROW) * @constructor.TEMPLATE_SPACING)

  _getY: (slot) ->
    @constructor.HEADER_OFFSET_Y + Math.floor(slot / @constructor.ITEMS_PER_ROW) * @constructor.TEMPLATE_THUMB

  _center_y: =>
    @game.height * 0.5

class stratego.CamperAppMenu

  constructor: (@camperManager) ->
    @eventManager = new stratego.EventManager()
    util.mark('CamperAppMenu')
    @createPromise = @create()
    @dialog = new stratego.CamperAppDialog()

  _handleErrors: (error) =>
    if error instanceof stratego.WifiError
      @dialog.displayError("No internet!", error);
    else if error instanceof stratego.CancelledScanError 
      @dialog.displayError("Can't scan", error)

  create: ->
    @camperManager.camper()
      .then (@camper) =>
        @_initUISelectors()
        @_initButtons()
        @_renderCamperApps()
        @_renderSharedApps()
      .catch (e) =>
        console.error(e)
        @_handleErrors(e);

  # Shutdown everything. No Phaser callbacks will fire later.
  shutdown: ->
    @_shutdownButtons()
    @_shutdownCamperApps()
    @_shutdownSharedApps()
    @eventManager.destroy()
    @eventManager = null

  _initUISelectors: () =>
    @ui =
      camperApps: $("#app-menu__apps-list")
      sharedAppsPrompt: $("#apps-list-share-prompt")
      sharedApps: $("#app-menu__apps-list--shared")
      backButton: $("#workshop__back-button")
      createButton: $("#app-menu__create-button")

  _renderCamperApps: () =>
    manager = new stratego.CamperAppManager(@camper)
    for slot in [0..7]
      camperApp = manager.appForSlot(slot)
      $slot = if camperApp?
        @_buildCamperApp(camperApp, slot)
      else
        @_buildEmptySlot()
      @ui.camperApps.find("li:nth-child(#{slot + 1})").replaceWith($slot)

  _shutdownCamperApps: () =>
    for button in @ui.camperApps.children()
      $(button).off('click')
      $(button).replaceWith @_buildEmptySlot()
    @ui.sharedAppsPrompt.hide()

  _renderSharedApps: () =>
    @camperManager.getSharedApps()
       .then (apps) =>
         if apps.length == 0
           @ui.sharedAppsPrompt.show()
         for app in apps
           $sharedApp = @_buildSharedApp(app)
           @ui.sharedApps.append($sharedApp)
       .catch (error) => console.error(error) # TODO: add messaging
       .done()

    #@camperManager.getSharedApps2()
    # @camperManager.getSharedApps()
    #   .then (response) =>
    #     console.log(" got response", response)
    #     if @camperManager.sharedAppsStore.findAll('camper_apps').length == 0
    #       console.log("camper_apps length is 0")
    #       @ui.sharedAppsPrompt.show()
    #     for app in @camperManager.sharedAppsStore.findAll('camper_apps')
    #       console.log("  got an app", app)
    #       if app.state == 'shared' && app.camper.id == @camper.id
    #         console.log("  and it's shared with the right camper")
    #         $sharedApp = @_buildSharedApp(app)
    #         @ui.sharedApps.append($sharedApp)
    #   .catch (error) => console.error(error) # TODO: add messaging
    #   .done()

  _shutdownSharedApps: () =>
    for button in @ui.sharedApps.children()
      $(button).off('click')
      $(button).remove()

  _buildCamperApp: (camperApp, slot) =>
    appTitle = stratego.CamperAppUI.appTitle(camperApp)
    imgSrc = stratego.CamperAppUI.iconSrc(camperApp)

    $("""
    <li>
    <div data-app-id="#{camperApp.id}" class="app-icon">
    <img src="#{imgSrc}">
    <p>#{appTitle}</p>
    </div>
    </li>
    """).on('click', @_onAppDetail(camperApp))

  _buildEmptySlot: () =>
    $("""
    <li>
    <div class="app-icon app-icon--empty"></div>
    </li>
    """)

  _buildSharedApp: (sharedApp) =>
    appTitle = stratego.CamperAppUI.appTitle(sharedApp)
    imgSrc = stratego.CamperAppUI.iconSrc(sharedApp)

    $("""
      <li data-shared-app-id="#{sharedApp.id}" >
        <div class="app-icon">
          <img src="#{imgSrc}">
          <p>#{appTitle}</p>
        </div>
        <p class="app-author">By #{sharedApp.parent.camper.first_name} #{sharedApp.parent.camper.last_name}</p>
      </li>
    """).on('click', @_onAppDetail(sharedApp))

  _initButtons: () =>
    @ui.backButton.on('click', @_onBack)
    @ui.createButton.on('click', @_onCreateApp)

  _shutdownButtons: () =>
    @ui.backButton.off('click')
    @ui.createButton.off('click')

  _onCreateApp: =>
    @eventManager.dispatchEvent('requestLevel', level: 'appTemplateMenu')

  _onAppDetail: (app) =>
    =>
      @eventManager.dispatchEvent('requestLevel', level: 'appDetail', app: app)

  _onBack: =>
    @eventManager.dispatchEvent('levelIncomplete')

class stratego.CamperAppDialog
  constructor: ->
    @_initUISelectors()
    @_initUIDefaults()
    @_initUIHandlers()

  _initUISelectors: ->
    @ui =
      dialog: $("#dialog-overlay")
      headerText: $("#dialog__header-text")
      helpText: $("#dialog__help-text")
      cancelButton: $("#dialog__cancel-button")
      confirmButton: $("#dialog__confirm-button")
      secondaryButton: $("#dialog__secondary-button")

      share:
        shareBody: $("#share-step-js")
        camperFrame: $("#camper-frame-js")
        camperName: $("#share-step__camper-name-js")
        camperPhoto: $("#share-step__camper-photo-js")
        friendFrame: $("#friend-frame-js")
        friendName: $("#share-step__camper-friend-name-js")
        friendPhoto: $("#share-step__camper-friend-photo-js")

  _initUIDefaults: ->
    @ui.defaults =
      share:
        friendName: @ui.share.friendName.text()
        friendPhoto: @ui.share.friendPhoto.attr('src')

  _initUIHandlers: =>
    @ui.cancelButton.on('click', @close)

  displayShare: (camper, onShareScan) ->
    @_reset()
    @ui.headerText.text("Share with a friend")
    @ui.helpText.text("When you are ready, scan your friend's badge.")
    @ui.confirmButton.text("Scan Friend's Badge")
    @ui.confirmButton.on('click', onShareScan)
    @ui.confirmButton.show()
    @ui.share.shareBody.show()
    @ui.share.camperFrame.show()
    @ui.share.camperName.text("#{camper.first_name} #{camper.last_name}")
    @ui.share.camperPhoto.attr('src', camper.photo_url_large)
    @ui.dialog.show()

  displayShareConfirm: (friend, onShareConfirm) ->
    @_reset()
    @ui.headerText.text("Share your app?")
    @ui.helpText.text("Confirm that you want to share with #{friend.first_name} #{friend.last_name}.")
    @ui.confirmButton.text('Share')
    @ui.confirmButton.on('click', onShareConfirm)
    @ui.confirmButton.show()
    @ui.share.shareBody.show()
    @ui.share.camperFrame.show()
    @ui.share.friendName.text("#{friend.first_name} #{friend.last_name}")
    @ui.share.friendPhoto.attr('src', friend.photo_url_large)
    @ui.dialog.show()

  displayPublishSuccess: () ->
    @_reset()
    @ui.headerText.text("Success")
    @ui.helpText.text("You have uploaded your app to Steve & Kate's.")
    @ui.dialog.addClass("dialog--success")
    @ui.dialog.show()

  displayShareSuccess: (friend) ->
    @_reset()
    @ui.headerText.text("Success")
    @ui.helpText.text("You have shared with #{friend.first_name} #{friend.last_name}")
    @ui.share.camperFrame.show()
    @ui.dialog.addClass("dialog--success")
    @ui.dialog.show()

  displayScanAgain: (onShareScan) ->
    @_reset()
    @ui.headerText.text("Try that again!")
    @ui.helpText.text('Scan the badge of your friend instead of your own!')
    @ui.confirmButton.text("Scan Friend's Badge")
    @ui.confirmButton.on('click', onShareScan)
    @ui.confirmButton.show()
    @ui.share.shareBody.show()
    @ui.dialog.show()

  displayOverwriteApp: (existingApp, onOverwriteConfirm) ->
    appTitle = stratego.CamperAppUI.appTitle(existingApp)
    maxLength = 130
    if appTitle.length > maxLength
      ending = "…"
      appTitle = appTitle.substring(0, maxLength - ending.length) + ending
    headerText = "Replace?"
    helpText = "Saving will overwrite \"#{appTitle}\""
    buttonText = 'Save'
    @displayConfirm(headerText, helpText, buttonText, onOverwriteConfirm)

  displayDeleteApp: (app, onDeleteConfirm) ->
    appTitle = stratego.CamperAppUI.appTitle(app)
    helpText = headerText = buttonText = null

    if app.state == 'shared'
      headerText = "Remove app?"
      helpText = "You will no longer see the app \"#{appTitle}\"."
      buttonText = "Remove"
    else
      headerText = "Delete app?"
      helpText = "Your app \"#{appTitle}\" will be permanently erased."
      buttonText = "Delete"

    @displayConfirm(headerText, helpText, buttonText, onDeleteConfirm)

  displayError: (headerText, error) ->
    @_reset()
    helpText = if typeof error == 'string' then error else error.message
    @ui.dialog.addClass("dialog--failure")
    @ui.headerText.text(headerText)
    @ui.helpText.text(helpText)
    @ui.dialog.show()

  displayConfirm: (headerText, helpText, buttonText, onConfirm) ->
    @_reset()
    @ui.dialog.addClass("dialog--compact")
    @ui.headerText.text(headerText)
    @ui.helpText.text(helpText)
    @ui.confirmButton.text(buttonText)
    @ui.confirmButton.on('click', onConfirm)
    @ui.confirmButton.show()
    @ui.dialog.show(0)

  displaySaveConfirm: (onSaveConfirm, onDeleteConfirm) ->
    @_reset()
    @ui.dialog.addClass("dialog--compact")
    @ui.headerText.text('Save changes?')
    @ui.helpText.text('')
    @ui.confirmButton.text('Save')
    @ui.confirmButton.on('click', onSaveConfirm)
    @ui.confirmButton.css('display', 'inline-block')
    @ui.secondaryButton.text('Delete')
    @ui.secondaryButton.on('click', onDeleteConfirm)
    @ui.secondaryButton.css('display', 'inline-block')
    @ui.dialog.show(0)


  displayFlash: (headerText, helpText, dismiss=false) ->
    @_reset()
    @ui.dialog.addClass("dialog--compact")
    @ui.headerText.text(headerText)
    @ui.helpText.text(helpText)
    dialog = @ui.dialog.show(0)
    setTimeout(@close, 2000) if dismiss

  close: =>
    @_reset()
    @ui.dialog.hide()

  _reset: =>
    @ui.share.camperFrame.hide()
    @ui.share.shareBody.hide()
    @ui.confirmButton.hide()
    @ui.secondaryButton.hide()

    @ui.headerText.text('')
    @ui.helpText.text('')
    @ui.confirmButton.text('')
    @ui.secondaryButton.text('')
    @ui.share.friendName.text(@ui.defaults.share.friendName)
    @ui.share.friendPhoto.attr('src', @ui.defaults.share.friendPhoto)
    @ui.dialog.removeClass("dialog--success")
    @ui.dialog.removeClass("dialog--failure")
    @ui.dialog.removeClass("dialog--compact")

    @ui.confirmButton.off('click')
    @ui.secondaryButton.off('click')

class stratego.CamperAppSaveMenu

  constructor: (@camperManager, @camperAppId, @appJson) ->
    @eventManager = new stratego.EventManager()
    util.mark('CamperAppSaveSlots')
    @createPromise = @create()

  create: ->
    @camperManager.camper()
      .then (@camper) =>
        @_initUISelectors()
        @_initUIHandlers()
        @_renderCamperApps()
        @dialog = new stratego.CamperAppDialog()
      .catch (e) =>
        console.error(e)

  # Shutdown everything. No Phaser callbacks will fire later.
  shutdown: ->
    @_shutdownUIHandlers()
    @_shutdownCamperApps()
    @dialog.close()
    @eventManager.destroy()
    @eventManager = null

  _initUISelectors: () =>
    @ui =
      camperApps: $("#app-menu__apps-list")
      backButton: $("#workshop__back-button")

  # UI Handlers

  _initUIHandlers: () =>
    @ui.backButton.on('click', @_onBack)

  _shutdownUIHandlers: () =>
    @ui.backButton.off('click')

  _onBack: =>
    app = @camperManager.app(@camperAppId)
    if app?
      @eventManager.dispatchEvent('requestLevel', level: 'app', app: app)
    else
      @eventManager.dispatchEvent('levelIncomplete')

  _onSlotBtn: (slot, existingApp) =>
    =>
      if existingApp?
        @dialog.displayOverwriteApp(existingApp, @_onOverwriteApp(slot, existingApp))
      else
        @_saveAppToSlot(slot)

  _onOverwriteApp: (slot, existingApp) =>
    =>
      existingApp.setAttribute('slot', null)
      @_saveAppToSlot(slot)

  # UI Display

  _renderCamperApps: () =>
    manager = new stratego.CamperAppManager(@camper)
    for slot in [0..7]
      camperApp = manager.appForSlot(slot)
      $slot = if camperApp?
        @_buildCamperApp(camperApp, slot)
      else
        @_buildEmptySlot(slot)
      @ui.camperApps.find("li:nth-child(#{slot + 1})").replaceWith($slot)

  _shutdownCamperApps: () =>
    for button in @ui.camperApps.children()
      $(button).off('click')
      $(button).replaceWith @_buildEmptySlot()

  _buildCamperApp: (camperApp, slot) =>
    appTitle = stratego.CamperAppUI.appTitle(camperApp)
    imgSrc = stratego.CamperAppUI.iconSrc(camperApp)

    $("""
    <li>
    <div data-app-id="#{camperApp.id}" class="app-icon">
    <img src="#{imgSrc}">
    <p>#{appTitle}</p>
    </div>
    </li>
    """).on('click', @_onSlotBtn(slot, camperApp))

  _buildEmptySlot: (slot) =>
    $("""
    <li>
    <div class="app-icon app-icon--empty"></div>
    </li>
    """).on('click', @_onSlotBtn(slot, null))

  # API

  _saveAppToSlot: (slot) =>
    return if @sendingSave

    @sendingSave = true
    @camperManager.camper()
    .then (camper) =>
      @camperManager.updateApp(@camperAppId, slot: slot, state: 'saved')
        .then (response) =>
          app = @camperManager.app(@camperAppId)
          @eventManager.dispatchEvent('requestLevel', level: 'appSaveTitle', app: app)
        .catch (error) =>
          @dialog.displayError("Can't save app", error)
    .catch (error) =>
      @dialog.displayError("Can't save app", new Error("Is wifi working?"))
    .finally =>
      @sendingSave = false

class stratego.CamperAppSaveTitle

  constructor: (@camperManager, @app) ->
    @eventManager = new stratego.EventManager()
    @createPromise = @create()

  create: ->
    @camperManager.camper()
      .then (@camper) =>
        @_initUISelectors()
        @_initUIDefaults()
        @_initUIHandlers()
        @_initUIDisplay()
        @titleEditor = new stratego.CamperAppTitleEditor(@camperManager, @app, @dialog)
      .done()

  shutdown: ->
    @eventManager.destroy(); @eventManager = null
    @dialog = null

  _shutdownUI: ->
    @_shutdownUIHandlers()
    @_resetUIDisplay()
    @titleEditor.shutdown()

  _initUISelectors: () =>
    @ui =
      header: $('#workshop-title')
      subtitle: $('#workshop-sub-title')
      doneButton: $("#app-detail__done-button")

  _initUIDefaults: () =>
    @ui.defaults =
      header: @ui.header.text()
      subtitle: @ui.subtitle.text()

  # UI Handlers

  _initUIHandlers: () =>
    @ui.doneButton.on('click', @_onDone)
    @dialog = new stratego.CamperAppDialog()

  _shutdownUIHandlers: () =>
    @ui.doneButton.off('click')

  _onDone: =>
    @_shutdownUI()
    @eventManager.dispatchEvent('requestLevel', level: 'appMenu')

  # UI Display

  _initUIDisplay: () =>
    @ui.header.text('Add a name & icon')
    @ui.subtitle.text('Optionally customize your app.')

  _resetUIDisplay: () =>
    @ui.header.text(@ui.defaults.header)
    @ui.subtitle.text(@ui.defaults.subtitle)
    @dialog.close()

###
app_template_menu.coffee
###

class stratego.AppTemplateMenu extends phaser.State

  constructor: (@camperManager) ->
    super()
    @eventManager = new stratego.EventManager()
    util.mark('AppTemplateMenu')

  preload: (game) ->
    game.load.atlasJSONHash('app_menu', 'textures/app_menu.png', 'textures/app_menu.json') unless game.cache.checkImageKey('app_menu')
    assets = [
      { key: 'workshop-bg', path: 'art/workshop/landing-workshop-bg_2x.png' }
    ]
    game.load.image( asset.key, asset.path) for asset in assets when not game.cache.checkImageKey(asset.key)

  create: ->
    @game.scale.scaleMode = phaser.ScaleManager.SHOW_ALL
    @depthGroup = new stratego.DepthGroups(@game, [
      'background'])
    @background = @game.add.image(-1, -1, 'workshop-bg', 0, @depthGroup['background'])

    # Back button
    x = stratego.CamperTemplateGrid.GUTTER * 3
    y = stratego.CamperTemplateGrid.GUTTER * 3
    @mainMenuBtn = @game.add.button(x, y, 'app_menu', @_onBackBtn, 'back', 'back', 'back', 'back__active')
    @mainMenuBtn.anchor = stratego.CamperTemplateGrid.MIDDLE

    # Instructions
    style = {font: "172px BBold", fill: "#ffffff", wordWrap: false, align: "middle"}
    title = "MAKE A NEW APP"
    text = @game.add.text(1024, 144, title, style)
    text.anchor.set(0.5)

    style = {font: "72px BMedium", fill: "#ffffff", wordWrap: false, align: "middle"}
    subTitle = "Please choose a template."
    subtext = @game.add.text(1024, 270, subTitle, style)
    subtext.anchor.set(0.5)

    # Template thumbnail buttons
    @camperManager.camper()
      .then (@camper) =>
        @grid = new stratego.CamperTemplateGrid(@game, @camper)
        @grid.addButtons(@_onTemplateBtn)

  shutdown: ->
    for button in @grid?.buttons || []
      button.destroy(true)
    @mainMenuBtn?.destroy(true); @mainMenuBtn = null
    @eventManager.destroy(); @eventManager = null
    @background.destroy(true)
    util.unmark('AppTemplateMenu')
    super()

  _onTemplateBtn: (button) =>
    app = new JsonApiDataStoreModel('camper_app', null)
    app.setAttribute('source', button.appJson)
    @eventManager.dispatchEvent('requestLevel', level: 'app', app: app)

  _onBackBtn: =>
    @eventManager.dispatchEvent('requestLevel', level: 'appMenu')

###
tilemap_manager.coffee
###

class stratego.TilemapManager
  @TILE_CLASSES = {}
  @TILE_CLASSES[stratego.TILESET.KEY] = stratego.Key
  @TILE_CLASSES[stratego.TILESET.LOCKED_KEY] = stratego.Key 
  @TILE_CLASSES[stratego.TILESET.ROUND_KEY] = stratego.LauncherKey 
  @TILE_CLASSES[stratego.TILESET.HOURGLASS_KEY] = stratego.LauncherKey 
  @TILE_CLASSES[stratego.TILESET.SQUARE_KEY] = stratego.LauncherKey 
  @TILE_CLASSES[stratego.TILESET.PIE_KEY] = stratego.LauncherKey 
  # These names have to be on lower case!! 
  @OBJECT_CLASSES = {
    elevator: stratego.Elevator,
    door: stratego.Door,
    sensor: stratego.Sensor,
    robodillo: stratego.Robodillo,
    bottle: stratego.Bottle,
    editablesensor: stratego.EditableSensor,
    raft: stratego.Raft,
    crab: stratego.Crab,
    scorpion: stratego.Scorpion,
    teleportdevice: stratego.teleportDevice,
    launcher: stratego.Launcher,
    projectile: stratego.Projectile,
    snowpile: stratego.SnowPile,
    breakableblock: stratego.BreakableBlock,
    keystone: stratego.Keystone
  }

  # Search through tilemap for Things and place them in the world.
  @placeFromTiles: (tilemap, groupToAddTo) ->
    result = []

    addThing = (tile) ->
      tileId = tile.index - stratego.TILESET.FIRST_GID
      ctor = @TILE_CLASSES[tileId]
      if ctor
        thing = new ctor(tilemap.game)
        thing.x = tile.x * tile.width
        thing.y = tile.y * tile.width
        thing.setTileId(tileId)
        thing.tileId = tileId
        groupToAddTo.add(thing)
        result.push(thing)

    tilemap.forEach(addThing, this, 0, 0, tilemap.width, tilemap.height)
    result

  # Search through Tiled "Object layers" for any Things to instantiate
  @placeFromObjects: (game, mapJson, groupToAddTo) ->
    things = []
    namedThings = {}
    for layer in mapJson.layers when layer.type == 'objectgroup'
      for obj in layer.objects
        if 'polyline' not of obj and obj.type # ignore polylines and objects with no 'type' property
          thingClass = @OBJECT_CLASSES[obj.type.toLowerCase()]
          if not thingClass
            console.error('This object from tiled has a "type" property but I couldn\'t find that type.', obj)
          else
            newThing = thingClass.createFromTiledObjectJson(game, obj)
            things.push(newThing)
            if obj.name
              if namedThings[obj.name]?
                console.error("Duplicate object name #{obj.name} in tilemap!")
              else
                namedThings[obj.name] = newThing
            groupToAddTo.add(newThing)
    [things, namedThings]


  @getStartTile: (tilemap) ->
    @_getQueryStartTile(tilemap) || @_findStartTile(tilemap)

  @_getQueryStartTile: (tilemap) ->
    start = util.getLocationQueryValue('start')
    return unless start
    return unless start.length >= 2
    [x, y, ...] = (parseInt(x) for x in start.split(','))
    tile = tilemap.getTile(x, y, 0, true )
    tile

  @_findStartTile: (tilemap) ->
    startTile = null

    checkStart = (tile) ->
      tileId = tile.index - stratego.TILESET.FIRST_GID
      if tileId == stratego.TILESET.START
        startTile = tile

    tilemap.forEach(checkStart, this)
    startTile

class stratego.DebugDisplay
  constructor: (@game, @_group) ->
    TEXT_STYLE = { font: "30px Arial", fill: "#000", align: "left" }
    @game.time.advancedTiming = true
    @_text = @game.add.text(400, 50, '(debug info soon)', TEXT_STYLE, @_group)
    @_display =
      'level': @game.state.current
      'url': window.location.href
    util.mark('DebugDisplay')

  shutdown: ->
    @_text?.destroy()
    @_text = null
    util.unmark('DebugDisplay')

  update: ->
    @_display.fps = @game.time.fps
    @_display.running_machines = stratego.Machine.num_running_machines
    @_display.player_x = @game.state?.getCurrentState().player?.xCoordinate()

    # Chrome only and need to run with: --enable-precise-memory-info
    if window.performance?.memory?.usedJSHeapSize?
      memoryUsed = Math.round(window.performance.memory.usedJSHeapSize * 10 / 1024 / 1024) / 10
      @_display.memory = "#{memoryUsed} MB"

    @_text.text = ("#{key}: #{value}" for key, value of @_display).join('\n')

stratego.SpritePlacement = (CreationPolicy) ->
  class SpritePlacement
    constructor: (@game, @level, @placements) ->
      @placements = @placements || []
      util.mark('SpritePlacement')

    create: ->
      @sprites = for place in @placements
        sprite =  CreationPolicy.add(@game, place)
        if 'name' of place
          @level.namedThings[place.name] = sprite
        sprite

    destroy: ->
      sprite.destroy(true) for sprite in @sprites
      util.unmark('SpritePlacement')

stratego.AtlasAnimatedSpritePlacement = (prefix, AnimationPolicy) ->
  class AtlasAnimatedSpritePlacement
    constructor: (@game, @level, @placements) ->
      @placements = @placements || []
      util.mark('AtlasAnimatedSpritePlacement')

    create: ->
      @sprites = ( @_add(place) for place in @placements )

    destroy: ->
      sprite.destroy() for sprite in @sprites
      @sprites = null
      util.unmark('AtlasAnimatedSpritePlacement')

    _add: (place) ->
      sprite = @game.add.sprite(place.x * 64, place.y * 64, 'atlas', "#{prefix}/0", @level.depthGroup['levelArt'])
      AnimationPolicy.animate(sprite, place)
      sprite

stratego.DimensionAnimatedSpritePlacement = (prefix, dimension, SizePolicy, AnimationPolicy) ->
  class AnimatedSpritePlacement
    constructor: (@game, @level, @placements) ->
      @placements = @placements || []
      util.mark('DimensionAnimatedSpritePlacement')

    preload: ->
      for dim in @_dimensions()
        @game.load.spritesheet(@_key(dim), @_path(dim), SizePolicy.width(dim), SizePolicy.height(dim))

    create: ->
      @sprites = ( @_add(place) for place in @placements )

    destroy: ->
      sprite.destroy() for sprite in @sprites
      @sprites = null

      for dim in @_dimensions()
        util.cleanUpImageCache(@game, @_key(dim))
#        @game.cache.removeImage(@_key(dim))
#        PIXI.BaseTextureCache[@_key(dim)].destroy()
      util.unmark('DimensionAnimatedSpritePlacement')

    _add: (place) ->
      sprite = @game.add.sprite(place.x * 64, place.y * 64, @_key(place[dimension]), 0, @level.depthGroup['levelArt'])
      AnimationPolicy.animate(sprite, place)
      sprite

    _worldPath: ->
      @level.constructor.WorldPath()

    _path: (dim) ->
      "#{@_worldPath()}#{prefix}-#{dim}.png"

    _key: (dim) ->
      "#{prefix}#{dim}"

    _dimensions: ->
      _.uniq( _.pluck( @placements, dimension) )

CannonballAnimationPolicy = 
  animate: (sprite, place) ->
    sprite.animations.add('shift', util.anim("cannonballs/", 0, 4).concat(util.anim("cannonballs/", 4, 0)), 8, true).play()

stratego.CannonballPlacement = stratego.AtlasAnimatedSpritePlacement('cannonballs', CannonballAnimationPolicy)

FlagAnimationPolicy =
  animate: (sprite, place) ->
    sprite.animations.add('wave',
      util.anim("flagPie/#{place.flagType}/", 0, 7), 12, true)
    .play()

stratego.FlagPlacement = stratego.AtlasAnimatedSpritePlacement(
  'flagPie/skinny',
  FlagAnimationPolicy)

PuddleAnimationPolicy = 
  animate: (sprite, place) ->
    sprite.animations.add('spurt', util.anim("puddle/", 0, 3), 10, true).play()

stratego.PuddlePlacement = stratego.AtlasAnimatedSpritePlacement('puddle', PuddleAnimationPolicy)

BurrowCreationPolicy = 
  add: (game, place) ->
    new stratego.RobodilloBurrow(game, place.spawn, place.x, place.y)

stratego.RobodilloBurrowPlacement = stratego.SpritePlacement( BurrowCreationPolicy )

RobodilloCreationPolicy = 
  add: (game, place) ->
    new stratego.Robodillo(game, place.left, place.right, place.y, if place.respawn then place.respawn else false )

stratego.RobodilloPlacement = stratego.SpritePlacement( RobodilloCreationPolicy )

ScorpionCreationPolicy = 
  add: (game, place) ->
    new stratego.Scorpion(game, place.left, place.right, place.y)

stratego.ScorpionPlacement = stratego.SpritePlacement( ScorpionCreationPolicy )

SharkAnimationPolicy =
  animate: (sprite, place) ->
    sprite.animations.add('jump', util.anim('sharks/', 0, 11), 12, true).play()

stratego.SharkPlacement = stratego.AtlasAnimatedSpritePlacement('sharks', SharkAnimationPolicy)

WaterfallSizePolicy = 
  width: (dim) ->
    64*dim

  height: (dim) ->
    1089

WaterfallAnimationPolicy =
  animate: (sprite, place) ->
    sprite.animations.add('fall', [0,1,2,3], 10, true).play()

stratego.WaterfallPlacement = stratego.DimensionAnimatedSpritePlacement( 'waterfall', 'width', WaterfallSizePolicy, WaterfallAnimationPolicy)

WaterspoutSizePolicy =
  width: (dim) ->
    { 3: 192, 5: 384}[dim]

  height: (dim) ->
    { 3: 192, 5: 320}[dim]

WaterspoutAnimationPolicy =
  animate: (sprite, place) ->
    sprite.animations.add('spout', [0,1,2], 10, true).play()

stratego.WaterspoutPlacement = stratego.DimensionAnimatedSpritePlacement( 'waterspout', 'height', WaterspoutSizePolicy, WaterspoutAnimationPolicy)

SeaUrchinAnimationPolicy =
  animate: (sprite, place) ->
    sprite.animations.add(place.urchinColor,
      util.anim("urchin/#{place.urchinColor}/", 0, 9), 8, true)
    .play()

stratego.SeaUrchinPlacement = stratego.AtlasAnimatedSpritePlacement(
  'urchin/black',
  SeaUrchinAnimationPolicy)

###
level.coffee

Game level base class
###

# imports
phaser = Phaser
util = stratego.util
physics = stratego.physics

class stratego.Level extends phaser.State
  @LevelName: -> throw new Error('levels must define a levelName method')
  @WorldName: -> throw new Error('levels must define a WorldName method')
  @WorldPath: -> "puzzles/#{@WorldName()}/"

  constructor: (args...) ->
    super(args...)
    @eventManager = new stratego.EventManager()
    util.mark('Level')
    @canSwitchDevice = true
  # WorldPath should refer to a directory containing:
  #  background.png
  #  levelName.json
  #  levelName-art0.png, levelName-art1.png, levelName-art2.png, levelName-art3.png
  #  (these are 2048x1536 screens from the full width levelName-art.png source)
  #
  # numScreens is how many 2048x1536 art files you have

  init: ->
    @_initPlacements()

  preload: (game) ->
    @_preloadArt(game)
    @_preloadSprites(game)
    @_preloadPlacements()

  create: ->
    @game.scale.scaleMode = phaser.ScaleManager.SHOW_ALL
    @_initPhysics()
    
    @game.time.advancedTiming = true
    @game.time.desiredFps = 60

    @depthGroup = new stratego.DepthGroups(@game, [
      'background',
      'levelArt',
      'graphics', # spotlight
      'devices',
      'player',
      'powerups',
      'overlay'])

    @_createArt()
    @_createSounds()
    @_createTiles()

    @_createController()
    @_setMachineManager()
    @_createPlayer()
    @_connectPlayerToController(@player, @controller)

    @_createThings()
    @_createPlacements()

    @_hud = @_createHud()
    @_debugDisplay = if stratego.IS_PRODUCTION then null else new stratego.DebugDisplay(@game, @_hud)
    @_createKeyDisplay()
    @_createGraphics()
    @_initDeviceNavButtons()
    @startTime = @game.time.now

  shutdown: ->
    # stop any pending loads
    @game.load.reset(true, true) if @game and @game.load
    @_editor()?.close()

    # shutdown ui
    @_shutdownDeviceNavButtons()
    @_destroyGraphics()
    @_destroyKeyDisplay()
    @_debugDisplay?.shutdown()
    @_debugDisplay = null
    @_shutdownHud()
    @game.sound.destroy()

    # shutdown game
    @_shutdownPlacements()
    @_shutdownThings()

    @_disconnectPlayerFromController(@player, @controller)
    @_destroyPlayer()
    @_destroyController()

    @_destroyTiles()
    @_destroySounds()
    @_destroyArt()
    @depthGroup.destroy(); @depthGroup = null
    @_shutdownPhysics()
    @eventManager.destroy(); @eventManager = null
    util.unmark('Level')
    super()

  @_screenPath: (index) ->
    "#{@WorldPath()}#{@LevelName()}-art#{index}.png"

  @_screenKey: (index) ->
    "#{@WorldName()}#{@LevelName()}screen#{index+1}"

  @ScreenAssets: ->
    ( { key: @_screenKey(index), path: @_screenPath(index) } for index in [0...@ScreenCount] )

  _preloadSprites: (game) ->
    game.load.atlasJSONHash('atlas', 'textures/atlas.png', 'textures/atlas.json') unless game.cache.checkImageKey('atlas')
    game.load.image('mainMenuBtn', 'art/main-menu-button.png') unless game.cache.checkImageKey('mainMenuBtn')
    game.load.image('keyDisplay', 'art/key-display.png') unless game.cache.checkImageKey('keyDisplay')
    game.load.spritesheet('touch', 'art/touchControlWhite.png', 192, 64) unless game.cache.checkImageKey('touch')

  _soundAssets: () ->
    'pickup-key': 'audio/key.mp3'
    'unlock-door': 'audio/door-open.mp3'
    'pop': 'audio/pop.mp3'
    'boom': 'audio/boom.mp3'
    'boing': 'audio/boing.mp3'
    'pickup-launcher-key': 'audio/pickup-launcher-key.mp3'
    'wall-break': 'audio/wall-break.mp3'
    'keystone-power-unlocked': 'audio/keystone-power-unlocked.mp3'
    'snow-plow': 'audio/snow-plow.mp3'

  #
  # Initialization related
  #

  _initPlacements: ->
    @placements = {}
    @placements.robodillo = new stratego.RobodilloPlacement(@game, this, @robodilloPlacements?())
    @placements.burrow = new stratego.RobodilloBurrowPlacement(@game, this, @burrowPlacements?())
    @placements.waterfall = new stratego.WaterfallPlacement(@game, this, @waterfallPlacements?())
    @placements.waterspout = new stratego.WaterspoutPlacement(@game, this, @waterspoutPlacements?())
    @placements.shark = new stratego.SharkPlacement(@game, this, @sharkPlacements?() )
    @placements.puddle = new stratego.PuddlePlacement(@game, this, @puddlePlacements?() )
    @placements.cannonball = new stratego.CannonballPlacement(@game, this, @cannonballPlacements?() )
    @placements.flag = new stratego.FlagPlacement(@game, this, @flagPlacements?() )
    @placements.seaUrchin = new stratego.SeaUrchinPlacement(@game, this, @seaUrchinPlacements?() )
    @placements.scorpion = new stratego.ScorpionPlacement(@game, this, @scorpionPlacements?() )

  _shutdownPlacements: ->
    for name, placer of @placements
      placer.destroy?()
    @placements = null

  _preloadPlacements: ->
    for name, placer of @placements
      placer.preload?()

  _createPlacements: ->
    for name, placer of @placements
      placer.create?()

  _destroyPlacements: ->
    for name, placer of @placements
      placer.create?()

  _shutdown: ->
    @eventManager.destroy() if @eventManager
    @eventManager = null

  _initPhysics: ->
    @game.physics.startSystem(phaser.Physics.ARCADE)
    @game.physics.arcade.gravity.y = 1000
    @game.physics.arcade.TILE_BIAS = 32 # fix: Moose falls through fire tiles when respawning.
    @_proximityChecker = new stratego.ProximityChecker(this, @eventManager)
    @_collisionManager = new stratego.CollisionManager(@game, @eventManager)
    @eventManager.addEventHandler('collisionPlayerEnd', @_onCollisionPlayerEnd, this)

  _shutdownPhysics: ->
    @eventManager.removeEventHandler('collisionPlayerEnd', @_onCollisionPlayerEnd, this)
    @_proximityChecker.shutdown() if @_proximityChecker
    @_proximityChecker = null
    @_collisionManager.shutdown() if @_collisionManager
    @_collisionManager = null

  _backgroundKey: ->
    "#{@constructor.WorldName()}background"

  _backgroundPath: ->
    "#{@constructor.WorldPath()}background.png"

  _preloadArt: (game) ->
    game.load.image(asset.key, asset.path) for asset in @constructor.ScreenAssets()
    game.load.image(@_backgroundKey(), @_backgroundPath()) unless @game.cache.checkImageKey(@_backgroundKey())
    game.load.image('tileset64', 'puzzles/tileset64.png') unless @game.cache.checkImageKey('tileset64')
    game.load.tilemap('map', @constructor.WorldPath() + @constructor.LevelName() + '.json', null, Phaser.Tilemap.TILED_JSON)

  _createArt: ->
    @background = @game.add.tileSprite(0, 0, 2048, 1536, @_backgroundKey(), 0, @depthGroup['background'])
    @background.fixedToCamera = true
    @levelPanes =( @game.add.image(2048*index, 0, asset.key, 0, @depthGroup['levelArt']) for asset, index in @constructor.ScreenAssets() )

  _destroyArt: ->
    for asset in @constructor.ScreenAssets()
      util.cleanUpImageCache(@game, asset.key)

    @background.destroy() if @background
    @background = null
    util.cleanUpImageCache(@game, @_backgroundKey())

    pane.destroy(true) for pane in @levelPanes
    @levelPanes = null

  _createSounds: ->
    @_sounds = {}
    for name, path of @_soundAssets()
      @_sounds[name] = new Howl({
        src: [path]
      }) 

  _destroySounds: ->
    if @_sounds
      sound.unload() for sound in @_sounds # Howler uses unload() instead of destroy()
    @_sounds = null

  _createTiles: ->
    @map = @game.add.tilemap('map')
    @map.addTilesetImage('tileset64', 'tileset64')
    @map.setCollision(TILES_WITH_COLLISION_BODIES, true)
    @mapLayer = @map.createLayer('layer1')
    @game.world.removeChild(@mapLayer) # don't render the tilemap, only for collisions
    @mapLayer.resizeWorld()

  _destroyTiles: ->
    @game.cache.removeTilemap('map')
    @map.destroy()
    @map = null
    @mapLayer = null

  # Get Machine Manager instance when starting a new level
  _setMachineManager: ->
    @machineManager = stratego.MachineManager.getInstance()
    @machineManager.emptyMachines() # Empty previous machine list to make sure there are no old machines left

  _createController: ->
    @controller = if phaser.Device.touch
      new stratego.InputNintendoSwipe(@game, @eventManager)
    else
      new stratego.InputNintendoKeyboard(@game, @eventManager)

  _destroyController: ->
    @controller.shutdown() if @controller
    @controller = null

  _createPlayer: ->
    startTile = stratego.TilemapManager.getStartTile(@map)
    if not startTile?
      console.error('This level is missing a start tile.')
    @player = new stratego.Player(@game, startTile)
    @depthGroup['player'].add(@player)
    @game.camera.follow(@player, phaser.Camera.FOLLOW_PLATFORMER)

  _destroyPlayer: ->
    @depthGroup['player'].remove(@player) if @player
    @game.camera.unfollow(@player) if @player
    @player?.destroy()
    @player = null

  _connectPlayerToController: (player, controller) ->
    controller.eventManager.addEventHandler('jump', player.jump, player)
    controller.eventManager.addEventHandler('move', player.move, player)
    controller.eventManager.addEventHandler('stop', player.stop, player)

  _disconnectPlayerFromController: (player, controller) ->
    controller.eventManager.removeAllEventHandlers(player)

  _createThings: ->
    @npcs = []
    tiledMapJson = @game.cache.getTilemapData('map').data
    @things = stratego.TilemapManager.placeFromTiles(@map, @depthGroup['powerups'])
    [moreThings, @namedThings] = stratego.TilemapManager.placeFromObjects(@game, tiledMapJson, @depthGroup['devices'])
    @things = @things.concat(moreThings)

  _shutdownThings: ->
    @namedThings = null
    @things = null
    @npcs = null

  _createHud: ->
    hudGroup = @game.add.group(@game.stage, 'hud') # attach to stage, not world, so it doesn't scroll
    mainMenuBtn = new phaser.Button(@game, 854, -20, 'mainMenuBtn', (source, pointer) =>
      ActivityIndicator?.show('loading main menu...')
      @eventManager.dispatchEvent('levelIncomplete')
    )
    hudGroup.add(mainMenuBtn)
    @game.add.image(944, -20, 'keyDisplay', 0, hudGroup)
    hudGroup

  _shutdownHud: ->
    if( @_hud )
      @_hud.destroy(true)
    @_hud = null

  _createKeyDisplay: ->
    @keyGroup = @game.add.group(@game.stage, 'keys')
    @keyImages = []
    for t in @things when t instanceof stratego.Key
      @keyImages.push(@game.add.image(1208 - 64*@keyImages.length, 16, 'atlas', 'key/0', @keyGroup))
    for t in @things when t instanceof stratego.LauncherKey
      @keyImages.push(@game.add.image(1208 - 64*@keyImages.length, 16, 'atlas', 'key/0', @keyGroup))
    
    @refreshKeyDisplay()

  _destroyKeyDisplay: ->
    for image in @keyImages
      image.destroy()
    @keyImages = null
    @keyGroup?.destroy(true)
    @keyGroup = null

  _createGraphics: ->
    @gfx = @game.add.graphics(0, 0, @depthGroup['graphics'])
    if @controller.touch
      @touchFeedback = @game.add.sprite(0, 0, 'touch', 3, @depthGroup['overlay'])
      @touchFeedback.kill()

  _destroyGraphics: ->
    @gfx?.destroy()
    @gfx = null

    if @controller.touch
      @touchFeedback?.destroy()

  elapsedTime: ->
    (@game.time.now - @startTime)/1000

  playSound: (name) ->
    if @_sounds[name]?
      @_sounds[name].play()
    else
      console.error("playSound #{name}: Can't find a sound with that name")

  pickupKey: ->
    @playSound('pickup-key')
    @refreshKeyDisplay()

  pickupLauncherKey: ->
    @playSound('pickup-launcher-key')
    @refreshKeyDisplay()

  unlockKey: (x, y) ->
    y = stratego.TILESET.GRID_HEIGHT - y # Quick fix to y coordinate inverting
    mappedX = x * stratego.TILESET.TILE_SIZE
    mappedY = y * stratego.TILESET.TILE_SIZE
    for t in @things when t.tileId == stratego.TILESET.LOCKED_KEY
      if t.position.x is mappedX and t.position.y is mappedY
        t.unlock()

  useKey: ->
    @refreshKeyDisplay()

  refreshKeyDisplay: ->
    keyImage.kill() for keyImage in @keyImages
    for i in [0...@player.numKeys()]
      @keyImages[i].reset(@keyImages[i].x, @keyImages[i].y)

  # NPCs and Things created outside of TilemapManager need to register
  registerNpc: (npc) ->
    @npcs.push npc

  unregisterNpc: (npc) ->
    @npcs.splice(@npcs.indexOf(npc), 1)

  registerThing: (thing) ->
    @things.push thing
  
  unregisterThing: (thing) ->
    idx = @things.indexOf(thing)
    if idx != -1
      @things.splice(@things.indexOf(thing), 1)

  tileAt: (worldX, worldY) ->
    tile = @map.getTileWorldXY(worldX, worldY)

  update: ->
    super()
    @_collisionManager.update(@player, @things, @npcs, @mapLayer)
    @_updateParallaxBackground()
    @_updateTouchFeedback() if @controller.touch and @controller.touchFeedback
    @_updateEditorDisplay()
    @_debugDisplay?.update()
    @_proximityChecker.update(@player, @things.concat(@npcs))
    if @machineManager != undefined
      @machineManager.updateMachines()

  #preRender is called after update, but before rendering
  preRender: ->
    return if @game.paused  # Because preRender still runs even if your game pauses!
    if @player
      @player.followLock()
    if @npcs
      for npc in @npcs
        npc.followLock()

  _updateParallaxBackground: ->
    @background.tilePosition.x = Math.round(-@game.camera.x * 0.7)

  _updateTouchFeedback: ->
    THUMB_Y_OFFSET = 160
    if @controller.touch and @controller.pressed('move')
      unless @touchFeedback.alive
        @touchFeedback.reset()

      frame = 3 + Math.round(3 * @player.velocity / stratego.Player.MAX_X_VEL)
      @touchFeedback.frame = frame

      world_pos = @game.clientToWorld( @controller.position('move') )

      @touchFeedback.x = world_pos.x - @touchFeedback.width/2
      @touchFeedback.y = world_pos.y - THUMB_Y_OFFSET

    else if @touchFeedback.alive
      @touchFeedback.kill()

  #
  # Blockly Editor related
  #
  shouldDelayEditorUpdate: ->
    m = util.magnitude(@player.body.velocity)
    m > 35      # velocity seems to settle at 16.5. Gravity?

  _editor: ->
    @game.app.blocklyEditor

  _updateEditorDisplay: ->
    @gfx.clear()
    return if not @_editor().isVisible()
    if @inCameraView(@_editor().device) and @_editor().device.alive and @_editor().isOpen()
      window.stratego.drawSpotlight(@gfx, @_editor().device)
    else
      @showEditorForClosestDevice()

  inCameraView: (thing) ->
    return false unless thing?
    camera = @game.camera
    left = camera.view.x
    right = camera.view.x + camera.view.width
    top = camera.view.y
    bottom = camera.view.y + camera.view.height
    # Use thing.right instead of thing.x when comparing with left to make sure the object isn't visible only when completely out of view
    thing.right > left and thing.x < right and thing.y > top and thing.y < bottom

  _initDeviceNavButtons: ->
    $("#editor__focus-buttons--prev").on('click', @previousDevice)
    $("#editor__focus-buttons--next").on('click', @nextDevice)

  _shutdownDeviceNavButtons: ->
    $("#editor__focus-buttons--prev").off('click', @previousDevice)
    $("#editor__focus-buttons--next").off('click', @nextDevice)

  getDeviceList: ->
    devices = util.filterByType(@things.concat(@npcs), stratego.GameDevice)
    devices = _.uniq(devices)
    devices.sort (a, b) -> a.x - b.x # ordered left to right
    devices

  nextDevice: =>
    @switchEditorDevice(1)

  previousDevice: =>
    @switchEditorDevice(-1)

  switchEditorDevice: (offset) ->
    return if not @canSwitchDevice
    @canSwitchDevice = false
    @game.time.events.add(Phaser.Timer.SECOND * 1, @enableSwitchDevice, this);

    devices = @getDeviceList()
    currentIndex = devices.indexOf(@_editor().device)
    selectedDevice = devices[currentIndex + offset]
    if selectedDevice? and @inCameraView(selectedDevice)
      @_editor().open(selectedDevice)
    else
      @cycleDevices(offset, devices)

  # Switch editor focus to a specific device
  switchEditorSpecificDevice: (device) ->
    devices = @getDeviceList()
    currentIndex = devices.indexOf(@_editor().device)
    if device? and @inCameraView(device)
      @_editor().open(device)

  enableSwitchDevice: ->
    @canSwitchDevice = true

  # Cycle through visible devices
  cycleDevices: (offset, devices) ->
    # Depending on the arrow pressed, the search is started on the opposite side
    currentIndex = if offset >= 1 then -1 else devices.length - 1

    indexFound = false
    
    while not indexFound
      indexFound = devices[currentIndex + offset]? and @inCameraView(devices[currentIndex + offset])
      
      if not indexFound
        currentIndex += offset
      
      # Avoid infinite loop
      if currentIndex < 0 or currentIndex > devices.length - 1
        break

    if indexFound
      @_editor().open(devices[currentIndex + offset])

  findClosestDevice: (player) ->
    devices = @getDeviceList()
    devices.sort (a, b) ->  # find the one closest to player
      util.distance(a, player) - util.distance(b, player)
    devices[0]

  showEditorForClosestDevice: () ->
    return if @shouldDelayEditorUpdate()
    closestDevice = @findClosestDevice(@player)
    if @inCameraView(closestDevice)
      @_editor().open(closestDevice)
    else
      @_editor().close()

  _onCollisionPlayerEnd: () ->
    if !@completed
      @completed = true
      @eventManager.dispatchEvent('levelComplete')

  # tween convenience functions

  fadeOutAndDestroy: (sprite) ->
    tween = @game.add.tween(sprite)
    tween.to({alpha: 0}, 500)
    tween.onComplete.add(->
      sprite.destroy()
      )
    tween.start()

  addAlphaTween: (sprite, opacity) ->
    @game.add.tween(sprite)
      .to({alpha: opacity})
      .to({alpha: 1.0})
      .loop()
      .start()

  addMovementTween: (sprite, x1, y1, x2, y2) ->
    @game.add.tween(sprite)
      .to({x: x1, y: y1})
      .to({x: x2, y: y2})
      .loop()
      .start()

  addScaleTween: (sprite, scale1, scale2) ->
    @game.add.tween(sprite.scale)
      .to({x: scale1, y: scale1})
      .to({x: scale2, y: scale2})
      .loop()
      .start()

class stratego.Boat1 extends stratego.Level

  @LevelName: -> 'level1'
  @WorldName: -> 'boat'
  @ScreenCount: 5

  robodilloPlacements: -> [
    { left: 43, right: 48, y: 21 },
    { left: 127, right: 129, y: 15 }
  ]

  sharkPlacements: -> [
      { x: 31, y: 21 },
      { x: 57, y: 21 }
    ]

  create: ->
    super()

    @namedThings.e1.setCode(stratego.Elevator.PROGRAM.SENSORS(
      'YELLOW', 'stratego_glide_up', 'GREEN', 'stratego_glide_down'
    ))
    @namedThings.e2.setCode(stratego.Elevator.PROGRAM.SENSORS(
      'YELLOW', 'stratego_glide_down', 'GREEN', 'stratego_reset_position'
    ))

    @namedThings.e1.readOnly = true
    @namedThings.e2.readOnly = true

    @namedThings.e3.setCode(stratego.Elevator.PROGRAM.SENSOR_EMPTY())
    @namedThings.e4.setCode(stratego.Elevator.PROGRAM.SENSOR_EMPTY())

    @namedThings.e3.toolboxXml = stratego.Elevator.TOOLBOX.SENSOR
    @namedThings.e4.toolboxXml = stratego.Elevator.TOOLBOX.SENSOR_CONDITIONAL

class stratego.Boat2 extends stratego.Level

  @LevelName: -> 'level2'
  @WorldName: -> 'boat'
  @ScreenCount: 6

  robodilloPlacements: -> [
      { left: 11, right: 13, y: 8 }
    ]

  burrowPlacements: -> [
      { spawn: 'right', x: 70, y: 11 }
    ]

  puddlePlacements: -> [
    {x: 56.5, y: 16},
    {x: 62, y: 16}
  ]

  cannonballPlacements: -> [
    { x: 74.5, y: 21 },
    { x: 85.5, y: 21 }
  ]

  create: ->
    super()

    yellowGreen = stratego.Door.PROGRAM.OPEN_IF_LOCK_IF('YELLOW', 'GREEN')
    @namedThings.d1.setCode(yellowGreen)
    @namedThings.d3.setCode(yellowGreen)
    @namedThings.d4.setCode(yellowGreen)
    @namedThings.d6.setCode(yellowGreen)

    greenYellow = stratego.Door.PROGRAM.OPEN_IF_LOCK_IF('GREEN', 'YELLOW')
    @namedThings.d5.setCode(greenYellow)
    @namedThings.d7.setCode(greenYellow)

    @namedThings.d6.open()
    @namedThings.d6.readOnly = false

    @namedThings.d2.toolboxXml = stratego.Door.TOOLBOX.SENSOR
    @namedThings.d2.readOnly = false

class stratego.Boat3 extends stratego.Level

  @LevelName: -> 'level3'
  @WorldName: -> 'boat'
  @ScreenCount: 5

  burrowPlacements: -> [
      { spawn: 'right', x: 11, y: 9 }
      { spawn: 'both', x: 39, y: 13 }
      { spawn: 'left', x: 70, y: 9 }
    ]

  flagPlacements: -> [
      { x: 40.9, y: 8, flagType: "skinny" }
      { x: 102.8, y: 8, flagType: "skinny" }
    ]

  create: ->
    super()

    @namedThings.d1.setCode(stratego.Door.PROGRAM.OPEN_IF_LOCK_IF('YELLOW', 'GREEN'))
    @namedThings.d2.setCode(stratego.Door.PROGRAM.OPEN_IF_LOCK_IF('GREEN', 'YELLOW'))
    @namedThings.d3.setCode(stratego.Door.PROGRAM.OPEN_IF_LOCK_IF('YELLOW', 'GREEN'))
    @namedThings.d4.setCode(stratego.Door.PROGRAM.OPEN_IF_LOCK_IF('GREEN', 'YELLOW'))
    @namedThings.d5.setCode(stratego.Door.PROGRAM.OPEN_IF_LOCK_IF('YELLOW', 'GREEN'))
    @namedThings.d6.setCode(stratego.Door.PROGRAM.OPEN_IF_LOCK_IF('GREEN', 'YELLOW'))

    @namedThings.d7.readOnly = false

###
boat/level4.coffee
###
class stratego.Boat4 extends stratego.Level

  @LevelName: -> 'level4'
  @WorldName: -> 'boat'
  @ScreenCount: 7  # 2048x1536px = 32x24tiles

  seaUrchinPlacements: -> [
      {x: 27 - 0.5, y: 21, urchinColor: 'pink'},
      {x: 36 - 0.5, y: 21, urchinColor: 'green'},
      {x: 40 - 0.5, y: 21, urchinColor: 'black'},
      {x: 54 - 0.5, y: 21, urchinColor: 'black'},
      {x: 61 - 0.5, y: 21, urchinColor: 'green'},
      {x: 63 - 0.5, y: 21, urchinColor: 'pink'},
      {x: 79 - 0.5, y: 21, urchinColor: 'black'},
      {x: 94 - 0.5, y: 21, urchinColor: 'purple'},
      {x:109 - 0.5, y: 21, urchinColor: 'pink'},
      {x:110 - 0.5, y: 21, urchinColor: 'purple'},
      {x:117 - 0.5, y: 21, urchinColor: 'black'},
      {x:126 - 0.5, y: 21, urchinColor: 'purple'},
      {x:131 - 0.5, y: 21, urchinColor: 'purple'},
      {x:152 - 0.5, y: 21, urchinColor: 'black'},
      {x:157 - 0.5, y: 21, urchinColor: 'black'},
    ]

  preload: (game) ->
    super(game)
    game.load.image('submarine', 'puzzles/boat/level4-Submarine.png')

  create: ->
    # raft:
    #   s1 -> e1
    # first ship:
    #   r1:
    #     s2 -> e2
    #     s3 -> e3
    # engine room
    #   rEngine:
    #     sensorAirlock1 -> airlock1
    #     sensorAirlock2 -> airlock2
    #     ? -> waterlock
    super()

    @game.add.image(194*stratego.TILESET.TILE_SIZE, 15*stratego.TILESET.TILE_SIZE,
      'submarine', 0, @depthGroup['overlay'])

    # robodillo toolbox
    for name in ['r0', 'r1', 'rEngine']
      robodillo = @namedThings[name]
      robodillo.readOnly = false
      robodillo.body.customSeparateX = false  # allow robodillos to collide with walls.
      robodillo.clearCode()
      robodillo.toolboxXml = """
        <block type="stratego_when_player_jump"></block>
        <block type="stratego_drive"></block>
        <block type="stratego_stop"></block>
        <block type="stratego_face"></block>
        <block type="stratego_left"></block>
        <block type="stratego_right"></block>
      """
    @namedThings.r0.face('right')
    @namedThings.r0.stop()


    glideUpOnButton = (buttonColor, steps) ->
      """
      <?xml version="1.0"?>
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_sensor_pressed" id="283" x="138" y="106">
          <statement name="DO">
            <block type="stratego_if" id="285" inline="false">
              <value name="IF0">
                <block type="stratego_sensor_is_color" id="286">
                  <field name="COLOR">#{buttonColor}</field>
                </block>
              </value>
              <statement name="DO0">
                <block type="stratego_repeat" id="284">
                  <field name="TIMES">#{steps}</field>
                  <statement name="DO">
                    <block type="stratego_glide_up" id="287"/>
                  </statement>
                </block>
              </statement>
            </block>
          </statement>
        </block>
      </xml>
      """

    @namedThings.e1.setCode(glideUpOnButton('YELLOW', 5))
    @namedThings.e1.readOnly = true
    @namedThings.e2.setCode(glideUpOnButton('GREEN', 6)) # go a little higher so Moose can get back to boat1
    @namedThings.e2.readOnly = true
    @namedThings.e3.setCode(glideUpOnButton('PINK', 6))
    @namedThings.e3.readOnly = true

    @namedThings.waterlock.readOnly = false
    @namedThings.airlock1.setCode(stratego.Door.PROGRAM.OPEN_IF_LOCK_IF('YELLOW', 'GREEN'))
    @namedThings.airlock2.setCode(stratego.Door.PROGRAM.OPEN_IF_LOCK_IF('GREEN', 'YELLOW'))

class stratego.Boat5 extends stratego.Level

  @LevelName: -> 'level5'
  @WorldName: -> 'boat'
  @ScreenCount: 5

  robodilloPlacements: -> [
    { left: 7, right: 12, y: 19, name: "r1" , respawn: true}
    { left: 39, right: 43, y: 4, name: "r2" }
    { left: 74, right: 74, y: 10, name: "r3a" , respawn: true}
    { left: 78, right: 78, y: 10, name: "r3b" , respawn: true}
    { left: 98, right: 98, y: 0, name: "r4" , respawn: true}
  ]

  burrowPlacements: -> [
      { spawn: 'both', x: 130, y: 8, name: "bur1" }
    ]

  flagPlacements: -> [
      { x: 121, y: 1, flagType: "skinny" }
    ]

  stopProgrammableRobodillo: (r) ->
    r.setCode(stratego.Robodillo.PROGRAM.SENSOR_ACTION('stratego_stop'))
    r.toolboxXml = stratego.Robodillo.TOOLBOX.SENSOR_AND_PLAYER
    r.readOnly = false

  simulateE3: =>
    @simulateElevator(@namedThings.e3)

  # Removed this functionality because it's really confusing what it actually does and we don't know why it was implemented in the first place
  # If planned on re-using this, take into account that at the current state of the game it won't work because of the MachineManager off-screen behaviour
  simulateElevator: (e) ->
    fake = new stratego.Elevator(@game, -1000, 1000)
    em = new stratego.EventManager()
    s = new stratego.Sensor(@game, -1500, 1000)
    fake.eventManager = em
    fake.inCameraView = -> true
    s.inCameraView = -> true
    fake.setCode(e._codeXml)
    fake.runCode()
    @runOneBlock(fake) # run one block to get the wait_for registered
    em.dispatchEvent( 'sensorPress',
      source: s
      color: 'YELLOW'
    )
    @runOneBlock(fake) for [1..20]
    if fake.y > 1000 then return 'left' else return'right'

  runOneBlock: (device) ->
    for m in device._machines
      m._runOneBlock()

  create: ->
    super()

    # puzzle 1 - escape the room
    @namedThings.r1.setCode(stratego.Robodillo.PROGRAM.SENSOR_PATROL('GREEN', 'YELLOW'))
    @namedThings.r1.toolboxXml = stratego.Robodillo.TOOLBOX.SENSOR
    @namedThings.r1.readOnly = false
    @namedThings.d1.setCode(stratego.Door.PROGRAM.OPEN_IF_LOCK_IF('PINK', 'GREEN'))
    @namedThings.d9.clearCode()
    @namedThings.d9.open()

    # puzzle 2 - make the robodillo bring the elevator down
    @stopProgrammableRobodillo(@namedThings.r2)
    @namedThings.e2.setCode(stratego.Elevator.PROGRAM.SENSORS(
      'PINK', 'stratego_glide_down', 'GREEN', 'stratego_glide_up'
    ))
    @namedThings.e2.readOnly = true

    #puzzle 3 - drive the correct robodillo
    @stopProgrammableRobodillo(@namedThings.r3a)
    @stopProgrammableRobodillo(@namedThings.r3b)
    @namedThings.d4.setCode(stratego.Door.PROGRAM.OPEN_IF_LOCK_IF('PINK', 'GREEN'))

    # puzzle 4 - save the elevator
    @namedThings.bur1.manualOverrideMode = true
    @namedThings.bur1.setCode(stratego.RobodilloBurrow.PROGRAM.RANDOM_SPAWN)

    @namedThings.e3.toolboxXml = stratego.Elevator.TOOLBOX.SENSOR_CONDITIONAL
    @namedThings.e3.clearCode()
    for e in ['e3above', 'e3below']
      @namedThings[e].setCode(stratego.Elevator.PROGRAM.SENSOR_REPEAT(
        'PINK', 'stratego_glide_down', 3, 'GREEN', 'stratego_glide_up', 3
      ))
      @namedThings[e].readOnly = true
    @namedThings.e3left.setCode(stratego.Elevator.PROGRAM.SENSOR_REPEAT(
      'PINK', 'stratego_glide_up', 1, 'GREEN', 'stratego_glide_up', 2
    ))
    @namedThings.e3left.readOnly = true
    @namedThings.e4.setCode(stratego.Elevator.PROGRAM.FOREVER_DOWN_UP(9))

    # puzzle 5 - send the robodillo to press the correct button
    @namedThings.d11.setCode(stratego.Door.PROGRAM.OPEN_IF_LOCK_IF('PINK', 'GREEN'))
    @stopProgrammableRobodillo(@namedThings.r4)
    @namedThings.r4.face('right')

class stratego.Forest1 extends stratego.Level

  @LevelName: -> 'level1'
  @WorldName: -> 'forest'
  @ScreenCount: 5

  tutorialAssets: -> [
      { key: 'leftThumb', path: 'art/tutorial/thumb-left.png' },
      { key: 'rightThumb', path: 'art/tutorial/thumb-right.png' },
      { key: 'leftThumbPrompt', path: 'art/tutorial/thumb-left-text.png' },
      { key: 'rightThumbPrompt', path: 'art/tutorial/thumb-right-text.png' },
      { key: 'leftThumbSlide', path: 'art/tutorial/thumb-left-slide.png' },
      { key: 'rightThumbSwipe', path: 'art/tutorial/thumb-right-swipe.png' },
      { key: 'thumbOffCircle', path: 'art/tutorial/thumb-circle-off.png' },
      { key: 'thumbOnCircle', path: 'art/tutorial/thumb-circle-on.png' },
      { key: 'dashedLine', path: 'art/tutorial/dashed-line.png' }
      { key: 'level1-screen1', path: 'art/tutorial/level1StoryScreens/level1-screen1.png' }
      { key: 'level1-screen2', path: 'art/tutorial/level1StoryScreens/level1-screen2.png' }
      { key: 'level1-screen3', path: 'art/tutorial/level1StoryScreens/level1-screen3.png' }

    ]

  robodilloPlacements: -> [
      { left: 64, right: 68, y: 0 }
    ]

  preload: (game) ->
    super(game)
    game.load.image( image.key, image.path) for image in @tutorialAssets()
    game.load.spritesheet('mooseIdle', 'art/tutorial/mooseIdle.png', 575.5, 704, 2);
    game.load.spritesheet('hunter', 'art/tutorial/hunterWithChickens.png', 960, 1088, 6);

  create: ->
    super()

    @level1Intro = new Howl({
      src: ['audio/level1-intro.mp3']
    }) 

    @exitIntro = false
    
    @_createTutorialGroup()

    return if not phaser.Device.touch
    @_tutorialGroup = @game.add.group(@game.stage, 'tutorial')
    

  shutdown: ->
    @_destroyTutorialGroup()
    for image in @tutorialAssets()
      @game.cache.removeImage(image.key)
    super()
    return if not phaser.Device.touch
    @level1Intro.unload() # Howler uses unload() instead of destroy()
    @mooseIdle.destroy()

  THUMB_MOVE_AMOUNT = 80

  initLeftThumbTarget: ->
    X = 400
    Y = 1200
    @leftPrompt = @game.add.image(X, Y, 'leftThumbPrompt', 0, @_tutorialGroup)
    @leftTarget = @game.add.image(X, Y, 'thumbOffCircle', 0, @_tutorialGroup)
    @leftPrompt.scale = @leftTarget.scale = new Point(0.6, 0.6)

    @leftThumb = @game.add.image(X, Y, 'leftThumb', 0, @_tutorialGroup)
    @leftThumb.scale = new Point(0.6, 0.6)

    @leftPrompt.anchor = @leftTarget.anchor = @leftThumb.anchor = new Point(0.5, 0.5)
    @addAlphaTween(@leftTarget, 0.6)
    @addMovementTween(@leftThumb, X + THUMB_MOVE_AMOUNT, Y + THUMB_MOVE_AMOUNT, X, Y)
    @addScaleTween(@leftThumb, 0.45, 0.6)

  initRightThumbTarget: ->
    X = 1650
    Y = 1200
    @rightPrompt = @game.add.image(X, Y, 'rightThumbPrompt', 0, @_tutorialGroup)
    @rightTarget = @game.add.image(X, Y, 'thumbOffCircle', 0, @_tutorialGroup)
    @rightPrompt.scale = @rightTarget.scale = new Point(0.6, 0.6)

    @rightThumb = @game.add.image(X, Y, 'rightThumb', 0, @_tutorialGroup)
    @rightThumb.scale = new Point(0.6, 0.6)

    @rightPrompt.anchor = @rightTarget.anchor = @rightThumb.anchor = new Point(0.5, 0.5)
    @addAlphaTween(@rightTarget, 0.6)
    @addMovementTween(@rightThumb, X - THUMB_MOVE_AMOUNT, Y + THUMB_MOVE_AMOUNT, X, Y)
    @addScaleTween(@rightThumb, 0.45, 0.6)

  initLeftThumbSlide: ->
    @dashedLine = @game.add.image(1008, 0, 'dashedLine', 0, @_tutorialGroup)
    @leftThumbSlide = @game.add.image(450, 700, 'leftThumbSlide', 0, @_tutorialGroup)
    @leftThumb = @game.add.image(400, 1200, 'leftThumb', 0, @_tutorialGroup)
    @leftThumbSlide.scale = @leftThumb.scale = new Point(0.6, 0.6)

    @leftThumbSlide.anchor = @leftThumb.anchor = new Point(0.5, 0.5)
    @addMovementTween(@leftThumb, 800, 1200, 400, 1200)

  initRightThumbJump: ->
    @rightThumbSwipe = @game.add.image(1600, 700, 'rightThumbSwipe', 0, @_tutorialGroup)
    @rightThumb = @game.add.image(1600, 1500, 'rightThumb', 0, @_tutorialGroup)
    @rightThumbSwipe.scale = new Point(0.6, 0.6)
    @rightThumb.scale = new Point(0.6, 0.6)

    @rightThumbSwipe.anchor = @rightThumb.anchor = new Point(0.5, 0.5)
    @addMovementTween(@rightThumb, 1600, 1200, 1600, 1500)
    @addScaleTween(@rightThumb, 0.55, 0.6)

  inputHandler: ->
    @fadeOutAndDestroy(@hunterBackground1)
    @fadeOutAndDestroy(@hunterBackground2)
    @fadeOutAndDestroy(@hunterBackground3)
    @fadeOutAndDestroy(@hunter)
    @fadeOutAndDestroy(@moose)
    @level1Intro.stop()
    @exitIntro = true
    @initLeftThumbTarget()
    @initRightThumbTarget()
    @controller.touchFeedback = false
    @controller.deactivate('move')
    @controller.deactivate('jump')

  update: ->
    super()

    if @level1Intro.seek() >= 10 and @level1Intro.seek() < 18
      @hunterBackground1.visible = false
      @hunterBackground2.visible = true
    else if @level1Intro.seek() >= 18.5
      @hunterBackground2.visible = false
      @hunterBackground3.visible = true
      @hunter.visible = false
      @moose.visible = true


    return if not phaser.Device.touch 

    return if not @exitIntro


    if @controller.pressed('move') and not @leftTargetActivated
      @leftTargetActivated = true
      @fadeOutAndDestroy(@leftPrompt)
      @fadeOutAndDestroy(@leftThumb)
      @leftTarget.loadTexture('thumbOnCircle')

    if @controller.pressed('jump') and not @rightTargetActivated
      @rightTargetActivated = true
      @fadeOutAndDestroy(@rightPrompt)
      @fadeOutAndDestroy(@rightThumb)
      @rightTarget.loadTexture('thumbOnCircle')

    if @controller.pressed('move') and @controller.pressed('jump') and not @slidePromptActivated
      @slidePromptActivated = true
      @controller.activate('move')
      @fadeOutAndDestroy(@leftTarget)
      @fadeOutAndDestroy(@rightTarget)
      @initLeftThumbSlide()

    if @player.x > 3 * 64 and not @slidePromptCleared
      @slidePromptCleared = true
      @controller.touchFeedback = true
      @fadeOutAndDestroy(@leftThumbSlide)
      @fadeOutAndDestroy(@leftThumb)

    if @player.x > 15 * 64 and not @jumpPromptActivated
      @jumpPromptActivated = true
      @controller.activate('jump')
      @initRightThumbJump()

    if @player.x > 25 * 64 and not @jumpPromptCleared
      @jumpPromptCleared = true
      @fadeOutAndDestroy(@rightThumbSwipe)
      @fadeOutAndDestroy(@rightThumb)

  _createTutorialGroup: ->
    @level1Intro.play()
    @_tutorialGroup = @game.add.group(@game.stage, 'tutorial')
    @hunterBackground1 = new phaser.Button(@game, 0, 0, 'level1-screen1', @inputHandler, this)
    @hunterBackground2 = new phaser.Button(@game, 0, 0, 'level1-screen2', @inputHandler, this)
    @hunterBackground3 = new phaser.Button(@game, 0, 0, 'level1-screen3', @inputHandler, this)
    @hunterBackground2.visible = false
    @hunterBackground3.visible = false
    @_tutorialGroup.add(@hunterBackground1)
    @_tutorialGroup.add(@hunterBackground2)
    @_tutorialGroup.add(@hunterBackground3)
    
    # moose
    @moose = new phaser.Button(@game, 800, 400, 'mooseIdle', @inputHandler, this)
    @mooseIdle = @moose.animations.add("mooseIdle", [0, 0, 0, 0, 0, 1])
    @mooseIdle.play(2, true)
    @moose.visible = false
    @mooseMoved = false
    
    # hunter
    @hunter = new phaser.Button(@game, 700, 100, 'hunter', @inputHandler, this)
    hunterIdle = @hunter.animations.add("idle")
    @hunter.animations.play("idle", 6, true)

    @_tutorialGroup.add(@hunter)
    @_tutorialGroup.add(@moose)    

  _destroyTutorialGroup: ->
    @_tutorialGroup?.destroy(true)
    @_tutorialGroup = null

class stratego.Forest2 extends stratego.Level

  @LevelName: -> 'level2'
  @WorldName: -> 'forest'
  @ScreenCount: 4

  robodilloPlacements: -> [
      { left: 105, right: 109, y: 19 }
    ]

  preload: (game) ->
    super(game)

    game.load.spritesheet('rotate', 'art/tutorial/rotate.png', 1024, 1024)
    game.load.image('hunter-background', 'art/tutorial/hunter-background.png')
    game.load.image('level2-screen1', 'art/tutorial/level2StoryScreens/level2-screen1.png')
    game.load.image('level2-screen2', 'art/tutorial/level2StoryScreens/level2-screen2.png')
    game.load.image('hunter', 'art/tutorial/hunter.png')

  create: ->
    super()

    @namedThings.e1.setCode(stratego.Elevator.PROGRAM.FOREVER_DOWN_UP(2))
    @namedThings.e1.readOnly = true
    @namedThings.e2.toolboxXml = stratego.Elevator.TOOLBOX.NO_REPEAT

    @level2Intro = new Howl({
      src: ['audio/level2-intro.mp3']
    }) 

#    @_showTutorial = phaser.Device.touch
    @_showTutorial = true
    if @_showTutorial
      @_createTutorialGroup()
      @levelStartTime = @game.time.now

  shutdown: ->
    @_destroyTutorialGroup() if @_showTutorial
    @level2Intro.unload() # Howler uses unload() instead of destroy()

    super()

  inputHandler: ->
    return if not @_showTutorial
    if @game.time.now > @levelStartTime + 5000
      @fadeOutAndDestroy(@hunterBackground1)
      @fadeOutAndDestroy(@hunterBackground2)
      @fadeOutAndDestroy(@hunter)
      @level2Intro.stop()

  update: ->
    super()
    return if not @_showTutorial
    if @level2Intro.seek() >= 10
      @hunterBackground1.visible = false
      @hunterBackground2.visible = true

    @rotateTutorial.visible = false
    if @player.x > 75 * 64 and @player.x < 102 * 64 and @player.y < 9 * 64
      @rotateTutorial.visible = true
    if util.orientation(window.innerWidth, window.innerHeight) == 'portrait'
      @rotateTutorial.visible = false
    if @namedThings.e2.firstLoc.y != @namedThings.e2.y
      @rotateTutorial.visible = false

  _createTutorialGroup: ->
    @level2Intro.play()
    @_tutorialGroup = @game.add.group(@game.stage, 'tutorial')
    @hunterBackground1 = new phaser.Button(@game, 0, 0, 'level2-screen1', @inputHandler, this)
    @hunterBackground2 = new phaser.Button(@game, 0, 0, 'level2-screen2', @inputHandler, this)
    @hunterBackground2.visible = false
    @hunter = new phaser.Button(@game, 768, 192, 'hunter', @inputHandler, this)
    @_tutorialGroup.add(@hunterBackground1)
    @_tutorialGroup.add(@hunterBackground2)
    @_tutorialGroup.add(@hunter)
    @addMovementTween(@hunter, 768, 224, 768, 192)
    @rotateTutorial = @game.add.sprite(512, 256, 'rotate', 0, @_tutorialGroup)
    @rotateTutorial.animations.add('rotate', [0,0,0,0,1,2,3,3,3,3,3,3,3], 8, true)
    @rotateTutorial.animations.play('rotate')
    @rotateTutorial.visible = false

  _destroyTutorialGroup: ->
    @_tutorialGroup?.destroy(true)
    @_tutorialGroup = null

class stratego.Forest3 extends stratego.Level

  @LevelName: -> 'level3'
  @WorldName: -> 'forest'
  @ScreenCount: 4

  robodilloPlacements: -> [
      { left: 44, right: 45, y: 18},
      { left: 61, right: 62, y: 15},
      { left: 71, right: 72, y: 15}
    ]

  waterfallPlacements: -> [
      { x: 3, y: 13, width: 4},
      { x: 9, y: 17, width: 4},
      { x: 82, y: 14, width: 2},
      { x: 86, y: 16, width: 2},
      { x: 90, y: 18, width: 2},
      { x: 94, y: 20, width: 2},
      { x: 98, y: 22, width: 2}
    ]

  waterspoutPlacements: -> [
      {x: 15, y: 17, height: 5},
      {x: 56, y: 21, height: 3}
    ]

  preload: (game) ->
    super(game)
    game.load.image('arrows', 'art/tutorial/arrows.png')

  create: ->
    super()
    @_tutorialGroup = @game.add.group(@game.stage, 'tutorial')

    @namedThings.e1.toolboxXml = stratego.Elevator.TOOLBOX.NO_REPEAT
    @namedThings.e2.toolboxXml = stratego.Elevator.TOOLBOX.NO_REPEAT

  shutdown: ->
    @_tutorialGroup.destroy(true)
    super()

    for key in ['arrows']
      @game.cache.removeImage(key)

  update: ->
    super()
    portraitOrientation = util.orientation(window.innerWidth, window.innerHeight) == 'portrait'
    if @player.x > 48 * 64 and portraitOrientation and not @arrowTutorialActivated
      @arrowTutorialActivated = true
      @arrows = @game.add.image(1400, 10, 'arrows', 0, @_tutorialGroup)

    if @arrowTutorialActivated and not portraitOrientation and not @arrowTutorialCleared
      @arrowTutorialActivated = false
      @arrows.destroy()

    if @game.app.blocklyEditor.device == @namedThings.e1 and not @arrowTutorialCleared
      @arrowTutorialCleared = true
      @fadeOutAndDestroy(@arrows)

class stratego.Forest4 extends stratego.Level

  @LevelName: -> 'level4'
  @WorldName: -> 'forest'
  @ScreenCount: 4

  robodilloPlacements: -> [
      { left: 24, right: 28, y: 12},
      { left: 34, right: 36, y: 16},
      { left: 60, right: 62, y: 6},
      { left: 96, right: 99, y: 9},
      { left: 106, right: 109, y: 13}
    ]

  waterfallPlacements: -> [
    { x: 63, y: 8, width: 7 }
  ]

  create: ->
    super()

    @namedThings.e3.maxBlocks = 5
    @namedThings.e1.limit =
      stratego_glide_up: 1
      stratego_glide_down: 1

class stratego.Forest5 extends stratego.Level
  @LevelName: -> 'level5'
  @WorldName: -> 'forest'
  @ScreenCount: 4

  robodilloPlacements: -> [
      { left: 31, right: 33, y:1},
      { left: 36, right: 38, y:16},
      { left: 41, right: 43, y:15},
      { left: 82, right: 86, y:6},
      { left: 102, right: 106, y:6}
    ]

  create: ->
    super()
    @namedThings.e2.setCode(stratego.Elevator.PROGRAM.FOREVER_DOWN_UP(6))
    @namedThings.e3.setCode(stratego.Elevator.PROGRAM.FOREVER_DOWN_UP(4))
    @namedThings.e4.setCode(stratego.Elevator.PROGRAM.FOREVER_DOWN_UP(6))

    @namedThings.e2.readOnly = true
    @namedThings.e3.readOnly = true
    @namedThings.e4.readOnly = true

    @namedThings.e5.toolboxXml = stratego.Elevator.TOOLBOX.REPEAT_FOREVER
    @namedThings.e6.toolboxXml = stratego.Elevator.TOOLBOX.REPEAT_FOREVER
    @namedThings.e7.toolboxXml = stratego.Elevator.TOOLBOX.REPEAT_FOREVER

class stratego.Sand1 extends stratego.Level

  @LevelName: -> 'level1'
  @WorldName: -> 'sand'
  @ScreenCount: 5
  
  min = 101
  max = 1000
  

  # Bottle messages
  bottle1Message = "You can ask a crab any question you please, but if you type 'clue' you'll get a clue instead of a tease."
  bottle2Message = "Talking to crabs seems silly at first, but stick to the 'clue' because lost keys are the worst."

  # Crab nonsense
  crab1Nonsense = "Welcome to Crab Island!"
  crab2Nonsense = "Why didn't the crab share his coconuts? Because he's shellfish!"
  crab3Nonsense = "Who sells seashells on the seashore?            "
  crab4Nonsense = "Ask for a clue and then I'll speak."
  crab5Nonsense = "Help please. Have you seen my key?"
  crab6Nonsense = "Hunter is getting away with it all. You're the only one who can save the chickens and that was your call?"

  # Crab answers
  crab1Answer = "It isn't so much the message in the bottle as how it is revealed, but don't dawdle."
  crab2Answer = "We've heard there is another bottle ahead. Send the right message to discover what was said."
  crab3Answer = "Why yes, I'm crab number three, but it's twice my grade who can really help thee."
  crab4Answer = "Without a key, you'll need a code. Beat Hunter von Highmore at the end of the road."
  crab5Answer = "Passcode changes may cause you trouble, but take it one life at a time and don't let them burst your bubble."
  crab6Answer = "The passcode revealed, right here in my lair. It's _randomPassword_, guard it with care."

  # Correct answers to crab
  crabDefaultCorrectAnswer = "clue"

  # Door password
  typePassword = "Type the password to enter"
  correctPassword = "Open sesame!"
  incorrectPassword = "That is not the password that we seek."

  robodilloPlacements: -> [
    { left: 47, right: 51, y: 18 },
    { left: 119, right: 124, y: 12 }
  ]

  sharkPlacements: -> [
      { x: 64, y: 21 }
  ]

  waterfallPlacements: -> [
      { x: 108, y: 15, width: 7}
  ]


  preload: (game) ->
    super(game)
    game.load.image('arrows', 'art/tutorial/arrows.png')

  create: ->
    super()

    @_tutorialGroup = @game.add.group(@game.stage, 'tutorial')

    @namedThings.bottle1.setCode(stratego.Bottle.PROGRAM.DEFAULT(stratego.MESSAGE_OPTIONS[0][0], bottle1Message))
    @namedThings.bottle1.readOnly = true
    @namedThings.s1.setCode(stratego.EditableSensor.PROGRAM.DEFAULT(stratego.MESSAGE_OPTIONS[0][0]))
    @namedThings.s1.readOnly = true

    @namedThings.bottle2.setCode(stratego.Bottle.PROGRAM.DEFAULT(stratego.MESSAGE_OPTIONS[1][0], bottle2Message))
    @namedThings.bottle2.readOnly = true
    @namedThings.s2.setCode(stratego.EditableSensor.PROGRAM.EMPTY_PRESSED())
    @namedThings.s2.toolboxXml = stratego.EditableSensor.TOOLBOX.DEFAULT
    @namedThings.s2.readOnly = false # second sensor is editable

    @namedThings.raft1.toolboxXml = stratego.Raft.TOOLBOX.DEFAULT
    @namedThings.raft2.toolboxXml = stratego.Raft.TOOLBOX.DEFAULT
    
    @namedThings.e1.setCode(stratego.Elevator.PROGRAM.FOREVER_UP_DOWN(15))
    @namedThings.e1.readOnly = true    

    @namedThings.crab1.setCode(stratego.Crab.PROGRAM.DEFAULT(crab1Answer, crab1Nonsense, crabDefaultCorrectAnswer))
    @namedThings.crab1.readOnly = true

    @namedThings.crab2.setCode(stratego.Crab.PROGRAM.DEFAULT(crab2Answer, crab2Nonsense, crabDefaultCorrectAnswer))
    @namedThings.crab2.readOnly = true

    @namedThings.crab3.setCode(stratego.Crab.PROGRAM.ASK_QUESTION_UNLOCK_KEY(crab3Answer, crab3Nonsense, crabDefaultCorrectAnswer, 79, 17, 'stratego_crab_up_say'))
    @namedThings.crab3.readOnly = true
    
    @namedThings.e7.toolboxXml = stratego.Elevator.TOOLBOX.DEFAULT
    @namedThings.e7.readOnly = false

    @namedThings.e2.setCode(stratego.Elevator.PROGRAM.FOREVER_UP_DOWN(12))
    @namedThings.e2.readOnly = true

    @namedThings.crab4.setCode(stratego.Crab.PROGRAM.DEFAULT(crab4Answer, crab4Nonsense, crabDefaultCorrectAnswer))
    @namedThings.crab4.readOnly = true

    @namedThings.e3.setCode(stratego.Elevator.PROGRAM.FOREVER_UP_DOWN(8))
    @namedThings.e3.readOnly = true

    randomPassword = 0
    randomPassword = Math.floor(Math.random() * (max - min) + min) # min <= number < max
    
    changedCrab6Answer = ""
    changedCrab6Answer = crab6Answer.replace(/_randomPassword_/, randomPassword)

    console.log(randomPassword + " - " + changedCrab6Answer)

    @namedThings.door1.setCode(stratego.Door.PROGRAM.OPEN_IF_PASSWORD(typePassword, randomPassword, correctPassword, incorrectPassword))
    @namedThings.door1.readOnly = true

    @namedThings.raft3.toolboxXml = stratego.Raft.TOOLBOX.DEFAULT

    @namedThings.e4.toolboxXml = stratego.Elevator.TOOLBOX.DEFAULT
    @namedThings.e4.readOnly = false

    @namedThings.e5.toolboxXml = stratego.Elevator.TOOLBOX.DEFAULT
    @namedThings.e5.readOnly = false

    @namedThings.crab5.setCode(stratego.Crab.PROGRAM.DEFAULT(crab5Answer, crab5Nonsense, crabDefaultCorrectAnswer))
    @namedThings.crab5.readOnly = true

    @namedThings.crab6.setCode(stratego.Crab.PROGRAM.DEFAULT(changedCrab6Answer, crab6Nonsense, crabDefaultCorrectAnswer, 'stratego_crab_up_say'))
    @namedThings.crab6.readOnly = true


  shutdown: ->
    @_tutorialGroup.destroy(true)
    super()

    @game.cache.removeImage('arrows')
    
  update: ->
    super()
    portraitOrientation = util.orientation(window.innerWidth, window.innerHeight) == 'portrait'
    if @player.x > 0 and portraitOrientation and not @arrowTutorialActivated
      @arrowTutorialActivated = true
      @arrows = @game.add.image(1400, 10, 'arrows', 0, @_tutorialGroup)

    if @arrows? and @arrowTutorialActivated and not portraitOrientation and not @arrowTutorialCleared
      @arrowTutorialActivated = false
      @arrows.destroy()

    if @arrows? and @game.app.blocklyEditor.device != @namedThings.s1 and not @arrowTutorialCleared
      @arrowTutorialCleared = true
      @fadeOutAndDestroy(@arrows)
  
class stratego.Sand3 extends stratego.Level

  @LevelName: -> 'level3'
  @WorldName: -> 'sand'
  @ScreenCount: 5

  # Bottle messages
  bottle1Message = "Crabs are curious creatures. Remember your answers, they may become features."

  # Crab questions
  crab1Question = "Helping Von Highmore is not what we do. We're here to help kids and give them a clue. So, how old are you?"
  crab2Question = "The beach is hot and dry, but that is its way. How may glasses of water did you drink today?"
  crab3Question = "King Crab says books are magic, especially before bed. How many pages was the longest book you've ever read?"
  crab4Question = "Last, but not least, an ADDITIONAL Q: Do SUM math with your previous replies and give a final answer that is TOTALLY true"

  # Correct answers to crab
  crabDefaultCorrectAnswer = "clue"

  # Final Crab answers
  finalCrabCorrectAnswer = "Correct summation my friend. The key is yours, you're unlocked to the end."
  finalCrabIncorrectAnswer = "Check the code and add all three, without the correct sum the key remains with me."

  # Door password
  typePassword = "Type the password to enter"
  correctPassword = "Correct!"
  incorrectPassword = "No! Try again!"

  scorpionPlacements: -> [
    { left: 43, right: 47, y: 20 },
    { left: 50, right: 52, y: 21 },
    { left: 54, right: 55, y: 20 },
    { left: 58, right: 59, y: 18 },
    { left: 61, right: 68, y: 17 },
    { left: 71, right: 71, y: 18 },
    { left: 75, right: 75, y: 20 },
    { left: 78, right: 81, y: 21 },
    { left: 147, right: 155, y: 5 }
  ]

  create: ->
    super()

    @namedThings.bottle1.setCode(stratego.Bottle.PROGRAM.DEFAULT(stratego.MESSAGE_OPTIONS[0][0], bottle1Message))
    @namedThings.bottle1.readOnly = true
    @namedThings.s1.setCode(stratego.EditableSensor.PROGRAM.DEFAULT(stratego.MESSAGE_OPTIONS[0][0]))
    @namedThings.s1.readOnly = true

    @namedThings.crab1.setCode(stratego.Crab.PROGRAM.ASK_QUESTION_UNLOCK_KEY_AND_STORE(crab1Question, "answer1", 19, 20, stratego.MESSAGE_OPTIONS[1][0]))
    @namedThings.crab1.readOnly = true

    @namedThings.t1.setCode(stratego.teleportDevice.PROGRAM.DEFAULT(0, 11)) # 1, 13))
    @namedThings.t1.readOnly = true
    @namedThings.t1.toolboxXml = ""

    @namedThings.e1.toolboxXml = stratego.Elevator.TOOLBOX.DEFAULT
    @namedThings.e1.readOnly = false    

    @namedThings.crab2.setCode(stratego.Crab.PROGRAM.ASK_QUESTION_UNLOCK_KEY_AND_STORE(crab2Question, "answer2", 8, 6, stratego.MESSAGE_OPTIONS[2][0]))
    @namedThings.crab2.readOnly = true

    @namedThings.t2.setCode(stratego.teleportDevice.PROGRAM.TELEPORT_X_AXIS(1)) # 3))
    @namedThings.t2.readOnly = false
    @namedThings.t2.toolboxXml = stratego.teleportDevice.TOOLBOX.LOCKED_NUMBER_LIST([5, 11, 13, 16])
    
    @namedThings.e2.toolboxXml = stratego.Elevator.TOOLBOX.DEFAULT
    @namedThings.e2.readOnly = false    

    @namedThings.e3.toolboxXml = stratego.Elevator.TOOLBOX.DEFAULT
    @namedThings.e3.readOnly = false

    @namedThings.raft1.toolboxXml = stratego.Raft.TOOLBOX.DEFAULT
    @namedThings.raft1.readOnly = false

    @namedThings.crab3.setCode(stratego.Crab.PROGRAM.ASK_QUESTION_UNLOCK_KEY_AND_STORE(crab3Question, "answer3", 136, 3, stratego.MESSAGE_OPTIONS[3][0]))
    @namedThings.crab3.readOnly = true

    @namedThings.t3.setCode(stratego.teleportDevice.PROGRAM.TELEPORT_Y_AXIS(158))
    @namedThings.t3.readOnly = false
    @namedThings.t3.toolboxXml = stratego.teleportDevice.TOOLBOX.LOCKED_NUMBER_LIST([20, 16, 10]) # 10, 16, 22])

    @namedThings.crab4.setCode(stratego.Crab.PROGRAM.UNLOCK_KEY_IF_SENT_ANSWERS(crab4Question, "finalAnswer", 138, 21, finalCrabCorrectAnswer, finalCrabIncorrectAnswer, 'stratego_crab_up_say'))
    @namedThings.crab4.readOnly = true



class stratego.Sand5 extends stratego.Level

  @LevelName: -> 'level5'
  @WorldName: -> 'sand'
  @ScreenCount: 5
  
  xRange = [139, 155]
  yRange = [17, 23] # This range is having y = 0 at the bottom
  
  
  # Bottle messages
  bottle1Message = "Hunter von Highmore senses he's been hacked. You'll have to store your messages as variables if you don't want to be tracked."

  # Crab questions
  crab1Message = "In your search for the chicken, the crab spies will not lead you astray. Come near and listen closely and we'll show you the way."
  crab2Message = "It is King Crab you seek. Use the bottle to set, store, and send your own secretPassword so von Highmore can't peek. When you find King Crab you'll prove it is indeed you. By matching the secretPassword known only by you two. Wink. Wink."
  crab3Question = "Now it's time to prove your identity by entering here the secret password you sent me"

  # Final Crab answers
  finalCrabCorrectAnswer = "Moose, your friendship is treasured by both chickens and this crab, The coordinates are _x_, _y_ go and make your grab."
  finalCrabIncorrectAnswer = "What are you, a double agent? To that I won't speak. Enter the password you set earlier to prove you're the real moose, not a pipsqueak."
  finalCrabBlankAnswer = "King Crab cannot share secrets without verifying your identity, so store a secretPassword in the bottle for him to see."

  # Correct answers to crab
  crabDefaultCorrectAnswer = "clue"

  # Door password
  typePassword = "Type the password to enter"
  correctPassword = "Correct!"
  incorrectPassword = "No! Try again!"

  scorpionPlacements: -> [
    { left: 114, right: 117, y: 21 },
  ]

  sharkPlacements: -> [
    { x: 59, y: 21 },
    { x: 85, y: 21 },
    { x: 143, y: 21 }
  ]

  robodilloPlacements: -> [
    { left: 63, right: 66, y: 10 },
    { left: 95, right: 100, y: 13 },
    { left: 155, right: 158, y: 17 }
  ]

  waterfallPlacements: -> [
      { x: 103, y: 11, width: 7}
  ]

  preload: (game) ->
    super(game)
    game.load.image('finalDoor', 'art/finalDoor.png')

  create: ->
    super()

    crabKingMessage = stratego.MESSAGE_OPTIONS[0][0]

    @namedThings.door0.setCode(stratego.Door.PROGRAM.DEFAULT())
    @namedThings.door0.readOnly = true

    @namedThings.bottle1.setCode(stratego.Bottle.PROGRAM.DEFAULT(stratego.MESSAGE_OPTIONS[1][0], bottle1Message))
    @namedThings.bottle1.readOnly = true
    @namedThings.s1.setCode(stratego.EditableSensor.PROGRAM.DEFAULT(stratego.MESSAGE_OPTIONS[1][0]))
    @namedThings.s1.readOnly = true

    @namedThings.e1.toolboxXml = stratego.Elevator.TOOLBOX.DEFAULT
    @namedThings.e1.readOnly = false    

    @namedThings.crab1.setCode(stratego.Crab.PROGRAM.SAY_MESSAGE(crab1Message))
    @namedThings.crab1.readOnly = true

    @namedThings.raft1.toolboxXml = stratego.Raft.TOOLBOX.DEFAULT
    @namedThings.raft1.readOnly = false

    @namedThings.e2.toolboxXml = stratego.Elevator.TOOLBOX.DEFAULT
    @namedThings.e2.readOnly = false  

    @namedThings.crab2.setCode(stratego.Crab.PROGRAM.SAY_MESSAGE(crab2Message))
    @namedThings.crab2.readOnly = true

    @namedThings.bottle2.setCode(stratego.Bottle.PROGRAM.EMPTY_PRESSED())
    @namedThings.bottle2.toolboxXml = stratego.Bottle.TOOLBOX.SEND_EMPTY_MESSAGE(crabKingMessage)
    @namedThings.bottle2.readOnly = false

    @namedThings.t1.setCode(stratego.teleportDevice.PROGRAM.DEFAULT(54, 21)) #23))
    @namedThings.t1.readOnly = true
    @namedThings.t1.toolboxXml = ""

    @namedThings.door1.setCode(stratego.Door.PROGRAM.OPEN_AND_CLOSE_IF_MESSAGE_RECIEVED(stratego.MESSAGE_OPTIONS[2][0], stratego.MESSAGE_OPTIONS[3][0]))
    @namedThings.door1.readOnly = true
  
    @namedThings.s2.setCode(stratego.EditableSensor.PROGRAM.EMPTY_PRESSED_BY_NPC())
    @namedThings.s2.readOnly = false
    @namedThings.s2.toolboxXml = stratego.EditableSensor.TOOLBOX.DEFAULT

    @namedThings.door2.setCode(stratego.Door.PROGRAM.OPEN_AND_CLOSE_IF_MESSAGE_RECIEVED(stratego.MESSAGE_OPTIONS[4][0], stratego.MESSAGE_OPTIONS[5][0]))
    @namedThings.door2.readOnly = true

    @namedThings.s3.setCode(stratego.EditableSensor.PROGRAM.EMPTY_PRESSED_BY_NPC())
    @namedThings.s3.readOnly = false
    @namedThings.s3.toolboxXml = stratego.EditableSensor.TOOLBOX.DEFAULT

    @namedThings.e3.toolboxXml = stratego.Elevator.TOOLBOX.DEFAULT
    @namedThings.e3.readOnly = false 

    @namedThings.e4.toolboxXml = stratego.Elevator.TOOLBOX.DEFAULT
    @namedThings.e4.readOnly = false 

    @namedThings.door3.setCode(stratego.Door.PROGRAM.DEFAULT())
    @namedThings.door3.readOnly = true

    @namedThings.s4.setCode(stratego.EditableSensor.PROGRAM.EMPTY_PRESSED())
    @namedThings.s4.readOnly = false
    @namedThings.s4.toolboxXml = stratego.EditableSensor.TOOLBOX.DEFAULT
    
    @namedThings.door4.setCode(stratego.Door.PROGRAM.OPEN_IF_MESSAGE_RECIEVED(stratego.MESSAGE_OPTIONS[6][0]))
    @namedThings.door4.readOnly = true

    @namedThings.raft3.toolboxXml = stratego.Raft.TOOLBOX.DEFAULT
    @namedThings.raft3.readOnly = false

    @namedThings.door5.setCode(stratego.Door.PROGRAM.DEFAULT())
    @namedThings.door5.readOnly = true

    doorX = 0
    doorY = 0
    doorX = parseInt(Math.random() * ((xRange[1] + 1) - xRange[0]) + xRange[0], 10)
    doorY = parseInt(Math.random() * ((yRange[1] + 1) - yRange[0]) + yRange[0], 10)

    mappedDoorY = stratego.TILESET.GRID_HEIGHT - doorY # Use mappedDoorY to place objects on screen, tiled has y inverted
    @game.add.image(stratego.TILESET.TILE_SIZE * doorX, stratego.TILESET.TILE_SIZE * mappedDoorY, 'finalDoor', 0, @depthGroup['levelArt']) #stratego.TILESET.TILE_SIZE * doorX, stratego.TILESET.TILE_SIZE * doorY, 'finalDoor', 0, @depthGroup['levelArt'])
    
    @map.putTile(11, doorX, mappedDoorY+4) 
    @map.putTile(11, doorX+1, mappedDoorY+4) 

    @map.putTile(4, doorX+2, mappedDoorY+4) 
    @map.putTile(4, doorX+3, mappedDoorY+4) 
    @map.putTile(4, doorX+4, mappedDoorY+4) 


    # The Y coordinate shown to the player has to be remapped
    # mappedDoorY = (@game.height/stratego.TILESET.TILE_SIZE) - doorY 

    changedFinalCrabCorrectAnswer = ""

    changedFinalCrabCorrectAnswer = finalCrabCorrectAnswer.replace(/_x_/, doorX)
    changedFinalCrabCorrectAnswer = changedFinalCrabCorrectAnswer.replace(/_y_/, doorY) # Show the original y to the player


    # Finish crab king program
    @namedThings.crab3.setCode(stratego.Crab.PROGRAM.CRAB_KING(crab3Question, changedFinalCrabCorrectAnswer, finalCrabIncorrectAnswer, finalCrabBlankAnswer, crabKingMessage, 'stratego_crab_right_say'))
    @namedThings.crab3.readOnly = true
    @namedThings.crab3.setAsKing()

    @namedThings.t2.setCode(stratego.teleportDevice.PROGRAM.TELEPORT_EMPTY())
    @namedThings.t2.readOnly = false
    @namedThings.t2.toolboxXml = stratego.teleportDevice.TOOLBOX.NUMBER

    @depthGroup["background"].add(@placements.waterfall.sprites[0]) # Add waterfall to background group for it to be seen behind art

class stratego.Snow1 extends stratego.Level

  @LevelName: -> 'level1'
  @WorldName: -> 'snow'
  @ScreenCount: 5


  waterfallPlacements: -> [
    { x: 43, y: 6, width: 2},
    { x: 43, y: 8, width: 2},
    { x: 52, y: 7, width: 2},
    { x: 61, y: 8, width: 2}
  ]

  preload: (game) ->
    super(game)

  create: ->
    super()

    @namedThings.e1.setCode(stratego.Elevator.PROGRAM.FOREVER_UP_DOWN_FUNCTION(2))
    @namedThings.e1.readOnly = true

    @namedThings.e2.setCode(stratego.Elevator.PROGRAM.FOREVER_UP_DOWN_FUNCTION_NOT_STARTED(5, true))
    @namedThings.e2.toolboxXml = stratego.Elevator.TOOLBOX.DEFAULT_FUNCTIONS

    @namedThings.r1.setCode(stratego.Robodillo.PROGRAM.WAIT_FOR_PLOW(10))
    @namedThings.r1.toolboxXml = stratego.Robodillo.TOOLBOX.PLOW_FUNCTIONS
    @namedThings.r1.readOnly = false
    @namedThings.r1.triggerSnowmodillo(true)

    @namedThings.l1.setCode(stratego.Launcher.PROGRAM.EXPLICIT_PROJECTILE_PROCEDURE(700, 45, false, true))
    @namedThings.l1.toolboxXml = stratego.Launcher.TOOLBOX.THROW_PROJECTILE_AND_NUMBER

    @namedThings.e3.setCode(stratego.Elevator.PROGRAM.FOREVER_UP_DOWN_FUNCTION_NOT_STARTED(7, true))
    @namedThings.e3.toolboxXml = stratego.Elevator.TOOLBOX.DEFAULT_FUNCTIONS

    @namedThings.l2.setCode(stratego.Launcher.PROGRAM.EXPLICIT_PROJECTILE_PROCEDURE(600, 45, true, true))
    @namedThings.l2.toolboxXml = stratego.Launcher.TOOLBOX.THROW_PROJECTILE_AND_NUMBER

    @namedThings.r2.setCode(stratego.Robodillo.PROGRAM.WAIT_FOR_PLOW(8))
    @namedThings.r2.toolboxXml = stratego.Robodillo.TOOLBOX.PLOW_FUNCTIONS_REPEAT_X
    @namedThings.r2.readOnly = false
    @namedThings.r2.triggerSnowmodillo(true)

    @namedThings.e4.setCode(stratego.Elevator.PROGRAM.FOREVER_DOWN_UP_FUNCTION_NOT_STARTED(5))
    @namedThings.e4.toolboxXml = stratego.Elevator.TOOLBOX.DEFAULT_FUNCTIONS

    @namedThings.l3.setCode(stratego.Launcher.PROGRAM.EXPLICIT_PROJECTILE_PROCEDURE(600, 90, true, true))
    @namedThings.l3.toolboxXml = stratego.Launcher.TOOLBOX.THROW_PROJECTILE_AND_NUMBER

    @namedThings.r3.triggerSnowmodillo(true)
    @namedThings.r4.triggerSnowmodillo(true)


class stratego.Snow2 extends stratego.Level

  @LevelName: -> 'level2'
  @WorldName: -> 'snow'
  @ScreenCount: 5


  preload: (game) ->
    super(game)

  create: ->
    super()

    @namedThings.l1.setCode(stratego.Launcher.PROGRAM.PROJECTILE_PROCEDURE_WITH_PARAMS())
    @namedThings.l1.toolboxXml = stratego.Launcher.TOOLBOX.THROW_PROJECTILE_AND_NUMBER

    @namedThings.l2.setCode(stratego.Launcher.PROGRAM.EMPTY_PARAMETERS_ON_PRESSED())
    @namedThings.l2.toolboxXml = stratego.Launcher.TOOLBOX.WITH_PARAMS("stratego_projectiles_dropdown_just_snowball")

    @namedThings.e1.setCode(stratego.Elevator.PROGRAM.UP_DOWN_ONCE_WHEN_SENSOR_FUNCTION('PINK', 6))
    @namedThings.e1.toolboxXml = stratego.Elevator.TOOLBOX.DEFAULT_FUNCTIONS

    @namedThings.l3.setCode(stratego.Launcher.PROGRAM.EMPTY_WITH_PARAMETERS())
    @namedThings.l3.toolboxXml = stratego.Launcher.TOOLBOX.WITH_PARAMS("stratego_projectiles_dropdown_just_snowball")

    @namedThings.l4.setCode(stratego.Launcher.PROGRAM.EMPTY_WITH_PARAMETERS())
    @namedThings.l4.toolboxXml = stratego.Launcher.TOOLBOX.WITH_PARAMS("stratego_projectiles_dropdown_just_snowball")
    
    @namedThings.e2.setCode(stratego.Elevator.PROGRAM.FOREVER_UP_DOWN_FUNCTION_NOT_STARTED(5, true))
    @namedThings.e2.toolboxXml = stratego.Elevator.TOOLBOX.DEFAULT_FUNCTIONS

    @namedThings.r1.triggerSnowmodillo(true)
    @namedThings.r2.triggerSnowmodillo(true)
    @namedThings.r3.triggerSnowmodillo(true)
class stratego.Snow3 extends stratego.Level

  @LevelName: -> 'level3'
  @WorldName: -> 'snow'
  @ScreenCount: 5


  preload: (game) ->
    super(game)
    @powerUpImages = ['PowerUnlockedEgg', 'PowerUnlockedFireball', 'PowerUnlockedRobopolli', 'PowerUnlockedRock']
    for image in @powerUpImages
      @game.load.image(image, "art/#{image}.png")

  create: ->
    super()

    @powerUnlocked = -1
    @powersUnlockedImageGroup = @game.add.group(@game.stage, 'tutorial')

    @namedThings.r1.setCode(stratego.Robodillo.PROGRAM.WAIT_FOR_PLOW(10))
    @namedThings.r1.toolboxXml = stratego.Robodillo.TOOLBOX.PLOW_FUNCTIONS
    @namedThings.r1.readOnly = false
    @namedThings.r1.triggerSnowmodillo(true)

    @namedThings.l1.setCode(stratego.Launcher.PROGRAM.EMPTY_FUNCTION_ON_PRESSED_WITH_PARAMETERS())
    @namedThings.l1.toolboxXml = stratego.Launcher.TOOLBOX.WITH_PARAMS("stratego_projectiles_dropdown_just_snowball")

    @namedThings.l2.setCode(stratego.Launcher.PROGRAM.EMPTY_SNOWBALL_CHICKENEGG_CHOICE())
    @namedThings.l2.toolboxXml = stratego.Launcher.TOOLBOX.WITH_PARAMS("stratego_projectiles_dropdown_2")

    @namedThings.l3.setCode(stratego.Launcher.PROGRAM.GENERIC_THROW_OBJECT_CHICKEN_FIREBALL_SNOWBALL())
    @namedThings.l3.toolboxXml = stratego.Launcher.TOOLBOX.WITH_PARAMS("stratego_projectiles_dropdown_3")

    @namedThings.l4.setCode(stratego.Launcher.PROGRAM.GENERIC_THROW_OBJECT_ROBOPOLLI_CHICKEN_FIREBALL_SNOWBALL_EMPTY())
    @namedThings.l4.toolboxXml = stratego.Launcher.TOOLBOX.WITH_PARAMS("stratego_projectiles_dropdown_4")

    @namedThings.l6.setCode(stratego.Launcher.PROGRAM.GENERIC_THROW_OBJECT_CHICKEN_SNOWBALL_EMPTY())
    @namedThings.l6.toolboxXml = stratego.Launcher.TOOLBOX.WITH_PARAMS("stratego_projectiles_dropdown_all")

    @namedThings.ks1.setCode(stratego.Keystone.PROGRAM.DEFAULT(stratego.KEYS.ROUND))
    @namedThings.ks1.toolboxXml = stratego.Keystone.TOOLBOX.DEFAULT
    @namedThings.ks1.readOnly = true

    @namedThings.ks2.setCode(stratego.Keystone.PROGRAM.DEFAULT(stratego.KEYS.HOURGLASS))
    @namedThings.ks2.toolboxXml = stratego.Keystone.TOOLBOX.DEFAULT
    @namedThings.ks2.readOnly = true

    @namedThings.ks3.setCode(stratego.Keystone.PROGRAM.DEFAULT(stratego.KEYS.SQUARE))
    @namedThings.ks3.toolboxXml = stratego.Keystone.TOOLBOX.DEFAULT
    @namedThings.ks3.readOnly = true

    @namedThings.ks4.setCode(stratego.Keystone.PROGRAM.DEFAULT(stratego.KEYS.PIE))
    @namedThings.ks4.toolboxXml = stratego.Keystone.TOOLBOX.DEFAULT
    @namedThings.ks4.readOnly = true

  shutdown: ->
    @powersUnlockedImageGroup.destroy(true)
    for image in @powerUpImages
      @game.cache.removeImage(image)

    super()

  fadePicture: (picture) ->
    tween = @game.add.tween(picture).to( { alpha: 0 }, 2000, Phaser.Easing.Linear.None, true)
    @powerUpImages.shift()
    @powerupShowing = false
    @powerUnlocked = -1

  update: ->
    super()

    if @powerUnlocked != -1 and not @powerupShowing and @powerUpImages.length > 0
      pictureY = if @player.body.center.y < 500 then 1000 else 350
      picture = @game.add.sprite(@player.position.x, pictureY, @powerUpImages[0])
      picture.anchor.setTo(0.5, 0.5)
      @powersUnlocked = @player._launcherKeys.length
      @powerupShowing = true
      @game.time.events.add(Phaser.Timer.SECOND * 3, @fadePicture, this, picture)

###
wwtest.coffee
###

window.stratego = window.stratego or {}

class stratego.WWTest extends stratego.Level

  preload: (game) ->
    super(game, 'puzzles/wwtest/', 'wwtest', 1)

  create: ->
    super()
    new stratego.Robodillo(@game, 11, 16, 0)
    new stratego.Robodillo(@game, 13, 15, 5)

    @namedThings.e1.setCode("""
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_sensor_pressed" id="158" x="235" y="142">
          <statement name="DO">
            <block type="stratego_if" id="147" inline="false">
              <value name="IF0">
                <block type="stratego_sensor_is_color" id="151">
                  <field name="COLOR">YELLOW</field>
                </block>
              </value>
              <statement name="DO0">
                <block type="stratego_glide_up" id="192">
                </block>
              </statement>
            </block>
          </statement>
        </block>
      </xml>
      """)
    @namedThings.e1.toolboxXml = '''
      <block type="stratego_when_started"></block>
      <block type="stratego_when_player_jump"></block>
      <block type="stratego_when_sensor_pressed"></block>
      <block type="stratego_glide_up"></block>
      <block type="stratego_glide_down"></block>
      <block type="controls_repeat"></block>
      <block type="stratego_repeat_forever"></block>
      <block type="stratego_if_beyond"></block>
      <block type="stratego_if"></block>
      <block type="stratego_sensor_is_color"></block>
      '''
    @namedThings.e2.setCode('''
      <xml xmlns="http://www.w3.org/1999/xhtml">
        <block type="stratego_when_started" id="42" x="100" y="58">
          <statement name="DO">
            <block type="controls_repeat_ext" id="43" inline="true">
              <value name="TIMES">
                <block type="math_number" id="44">
                  <field name="NUM">3</field>
                </block>
              </value>
              <statement name="DO">
                <block type="stratego_glide_up" id="45">
                  <next>
                    <block type="stratego_glide_down" id="46">
                    </block>
                  </next>
                </block>
              </statement>
            </block>
          </statement>
        </block>
      </xml>
      ''')
    @namedThings.e2.autoRun = true
    @namedThings.e2.readOnly = false

    @namedThings.d1.readOnly = false

###
s3_manager.coffee
###

class stratego.CamperManager

  constructor: (@camperId, mancalaUrl, mancalaToken, unoUrl, unoToken) ->
    @store = new JsonApiDataStore()
    @devicePermissions =
      tiltPermissionAsked: false
    @sharedAppsStore = new JsonApiDataStore()
    @serverConfig =
      mancalaUrl: mancalaUrl
      mancalaToken: mancalaToken
      unoUrl: unoUrl
      unoToken: unoToken

  camperCount: ->
    @store.findAll('campers').length

  camper: ->
    return @login() if @camperCount() == 0
    Q.fcall( => @store.find('campers', @camperId) )

  app: (appId) ->
    @store.find('camper_apps', appId)

  createApp: (appJson) ->
    # https://github.com/beauby/jsonapi-datastore/blob/master/src/jsonapi-datastore.js
    model = new JsonApiDataStoreModel('camper_apps', null)
    model.setAttribute('source', appJson)
    model.setAttribute('state', 'unsaved')
    model.setRelationship('camper', @store.find('campers', @camperId))
    app = model.serialize()

    stratego.Mancala.createApp(@camperId, app, @serverConfig, @store)
      .then (response) =>
        console.log("Response from createApp is", response)
        @camperAppManager.addCamperApp(response)
        response


  updateApp: (appId, attrs) ->
    model = @app(appId)
    _.mapObject attrs, (val, key) -> model.setAttribute(key, val) # wtf, underscore?

    stratego.Mancala.saveApp(model, @serverConfig, @store)
      .then (response) =>
        @camperAppManager.addCamperApp(response)
        response

  deleteApp: (appId) ->
    stratego.Mancala.deleteApp(appId, @serverConfig, @store)

  shareApp: (app, friend) ->
    stratego.Mancala.shareApp(app.id, friend.id, @serverConfig, @store)

  copyApp: (app) ->
    stratego.Mancala.copyApp(app.id, @serverConfig, @store)
      .then (response) =>
        @camperAppManager.addCamperApp(response)
        response

  login: ->
    @_getCamperForBarcode(@camperId)
    .then( @_getCamperFromStore )

  getFriend: ->
    return promise = new Promise (resolve, reject) =>
      onScanSuccess = (camperId) =>
        console.log("In onScanSuccess with", camperId)
        resolve(@_getCamperFriendForBarcode(camperId))


      onScanFailure = (error) ->
        console.log("In onScanFailure with")
        reject(error)

      stratego.renderScanner(onScanSuccess, onScanFailure)

  getSharedApps: ->
    @_getCamperFromStore().then (camper) =>
      sharedApps = (app for app in camper.apps when app.state == "shared")
      for app in sharedApps
        app.parent.camper =
          first_name: camper.first_name
          last_name: camper.last_name
      sharedApps

  relogin: (camper_id) ->
    @camperId = camper_id
    stratego.Mancala.getCamper(@camperId, @serverConfig, @store)
    .then( @_getCamperFromStore )

  logout: ->
    @camperId = null
    @store.reset()
    @sharedAppsStore.reset()

  _stringToCamperID: (string) =>
    return stratego.STAFF_CAMPER_ID if string.toString().indexOf('S') == 0
    parseInt(string, 10)

  _getCamperForBarcode: (camperId) =>

    # New /graphql code
    stratego.Mancala.getCamper(camperId, @serverConfig, @store)
      .then (camper) =>
        window.fabric?.Crashlytics.setUserIdentifier(camper.id)
        window.fabric?.Crashlytics.setUserName("#{camper.first_name} #{camper.last_name}")
        @camperAppManager = new stratego.CamperAppManager(camper)

  _getCamperFriendForBarcode: (camperId) =>
    #return Q.reject(new stratego.CancelledScanError()) if result.cancelled
    #return Q.reject(new stratego.UnrecognizedBarcodeTypeError()) if result.format != "QR_CODE"
    #camperId = @_stringToCamperID(result.text)
    stratego.Mancala.getCamper(camperId, @serverConfig, @store)

  _getCamperFromStore: () =>
    Q.fcall( => @store.find('campers', @camperId) )

###
router.coffee

Router
###

window.stratego = window.stratego or {}

# imports
phaser = Phaser

class stratego.Router
  constructor: (@app, @game) ->

  _handleErrors: (error) =>
    @dialog = new stratego.CamperAppDialog();
    if error instanceof stratego.WifiError
      @dialog.displayError("No internet!", error);
    else if error instanceof stratego.CancelledScanError 
      @dialog.displayError("Can't scan", error)
    else
      @dialog.displayError("Unknown error", error)
 
  startLevel: (levelName, params={}) ->
    # shutdown manually if no Phaser lifecycle callbacks
    if @htmlLevel?
      @htmlLevel.shutdown()
      @htmlLevel = null

    @_previousLevelName = @levelName
    @levelName = levelName

    if levelName == 'appMenu'
      @_runCamperAppOrMenu(levelName, params)
    else
      @_runLevel(levelName, params)

    @_resetUIDisplay()

  _runLevel: (levelName, params) ->
    $('html')[0].dataset.levelname = levelName

    if @_isGameLevel(@levelName)
      window.fabric?.Answers.sendLevelStart(@levelName)

    level = @_levelFactory(levelName, params)
    if @_isHtmlLevel(levelName)
      @htmlLevel = level
    else
      @htmlLevel = null
      @game.state.add(@levelName, level)
      @game.state.start(@levelName, true, true)

    if level.eventManager?
      level.eventManager.addEventHandler('levelComplete', @_onLevelComplete, this)
      level.eventManager.addEventHandler('levelIncomplete', @_onLevelExit, this)
      level.eventManager.addEventHandler('quitAppEditor', @_onQuitAppEditor, this)
      level.eventManager.addEventHandler('requestLevel', @_onRequestLevel, this)

  _runCamperAppOrMenu: (levelName, params) ->
    @dialog = new stratego.CamperAppDialog();
    @app.camperManager.camper()
      .then( (camper) =>
        manager = new stratego.CamperAppManager(camper)
        editingApp = manager.editingApp()

        if editingApp?
          levelName = 'app'
          @levelName = 'app' # FIXME: this tells the UI to show the relevant toolbar. Confusing!
          params.app = editingApp

        @_runLevel(levelName, params)
      ).catch (e) =>
        @_handleErrors(e);

  _goMainMenu: ->
#    location.reload()
    @startLevel(MAIN_MENU_STATE_KEY)

  level: ->
    @game.state.getCurrentState()

  hasCompletedLevel: (camper, levelName) ->
    playedLevels = _.pluck(camper.stratego_progresses, 'level')
    _.contains(playedLevels, levelName)

  canPlayLevel: (camper, levelName) ->
    levelDependencies =
      'forest1' : []
      'forest2' : ['forest1']
      'forest3' : ['forest2']
      'forest4' : ['forest3']
      'forest5' : ['forest4']
      'boat1' : ['forest3']
      'boat2' : ['boat1']
      'boat3' : ['boat2']
      'boat4' : ['boat3']
      'boat5' : ['boat4']
      'sand1' : ['boat4']
      'sand3' : ['sand1']
      'sand5' : ['sand3']
      'snow1' : ['forest5']
      'snow2' : ['snow1']
      'snow3' : ['snow2']

    playedLevels = _.pluck(camper.stratego_progresses, 'level')
    levelDependencies[levelName].length == 0 or (playedLevels.length > 0 and _.every(levelDependencies[levelName], (dep) -> dep in playedLevels))

  _onRequestLevel: (params) ->
    unless params.level?
      throw new Error("Router: requestLevel event missing level parameter.")
    @startLevel(params.level, params)

  _shutdownLevel: ->
    level = @level()
    level.eventManager.removeAllEventHandlers(this) if level.eventManager?

  _onLevelComplete: ->
    if @levelName == 'levelComplete'
      Q.all([@progressSend]).then( =>
        @_goMainMenu()
      ).done()
    else
      if @_isGameLevel(@levelName)
        level = @level()
        window.fabric?.Answers.sendLevelEnd(@levelName, level.player.deaths, true)
      @progressSend = @app.camperManager.camper()
      .then (camper) =>
        camper.stratego_progresses = camper.stratego_progresses || []
        camper.stratego_progresses.push { level: @levelName } unless @levelName in camper.stratego_progresses
        lastLevel = @levelName
        @_shutdownLevel()
        @startLevel('levelComplete')
        stratego.Mancala.sendGameProgress(camper.id, lastLevel, @app.camperManager.serverConfig)
        .then (tmpCamper) ->
          console.log("progress result is: ", tmpCamper)
          camper.stratego_progresses = tmpCamper.strategoProgresses
          localStorage.setItem('camper_id', tmpCamper.id)
      .catch (e) ->
        console.error(e)

  _onQuitAppEditor: (params) ->
    @startLevel('appMenu')

  _onLevelExit: ->
    @_resetUIDisplay()
    @_shutdownLevel()
    if @_isGameLevel(@levelName)
      level = @level()
      deaths = level.player?.deaths
      x = level.player?.xCoordinate()
      window.fabric?.Answers.sendLevelEnd(@levelName, deaths, false)
      @app.camperManager.camper()
      .then (camper) =>
        ActivityIndicator?.hide()
        localStorage.setItem('camper_id', camper.id)
        @_goMainMenu()
    else
      @app.camperManager.camper()
      .then (camper) =>
        localStorage.setItem('camper_id', camper.id)
        @_goMainMenu()

  _isGameLevel: (levelName) ->
    nonGameLevels = [MAIN_MENU_STATE_KEY, 'app', 'appMenu', 'levelComplete', 'wwtest', 'appDetail', 'appSaveMenu', 'appSaveTitle', 'appTemplateMenu']
    return !_.contains(nonGameLevels, levelName)

  _isHtmlLevel: (levelName) ->
    htmlLevels = ['appMenu', 'appSaveMenu', 'appSaveTitle']
    return _.contains(htmlLevels, levelName)

  _levelFactory: (levelName, params) ->
    newLevel = switch levelName
      when MAIN_MENU_STATE_KEY then new stratego.MainMenu(@app.camperManager)
      when 'levelComplete' then new stratego.LevelComplete(@_previousLevelName)
      when 'forest1'    then new stratego.Forest1()
      when 'forest2'    then new stratego.Forest2()
      when 'forest3'    then new stratego.Forest3()
      when 'forest4'    then new stratego.Forest4()
      when 'forest5'    then new stratego.Forest5()
      when 'boat1'      then new stratego.Boat1()
      when 'boat2'      then new stratego.Boat2()
      when 'boat3'      then new stratego.Boat3()
      when 'boat4'      then new stratego.Boat4()
      when 'boat5'      then new stratego.Boat5()
      when 'sand1'      then new stratego.Sand1()
      when 'sand3'      then new stratego.Sand3()
      when 'sand5'      then new stratego.Sand5()
      when 'snow1'      then new stratego.Snow1()
      when 'snow2'      then new stratego.Snow2()
      when 'snow3'      then new stratego.Snow3()
      when 'wwtest'     then new stratego.WWTest()
      when 'appMenu'    then new stratego.CamperAppMenu(@app.camperManager)
      when 'appSaveMenu' then new stratego.CamperAppSaveMenu(@app.camperManager, params.camperAppId, params.appJson)
      when 'appSaveTitle' then new stratego.CamperAppSaveTitle(@app.camperManager, params.app)
      when 'appTemplateMenu' then new stratego.AppTemplateMenu(@app.camperManager)
      when 'appDetail'  then new stratego.CamperAppDetail(@app.camperManager, params.app)
      when 'app'
        util.assertExists(params.app)
        new stratego.CamperAppEditor( @app.camperManager, params.app )
      else
        throw new stratego.StrategoException("Tried to start unknown level '#{levelName}'")
    newLevel

  @isReloadingBrowser: ->
    localStorage.getItem('camper_id')

  # UI Display
  _resetUIDisplay: () =>
    $('#editor__title').text(' ')

###
main.coffee

Coding Studio

###
window.stratego = window.stratego or {}
window.PhaserGlobal = {}

# imports
phaser = Phaser

createCodingStudio = () ->
  return if window.codingStudio?

  window.codingStudio = new stratego.CodingStudio(
    document.getElementById('gameScreenContainer'),
    document.getElementById('editorElement'),
    document.getElementById('blocklyContainer'),
    document.getElementById('readOnlyCover')
  )

# TODO: This messes up since stratego.js is imported for both Camper App and Coding Studio.
$(document).ready(() ->
  createCodingStudio() if $('body').data('codingstudio')
)


#
# Includes coding editor and other stuff that's not included in a user's app.
#
class stratego.CodingStudio

  # gameScreenContainer = html element, generally a <div>, inside which the game
  #     screen will be created.
  # editorElement = html element that should be shown when editor is shown.
  # blocklyContainer = html element inside which the Blockly interface will appear
  constructor: (gameScreenContainer, editorElement, blocklyContainer, readOnlyCover) ->

    @blocklyEditor = new stratego.BlocklyEditor(
      editorElement,
      blocklyContainer,
      stratego.BlockDefinitions,
      => @router.level().shouldDelayEditorUpdate?()
    )

    camperId = util.getLocationQueryValue('camperId')
    mancalaUrl = util.getLocationQueryValue('mancalaUrl')
    mancalaToken = util.getLocationQueryValue('mancalaToken')
    unoUrl = util.getLocationQueryValue('unoUrl')
    unoToken = util.getLocationQueryValue('unoToken')
    @camperManager = new stratego.CamperManager(camperId, mancalaUrl, mancalaToken, unoUrl, unoToken)

    w = 2048
    h = 1536
    @game = new phaser.Game(w, h, phaser.CANVAS, gameScreenContainer)
    @game.app = this
    # new stratego.Bulletins(@game)

    @router = new stratego.Router(this, @game)
    @router.startLevel(util.getLocationQueryValue('level') || MAIN_MENU_STATE_KEY)

###
main_menu.coffee
###

class stratego.MainMenu extends phaser.State

  CAMPER_PHOTO_X = 42
  CAMPER_PHOTO_Y = 15
  LABEL_CENTER_X = 212
  LABEL_CENTER_Y = 272
  LOGOUT_X = 1850
  LOGOUT_Y = 20
  IDLE_TIMEOUT = 6500 # milliseconds


  constructor: (@camperManager) ->
    super()
    @eventManager = new stratego.EventManager()
    util.mark('MainMenu')

  preload: (game) ->
    @game.stage.backgroundColor = '#000000'
    game.load.atlasJSONHash('menu', 'textures/main_menu.png', 'textures/main_menu.json') unless game.cache.checkImageKey('menu')
    assets = [
      { key: 'map', path: 'art/main_menu/map.png' },
      { key: 'o', path: 'art/main_menu/o.png' },
      { key: 'x', path: 'art/main_menu/x.png' },
      { key: 'quit', path: 'art/main_menu/red_x.png' },
      { key: 'star', path: 'art/main_menu/star.png' },
      { key: 'start', path: 'art/main_menu/start.png' },
      { key: 'frame', path: 'art/main_menu/picture_frame.png' },
      { key: 'default_camper_photo', path: 'art/main_menu/default_camper_photo.png' },
      { key: 'unknown_camper_photo', path: 'art/main_menu/unknown_camper_photo.png' }
    ]

    game.load.image( asset.key, asset.path) for asset in assets when not game.cache.checkImageKey(asset.key)

  create: ->
    util.logMarks()
    @_deleteOtherStates()
    @lastAnimTime = @game.time.now
    @game.scale.scaleMode = phaser.ScaleManager.SHOW_ALL

    @depthGroup = new stratego.DepthGroups(@game, [
      'background',
      'midground',
      'camper_photo',
      'buttons',
      'frame',
      'camper_name'])
    @background = @game.add.image(0, 0, 'map', 0, @depthGroup['background'])
    @frame = @game.add.image(0, 10, 'frame', 0, @depthGroup['frame'])

    @start = @game.add.sprite(1752, 1318, 'menu', 'start/0', @depthGroup['midground'])
    @boats = @game.add.sprite(225, 1010, 'menu', 'boats/0', @depthGroup['midground'])
    @island = @game.add.sprite(156, 387, 'menu', 'island/0', @depthGroup['midground'])
    @shark = @game.add.sprite(570, 133, 'menu', 'shark/0', @depthGroup['midground'])
    @squid = @game.add.sprite(882, 196, 'menu', 'squid/0', @depthGroup['midground'])
    @trees = @game.add.sprite(666, 570, 'menu', 'trees/0', @depthGroup['midground'])

    @start.animations.add('go', util.anim('start/', 0, 7), 6, true).play()
    @island.animations.add('go', util.anim('island/', 0, 3), 4, false)
    @boats.animations.add('go', util.anim('boats/', 0, 6), 6, false)
    @shark.animations.add('go', util.anim('shark/', 0, 17), 9, false)
    @squid.animations.add('go', util.anim('squid/', 0, 20), 8, false)
    @trees.animations.add('go', util.anim('trees/', 0, 3), 8, true).play()
    @start.visible = false
    @dialog = new stratego.CamperAppDialog()

    persistentLogin = =>
      camper_id = localStorage.getItem('camper_id')
      localStorage.removeItem('camper_id')
      promise = if camper_id? then @camperManager.relogin(camper_id) else @camperManager.camper()
      promise

    ActivityIndicator?.show("logging in") unless camper_id?
    persistentLogin()
    .catch (error) => # catch login error but allow initialization to continue
      @_handleScanError(error)
    .then (camper) =>
      @_initCamper(camper)
      .then =>
        @_initLevelButtons(camper)
        @_initAppButton()
        @_initQuitButton()
        @start.visible = true
      .catch (exc) =>
        # something totally unexpected happened. better messaging here?
        @dialog.displayError("Can't start app", exc)
        console.error(exc)
    .finally ->
      ActivityIndicator?.hide()
    .done()

    @_hud = @game.add.group(@game.stage, 'hud') # attach to stage, not world, so it doesn't scroll
    @_debugDisplay = if stratego.IS_PRODUCTION then null else new stratego.DebugDisplay(@game, @_hud)
    @_showVersionNumber()

  shutdown: ->
    util.unmark('MainMenu')
    @_debugDisplay?.shutdown()
    @_debugDisplay = null

    @_shutdownLevelButtons()
    @_shutdownAppButton()
    @game.stage.removeChild(@_hud)

    @start.destroy(true)
    @island.destroy(true)
    @boats.destroy(true)
    @shark.destroy(true)
    @squid.destroy(true)
    @trees.destroy(true)

    @frame.destroy(true)
    @background.destroy(true)
    @depthGroup.destroy(); @depthGroup = null
    @eventManager.destroy(); @eventManager = null
    @_crossOriginAdjuster.destroy(); @_crossOriginAdjuster = null
    @dialog.close(); @dialog = null
    super()

  update: ->
    @_debugDisplay?.update()
    if @game.time.now - @lastAnimTime > IDLE_TIMEOUT
      @_idle()

  _idle: ->
    chosenSprite = util.randomOf( [@squid, @island, @boats, @shark] )
    chosenSprite.animations.play('go')
    @lastAnimTime = @game.time.now

  _showVersionNumber: ->
    versionStyle =
      fontSize: 20 
      fill: '#777'
    @versionTxt = @game.add.text(425, 1515, stratego.VERSION, versionStyle)

  onLevelButtonPress: (source, pointer) ->
    levelName = source.levelName
    if levelName
      @eventManager.dispatchEvent('requestLevel', level: levelName)

  _onQuitButtonPress: (source, pointer) ->
    console.log("Quitting!")
    window.ReactNativeWebView.postMessage("Returning to react-native S&K app");

  _onAppButtonPress: (source, pointer) ->
    @eventManager.dispatchEvent('requestLevel', level: 'appMenu')

  _deleteOtherStates: ->
    for key, val of @game.state.states
      continue if key == @game.state.current
      @game.state.unlink(key)
      @game.state.remove(key)

  _initCamper: (camper) ->
    deferred = Q.defer()
    @_shutdownStartButton()
    @depthGroup['camper_name'].removeAll(true)

    util.assertExists(camper)

    camper_image = if camper.photo_url_large then camper.photo_url_large else 'art/main_menu/default_camper_photo.png'
    @_crossOriginAdjuster = new stratego.CrossOriginAdjuster(@game).enable()
    @game.load.image('camper_photo', camper_image)
    @game.load.onFileComplete.addOnce( (progress, key, success, loadedFileCount, totalFileCount) =>
      # Once camper's photo is loaded, add it to the map
      imageKey = if success then 'camper_photo' else 'default_camper_photo'
      @camperPhoto = @game.add.image(CAMPER_PHOTO_X, CAMPER_PHOTO_Y, imageKey, 0, @depthGroup['camper_photo'])
      deferred.resolve(camper)
    , this)
    @game.load.start()

    style =
      font: "40px BReg"
      fill: "#663300"
      align: "center"
    @camperFirstName = new phaser.Text(@game, LABEL_CENTER_X, LABEL_CENTER_Y, camper.first_name, style)
    @camperFirstName.anchor.set(0.5)
    @depthGroup['camper_name'].add(@camperFirstName)

    @camperLastName = new phaser.Text(@game, LABEL_CENTER_X, LABEL_CENTER_Y+44, camper.last_name, style)
    @camperLastName.anchor.set(0.5)
    @depthGroup['camper_name'].add(@camperLastName)

    deferred.promise

  _initLevelButtons: (camper) ->
    levelButtons = [ # x, y, levelName
      { x:1680, y:1430, level: 'forest1' },
      { x:1525, y:1435, level: 'forest2' },
      { x:1157, y:940, level: 'forest3' },
      { x:1071, y:800, level: 'forest4' },
      { x:900, y:610, level: 'forest5' },

      { x:1026, y:1300, level: 'boat1' },
      { x:782, y:1300, level: 'boat2' },
      { x:586, y:1262, level: 'boat3' },
      { x:420, y:1140, level: 'boat4' },
      { x:286, y:1022, level: 'boat5' },

      { x:370, y:570, level: 'sand1'},
      { x:290, y:470, level: 'sand3'},
      { x:505, y:470, level: 'sand5'},

      { x:1190, y:570, level: 'snow1'},
      { x:1280, y:440, level: 'snow2'},
      { x:1350, y:310, level: 'snow3'},
    ]

    throw new Error('levelButtons exist') if @levelButtons

    @levelButtons = []
    for button in levelButtons
      if camper? and @game.app.router.canPlayLevel(camper, button.level)
        mark = if @game.app.router.hasCompletedLevel(camper, button.level) then 'star' else 'o'
        btn = new phaser.Button(@game, button.x, button.y, mark, @onLevelButtonPress, this)
        btn.levelName = button.level
      else
        btn = new phaser.Sprite(@game, button.x, button.y, 'x')

      @levelButtons.push( @game.add.existing(btn) )

  _shutdownLevelButtons: ->
    button.destroy() for button in @levelButtons
    @levelButtons = null

  _initQuitButton: ->
    @quitButton = new phaser.Button(@game, LOGOUT_X, LOGOUT_Y, 'quit', @_onQuitButtonPress, this)
    @quitButton.width = 100
    @quitButton.height = 100
    @game.add.existing(@quitButton)

  _initAppButton: ->
    @appButton = new phaser.Button(@game, 46, 1260, null, @_onAppButtonPress, this)
    @appButton.width = 167
    @appButton.height = 148
    @game.add.existing(@appButton)

  _shutdownAppButton: ->
    @appButton.destroy()
    @quitButton.destroy()

  _handleScanError: (error) =>
    console.log("Can't scan!")
    return if error instanceof stratego.CancelledScanError
    @dialog.displayError("Can't scan", error)

  _setCamper: (camper) =>
    promise = @_initCamper(camper)
    @_shutdownLevelButtons()
    @_shutdownAppButton()
    @start.visible = false
    @_initLevelButtons(camper)
    if camper?
      @_initQuitButton()
      @_initAppButton()
      @start.visible = true
    promise

  _shutdownStartButton: ->
    @camperPhoto?.destroy(true)
    @camperPhoto = null
    @camperFirstName?.destroy()
    @camperFirstName = null
    @camperLastName?.destroy()
    @camperLastName = null

    @_start.destroy() if @_start
    @_start = null

###
level_complete.coffee
###

class stratego.LevelComplete extends phaser.State

  constructor: (@completedLevelName) ->
    super()
    @bonusTemplate = stratego.BONUS_TEMPLATES[@completedLevelName]
    @eventManager = new stratego.EventManager()
    util.mark('LevelComplete')

  preload: (game) ->
    assets = [
      { key: 'levelComplete-background', path: 'art/level_complete/Level_CompletedBackground.png' },
      { key: 'levelComplete_completedText', path: 'art/level_complete/Level_CompletedText.png' }
      { key: 'levelComplete_mainMenu_btn', path: 'art/level_complete/Level_CompletedMainMenuArrow.png' }
      { key: 'levelComplete_workshop', path: 'art/level_complete/LevelCompletedWorkshop.png' }
      { key: 'levelComplete_challenge_btn', path: 'art/level_complete/Level_CompletedWorkshopBonusArrow.png' }
    ]
    for asset in assets
      game.load.image( asset.key, asset.path)

    game.load.spritesheet('chicken', 'art/level_complete/chicken/levelCompletedChicken.png', 127.75, 256, 8);
    game.load.spritesheet('moose', 'art/level_complete/moose/levelCompletedMoose.png', 575.5, 704, 2);


  fallingTween: (displayObject, timing) ->
    displayObject.alpha = 0
    displayObject.scale.set(3, 3)
    delay = timing.doneTime - timing.duration
    @game.add.tween(displayObject.scale).to({x: 1, y: 1}, timing.duration, undefined, true, delay)
    @game.add.tween(displayObject).to({alpha: 1}, timing.duration, undefined, true, delay)

  create: ->
    @background = @game.add.image(0, 0, 'levelComplete-background')

    @tada = new Howl({
        src: ['audio/tada.mp3']
      }) 

    @tada.play()

    # chicken
    @chicken = @game.add.sprite(1360, 730, 'chicken')  
    @chicken.animations.add("idle")
    @chicken.animations.play("idle", 30, true)


    # moose
    @moose = @game.add.sprite(700, 300, 'moose')  
    mooseIdle = @moose.animations.add("idle")
    @moose.animations.play("idle", 3, true)

    mooseIdle.enableUpdate = true;
    mooseIdle.onUpdate.add(@onUpdateMooseIdle, this);

    @mainMenuBtn = @game.add.button(1105, 1300, 'levelComplete_mainMenu_btn', @_mainMenu, this)
    @mainMenuBtn.alpha = 0
    @mainMenuBtn.anchor.set(0.5, 0.5)

    completed = {doneTime: 1250, duration: 500}
    mainMenu  = {doneTime: 1750, duration: 500}
    bonus     = {doneTime: 2000, duration: 500}
    @fallingTween(@mainMenuBtn, mainMenu)

    if @bonusTemplate
      @treehouseBtn = @game.add.button(240, 840, 'levelComplete_workshop', @_goChallenge, this)
      @treehouseBtn.anchor.set(0.5, 0)
      @treehouseBtn.alpha = 0

      @workshopArrowBtn = @game.add.button(970, 1000, 'levelComplete_challenge_btn', @_goChallenge, this)
      @workshopArrowBtn.anchor.set(0.5, 0.5)
      @workshopArrowBtn.alpha = 0

      @fallingTween(@treehouseBtn, bonus)
      @fallingTween(@workshopArrowBtn, bonus)

  onUpdateMooseIdle: (anim, frame) ->
    if frame.index == 1
      anim.speed = 1
    else 
      anim.speed = 3

  shutdown: ->
    @background.destroy(true); @background = null
    @tada.unload(); @tada = null # Howler uses unload() instead of destroy()
    @eventManager.destroy(); @eventManager = null
    util.unmark('LevelComplete')
    super()

  _mainMenu: =>
    @eventManager.dispatchEvent('levelComplete')
    @_showActivated(@mainMenuBtn)

  _showActivated: (button) ->
    button.scale.set(1.1, 1.1)

  _goChallenge: =>
    util.assertExists(@bonusTemplate.appJson)
    @_showActivated(@treehouseBtn)
    @_showActivated(@workshopArrowBtn)

    app = new JsonApiDataStoreModel('camper_app', null)
    app.setAttribute('source', @bonusTemplate.appJson)

    @eventManager.dispatchEvent('requestLevel',
      level: 'app',
      app: app
    )
